var Hp = Object.defineProperty;
var jp = (t, e, n) => e in t ? Hp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var A = (t, e, n) => (jp(t, typeof e != "symbol" ? e + "" : e, n), n);
import { openBlock as b, createElementBlock as M, normalizeClass as H, renderSlot as _e, defineComponent as ne, computed as I, unref as S, resolveComponent as z, createVNode as T, withCtx as W, createTextVNode as V, toDisplayString as j, normalizeStyle as Ut, pushScopeId as In, popScopeId as Nn, createElementVNode as R, createStaticVNode as Tl, createCommentVNode as E, useCssVars as so, useSlots as Ff, createBlock as L, h as wc, ref as U, onMounted as Wn, onUnmounted as Hf, resolveDynamicComponent as _t, withKeys as st, withModifiers as ve, Fragment as de, watch as Yt, nextTick as So, withDirectives as Ve, renderList as xe, mergeProps as He, toHandlers as Vp, isRef as je, vModelText as Mr, onBeforeUnmount as jf, createSlots as hi, vModelRadio as qp, vModelCheckbox as Vf, normalizeProps as qo, guardReactiveProps as Up, resolveDirective as Yp, createApp as Xp } from "vue";
const B = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [r, a] of e)
    n[r] = a;
  return n;
}, Kp = ["one", "two", "three", "four", "five"], Qp = {
  name: "CUi.vue",
  props: {
    type: {
      type: String,
      required: !1,
      default: "one"
    }
  },
  computed: {
    uiStyle() {
      return Kp.includes(this.type) ? `c-ui-${this.type}` : "c-ui-one";
    }
  }
};
function Gp(t, e, n, r, a, i) {
  return b(), M("p", {
    class: H([i.uiStyle, "c-ui"])
  }, [
    _e(t.$slots, "default", {}, void 0, !0)
  ], 2);
}
const we = /* @__PURE__ */ B(Qp, [["render", Gp], ["__scopeId", "data-v-bf70c2cb"]]), Zp = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    type: { default: "one" }
  },
  setup(t) {
    const e = t, n = ["one", "two", "three", "four", "five"], r = I(() => n.includes(e.type) ? `c-heading-${e.type}` : "c-heading-one");
    return (a, i) => (b(), M("p", {
      class: H([S(r), "c-heading"])
    }, [
      _e(a.$slots, "default", {}, void 0, !0)
    ], 2));
  }
});
const qf = /* @__PURE__ */ B(Zp, [["__scopeId", "data-v-b646f4b5"]]);
const Jp = ["one", "two", "three", "four"], em = {
  name: "CSubheading.vue",
  props: {
    type: {
      type: String,
      required: !1,
      default: "one"
    }
  },
  computed: {
    headingStyle() {
      return Jp.includes(this.type) ? `c-subheading-${this.type}` : "c-subheading-one";
    }
  }
};
function tm(t, e, n, r, a, i) {
  return b(), M("p", {
    class: H([i.headingStyle, "c-subheading"])
  }, [
    _e(t.$slots, "default", {}, void 0, !0)
  ], 2);
}
const Ne = /* @__PURE__ */ B(em, [["render", tm], ["__scopeId", "data-v-05761334"]]), nm = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    type: { default: "one" }
  },
  setup(t) {
    const e = t, n = I(() => `c-caption-${e.type}`);
    return (r, a) => (b(), M("caption", {
      class: H(S(n))
    }, [
      _e(r.$slots, "default", {}, void 0, !0)
    ], 2));
  }
});
const rm = /* @__PURE__ */ B(nm, [["__scopeId", "data-v-966d263d"]]);
const am = {
  name: "CSeparator",
  props: {
    vertical: {
      type: Boolean,
      required: !1,
      default: !1
    }
  }
}, im = { key: 0 }, om = {
  key: 1,
  class: "vertical"
};
function sm(t, e, n, r, a, i) {
  return n.vertical ? (b(), M("hr", om)) : (b(), M("div", im));
}
const lo = /* @__PURE__ */ B(am, [["render", sm], ["__scopeId", "data-v-f7c6d5cc"]]);
const lm = ["one", "two", "three"], cm = {
  name: "CRunning",
  props: {
    type: {
      type: String,
      required: !1,
      default: "one"
    }
  },
  computed: {
    runningStyle() {
      return lm.includes(this.type) ? `c-running-${this.type}` : "c-running-one";
    }
  }
};
function um(t, e, n, r, a, i) {
  return b(), M("p", {
    class: H([i.runningStyle, "c-running"])
  }, [
    _e(t.$slots, "default", {}, void 0, !0)
  ], 2);
}
const zn = /* @__PURE__ */ B(cm, [["render", um], ["__scopeId", "data-v-852a95a9"]]);
var G = /* @__PURE__ */ ((t) => (t.info = "info", t.default = "default", t.primaryInverted = "primary-inverted", t.primary = "primary", t.secondary = "secondary", t.critical = "critical", t.criticalInverted = "critical-inverted", t.warning = "warning", t.success = "success", t.neutral = "neutral", t))(G || {});
const dm = {
  info: "info",
  default: "default",
  primaryInverted: "primary-inverted",
  primary: "primary",
  secondary: "secondary",
  critical: "critical",
  warning: "warning",
  success: "success",
  neutral: "neutral"
}, P$ = [
  "info",
  "primary",
  "critical",
  "warning",
  "success",
  "default"
  /* default */
];
const fm = {
  name: "CLink",
  components: {
    CUi: we
  },
  props: {
    intent: {
      type: String,
      required: !1,
      default: G.primary,
      validate: (t) => [
        G.primary,
        G.secondary,
        G.critical
      ].includes(t)
    },
    label: {
      required: !1,
      default: "",
      type: String
    }
  },
  computed: {
    linkClassProperty() {
      return this.intent;
    }
  }
};
function hm(t, e, n, r, a, i) {
  const o = z("c-ui");
  return b(), M("a", {
    class: H(["c-link", i.linkClassProperty])
  }, [
    _e(t.$slots, "default"),
    T(o, { type: "four" }, {
      default: W(() => [
        V(j(n.label), 1)
      ]),
      _: 1
    })
  ], 2);
}
const Uf = /* @__PURE__ */ B(fm, [["render", hm]]);
const kc = (t) => t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2, pm = {
  name: "CAccordion",
  props: {
    status: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  data() {
    return {
      lastTimestamp: null,
      heightToReach: null,
      currentFrame: 0,
      currentHeight: 0,
      animationDuration: 270,
      running: !1,
      observer: null
    };
  },
  computed: {
    accordionStyle() {
      return this.heightToReach === null ? "" : `height:${this.currentHeight}px`;
    }
  },
  watch: {
    status: {
      handler() {
        if (!this.running) {
          this.startAnimating();
          return;
        }
        this.lastTimestamp = null;
      },
      immediate: !1
    }
  },
  mounted() {
    try {
      this.observer = new ResizeObserver(this.getHeight), this.observer.observe(this.$el), this.status && !this.running && this.startAnimating();
    } catch (t) {
      if (this.$logError)
        this.$logError(t);
      else
        throw t;
    }
  },
  beforeUnmount() {
    if (this.observer)
      try {
        this.observer.disconnect();
      } catch (t) {
        if (this.$logError)
          this.$logError(t);
        else
          throw t;
      }
  },
  methods: {
    startAnimating() {
      window.requestAnimationFrame(this.animateFrame);
    },
    getHeight() {
      window.requestAnimationFrame(() => (this.heightToReach = null, this.$nextTick().then(() => {
        var t, e;
        this.heightToReach = ((e = (t = this.$refs) == null ? void 0 : t.accordionOuter) == null ? void 0 : e.offsetHeight) ?? null;
      })));
    },
    animateFrame(t) {
      return this.running = !0, this.status ? this.animateGrow(t) : this.animateShrink(t);
    },
    animateShrink(t) {
      this.lastTimestamp || (this.lastTimestamp = t);
      const e = t - this.lastTimestamp, n = kc(e / this.animationDuration);
      this.currentHeight = this.heightToReach - n * this.heightToReach, e < this.animationDuration ? window.requestAnimationFrame(this.animateFrame) : (this.currentHeight = 0, this.lastTimestamp = null, this.running = !1);
    },
    animateGrow(t) {
      this.lastTimestamp || (this.lastTimestamp = t);
      const e = t - this.lastTimestamp, n = kc(e / this.animationDuration);
      this.currentHeight = n * this.heightToReach, e < this.animationDuration ? window.requestAnimationFrame(this.animateFrame) : (this.currentHeight = this.heightToReach, this.lastTimestamp = null, this.running = !1);
    }
  }
};
function mm(t, e, n, r, a, i) {
  return b(), M("div", {
    ref: "accordionOuter",
    style: Ut(i.accordionStyle)
  }, [
    _e(t.$slots, "default", {}, void 0, !0)
  ], 4);
}
const co = /* @__PURE__ */ B(pm, [["render", mm], ["__scopeId", "data-v-1138814b"]]), Yf = (t) => (In("data-v-7590984d"), t = t(), Nn(), t), gm = {
  key: 0,
  class: "c-full-size"
}, vm = /* @__PURE__ */ Yf(() => /* @__PURE__ */ R("svg", {
  width: "134",
  height: "22",
  viewBox: "0 0 134 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ R("path", {
    d: "M5.64235 8.63207L1 5.96565V14.6049C0.999903 14.8193 1.05655 15.0298 1.16424 15.2155C1.27193 15.4011 1.42686 15.5552 1.61346 15.6624L9.12212 19.9746V14.6286C9.12218 13.4132 8.80064 12.2192 8.18982 11.1666C7.57899 10.114 6.7004 9.23983 5.64235 8.63206V8.63207ZM13.508 7.14936L18.1503 4.48383L10.6293 0.163739C10.4429 0.0564765 10.2313 0 10.0159 0C9.80047 0 9.58888 0.0564765 9.40241 0.163739L1.89374 4.47681L6.54755 7.14935C7.60562 7.75722 8.80592 8.07725 10.0278 8.07725C11.2496 8.07725 12.4499 7.75722 13.508 7.14935V7.14936ZM19 14.6234V5.99809L14.3453 8.67063C13.2873 9.27848 12.4088 10.1526 11.798 11.2052C11.1872 12.2578 10.8656 13.4518 10.8655 14.6672V20L18.3865 15.6799C18.5731 15.573 18.728 15.419 18.8357 15.2335C18.9434 15.048 19.0001 14.8376 19 14.6234Z",
    fill: "#F8A42A"
  }),
  /* @__PURE__ */ R("path", {
    class: "c-bk-logo-name",
    d: "M100.922 8.6527V17.2786C100.918 17.329 100.924 17.3798 100.942 17.4275C100.959 17.4751 100.986 17.5183 101.022 17.5541C101.058 17.5899 101.101 17.6174 101.149 17.6346C101.196 17.6519 101.247 17.6584 101.298 17.6538H101.673C101.723 17.6585 101.774 17.6521 101.822 17.6349C101.869 17.6177 101.913 17.5902 101.949 17.5544C101.984 17.5186 102.012 17.4753 102.029 17.4276C102.046 17.3799 102.053 17.3291 102.048 17.2786V8.6527C102.053 8.60225 102.046 8.55138 102.029 8.50371C102.012 8.45604 101.984 8.41275 101.949 8.37692C101.913 8.34109 101.869 8.3136 101.822 8.29641C101.774 8.27922 101.723 8.27276 101.673 8.27748H101.298C101.247 8.27288 101.196 8.27943 101.149 8.29666C101.101 8.31389 101.058 8.34138 101.022 8.37719C100.986 8.41299 100.959 8.45623 100.942 8.50384C100.924 8.55146 100.918 8.60228 100.922 8.6527ZM67.5948 8.5785V17.3542C67.597 17.433 67.6293 17.5079 67.685 17.5636C67.7407 17.6194 67.8157 17.6516 67.8944 17.6538H69.7327C69.8115 17.6516 69.8864 17.6194 69.9422 17.5636C69.9979 17.5079 70.0302 17.433 70.0324 17.3542V8.5785C70.0302 8.49958 69.998 8.42446 69.9423 8.36851C69.8866 8.31255 69.8116 8.27999 69.7327 8.27748H67.8944C67.8155 8.27999 67.7406 8.31255 67.6849 8.36851C67.6292 8.42446 67.597 8.49958 67.5948 8.5785ZM35.3986 14.372C35.3849 14.5401 35.337 14.7036 35.2579 14.8525C35.1788 15.0014 35.0701 15.1326 34.9385 15.238C34.8068 15.3434 34.6551 15.4208 34.4925 15.4654C34.3299 15.5101 34.1599 15.5211 33.9929 15.4977C33.0744 15.4977 32.6236 15.0287 32.5676 14.372C32.5116 13.4353 32.5116 12.496 32.5676 11.5593C32.6236 10.8466 33.0744 10.435 33.9929 10.435C34.1598 10.4115 34.3297 10.4223 34.4923 10.4668C34.6549 10.5114 34.8066 10.5886 34.9382 10.6939C35.0699 10.7992 35.1786 10.9302 35.2578 11.0791C35.3369 11.2279 35.3848 11.3913 35.3986 11.5593C35.456 12.496 35.456 13.4353 35.3986 14.372ZM37.8361 14.372C37.8935 13.4353 37.8935 12.496 37.8361 11.5593C37.8086 10.6302 37.4222 9.74788 36.7581 9.09759C36.094 8.4473 35.2037 8.07959 34.2743 8.07167C33.8868 8.06048 33.5019 8.13757 33.1486 8.29708C32.8672 8.40909 32.5858 8.31528 32.5858 7.90366V4.71568C32.5856 4.61645 32.5462 4.52132 32.4762 4.45103C32.4062 4.38074 32.3112 4.34099 32.212 4.34045H30.5235C30.4241 4.34094 30.329 4.38063 30.2587 4.45089C30.1884 4.52115 30.1487 4.61631 30.1483 4.71568V17.2786C30.1487 17.378 30.1884 17.4731 30.2587 17.5434C30.329 17.6137 30.4241 17.6533 30.5235 17.6538H31.4615C31.512 17.6518 31.5615 17.639 31.6067 17.6163C31.6518 17.5936 31.6916 17.5616 31.7233 17.5222C31.7774 17.4434 31.8468 17.3762 31.9274 17.3247C32.008 17.2733 32.0981 17.2385 32.1924 17.2226C32.737 17.2226 32.8868 17.8596 34.2743 17.8596C35.2037 17.8517 36.094 17.484 36.7581 16.8337C37.4222 16.1834 37.8086 15.3011 37.8361 14.372ZM44.7371 14.372C44.6433 14.9909 44.2317 15.4221 43.2754 15.4221C42.3374 15.4221 41.9243 15.0287 41.8305 14.372C41.7185 13.4378 41.7185 12.4935 41.8305 11.5593C41.9439 10.8466 42.3374 10.5092 43.2754 10.5092C44.2317 10.5092 44.6433 10.9404 44.7371 11.5593C44.8505 12.4934 44.8505 13.4379 44.7371 14.372ZM47.1746 14.372C47.2684 13.4368 47.2684 12.4945 47.1746 11.5593C47.0695 10.6008 46.6143 9.71485 45.8963 9.07127C45.1783 8.4277 44.248 8.0718 43.2838 8.0718C42.3196 8.0718 41.3893 8.4277 40.6713 9.07127C39.9533 9.71485 39.4981 10.6008 39.393 11.5593C39.2992 12.4945 39.2992 13.4368 39.393 14.372C39.4981 15.3305 39.9533 16.2165 40.6713 16.86C41.3893 17.5036 42.3196 17.8595 43.2838 17.8595C44.248 17.8595 45.1783 17.5036 45.8963 16.86C46.6143 16.2165 47.0695 15.3305 47.1746 14.372ZM54.1498 14.372C54.056 14.9909 53.6444 15.4221 52.6882 15.4221C51.7501 15.4221 51.3371 15.0287 51.2433 14.372C51.1313 13.4378 51.1313 12.4935 51.2433 11.5593C51.3567 10.8466 51.7501 10.5092 52.6882 10.5092C53.6444 10.5092 54.056 10.9404 54.1498 11.5593C54.2632 12.4934 54.2632 13.4379 54.1498 14.372ZM56.5874 14.372C56.6812 13.4368 56.6812 12.4945 56.5874 11.5593C56.4823 10.6008 56.0271 9.71479 55.3091 9.0712C54.5911 8.4276 53.6608 8.07168 52.6966 8.07168C51.7323 8.07168 50.802 8.4276 50.084 9.0712C49.366 9.71479 48.9108 10.6008 48.8057 11.5593C48.7119 12.4945 48.7119 13.4368 48.8057 14.372C48.9108 15.3305 49.366 16.2165 50.084 16.8601C50.802 17.5037 51.7323 17.8596 52.6966 17.8596C53.6608 17.8596 54.5911 17.5037 55.3091 16.8601C56.0271 16.2165 56.4823 15.3305 56.5874 14.372ZM66.0939 17.035L63.0375 12.9285C62.8513 12.6849 62.8513 12.5715 63.0193 12.3657L65.8139 8.89632C65.861 8.84066 65.8909 8.77251 65.9 8.70016C65.9091 8.62781 65.8969 8.55438 65.8651 8.48881C65.8332 8.42324 65.7829 8.36835 65.7204 8.33083C65.6578 8.29331 65.5858 8.27478 65.5129 8.27748H63.6564C63.5633 8.27027 63.4701 8.28944 63.3874 8.33277C63.3046 8.3761 63.2358 8.44185 63.1888 8.52249L61.013 11.3157C61.0011 11.3342 60.9834 11.3483 60.9627 11.356C60.942 11.3636 60.9194 11.3643 60.8982 11.358C60.8771 11.3517 60.8586 11.3387 60.8454 11.321C60.8323 11.3032 60.8253 11.2817 60.8254 11.2597V4.71568C60.8252 4.61624 60.7856 4.52094 60.7152 4.45063C60.6449 4.38032 60.5496 4.34071 60.4502 4.34045H58.7631C58.6637 4.34094 58.5686 4.38063 58.4983 4.45089C58.4281 4.52115 58.3884 4.61631 58.3879 4.71568V17.2786C58.3884 17.378 58.4281 17.4731 58.4983 17.5434C58.5686 17.6137 58.6637 17.6533 58.7631 17.6538H60.4502C60.5496 17.6536 60.6449 17.614 60.7153 17.5436C60.7856 17.4733 60.8252 17.378 60.8254 17.2786V14.1844C60.8255 14.1624 60.8326 14.1411 60.8457 14.1234C60.8589 14.1058 60.8773 14.0929 60.8984 14.0866C60.9195 14.0803 60.942 14.081 60.9626 14.0885C60.9833 14.0961 61.001 14.1101 61.013 14.1284L63.3568 17.3724C63.4054 17.4586 63.4762 17.5302 63.5619 17.5797C63.6476 17.6292 63.745 17.6548 63.844 17.6538H65.7943C65.8682 17.6592 65.942 17.6422 66.0061 17.6052C66.0702 17.5681 66.1218 17.5127 66.154 17.446C66.1863 17.3794 66.1978 17.3046 66.1871 17.2313C66.1764 17.158 66.1439 17.0896 66.0939 17.035ZM70.1262 6.66599V4.64007C70.1239 4.56131 70.0917 4.48637 70.036 4.43066C69.9802 4.37494 69.9053 4.34266 69.8265 4.34045H67.8006C67.7219 4.34266 67.6469 4.37494 67.5912 4.43066C67.5355 4.48637 67.5032 4.56131 67.501 4.64007V6.66599C67.5006 6.70545 67.508 6.74461 67.5229 6.78115C67.5379 6.81769 67.5599 6.85089 67.5878 6.8788C67.6157 6.90671 67.6489 6.92876 67.6855 6.94367C67.722 6.95857 67.7612 6.96603 67.8006 6.96561H69.8265C69.866 6.96603 69.9052 6.95857 69.9417 6.94367C69.9782 6.92876 70.0114 6.90671 70.0394 6.8788C70.0673 6.85089 70.0893 6.81769 70.1042 6.78115C70.1191 6.74461 70.1266 6.70545 70.1262 6.66599ZM80.0639 17.2786V11.5593C80.0732 11.1003 79.99 10.6441 79.8191 10.2179C79.6483 9.7918 79.3934 9.40443 79.0696 9.07895C78.7458 8.75346 78.3598 8.49653 77.9346 8.32347C77.5093 8.15041 77.0536 8.06477 76.5945 8.07167C75.4703 8.07167 75.0768 8.72831 74.5322 8.72831C74.2704 8.72831 74.1766 8.5407 74.0268 8.40909C73.9831 8.36442 73.9305 8.32958 73.8723 8.30688C73.8141 8.28419 73.7517 8.27416 73.6894 8.27748H72.7513C72.6519 8.27797 72.5568 8.31765 72.4865 8.38792C72.4163 8.45818 72.3766 8.55334 72.3761 8.6527V17.2786C72.3766 17.378 72.4163 17.4731 72.4865 17.5434C72.5568 17.6136 72.6519 17.6533 72.7513 17.6538H74.4384C74.5378 17.6536 74.6331 17.614 74.7035 17.5436C74.7738 17.4733 74.8134 17.378 74.8136 17.2786V11.4655C74.8136 10.9026 75.3387 10.435 76.2207 10.435C77.1196 10.435 77.6264 10.9222 77.6264 11.5411V17.2786C77.6269 17.378 77.6666 17.4731 77.7368 17.5434C77.8071 17.6136 77.9022 17.6533 78.0016 17.6538H79.6887C79.7882 17.6536 79.8834 17.614 79.9538 17.5436C80.0241 17.4733 80.0637 17.378 80.0639 17.2786ZM87.2085 14.372C87.1511 15.0287 86.7017 15.4977 85.7833 15.4977C85.6162 15.521 85.4462 15.5099 85.2835 15.4652C85.1209 15.4205 84.9691 15.3432 84.8374 15.2378C84.7057 15.1324 84.5969 15.0013 84.5176 14.8524C84.4383 14.7036 84.3901 14.5401 84.3762 14.372C84.3202 13.4353 84.3202 12.496 84.3762 11.5593C84.3902 11.3913 84.4383 11.2279 84.5177 11.0791C84.597 10.9303 84.7059 10.7993 84.8376 10.6941C84.9693 10.5889 85.1211 10.5116 85.2837 10.467C85.4463 10.4225 85.6163 10.4116 85.7833 10.435C86.7017 10.435 87.1511 10.8466 87.2085 11.5593C87.2646 12.496 87.2646 13.4353 87.2085 14.372ZM89.6265 18.2167V8.6527C89.6262 8.55326 89.5866 8.45797 89.5163 8.38766C89.446 8.31735 89.3507 8.27773 89.2513 8.27748H88.3146C88.264 8.27978 88.2144 8.29268 88.169 8.31535C88.1237 8.33802 88.0836 8.36996 88.0514 8.40909C87.9976 8.48808 87.9285 8.55544 87.8482 8.60716C87.7679 8.65887 87.6779 8.69388 87.5838 8.7101C87.0391 8.7101 86.8893 8.07167 85.5019 8.07167C84.5722 8.07954 83.6818 8.44718 83.0175 9.09745C82.3531 9.74772 81.9664 10.63 81.9386 11.5593C81.8827 12.496 81.8827 13.4353 81.9386 14.372C81.9664 15.3013 82.3531 16.1836 83.0175 16.8339C83.6818 17.4841 84.5722 17.8518 85.5019 17.8596C85.8879 17.8622 86.2705 17.786 86.6261 17.6356C86.9831 17.504 87.1889 17.6538 87.1889 18.029V18.2167C87.1872 18.3899 87.1496 18.561 87.0785 18.719C87.0074 18.877 86.9044 19.0186 86.7759 19.1349C86.6474 19.2511 86.4962 19.3396 86.3319 19.3945C86.1676 19.4495 85.9936 19.4699 85.8211 19.4543C85.0706 19.4543 84.6016 19.0973 84.5078 18.6479C84.4518 18.3847 84.47 18.2167 84.0206 18.2167H82.6135C82.5142 18.2169 82.4191 18.2566 82.349 18.327C82.2789 18.3973 82.2396 18.4926 82.2397 18.5919C82.2771 19.0382 82.4026 19.4727 82.6089 19.8703C82.8152 20.2679 83.0982 20.6206 83.4417 20.9082C83.7851 21.1957 84.182 21.4124 84.6097 21.5457C85.0373 21.679 85.4871 21.7262 85.9331 21.6847C86.4043 21.7037 86.8746 21.6286 87.3166 21.4639C87.7585 21.2991 88.1632 21.048 88.507 20.7252C88.8509 20.4023 89.1269 20.0142 89.3191 19.5835C89.5113 19.1528 89.6158 18.6882 89.6265 18.2167ZM98.748 16.9972L94.3602 13.0042C94.3234 12.9791 94.2934 12.9455 94.2726 12.9062C94.2518 12.8669 94.241 12.8232 94.241 12.7787C94.241 12.7343 94.2518 12.6905 94.2726 12.6512C94.2934 12.612 94.3234 12.5783 94.3602 12.5533L98.4666 8.89632C98.5223 8.84717 98.5612 8.78175 98.5777 8.7093C98.5942 8.63685 98.5875 8.56104 98.5585 8.49261C98.5296 8.42418 98.4799 8.36658 98.4164 8.32797C98.3529 8.28937 98.2789 8.2717 98.2048 8.27748H97.8674C97.7673 8.27791 97.6686 8.30004 97.5779 8.34234C97.4873 8.38464 97.4069 8.44611 97.3423 8.52249L93.5733 11.8407C93.4977 11.8967 93.4221 11.8967 93.4221 11.8029V4.77168C93.4219 4.67246 93.3825 4.57733 93.3125 4.50704C93.2425 4.43675 93.1475 4.397 93.0483 4.39646H92.6913C92.5919 4.39694 92.4967 4.43663 92.4265 4.50689C92.3562 4.57715 92.3165 4.67231 92.316 4.77168V17.2786C92.3165 17.378 92.3562 17.4731 92.4265 17.5434C92.4967 17.6137 92.5919 17.6533 92.6913 17.6538H93.0483C93.1475 17.6533 93.2425 17.6135 93.3125 17.5432C93.3825 17.473 93.4219 17.3778 93.4221 17.2786V13.7728C93.4221 13.679 93.5159 13.679 93.5733 13.735L97.5481 17.3724C97.6181 17.4548 97.7041 17.5223 97.8008 17.5706C97.8975 17.619 98.003 17.6473 98.111 17.6538H98.4848C98.5638 17.6608 98.643 17.6421 98.7106 17.6006C98.7782 17.559 98.8306 17.4968 98.8601 17.4232C98.8897 17.3496 98.8947 17.2684 98.8745 17.1917C98.8543 17.1149 98.81 17.0467 98.748 16.9972ZM102.254 5.69013V4.69607C102.252 4.61723 102.22 4.54215 102.164 4.48638C102.108 4.43061 102.033 4.39842 101.954 4.39646H100.98C100.901 4.39837 100.825 4.43051 100.769 4.48625C100.713 4.54199 100.681 4.61709 100.679 4.69607V5.69013C100.678 5.72981 100.686 5.76919 100.701 5.80595C100.715 5.84272 100.738 5.87611 100.766 5.90417C100.794 5.93223 100.827 5.95438 100.864 5.96932C100.901 5.98426 100.94 5.99168 100.98 5.99115H101.954C101.994 5.99166 102.033 5.9842 102.07 5.96924C102.106 5.95427 102.14 5.9321 102.168 5.90402C102.196 5.87595 102.218 5.84255 102.232 5.80581C102.247 5.76907 102.255 5.72973 102.254 5.69013ZM111.795 14.8411C111.795 14.7417 111.755 14.6465 111.685 14.5763C111.615 14.506 111.52 14.4663 111.42 14.4658H111.027C110.927 14.4663 110.832 14.506 110.762 14.5763C110.692 14.6465 110.652 14.7417 110.651 14.8411C110.672 15.0798 110.643 15.3203 110.566 15.5471C110.488 15.774 110.365 15.9822 110.202 16.1586C110.04 16.335 109.843 16.4756 109.623 16.5715C109.403 16.6675 109.166 16.7166 108.927 16.7158C108.671 16.7079 108.419 16.647 108.188 16.5368C107.956 16.4266 107.751 16.2696 107.583 16.0757C107.416 15.8819 107.29 15.6554 107.215 15.4105C107.14 15.1657 107.116 14.9079 107.146 14.6534V9.66636C107.144 9.64141 107.148 9.61638 107.156 9.59295C107.165 9.56951 107.179 9.54821 107.196 9.53046C107.214 9.51271 107.235 9.49891 107.259 9.49C107.282 9.48108 107.307 9.47725 107.332 9.47875H110.446C110.545 9.47827 110.64 9.43859 110.71 9.36832C110.781 9.29806 110.82 9.2029 110.821 9.10353V8.74651C110.82 8.64714 110.781 8.55197 110.71 8.4817C110.64 8.41144 110.545 8.37175 110.446 8.37129H107.332C107.307 8.37283 107.282 8.36907 107.259 8.36026C107.236 8.35145 107.214 8.33779 107.197 8.32018C107.179 8.30257 107.166 8.28141 107.157 8.25812C107.148 8.23483 107.144 8.20993 107.146 8.18507V5.27851C107.145 5.17907 107.106 5.08377 107.036 5.01345C106.965 4.94314 106.87 4.90353 106.77 4.90329H106.395C106.296 4.90353 106.201 4.94314 106.13 5.01345C106.06 5.08377 106.02 5.17907 106.02 5.27851V8.18507C106.021 8.21001 106.018 8.23496 106.009 8.25827C106 8.28159 105.986 8.30274 105.968 8.32033C105.95 8.33793 105.929 8.35156 105.906 8.36035C105.882 8.36913 105.857 8.37286 105.832 8.37129H104.774C104.675 8.37152 104.579 8.41113 104.509 8.48144C104.439 8.55176 104.399 8.64706 104.399 8.74651V9.10353C104.399 9.20297 104.439 9.29826 104.509 9.36858C104.579 9.43889 104.675 9.47851 104.774 9.47875H105.832C105.857 9.47722 105.883 9.48102 105.906 9.4899C105.929 9.49879 105.951 9.51256 105.968 9.53029C105.986 9.54803 106 9.56933 106.009 9.59279C106.018 9.61625 106.022 9.64132 106.02 9.66636V14.8411C106.011 15.2298 106.079 15.6165 106.22 15.9786C106.362 16.3407 106.574 16.671 106.845 16.9503C107.115 17.2296 107.439 17.4522 107.796 17.6052C108.153 17.7582 108.538 17.8385 108.927 17.8414C109.313 17.8376 109.696 17.7563 110.05 17.6025C110.405 17.4487 110.726 17.2254 110.993 16.9458C111.261 16.6662 111.469 16.336 111.607 15.9745C111.745 15.613 111.809 15.2277 111.795 14.8411Z"
  })
], -1)), ym = [
  vm
], bm = { key: 1 }, _m = /* @__PURE__ */ Yf(() => /* @__PURE__ */ R("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ R("path", {
    d: "M5.64235 8.63207L1 5.96565V14.6049C0.999903 14.8193 1.05655 15.0298 1.16424 15.2155C1.27193 15.4011 1.42686 15.5552 1.61346 15.6624L9.12212 19.9746V14.6286C9.12218 13.4132 8.80064 12.2192 8.18982 11.1666C7.57899 10.114 6.7004 9.23983 5.64235 8.63206V8.63207ZM13.508 7.14936L18.1503 4.48383L10.6293 0.163739C10.4429 0.0564765 10.2313 0 10.0159 0C9.80047 0 9.58888 0.0564765 9.40241 0.163739L1.89374 4.47681L6.54755 7.14935C7.60562 7.75722 8.80592 8.07725 10.0278 8.07725C11.2496 8.07725 12.4499 7.75722 13.508 7.14935V7.14936ZM19 14.6234V5.99809L14.3453 8.67063C13.2873 9.27848 12.4088 10.1526 11.798 11.2052C11.1872 12.2578 10.8656 13.4518 10.8655 14.6672V20L18.3865 15.6799C18.5731 15.573 18.728 15.419 18.8357 15.2335C18.9434 15.048 19.0001 14.8376 19 14.6234Z",
    fill: "#F8A42A"
  })
], -1)), wm = [
  _m
], km = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    complete: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, n) => t.complete ? (b(), M("span", gm, ym)) : (b(), M("span", bm, wm));
  }
});
const Xf = /* @__PURE__ */ B(km, [["__scopeId", "data-v-7590984d"]]);
const xm = {}, Cm = /* @__PURE__ */ Tl('<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-ead5ebf8><path d="M12.5527 18.0911C11.8003 18.8777 10.7682 19.336 9.68009 19.3669C8.59202 19.3977 7.53563 18.9985 6.73989 18.2557C7.12574 18.2088 7.48363 18.0303 7.75331 17.7504C8.02299 17.4705 8.18798 17.1062 8.22051 16.7189C8.27473 16.25 8.19884 15.7753 8.00116 15.3467L4.65608 11.8887C4.23947 11.655 3.75962 11.5589 3.28514 11.6143C2.89318 11.6592 2.528 11.8356 2.24916 12.1147C1.97031 12.3938 1.79425 12.7591 1.74969 13.1511C1.03083 12.3002 0.650298 11.2145 0.680639 10.1009C0.71098 8.98741 1.15007 7.92401 1.9142 7.11347C2.35729 6.65576 2.89833 6.30438 3.49668 6.08574C4.09504 5.86709 4.73516 5.78686 5.36896 5.85106C5.94587 5.93367 6.50315 6.1196 7.01408 6.39994L13.2656 12.8218C13.5541 13.3493 13.7401 13.9266 13.8139 14.5233C13.8658 15.1732 13.7804 15.8268 13.5631 16.4415C13.3458 17.0561 13.0015 17.6182 12.5527 18.0911Z" fill="#007AA9" data-v-ead5ebf8></path><path d="M12.7174 8.97978C13.7168 8.97978 14.527 8.14426 14.527 7.11359C14.527 6.08293 13.7168 5.24741 12.7174 5.24741C11.7179 5.24741 10.9077 6.08293 10.9077 7.11359C10.9077 8.14426 11.7179 8.97978 12.7174 8.97978Z" fill="#F8A42A" data-v-ead5ebf8></path><path d="M14.9657 11.3399C16.4899 9.76225 17.6504 7.87008 18.3656 5.79624C17.432 5.21957 16.5673 4.53822 15.7882 3.76541C15.3939 3.37049 15.0274 2.94867 14.6915 2.50299C14.4173 2.06388 14.0883 1.67967 13.8689 1.24057C11.8769 1.98365 10.0777 3.16549 8.60452 4.6985C6.6918 6.67773 5.36335 9.14712 4.7659 11.8339C4.24617 11.9244 3.76723 12.1737 3.39497 12.5475C3.11999 12.8882 2.915 13.2799 2.79175 13.7001V13.755C2.79175 13.8099 2.62724 14.4685 2.51756 15.237C2.29822 16.6641 2.40789 17.1032 2.68208 17.3227C2.95627 17.5423 3.34012 17.652 4.76591 17.3776C5.53363 17.2678 6.24652 17.1032 6.24652 17.1032H6.30137C6.7387 16.9942 7.1373 16.7662 7.45296 16.4445C7.75866 16.1248 7.96777 15.7253 8.05617 15.2919C10.7055 14.7024 13.1144 13.3247 14.9657 11.3399ZM12.7173 9.96774C12.3527 9.96333 11.9926 9.88715 11.6574 9.74355C11.3223 9.59995 11.0187 9.39174 10.764 9.13082C10.5093 8.86989 10.3085 8.56135 10.173 8.22282C10.0376 7.88429 9.97015 7.52239 9.97456 7.1578L9.97545 7.11357C9.96102 6.7535 10.0177 6.39411 10.1421 6.05593C10.2666 5.71775 10.4564 5.40739 10.7008 5.14258C10.9453 4.87777 11.2394 4.66369 11.5666 4.51257C11.8937 4.36145 12.2474 4.27624 12.6075 4.26182C13.3347 4.23268 14.0437 4.49361 14.5785 4.98722C15.1133 5.48082 15.4301 6.16665 15.4592 6.89385C15.4622 6.96706 15.4622 7.04031 15.4592 7.11357C15.4706 7.85466 15.189 8.57029 14.6755 9.10478C14.162 9.63928 13.4583 9.94942 12.7173 9.96774Z" fill="#F8A42A" data-v-ead5ebf8></path><path d="M14.5166 0.869477C14.7222 1.27621 15.0307 1.6321 15.2878 2.03883C15.603 2.45197 15.9465 2.8427 16.316 3.20818C17.0474 3.92488 17.858 4.55598 18.7322 5.08933C19.3046 3.45511 19.6 1.73675 19.6062 0.00519024C17.8694 -0.0434536 16.14 0.250223 14.5166 0.869477Z" fill="#007AA9" data-v-ead5ebf8></path></svg>', 1), Pm = [
  Cm
];
function Sm(t, e) {
  return b(), M("span", null, Pm);
}
const Mm = /* @__PURE__ */ B(xm, [["render", Sm], ["__scopeId", "data-v-ead5ebf8"]]);
const Om = {}, Dm = /* @__PURE__ */ Tl('<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-e5af8591><path d="M8.33333 2.5H2.5V8.33333H8.33333V2.5Z" fill="#FF6D00" stroke="#FF6D00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-v-e5af8591></path><path d="M17.5 2.5H11.6667V8.33333H17.5V2.5Z" fill="#FF9100" stroke="#FF9100" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-v-e5af8591></path><path d="M8.33333 11.6667H2.5V17.5H8.33333V11.6667Z" fill="#FF3C00" stroke="#FF3C00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-v-e5af8591></path><line x1="14.5" y1="11.5833" x2="14.5" y2="17.5833" stroke="#F8A42A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-v-e5af8591></line><line x1="11.5833" y1="14.6667" x2="17.5833" y2="14.6667" stroke="#F8A42A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-v-e5af8591></line></svg>', 1), Tm = [
  Dm
];
function $m(t, e) {
  return b(), M("span", null, Tm);
}
const Rm = /* @__PURE__ */ B(Om, [["render", $m], ["__scopeId", "data-v-e5af8591"]]);
const Em = {
  name: "CAvatar",
  props: {
    name: {
      type: String,
      required: !1,
      default: void 0
    },
    url: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  data() {
    return {
      isReady: !1,
      imageWidth: 0,
      intersectionObserver: null,
      showImageINT: !1
    };
  },
  computed: {
    avatarBackground() {
      return this.url && this.isReady && this.showImageINT ? `background: url(${encodeURI(this.getImageUrl)}); background-size: cover; background-repeat: no-repeat;` : "";
    },
    getImageUrl() {
      return `${this.url}?${this.name}`;
    },
    stringAvatar() {
      return this.name ? this.name.charAt(0) : "";
    }
  },
  mounted() {
    try {
      this.intersectionObserver = new IntersectionObserver((t) => {
        var e;
        this.showImageINT = (e = t[0]) == null ? void 0 : e.isIntersecting;
      }, { root: null }), this.intersectionObserver.observe(this.$el);
    } catch (t) {
      this.$logError && this.$logError(t), this.showImageINT = !0;
    }
  },
  beforeUnmount() {
    if (this.intersectionObserver)
      try {
        this.intersectionObserver.disconnect();
      } catch (t) {
        this.$logError && this.$logError(t);
      }
  },
  methods: {
    showImage() {
      this.isReady = !0;
    }
  }
}, Am = { class: "c-avatar" }, Lm = ["src"];
function Im(t, e, n, r, a, i) {
  return b(), M("div", Am, [
    R("h5", null, j(i.stringAvatar), 1),
    R("div", {
      style: Ut(i.avatarBackground),
      class: H(["c-avatar-image", { hide: !a.isReady }])
    }, null, 6),
    n.url && a.showImageINT ? (b(), M("img", {
      key: 0,
      "aria-hidden": "true",
      loading: "lazy",
      src: i.getImageUrl,
      onLoad: e[0] || (e[0] = (...o) => i.showImage && i.showImage(...o))
    }, null, 40, Lm)) : E("", !0)
  ]);
}
const Kf = /* @__PURE__ */ B(Em, [["render", Im], ["__scopeId", "data-v-87bc956a"]]), Nm = () => Object.values(dm), Wm = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    value: null,
    intent: { default: G.default }
  },
  setup(t) {
    const e = t, n = I(() => e.value ? e.value : ""), r = I(() => {
      const a = Nm();
      return e.intent && a.includes(e.intent) ? `c-${e.intent}` : `c-${G.default}`;
    });
    return (a, i) => (b(), M("span", {
      class: H(S(r))
    }, [
      T(S(rm), { type: "two" }, {
        default: W(() => [
          V(j(S(n)), 1)
        ]),
        _: 1
      })
    ], 2));
  }
});
const ur = /* @__PURE__ */ B(Wm, [["__scopeId", "data-v-9a0a37c5"]]), zm = {
  key: 0,
  class: "media-slot"
}, Bm = {
  key: 2,
  class: "additional-info-slot"
}, Fm = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    tabColor: { default: "#DFDFDF" },
    showTab: { type: Boolean, default: !0 }
  },
  setup(t) {
    const e = t;
    so((o) => ({
      "580ee4d8": t.tabColor
    }));
    const n = Ff(), r = I(() => typeof n != "object" ? [] : Object.keys(n)), a = I(() => r.value.includes("media")), i = I(() => r.value.includes("additional-info"));
    return (o, s) => (b(), M("div", {
      class: H([{ "with-tab": e.showTab }, "c-card-container c-layer-elevated"])
    }, [
      S(a) ? (b(), M("div", zm, [
        _e(o.$slots, "media", {}, void 0, !0)
      ])) : E("", !0),
      _e(o.$slots, "default", {}, void 0, !0),
      S(i) ? (b(), L(lo, {
        key: 1,
        vertical: !0
      })) : E("", !0),
      S(i) ? (b(), M("div", Bm, [
        _e(o.$slots, "additional-info", {}, void 0, !0)
      ])) : E("", !0)
    ], 2));
  }
});
const S$ = /* @__PURE__ */ B(Fm, [["__scopeId", "data-v-eff44ce7"]]), Xr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
var Hm = ["size", "color"];
function Uo() {
  return Uo = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Uo.apply(this, arguments);
}
function jm(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
var Vm = function(e) {
  return e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}, qm = function(e, n) {
  return function(r, a) {
    var i = r.size, o = r.color, s = jm(r, Hm), l = a.attrs;
    a.emit;
    var c = a.slots;
    return wc("svg", Uo({}, Xr, {
      width: i || Xr.width,
      height: i || Xr.height,
      stroke: o || Xr.stroke
    }, l, {
      class: ["lucide", "lucide-" + Vm(e), (l == null ? void 0 : l.class) || ""]
    }, s), [].concat(n.map(function(u) {
      return wc.apply(void 0, u);
    }), c.default ? [c.default()] : []));
  };
};
const J = qm;
var Um = J("AlertCircleIcon", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["line", {
  x1: "12",
  y1: "8",
  x2: "12",
  y2: "12",
  key: "1grbh0"
}], ["line", {
  x1: "12",
  y1: "16",
  x2: "12.01",
  y2: "16",
  key: "1w440g"
}]]);
const Yo = Um;
var Ym = J("AlertTriangleIcon", [["path", {
  d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z",
  key: "c3ski4"
}], ["line", {
  x1: "12",
  y1: "9",
  x2: "12",
  y2: "13",
  key: "mb7vjk"
}], ["line", {
  x1: "12",
  y1: "17",
  x2: "12.01",
  y2: "17",
  key: "kdstpg"
}]]);
const Qf = Ym;
var Xm = J("BellIcon", [["path", {
  d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9",
  key: "oql5b8"
}], ["path", {
  d: "M13.73 21a2 2 0 0 1-3.46 0",
  key: "6o5tke"
}]]);
const Km = Xm;
var Qm = J("BoxIcon", [["path", {
  d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
  key: "yt0hxn"
}], ["polyline", {
  points: "3.29 7 12 12 20.71 7",
  key: "ousv84"
}], ["line", {
  x1: "12",
  y1: "22",
  x2: "12",
  y2: "12",
  key: "gdv6h4"
}]]);
const Gm = Qm;
var Zm = J("CalendarIcon", [["rect", {
  x: "3",
  y: "4",
  width: "18",
  height: "18",
  rx: "2",
  ry: "2",
  key: "1dtxiw"
}], ["line", {
  x1: "16",
  y1: "2",
  x2: "16",
  y2: "6",
  key: "18saeg"
}], ["line", {
  x1: "8",
  y1: "2",
  x2: "8",
  y2: "6",
  key: "1u51jw"
}], ["line", {
  x1: "3",
  y1: "10",
  x2: "21",
  y2: "10",
  key: "6sq0yj"
}]]);
const uo = Zm;
var Jm = J("CheckCircleIcon", [["path", {
  d: "M22 11.08V12a10 10 0 1 1-5.93-9.14",
  key: "g774vq"
}], ["polyline", {
  points: "22 4 12 14.01 9 11.01",
  key: "6xbx8j"
}]]);
const Gf = Jm;
var eg = J("CheckIcon", [["polyline", {
  points: "20 6 9 17 4 12",
  key: "10jjfj"
}]]);
const tg = eg;
var ng = J("ChevronDownIcon", [["polyline", {
  points: "6 9 12 15 18 9",
  key: "1do0m2"
}]]);
const fo = ng;
var rg = J("ChevronLeftIcon", [["polyline", {
  points: "15 18 9 12 15 6",
  key: "kvxz59"
}]]);
const ho = rg;
var ag = J("ChevronRightIcon", [["polyline", {
  points: "9 18 15 12 9 6",
  key: "1rtp27"
}]]);
const po = ag;
var ig = J("ChevronUpIcon", [["polyline", {
  points: "18 15 12 9 6 15",
  key: "1uugdp"
}]]);
const mo = ig;
var og = J("ClipboardCheckIcon", [["rect", {
  x: "8",
  y: "2",
  width: "8",
  height: "4",
  rx: "1",
  ry: "1",
  key: "wz2j3u"
}], ["path", {
  d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
  key: "116196"
}], ["path", {
  d: "m9 14 2 2 4-4",
  key: "df797q"
}]]);
const sg = og;
var lg = J("ClipboardCopyIcon", [["rect", {
  x: "8",
  y: "2",
  width: "8",
  height: "4",
  rx: "1",
  ry: "1",
  key: "wz2j3u"
}], ["path", {
  d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2",
  key: "4jdomd"
}], ["path", {
  d: "M16 4h2a2 2 0 0 1 2 2v4",
  key: "3hqy98"
}], ["path", {
  d: "M21 14H11",
  key: "1bme5i"
}], ["path", {
  d: "m15 10-4 4 4 4",
  key: "5dvupr"
}]]);
const cg = lg;
var ug = J("ClipboardXIcon", [["rect", {
  x: "8",
  y: "2",
  width: "8",
  height: "4",
  rx: "1",
  ry: "1",
  key: "wz2j3u"
}], ["path", {
  d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
  key: "116196"
}], ["path", {
  d: "m15 11-6 6",
  key: "1toa9n"
}], ["path", {
  d: "m9 11 6 6",
  key: "wlibny"
}]]);
const dg = ug;
var fg = J("ClockIcon", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["polyline", {
  points: "12 6 12 12 16 14",
  key: "68esgv"
}]]);
const hg = fg;
var pg = J("CompassIcon", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["polygon", {
  points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76",
  key: "m9r19z"
}]]);
const mg = pg;
var gg = J("DeleteIcon", [["path", {
  d: "M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z",
  key: "1oy587"
}], ["line", {
  x1: "18",
  y1: "9",
  x2: "12",
  y2: "15",
  key: "1328vg"
}], ["line", {
  x1: "12",
  y1: "9",
  x2: "18",
  y2: "15",
  key: "6xbiik"
}]]);
const vg = gg;
var yg = J("DollarSignIcon", [["line", {
  x1: "12",
  y1: "2",
  x2: "12",
  y2: "22",
  key: "1k6o5o"
}], ["path", {
  d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
  key: "1b0p4s"
}]]);
const bg = yg;
var _g = J("EditIcon", [["path", {
  d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
  key: "1qinfi"
}], ["path", {
  d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z",
  key: "1cs3r3"
}]]);
const wg = _g;
var kg = J("HelpCircleIcon", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["path", {
  d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
  key: "1u773s"
}], ["line", {
  x1: "12",
  y1: "17",
  x2: "12.01",
  y2: "17",
  key: "kdstpg"
}]]);
const xg = kg;
var Cg = J("InboxIcon", [["polyline", {
  points: "22 12 16 12 14 15 10 15 8 12 2 12",
  key: "o97t9d"
}], ["path", {
  d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
  key: "oot6mr"
}]]);
const Pg = Cg;
var Sg = J("InfoIcon", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["line", {
  x1: "12",
  y1: "16",
  x2: "12",
  y2: "12",
  key: "dkqlv3"
}], ["line", {
  x1: "12",
  y1: "8",
  x2: "12.01",
  y2: "8",
  key: "1kl4hv"
}]]);
const Zf = Sg;
var Mg = J("KeyIcon", [["path", {
  d: "m21 2-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0 3 3L22 7l-3-3m-3.5 3.5L19 4",
  key: "1b7wfm"
}]]);
const Og = Mg;
var Dg = J("LayoutDashboardIcon", [["rect", {
  x: "3",
  y: "3",
  width: "7",
  height: "9",
  key: "1eurd7"
}], ["rect", {
  x: "14",
  y: "3",
  width: "7",
  height: "5",
  key: "zff5ux"
}], ["rect", {
  x: "14",
  y: "12",
  width: "7",
  height: "9",
  key: "1oiq0r"
}], ["rect", {
  x: "3",
  y: "16",
  width: "7",
  height: "5",
  key: "1145ac"
}]]);
const Tg = Dg;
var $g = J("LightbulbIcon", [["line", {
  x1: "9",
  y1: "18",
  x2: "15",
  y2: "18",
  key: "poumom"
}], ["line", {
  x1: "10",
  y1: "22",
  x2: "14",
  y2: "22",
  key: "1oekqc"
}], ["path", {
  d: "M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14",
  key: "a9yf0y"
}]]);
const Rg = $g;
var Eg = J("MenuIcon", [["line", {
  x1: "4",
  y1: "12",
  x2: "20",
  y2: "12",
  key: "1q6rtp"
}], ["line", {
  x1: "4",
  y1: "6",
  x2: "20",
  y2: "6",
  key: "1jr6gt"
}], ["line", {
  x1: "4",
  y1: "18",
  x2: "20",
  y2: "18",
  key: "98tuvx"
}]]);
const Ag = Eg;
var Lg = J("MinusIcon", [["line", {
  x1: "5",
  y1: "12",
  x2: "19",
  y2: "12",
  key: "1smlys"
}]]);
const Ig = Lg;
var Ng = J("MoonIcon", [["path", {
  d: "M12 3a6.364 6.364 0 0 0 9 9 9 9 0 1 1-9-9Z",
  key: "1rit1i"
}]]);
const Wg = Ng;
var zg = J("NetworkIcon", [["rect", {
  x: "9",
  y: "2",
  width: "6",
  height: "6",
  key: "1iwon9"
}], ["rect", {
  x: "16",
  y: "16",
  width: "6",
  height: "6",
  key: "gonbwd"
}], ["rect", {
  x: "2",
  y: "16",
  width: "6",
  height: "6",
  key: "1q0lzr"
}], ["path", {
  d: "M5 16v-4h14v4",
  key: "8njgxx"
}], ["path", {
  d: "M12 12V8",
  key: "2874zd"
}]]);
const Bg = zg;
var Fg = J("PieChartIcon", [["path", {
  d: "M21.21 15.89A10 10 0 1 1 8 2.83",
  key: "k2fpak"
}], ["path", {
  d: "M22 12A10 10 0 0 0 12 2v10z",
  key: "1rfc4y"
}]]);
const Hg = Fg;
var jg = J("PlusIcon", [["line", {
  x1: "12",
  y1: "5",
  x2: "12",
  y2: "19",
  key: "myz83a"
}], ["line", {
  x1: "5",
  y1: "12",
  x2: "19",
  y2: "12",
  key: "1smlys"
}]]);
const Jf = jg;
var Vg = J("SearchIcon", [["circle", {
  cx: "11",
  cy: "11",
  r: "8",
  key: "4ej97u"
}], ["line", {
  x1: "21",
  y1: "21",
  x2: "16.65",
  y2: "16.65",
  key: "1p50m8"
}]]);
const eh = Vg;
var qg = J("SettingsIcon", [["path", {
  d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
  key: "1qme2f"
}], ["circle", {
  cx: "12",
  cy: "12",
  r: "3",
  key: "1v7zrd"
}]]);
const Ug = qg;
var Yg = J("SunIcon", [["circle", {
  cx: "12",
  cy: "12",
  r: "4",
  key: "4exip2"
}], ["path", {
  d: "M12 2v2",
  key: "tus03m"
}], ["path", {
  d: "M12 20v2",
  key: "1lh1kg"
}], ["path", {
  d: "m4.93 4.93 1.41 1.41",
  key: "149t6j"
}], ["path", {
  d: "m17.66 17.66 1.41 1.41",
  key: "ptbguv"
}], ["path", {
  d: "M2 12h2",
  key: "1t8f8n"
}], ["path", {
  d: "M20 12h2",
  key: "1q8mjw"
}], ["path", {
  d: "m6.34 17.66-1.41 1.41",
  key: "1m8zz5"
}], ["path", {
  d: "m19.07 4.93-1.41 1.41",
  key: "1shlcs"
}]]);
const Xg = Yg;
var Kg = J("TargetIcon", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["circle", {
  cx: "12",
  cy: "12",
  r: "6",
  key: "1vlfrh"
}], ["circle", {
  cx: "12",
  cy: "12",
  r: "2",
  key: "1c9p78"
}]]);
const Qg = Kg;
var Gg = J("TicketIcon", [["path", {
  d: "M3 7v2a3 3 0 1 1 0 6v2c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2Z",
  key: "nswdcl"
}], ["path", {
  d: "M13 5v2",
  key: "dyzc3o"
}], ["path", {
  d: "M13 17v2",
  key: "1ont0d"
}], ["path", {
  d: "M13 11v2",
  key: "1wjjxi"
}]]);
const Zg = Gg;
var Jg = J("UserIcon", [["path", {
  d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
  key: "975kel"
}], ["circle", {
  cx: "12",
  cy: "7",
  r: "4",
  key: "17ys0d"
}]]);
const ev = Jg;
var tv = J("WalletIcon", [["path", {
  d: "M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4",
  key: "st805m"
}], ["path", {
  d: "M4 6v12c0 1.1.9 2 2 2h14v-4",
  key: "16cu1e"
}], ["path", {
  d: "M18 12a2 2 0 0 0-2 2c0 1.1.9 2 2 2h4v-4h-4z",
  key: "lwd56p"
}]]);
const nv = tv;
var rv = J("XCircleIcon", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["line", {
  x1: "15",
  y1: "9",
  x2: "9",
  y2: "15",
  key: "19zs77"
}], ["line", {
  x1: "9",
  y1: "9",
  x2: "15",
  y2: "15",
  key: "10u9bu"
}]]);
const av = rv;
var iv = J("XIcon", [["line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18",
  key: "1o5bob"
}], ["line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18",
  key: "z4dcbv"
}]]);
const Bn = iv, ov = J("AppStoreIcon", [["rect", {
  x: "3",
  y: "3",
  width: "7",
  height: "7"
}], ["rect", {
  x: "14",
  y: "3",
  width: "7",
  height: "7"
}], ["rect", {
  x: "3",
  y: "14",
  width: "7",
  height: "7"
}], ["line", {
  x1: "17.5",
  y1: "14",
  x2: "17.5",
  y2: "21"
}], ["line", {
  x1: "14",
  y1: "17.5",
  x2: "21",
  y2: "17.5"
}]]), sv = J("VoucherIcon", [["path", {
  d: "M3 9V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V9M3 15V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V15"
}], ["path", {
  d: "M21 15C20.2044 15 19.4413 14.6839 18.8787 14.1213C18.3161 13.5587 18 12.7956 18 12C18 11.2044 18.3161 10.4413 18.8787 9.87868C19.4413 9.31607 20.2044 9 21 9"
}], ["path", {
  d: "M3 15C3.79565 15 4.55871 14.6839 5.12132 14.1213C5.68393 13.5587 6 12.7956 6 12C6 11.2044 5.68393 10.4413 5.12132 9.87868C4.55871 9.31607 3.79565 9 3 9"
}], ["path", {
  d: "M12 8V9"
}], ["path", {
  d: "M12 15V16"
}], ["path", {
  d: "M14.0833 9.08325H10.9583C10.5716 9.08325 10.2006 9.2369 9.92714 9.51039C9.65365 9.78388 9.5 10.1548 9.5 10.5416C9.5 10.9284 9.65365 11.2993 9.92714 11.5728C10.2006 11.8463 10.5716 11.9999 10.9583 11.9999H13.0417C13.4284 11.9999 13.7994 12.1536 14.0729 12.4271C14.3464 12.7005 14.5 13.0715 14.5 13.4583C14.5 13.845 14.3464 14.216 14.0729 14.4895C13.7994 14.7629 13.4284 14.9166 13.0417 14.9166H9.5"
}]]), lv = J("NetworkResellerIcon", [["path", {
  d: "M8.00002 12C8.00002 13.6569 9.34317 15 11 15C12.6569 15 14 13.6569 14 12C14 10.3432 12.6569 9 11 9C9.34317 9 8.00002 10.3432 8.00002 12Z"
}], ["path", {
  d: "M3 17.0003C3 18.1048 3.89543 19.0003 5.00001 19.0003C6.10458 19.0003 7.00001 18.1048 7.00001 17.0003C7.00001 15.8957 6.10458 15.0002 5.00001 15.0002C3.89543 15.0002 3 15.8957 3 17.0003Z"
}], ["path", {
  d: "M15 19C15 20.1046 15.8955 21 17 21C18.1046 21 19.0001 20.1046 19.0001 19C19.0001 17.8954 18.1046 17 17 17C15.8955 17 15 17.8954 15 19Z"
}], ["path", {
  d: "M13 5.00001C13 6.10458 13.8955 7.00001 15 7.00001C16.1046 7.00001 17.0001 6.10458 17.0001 5.00001C17.0001 3.89543 16.1046 3 15 3C13.8955 3 13 3.89543 13 5.00001Z"
}], ["path", {
  d: "M3 5.00001C3 6.10458 3.89543 7.00001 5.00001 7.00001C6.10458 7.00001 7.00001 6.10458 7.00001 5.00001C7.00001 3.89543 6.10458 3 5.00001 3C3.89543 3 3 3.89543 3 5.00001Z"
}], ["path", {
  d: "M17 12C17 13.1046 17.8955 14 19.0001 14C20.1046 14 21.0001 13.1046 21.0001 12C21.0001 10.8954 20.1046 10 19.0001 10C17.8955 10 17 10.8954 17 12Z"
}], ["path", {
  d: "M6.00001 7.00024L8.47489 9.47513"
}], ["path", {
  d: "M6.96797 15.0002L7.96798 14.0002"
}], ["path", {
  d: "M13 9.59814L14.5 7.00006"
}], ["path", {
  d: "M14.1875 12.1997L16.7917 12.1997"
}], ["path", {
  d: "M13 15.0002L15.4749 17.4751"
}]]), cv = { class: "c-toast-inner-container" }, uv = { class: "c-toast-icon" }, dv = { class: "c-toast-inner-container" }, fv = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    intent: { default: G.critical },
    message: null,
    actionButtonLabel: { default: "" },
    progressTime: { default: 5e3 },
    showCloseButton: { type: Boolean, default: !0 },
    closeAfterProcessTime: { type: Boolean, default: !0 }
  },
  emits: ["handleAction", "close"],
  setup(t, { emit: e }) {
    const n = t, r = U(""), a = U(0), i = U(void 0), o = U(void 0), s = I(() => {
      switch (n.intent) {
        case G.critical:
          return {
            icon: Yo,
            class: G.critical
          };
        case G.warning:
          return {
            icon: Qf,
            class: G.warning
          };
        case G.success:
          return {
            icon: Gf,
            class: G.success
          };
        case G.info:
          return {
            icon: Zf,
            class: G.info
          };
        default:
          return {
            icon: Yo,
            class: G.critical
          };
      }
    }), l = I(() => ({ width: a.value / n.progressTime * 100 + "%" })), c = (p) => {
      r.value = "c-toast-container-fade-out", e("close", p);
    }, u = (p) => {
      e("handleAction", p);
    }, f = () => {
      n.closeAfterProcessTime && (clearInterval(i.value), clearTimeout(o.value));
    }, d = () => {
      i.value = setInterval(() => {
        if (a.value > n.progressTime) {
          clearInterval(i.value);
          return;
        }
        a.value += 4.1;
      }, 1);
    }, h = () => {
      o.value = setTimeout(() => {
        c();
      }, n.progressTime - a.value);
    }, m = () => {
      n.closeAfterProcessTime && (d(), h());
    };
    return Wn(() => {
      r.value = "", m();
    }), Hf(() => {
      f();
    }), (p, g) => (b(), M("div", {
      class: H(["c-toast-container", r.value]),
      onMouseover: f,
      onMouseleave: m
    }, [
      R("div", cv, [
        R("div", uv, [
          (b(), L(_t(S(s).icon), {
            class: H(["c-icon-s", S(s).class])
          }, null, 8, ["class"]))
        ]),
        T(we, {
          type: "four",
          class: "c-toast-message"
        }, {
          default: W(() => [
            V(j(t.message), 1)
          ]),
          _: 1
        })
      ]),
      R("div", dv, [
        t.actionButtonLabel ? (b(), M("button", {
          key: 0,
          class: "c-toast-button",
          onClick: u
        }, [
          T(we, {
            class: "c-action-label",
            type: "four"
          }, {
            default: W(() => [
              V(j(t.actionButtonLabel), 1)
            ]),
            _: 1
          })
        ])) : E("", !0),
        t.showCloseButton ? (b(), M("button", {
          key: 1,
          class: "c-toast-button",
          onClick: c
        }, [
          T(S(Bn), { class: "c-icon-s c-close-icon" })
        ])) : E("", !0)
      ]),
      t.actionButtonLabel ? (b(), M("div", {
        key: 0,
        class: "c-toast-progress",
        style: Ut(S(l))
      }, null, 4)) : E("", !0)
    ], 34));
  }
});
const M$ = /* @__PURE__ */ B(fv, [["__scopeId", "data-v-c8b5e0ab"]]), F = {
  cs: "cs",
  da: "da",
  no: "no",
  nl: "nl",
  it: "it",
  fi: "fi",
  en: "en",
  de: "de",
  es: "es",
  fr: "fr",
  sv: "sv"
}, go = {
  european: "dd/mm/yyyy"
}, O$ = "contentPosition", Pn = {
  leading: "leading",
  middle: "middle",
  trailing: "trailing"
};
var ot = /* @__PURE__ */ ((t) => (t.starts = "starts", t.ends = "ends", t))(ot || {});
const hv = {
  name: "CIdentifier",
  components: {
    Info: Zf,
    XCircle: av,
    Lightbulb: Rg,
    AlertTriangle: Qf,
    CheckCircle: Gf
  },
  props: {
    intent: {
      default: G.info,
      type: String
    },
    icon: {
      required: !1,
      default: "Info",
      type: String,
      validate: (t) => [
        "Info",
        "XCircle",
        "Lightbulb",
        "AlertTriangle",
        "CheckCircle"
      ].includes(t)
    }
  },
  computed: {
    coppiIntent() {
      return `c-${this.intent}`;
    }
  }
};
function pv(t, e, n, r, a, i) {
  return b(), M("div", {
    class: H(["c-icon-container", i.coppiIntent])
  }, [
    (b(), L(_t(n.icon), { class: "c-icon-m" }))
  ], 2);
}
const th = /* @__PURE__ */ B(hv, [["render", pv], ["__scopeId", "data-v-602fae3a"]]);
const mv = {
  name: "CChevron",
  components: {
    ChevronDown: fo,
    ChevronUp: mo,
    ChevronLeft: ho,
    ChevronRight: po
  },
  props: {
    chevronDirection: {
      type: String,
      required: !1,
      default: "up"
    },
    shouldToggle: {
      type: Boolean,
      required: !1,
      default: !0
    },
    activeStatus: {
      required: !1,
      type: Boolean
    }
  },
  emits: ["interacted", "update:activeStatus"],
  data() {
    return {
      active: !1
    };
  },
  computed: {
    getChevronType() {
      switch (this.chevronDirection) {
        case "up":
          return this.getStatus ? "ChevronDown" : "ChevronUp";
        case "bottom":
          return this.getStatus ? "ChevronUp" : "ChevronDown";
        case "left":
          return this.getStatus ? "ChevronRight" : "ChevronLeft";
        case "right":
          return this.getStatus ? "ChevronLeft" : "ChevronRight";
        default:
          return this.getStatus ? "ChevronDown" : "ChevronUp";
      }
    },
    getStatus() {
      return this.active;
    }
  },
  watch: {
    activeStatus: {
      immediate: !0,
      handler(t) {
        this.active = t;
      }
    }
  },
  methods: {
    toggleChevronState() {
      this.active = !this.active, this.$emit("update:activeStatus", this.active);
    },
    handleToggle(t) {
      t.stopImmediatePropagation(), this.$emit("interacted", t), this.shouldToggle && this.toggleChevronState();
    }
  }
};
function gv(t, e, n, r, a, i) {
  return b(), M("button", {
    class: "c-chevron-button",
    onClick: e[0] || (e[0] = (...o) => i.handleToggle && i.handleToggle(...o))
  }, [
    (b(), L(_t(i.getChevronType), {
      "aria-label": a.active ? "collapse" : "expand",
      class: "c-icon-s c-nav-chevron"
    }, null, 8, ["aria-label"]))
  ]);
}
const Xt = /* @__PURE__ */ B(mv, [["render", gv], ["__scopeId", "data-v-7d97d2d0"]]);
const vv = {
  name: "InlineLoader",
  props: {
    size: {
      type: String,
      default: "s",
      required: !1,
      validate: (t) => ["s", "m", "l", "xl"].includes(t)
    }
  }
}, yv = (t) => (In("data-v-68f3769d"), t = t(), Nn(), t), bv = /* @__PURE__ */ yv(() => /* @__PURE__ */ R("circle", {
  class: "c-circle",
  cx: "25",
  cy: "25",
  r: "20",
  "stroke-linecap": "round",
  "stroke-width": "3"
}, null, -1)), _v = [
  bv
];
function wv(t, e, n, r, a, i) {
  return b(), M("svg", {
    class: H(["c-spinner", n.size]),
    fill: "none",
    height: "20px",
    width: "20px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, _v, 2);
}
const vo = /* @__PURE__ */ B(vv, [["render", wv], ["__scopeId", "data-v-68f3769d"]]);
const kv = {
  name: "SupplierListItem",
  components: {
    CAvatar: Kf,
    CSubheading: Ne,
    deleteIcon: Bn,
    InlineLoader: vo,
    AlertCircle: Yo,
    CUi: we
  },
  props: {
    supplier: {
      type: Object,
      required: !0
    },
    isLoading: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isErrored: {
      type: Boolean,
      required: !1,
      default: !1
    },
    canDelete: {
      type: Boolean,
      required: !1,
      default: !1
    },
    active: {
      type: Boolean,
      required: !1,
      default: !1
    },
    tabIndex: {
      type: Number,
      required: !1,
      default: 0
    }
  },
  emits: ["select-supplier", "delete-supplier"],
  computed: {
    showDeleteButton() {
      return this.canDelete && !this.isLoading && !this.isErrored;
    },
    supplierImage() {
      var t;
      return (t = this == null ? void 0 : this.supplier) == null ? void 0 : t.logo;
    },
    supplierName() {
      var t;
      return (t = this == null ? void 0 : this.supplier) == null ? void 0 : t.name;
    },
    supplierAccountNumber() {
      var t;
      return (t = this == null ? void 0 : this.supplier) == null ? void 0 : t.accountNumber;
    }
  },
  methods: {
    selectSupplier() {
      this.$emit("select-supplier");
    },
    deleteElement() {
      this.$emit("delete-supplier");
    }
  }
}, xv = ["tabindex"], Cv = { class: "c-supplier-info-container" }, Pv = { class: "c-slot-space" }, Sv = {
  key: 0,
  class: "c-delete-button"
}, Mv = {
  key: 1,
  class: "c-error-button"
}, Ov = {
  key: 2,
  class: "c-spinner-wrapper"
};
function Dv(t, e, n, r, a, i) {
  const o = z("c-avatar"), s = z("c-subheading"), l = z("c-ui"), c = z("delete-icon"), u = z("alert-circle"), f = z("inline-loader");
  return b(), M("div", {
    class: "c-supplier-list-item-out",
    tabindex: n.tabIndex,
    onKeyup: e[1] || (e[1] = st(ve((...d) => i.selectSupplier && i.selectSupplier(...d), ["prevent"]), ["enter"]))
  }, [
    R("div", {
      class: H(["c-supplier-list-item", { active: n.active }]),
      onClick: e[0] || (e[0] = (...d) => i.selectSupplier && i.selectSupplier(...d))
    }, [
      T(o, {
        url: i.supplierImage,
        name: i.supplierName,
        "aria-hidden": "true",
        class: "c-supplier-avatar"
      }, null, 8, ["url", "name"]),
      R("div", Cv, [
        T(s, {
          type: "four",
          class: "c-supplier-label",
          "aria-label": "Supplier name"
        }, {
          default: W(() => [
            V(j(i.supplierName), 1)
          ]),
          _: 1
        }),
        i.supplierAccountNumber ? (b(), L(l, {
          key: 0,
          type: "five",
          class: "c-supplier-account-number",
          "aria-label": "Supplier name"
        }, {
          default: W(() => [
            V(j(i.supplierAccountNumber), 1)
          ]),
          _: 1
        })) : E("", !0)
      ])
    ], 2),
    R("div", Pv, [
      i.showDeleteButton ? (b(), M("span", Sv, [
        T(c, {
          class: "c-icon-s c-remove-icon",
          onClick: ve(i.deleteElement, ["stop"])
        }, null, 8, ["onClick"])
      ])) : E("", !0),
      n.isErrored ? (b(), M("span", Mv, [
        T(u, { class: "c-icon-s c-error-icon" })
      ])) : E("", !0),
      n.isLoading ? (b(), M("span", Ov, [
        T(f, { class: "c-loader-color" })
      ])) : E("", !0)
    ])
  ], 40, xv);
}
const D$ = /* @__PURE__ */ B(kv, [["render", Dv], ["__scopeId", "data-v-24f20fcc"]]), Tv = { class: "c-callout-main c-border-default" }, $v = { class: "c-status-column" }, Rv = { class: "c-description-column" }, Ev = { class: "c-actions-container" }, Av = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    title: { default: "" },
    content: { default: "" },
    intent: { default: G.primary }
  },
  setup(t) {
    const e = t, n = I(() => {
      switch (e.intent) {
        case G.critical:
          return "XCircle";
        case G.primary:
          return "Lightbulb";
        case G.warning:
          return "AlertTriangle";
        case G.info:
          return "Info";
        case G.success:
          return "CheckCircle";
        default:
          return "Info";
      }
    });
    return (r, a) => (b(), M("div", Tv, [
      R("div", $v, [
        T(th, {
          icon: S(n),
          intent: t.intent
        }, null, 8, ["icon", "intent"])
      ]),
      R("div", Rv, [
        R("h5", null, j(t.title), 1),
        T(zn, { class: "c-description-text" }, {
          default: W(() => [
            V(j(t.content), 1)
          ]),
          _: 1
        }),
        R("div", Ev, [
          _e(r.$slots, "actionsList", {}, void 0, !0)
        ])
      ])
    ]));
  }
});
const T$ = /* @__PURE__ */ B(Av, [["__scopeId", "data-v-f769d4df"]]), Lv = {
  key: 0,
  class: "c-icon-m c-icon-before"
}, Iv = {
  key: 2,
  class: "c-icon-m c-icon-after"
}, Nv = {
  key: 0,
  class: "c-loading-state",
  "aria-hidden": "true"
}, Wv = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    label: null,
    size: { default: "default" },
    fullWidth: { type: Boolean, default: !1 },
    intent: { default: G.primary },
    isLoading: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, n = I(() => e.size !== "small" ? "m" : "s"), r = I(() => e.size !== "small" ? "two" : "three"), a = I(() => {
      const s = e.fullWidth ? "full-width" : "", l = o.value ? "" : "c-icon-only";
      return `${s} ${e.size} ${e.intent} ${l}`;
    }), i = Ff(), o = I(() => e.label || (i.default ? i.default().length > 0 : !1));
    return (s, l) => (b(), M("button", {
      class: H(["c-button", S(a)])
    }, [
      R("span", {
        class: H(["c-button-content", { "c-hidden": t.isLoading }])
      }, [
        s.$slots.iconBefore ? (b(), M("span", Lv, [
          _e(s.$slots, "iconBefore", {}, void 0, !0)
        ])) : E("", !0),
        t.label || s.$slots.default ? (b(), L(S(Ne), {
          key: 1,
          type: S(r),
          class: "c-label"
        }, {
          default: W(() => [
            s.$slots.default ? E("", !0) : (b(), M(de, { key: 0 }, [
              V(j(t.label), 1)
            ], 64)),
            _e(s.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["type"])) : E("", !0),
        s.$slots.iconAfter ? (b(), M("span", Iv, [
          _e(s.$slots, "iconAfter", {}, void 0, !0)
        ])) : E("", !0)
      ], 2),
      t.isLoading ? (b(), M("span", Nv, [
        t.isLoading ? (b(), L(S(vo), {
          key: 0,
          class: "c-spin-loader",
          size: S(n)
        }, null, 8, ["size"])) : E("", !0)
      ])) : E("", !0)
    ], 2));
  }
});
const dr = /* @__PURE__ */ B(Wv, [["__scopeId", "data-v-22e20500"]]), zv = { class: "c-alert c-layer-elevated" }, Bv = { class: "c-alert-content" }, Fv = { class: "c-alert-header" }, Hv = { class: "c-alert-button-group" }, jv = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    intent: { default: G.info },
    heading: null,
    content: null,
    linkIcon: { default: "ExternalLink" },
    linkLabel: { default: "" },
    buttonLabels: { default: () => ({ confirm: "Confirm", cancel: "Cancel" }) },
    displayCancelButton: { type: Boolean, default: !0 }
  },
  emits: ["confirm", "cancel"],
  setup(t, { emit: e }) {
    const n = t, r = I(() => n.intent === G.critical ? "AlertTriangle" : "Info"), a = I(() => n.intent === G.critical ? G.critical : G.primary), i = I(() => G.secondary), o = () => e("confirm"), s = () => e("cancel");
    return (l, c) => (b(), M("div", zv, [
      T(th, {
        class: "c-identifier-column",
        icon: S(r),
        intent: t.intent
      }, null, 8, ["icon", "intent"]),
      R("div", Bv, [
        R("h5", Fv, j(t.heading), 1),
        T(zn, {
          class: "c-alert-body",
          type: "one"
        }, {
          default: W(() => [
            V(j(t.content), 1)
          ]),
          _: 1
        }),
        t.linkLabel ? (b(), L(Uf, {
          key: 0,
          class: "c-link",
          label: t.linkLabel
        }, {
          default: W(() => [
            (b(), L(_t(t.linkIcon)))
          ]),
          _: 1
        }, 8, ["label"])) : E("", !0),
        R("div", Hv, [
          t.displayCancelButton ? (b(), L(dr, {
            key: 0,
            onClick: s,
            label: t.buttonLabels.cancel,
            intent: S(i)
          }, null, 8, ["label", "intent"])) : E("", !0),
          T(dr, {
            onClick: o,
            label: t.buttonLabels.confirm,
            intent: S(a),
            class: "c-confirm-button"
          }, null, 8, ["label", "intent"])
        ])
      ])
    ]));
  }
});
const $$ = /* @__PURE__ */ B(jv, [["__scopeId", "data-v-7f70de86"]]);
var Je = "top", dt = "bottom", ft = "right", et = "left", yo = "auto", Or = [Je, dt, ft, et], Mn = "start", fr = "end", Vv = "clippingParents", nh = "viewport", jn = "popper", qv = "reference", xc = /* @__PURE__ */ Or.reduce(function(t, e) {
  return t.concat([e + "-" + Mn, e + "-" + fr]);
}, []), rh = /* @__PURE__ */ [].concat(Or, [yo]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Mn, e + "-" + fr]);
}, []), Uv = "beforeRead", Yv = "read", Xv = "afterRead", Kv = "beforeMain", Qv = "main", Gv = "afterMain", Zv = "beforeWrite", Jv = "write", ey = "afterWrite", Xo = [Uv, Yv, Xv, Kv, Qv, Gv, Zv, Jv, ey];
function wt(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function nt(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function pn(t) {
  var e = nt(t).Element;
  return t instanceof e || t instanceof Element;
}
function tt(t) {
  var e = nt(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function $l(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = nt(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function ty(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, a = e.attributes[n] || {}, i = e.elements[n];
    !tt(i) || !wt(i) || (Object.assign(i.style, r), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function ny(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var a = e.elements[r], i = e.attributes[r] || {}, o = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), s = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !tt(a) || !wt(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
const ry = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: ty,
  effect: ny,
  requires: ["computeStyles"]
};
function ct(t) {
  return t.split("-")[0];
}
var un = Math.max, pi = Math.min, On = Math.round;
function Ko() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function ah() {
  return !/^((?!chrome|android).)*safari/i.test(Ko());
}
function Dn(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), a = 1, i = 1;
  e && tt(t) && (a = t.offsetWidth > 0 && On(r.width) / t.offsetWidth || 1, i = t.offsetHeight > 0 && On(r.height) / t.offsetHeight || 1);
  var o = pn(t) ? nt(t) : window, s = o.visualViewport, l = !ah() && n, c = (r.left + (l && s ? s.offsetLeft : 0)) / a, u = (r.top + (l && s ? s.offsetTop : 0)) / i, f = r.width / a, d = r.height / i;
  return {
    width: f,
    height: d,
    top: u,
    right: c + f,
    bottom: u + d,
    left: c,
    x: c,
    y: u
  };
}
function Rl(t) {
  var e = Dn(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function ih(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && $l(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function ht(t) {
  return nt(t).getComputedStyle(t);
}
function ay(t) {
  return ["table", "td", "th"].indexOf(wt(t)) >= 0;
}
function Gt(t) {
  return ((pn(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function bo(t) {
  return wt(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    ($l(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Gt(t)
  );
}
function Cc(t) {
  return !tt(t) || // https://github.com/popperjs/popper-core/issues/837
  ht(t).position === "fixed" ? null : t.offsetParent;
}
function iy(t) {
  var e = /firefox/i.test(Ko()), n = /Trident/i.test(Ko());
  if (n && tt(t)) {
    var r = ht(t);
    if (r.position === "fixed")
      return null;
  }
  var a = bo(t);
  for ($l(a) && (a = a.host); tt(a) && ["html", "body"].indexOf(wt(a)) < 0; ) {
    var i = ht(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function Dr(t) {
  for (var e = nt(t), n = Cc(t); n && ay(n) && ht(n).position === "static"; )
    n = Cc(n);
  return n && (wt(n) === "html" || wt(n) === "body" && ht(n).position === "static") ? e : n || iy(t) || e;
}
function El(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function rr(t, e, n) {
  return un(t, pi(e, n));
}
function oy(t, e, n) {
  var r = rr(t, e, n);
  return r > n ? n : r;
}
function oh() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function sh(t) {
  return Object.assign({}, oh(), t);
}
function lh(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var sy = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, sh(typeof e != "number" ? e : lh(e, Or));
};
function ly(t) {
  var e, n = t.state, r = t.name, a = t.options, i = n.elements.arrow, o = n.modifiersData.popperOffsets, s = ct(n.placement), l = El(s), c = [et, ft].indexOf(s) >= 0, u = c ? "height" : "width";
  if (!(!i || !o)) {
    var f = sy(a.padding, n), d = Rl(i), h = l === "y" ? Je : et, m = l === "y" ? dt : ft, p = n.rects.reference[u] + n.rects.reference[l] - o[l] - n.rects.popper[u], g = o[l] - n.rects.reference[l], v = Dr(i), w = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, C = p / 2 - g / 2, x = f[h], y = w - d[u] - f[m], _ = w / 2 - d[u] / 2 + C, k = rr(x, _, y), P = l;
    n.modifiersData[r] = (e = {}, e[P] = k, e.centerOffset = k - _, e);
  }
}
function cy(t) {
  var e = t.state, n = t.options, r = n.element, a = r === void 0 ? "[data-popper-arrow]" : r;
  if (a != null && !(typeof a == "string" && (a = e.elements.popper.querySelector(a), !a))) {
    if (process.env.NODE_ENV !== "production" && (tt(a) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !ih(e.elements.popper, a)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    e.elements.arrow = a;
  }
}
const uy = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: ly,
  effect: cy,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Tn(t) {
  return t.split("-")[1];
}
var dy = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function fy(t, e) {
  var n = t.x, r = t.y, a = e.devicePixelRatio || 1;
  return {
    x: On(n * a) / a || 0,
    y: On(r * a) / a || 0
  };
}
function Pc(t) {
  var e, n = t.popper, r = t.popperRect, a = t.placement, i = t.variation, o = t.offsets, s = t.position, l = t.gpuAcceleration, c = t.adaptive, u = t.roundOffsets, f = t.isFixed, d = o.x, h = d === void 0 ? 0 : d, m = o.y, p = m === void 0 ? 0 : m, g = typeof u == "function" ? u({
    x: h,
    y: p
  }) : {
    x: h,
    y: p
  };
  h = g.x, p = g.y;
  var v = o.hasOwnProperty("x"), w = o.hasOwnProperty("y"), C = et, x = Je, y = window;
  if (c) {
    var _ = Dr(n), k = "clientHeight", P = "clientWidth";
    if (_ === nt(n) && (_ = Gt(n), ht(_).position !== "static" && s === "absolute" && (k = "scrollHeight", P = "scrollWidth")), _ = _, a === Je || (a === et || a === ft) && i === fr) {
      x = dt;
      var $ = f && _ === y && y.visualViewport ? y.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        _[k]
      );
      p -= $ - r.height, p *= l ? 1 : -1;
    }
    if (a === et || (a === Je || a === dt) && i === fr) {
      C = ft;
      var O = f && _ === y && y.visualViewport ? y.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        _[P]
      );
      h -= O - r.width, h *= l ? 1 : -1;
    }
  }
  var D = Object.assign({
    position: s
  }, c && dy), N = u === !0 ? fy({
    x: h,
    y: p
  }, nt(n)) : {
    x: h,
    y: p
  };
  if (h = N.x, p = N.y, l) {
    var q;
    return Object.assign({}, D, (q = {}, q[x] = w ? "0" : "", q[C] = v ? "0" : "", q.transform = (y.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + p + "px)" : "translate3d(" + h + "px, " + p + "px, 0)", q));
  }
  return Object.assign({}, D, (e = {}, e[x] = w ? p + "px" : "", e[C] = v ? h + "px" : "", e.transform = "", e));
}
function hy(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, a = r === void 0 ? !0 : r, i = n.adaptive, o = i === void 0 ? !0 : i, s = n.roundOffsets, l = s === void 0 ? !0 : s;
  if (process.env.NODE_ENV !== "production") {
    var c = ht(e.elements.popper).transitionProperty || "";
    o && ["transform", "top", "right", "bottom", "left"].some(function(f) {
      return c.indexOf(f) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var u = {
    placement: ct(e.placement),
    variation: Tn(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: a,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Pc(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Pc(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const py = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: hy,
  data: {}
};
var Kr = {
  passive: !0
};
function my(t) {
  var e = t.state, n = t.instance, r = t.options, a = r.scroll, i = a === void 0 ? !0 : a, o = r.resize, s = o === void 0 ? !0 : o, l = nt(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, Kr);
  }), s && l.addEventListener("resize", n.update, Kr), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, Kr);
    }), s && l.removeEventListener("resize", n.update, Kr);
  };
}
const gy = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: my,
  data: {}
};
var vy = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ga(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return vy[e];
  });
}
var yy = {
  start: "end",
  end: "start"
};
function Sc(t) {
  return t.replace(/start|end/g, function(e) {
    return yy[e];
  });
}
function Al(t) {
  var e = nt(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Ll(t) {
  return Dn(Gt(t)).left + Al(t).scrollLeft;
}
function by(t, e) {
  var n = nt(t), r = Gt(t), a = n.visualViewport, i = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (a) {
    i = a.width, o = a.height;
    var c = ah();
    (c || !c && e === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + Ll(t),
    y: l
  };
}
function _y(t) {
  var e, n = Gt(t), r = Al(t), a = (e = t.ownerDocument) == null ? void 0 : e.body, i = un(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = un(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -r.scrollLeft + Ll(t), l = -r.scrollTop;
  return ht(a || n).direction === "rtl" && (s += un(n.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function Il(t) {
  var e = ht(t), n = e.overflow, r = e.overflowX, a = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + a + r);
}
function ch(t) {
  return ["html", "body", "#document"].indexOf(wt(t)) >= 0 ? t.ownerDocument.body : tt(t) && Il(t) ? t : ch(bo(t));
}
function ar(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = ch(t), a = r === ((n = t.ownerDocument) == null ? void 0 : n.body), i = nt(r), o = a ? [i].concat(i.visualViewport || [], Il(r) ? r : []) : r, s = e.concat(o);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(ar(bo(o)))
  );
}
function Qo(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function wy(t, e) {
  var n = Dn(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Mc(t, e, n) {
  return e === nh ? Qo(by(t, n)) : pn(e) ? wy(e, n) : Qo(_y(Gt(t)));
}
function ky(t) {
  var e = ar(bo(t)), n = ["absolute", "fixed"].indexOf(ht(t).position) >= 0, r = n && tt(t) ? Dr(t) : t;
  return pn(r) ? e.filter(function(a) {
    return pn(a) && ih(a, r) && wt(a) !== "body";
  }) : [];
}
function xy(t, e, n, r) {
  var a = e === "clippingParents" ? ky(t) : [].concat(e), i = [].concat(a, [n]), o = i[0], s = i.reduce(function(l, c) {
    var u = Mc(t, c, r);
    return l.top = un(u.top, l.top), l.right = pi(u.right, l.right), l.bottom = pi(u.bottom, l.bottom), l.left = un(u.left, l.left), l;
  }, Mc(t, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function uh(t) {
  var e = t.reference, n = t.element, r = t.placement, a = r ? ct(r) : null, i = r ? Tn(r) : null, o = e.x + e.width / 2 - n.width / 2, s = e.y + e.height / 2 - n.height / 2, l;
  switch (a) {
    case Je:
      l = {
        x: o,
        y: e.y - n.height
      };
      break;
    case dt:
      l = {
        x: o,
        y: e.y + e.height
      };
      break;
    case ft:
      l = {
        x: e.x + e.width,
        y: s
      };
      break;
    case et:
      l = {
        x: e.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = a ? El(a) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case Mn:
        l[c] = l[c] - (e[u] / 2 - n[u] / 2);
        break;
      case fr:
        l[c] = l[c] + (e[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Nl(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, a = r === void 0 ? t.placement : r, i = n.strategy, o = i === void 0 ? t.strategy : i, s = n.boundary, l = s === void 0 ? Vv : s, c = n.rootBoundary, u = c === void 0 ? nh : c, f = n.elementContext, d = f === void 0 ? jn : f, h = n.altBoundary, m = h === void 0 ? !1 : h, p = n.padding, g = p === void 0 ? 0 : p, v = sh(typeof g != "number" ? g : lh(g, Or)), w = d === jn ? qv : jn, C = t.rects.popper, x = t.elements[m ? w : d], y = xy(pn(x) ? x : x.contextElement || Gt(t.elements.popper), l, u, o), _ = Dn(t.elements.reference), k = uh({
    reference: _,
    element: C,
    strategy: "absolute",
    placement: a
  }), P = Qo(Object.assign({}, C, k)), $ = d === jn ? P : _, O = {
    top: y.top - $.top + v.top,
    bottom: $.bottom - y.bottom + v.bottom,
    left: y.left - $.left + v.left,
    right: $.right - y.right + v.right
  }, D = t.modifiersData.offset;
  if (d === jn && D) {
    var N = D[a];
    Object.keys(O).forEach(function(q) {
      var le = [ft, dt].indexOf(q) >= 0 ? 1 : -1, Y = [Je, dt].indexOf(q) >= 0 ? "y" : "x";
      O[q] += N[Y] * le;
    });
  }
  return O;
}
function Cy(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, a = n.boundary, i = n.rootBoundary, o = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? rh : l, u = Tn(r), f = u ? s ? xc : xc.filter(function(m) {
    return Tn(m) === u;
  }) : Or, d = f.filter(function(m) {
    return c.indexOf(m) >= 0;
  });
  d.length === 0 && (d = f, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var h = d.reduce(function(m, p) {
    return m[p] = Nl(t, {
      placement: p,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[ct(p)], m;
  }, {});
  return Object.keys(h).sort(function(m, p) {
    return h[m] - h[p];
  });
}
function Py(t) {
  if (ct(t) === yo)
    return [];
  var e = ga(t);
  return [Sc(t), e, Sc(e)];
}
function Sy(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !0 : o, l = n.fallbackPlacements, c = n.padding, u = n.boundary, f = n.rootBoundary, d = n.altBoundary, h = n.flipVariations, m = h === void 0 ? !0 : h, p = n.allowedAutoPlacements, g = e.options.placement, v = ct(g), w = v === g, C = l || (w || !m ? [ga(g)] : Py(g)), x = [g].concat(C).reduce(function(Le, Ie) {
      return Le.concat(ct(Ie) === yo ? Cy(e, {
        placement: Ie,
        boundary: u,
        rootBoundary: f,
        padding: c,
        flipVariations: m,
        allowedAutoPlacements: p
      }) : Ie);
    }, []), y = e.rects.reference, _ = e.rects.popper, k = /* @__PURE__ */ new Map(), P = !0, $ = x[0], O = 0; O < x.length; O++) {
      var D = x[O], N = ct(D), q = Tn(D) === Mn, le = [Je, dt].indexOf(N) >= 0, Y = le ? "width" : "height", Q = Nl(e, {
        placement: D,
        boundary: u,
        rootBoundary: f,
        altBoundary: d,
        padding: c
      }), te = le ? q ? ft : et : q ? dt : Je;
      y[Y] > _[Y] && (te = ga(te));
      var Re = ga(te), pe = [];
      if (i && pe.push(Q[N] <= 0), s && pe.push(Q[te] <= 0, Q[Re] <= 0), pe.every(function(Le) {
        return Le;
      })) {
        $ = D, P = !1;
        break;
      }
      k.set(D, pe);
    }
    if (P)
      for (var Ke = m ? 3 : 1, at = function(Ie) {
        var qe = x.find(function(kt) {
          var me = k.get(kt);
          if (me)
            return me.slice(0, Ie).every(function(ue) {
              return ue;
            });
        });
        if (qe)
          return $ = qe, "break";
      }, Ee = Ke; Ee > 0; Ee--) {
        var Qe = at(Ee);
        if (Qe === "break")
          break;
      }
    e.placement !== $ && (e.modifiersData[r]._skip = !0, e.placement = $, e.reset = !0);
  }
}
const My = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Sy,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Oy(t, e, n) {
  var r = ct(t), a = [et, Je].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [et, ft].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function Dy(t) {
  var e = t.state, n = t.options, r = t.name, a = n.offset, i = a === void 0 ? [0, 0] : a, o = rh.reduce(function(u, f) {
    return u[f] = Oy(f, e.rects, i), u;
  }, {}), s = o[e.placement], l = s.x, c = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[r] = o;
}
const Ty = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Dy
};
function $y(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = uh({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const Ry = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: $y,
  data: {}
};
function Ey(t) {
  return t === "x" ? "y" : "x";
}
function Ay(t) {
  var e = t.state, n = t.options, r = t.name, a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !1 : o, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, f = n.padding, d = n.tether, h = d === void 0 ? !0 : d, m = n.tetherOffset, p = m === void 0 ? 0 : m, g = Nl(e, {
    boundary: l,
    rootBoundary: c,
    padding: f,
    altBoundary: u
  }), v = ct(e.placement), w = Tn(e.placement), C = !w, x = El(v), y = Ey(x), _ = e.modifiersData.popperOffsets, k = e.rects.reference, P = e.rects.popper, $ = typeof p == "function" ? p(Object.assign({}, e.rects, {
    placement: e.placement
  })) : p, O = typeof $ == "number" ? {
    mainAxis: $,
    altAxis: $
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, $), D = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, N = {
    x: 0,
    y: 0
  };
  if (_) {
    if (i) {
      var q, le = x === "y" ? Je : et, Y = x === "y" ? dt : ft, Q = x === "y" ? "height" : "width", te = _[x], Re = te + g[le], pe = te - g[Y], Ke = h ? -P[Q] / 2 : 0, at = w === Mn ? k[Q] : P[Q], Ee = w === Mn ? -P[Q] : -k[Q], Qe = e.elements.arrow, Le = h && Qe ? Rl(Qe) : {
        width: 0,
        height: 0
      }, Ie = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : oh(), qe = Ie[le], kt = Ie[Y], me = rr(0, k[Q], Le[Q]), ue = C ? k[Q] / 2 - Ke - me - qe - O.mainAxis : at - me - qe - O.mainAxis, Ue = C ? -k[Q] / 2 + Ke + me + kt + O.mainAxis : Ee + me + kt + O.mainAxis, Nt = e.elements.arrow && Dr(e.elements.arrow), qr = Nt ? x === "y" ? Nt.clientTop || 0 : Nt.clientLeft || 0 : 0, Fn = (q = D == null ? void 0 : D[x]) != null ? q : 0, Hn = te + ue - Fn - qr, Ur = te + Ue - Fn, hc = rr(h ? pi(Re, Hn) : Re, te, h ? un(pe, Ur) : pe);
      _[x] = hc, N[x] = hc - te;
    }
    if (s) {
      var pc, Bp = x === "x" ? Je : et, Fp = x === "x" ? dt : ft, Jt = _[y], Yr = y === "y" ? "height" : "width", mc = Jt + g[Bp], gc = Jt - g[Fp], Po = [Je, et].indexOf(v) !== -1, vc = (pc = D == null ? void 0 : D[y]) != null ? pc : 0, yc = Po ? mc : Jt - k[Yr] - P[Yr] - vc + O.altAxis, bc = Po ? Jt + k[Yr] + P[Yr] - vc - O.altAxis : gc, _c = h && Po ? oy(yc, Jt, bc) : rr(h ? yc : mc, Jt, h ? bc : gc);
      _[y] = _c, N[y] = _c - Jt;
    }
    e.modifiersData[r] = N;
  }
}
const Ly = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Ay,
  requiresIfExists: ["offset"]
};
function Iy(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function Ny(t) {
  return t === nt(t) || !tt(t) ? Al(t) : Iy(t);
}
function Wy(t) {
  var e = t.getBoundingClientRect(), n = On(e.width) / t.offsetWidth || 1, r = On(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function zy(t, e, n) {
  n === void 0 && (n = !1);
  var r = tt(e), a = tt(e) && Wy(e), i = Gt(e), o = Dn(t, a, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((wt(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Il(i)) && (s = Ny(e)), tt(e) ? (l = Dn(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : i && (l.x = Ll(i))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function By(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function a(i) {
    n.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var l = e.get(s);
        l && a(l);
      }
    }), r.push(i);
  }
  return t.forEach(function(i) {
    n.has(i.name) || a(i);
  }), r;
}
function Fy(t) {
  var e = By(t);
  return Xo.reduce(function(n, r) {
    return n.concat(e.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function Hy(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function Wt(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  return [].concat(n).reduce(function(a, i) {
    return a.replace(/%s/, i);
  }, t);
}
var en = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', jy = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', Oc = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function Vy(t) {
  t.forEach(function(e) {
    [].concat(Object.keys(e), Oc).filter(function(n, r, a) {
      return a.indexOf(n) === r;
    }).forEach(function(n) {
      switch (n) {
        case "name":
          typeof e.name != "string" && console.error(Wt(en, String(e.name), '"name"', '"string"', '"' + String(e.name) + '"'));
          break;
        case "enabled":
          typeof e.enabled != "boolean" && console.error(Wt(en, e.name, '"enabled"', '"boolean"', '"' + String(e.enabled) + '"'));
          break;
        case "phase":
          Xo.indexOf(e.phase) < 0 && console.error(Wt(en, e.name, '"phase"', "either " + Xo.join(", "), '"' + String(e.phase) + '"'));
          break;
        case "fn":
          typeof e.fn != "function" && console.error(Wt(en, e.name, '"fn"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "effect":
          e.effect != null && typeof e.effect != "function" && console.error(Wt(en, e.name, '"effect"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "requires":
          e.requires != null && !Array.isArray(e.requires) && console.error(Wt(en, e.name, '"requires"', '"array"', '"' + String(e.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(e.requiresIfExists) || console.error(Wt(en, e.name, '"requiresIfExists"', '"array"', '"' + String(e.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + e.name + '" modifier, valid properties are ' + Oc.map(function(r) {
            return '"' + r + '"';
          }).join(", ") + '; but "' + n + '" was provided.');
      }
      e.requires && e.requires.forEach(function(r) {
        t.find(function(a) {
          return a.name === r;
        }) == null && console.error(Wt(jy, String(e.name), r, r));
      });
    });
  });
}
function qy(t, e) {
  var n = /* @__PURE__ */ new Set();
  return t.filter(function(r) {
    var a = e(r);
    if (!n.has(a))
      return n.add(a), !0;
  });
}
function Uy(t) {
  var e = t.reduce(function(n, r) {
    var a = n[r.name];
    return n[r.name] = a ? Object.assign({}, a, r, {
      options: Object.assign({}, a.options, r.options),
      data: Object.assign({}, a.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var Dc = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", Yy = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", Tc = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function $c() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Xy(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, a = e.defaultOptions, i = a === void 0 ? Tc : a;
  return function(s, l, c) {
    c === void 0 && (c = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Tc, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], d = !1, h = {
      state: u,
      setOptions: function(v) {
        var w = typeof v == "function" ? v(u.options) : v;
        p(), u.options = Object.assign({}, i, u.options, w), u.scrollParents = {
          reference: pn(s) ? ar(s) : s.contextElement ? ar(s.contextElement) : [],
          popper: ar(l)
        };
        var C = Fy(Uy([].concat(r, u.options.modifiers)));
        if (u.orderedModifiers = C.filter(function(D) {
          return D.enabled;
        }), process.env.NODE_ENV !== "production") {
          var x = qy([].concat(C, u.options.modifiers), function(D) {
            var N = D.name;
            return N;
          });
          if (Vy(x), ct(u.options.placement) === yo) {
            var y = u.orderedModifiers.find(function(D) {
              var N = D.name;
              return N === "flip";
            });
            y || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var _ = ht(l), k = _.marginTop, P = _.marginRight, $ = _.marginBottom, O = _.marginLeft;
          [k, P, $, O].some(function(D) {
            return parseFloat(D);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return m(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!d) {
          var v = u.elements, w = v.reference, C = v.popper;
          if (!$c(w, C)) {
            process.env.NODE_ENV !== "production" && console.error(Dc);
            return;
          }
          u.rects = {
            reference: zy(w, Dr(C), u.options.strategy === "fixed"),
            popper: Rl(C)
          }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(D) {
            return u.modifiersData[D.name] = Object.assign({}, D.data);
          });
          for (var x = 0, y = 0; y < u.orderedModifiers.length; y++) {
            if (process.env.NODE_ENV !== "production" && (x += 1, x > 100)) {
              console.error(Yy);
              break;
            }
            if (u.reset === !0) {
              u.reset = !1, y = -1;
              continue;
            }
            var _ = u.orderedModifiers[y], k = _.fn, P = _.options, $ = P === void 0 ? {} : P, O = _.name;
            typeof k == "function" && (u = k({
              state: u,
              options: $,
              name: O,
              instance: h
            }) || u);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Hy(function() {
        return new Promise(function(g) {
          h.forceUpdate(), g(u);
        });
      }),
      destroy: function() {
        p(), d = !0;
      }
    };
    if (!$c(s, l))
      return process.env.NODE_ENV !== "production" && console.error(Dc), h;
    h.setOptions(c).then(function(g) {
      !d && c.onFirstUpdate && c.onFirstUpdate(g);
    });
    function m() {
      u.orderedModifiers.forEach(function(g) {
        var v = g.name, w = g.options, C = w === void 0 ? {} : w, x = g.effect;
        if (typeof x == "function") {
          var y = x({
            state: u,
            name: v,
            instance: h,
            options: C
          }), _ = function() {
          };
          f.push(y || _);
        }
      });
    }
    function p() {
      f.forEach(function(g) {
        return g();
      }), f = [];
    }
    return h;
  };
}
var Ky = [gy, Ry, py, ry], Qy = /* @__PURE__ */ Xy({
  defaultModifiers: Ky
});
const Qr = {
  top: "top",
  bottom: "bottom",
  right: "right",
  left: "left"
}, Gy = {
  name: "CTooltip",
  components: {
    CUi: we
  },
  data() {
    return {
      pointerDirection: this.defaultPointerDirection
    };
  },
  props: {
    defaultPointerDirection: {
      type: String,
      required: !1,
      default: Qr.bottom
    },
    content: {
      type: String,
      required: !0
    },
    target: {
      type: HTMLElement,
      required: !0
    },
    maxWidth: {
      type: Number,
      required: !1,
      default: 272
    }
  },
  computed: {
    tooltipStyle() {
      return `max-width:${this.maxWidth}px;`;
    },
    pointerStyle() {
      switch (this.pointerDirection) {
        case Qr.bottom:
          return "position-top";
        case Qr.left:
          return "position-right";
        case Qr.right:
          return "position-left";
        default:
          return "position-bottom";
      }
    }
  },
  mounted() {
    this.initPopper();
  },
  methods: {
    initPopper() {
      const t = this.$refs["c-tooltip-ref"], e = this.$refs["c-tooltip-arrow"], n = {
        name: "moveArrow",
        enabled: !0,
        phase: "main",
        fn: ({ state: r }) => {
          r.placement === "top" && (this.pointerDirection = "top"), r.placement === "bottom" && (this.pointerDirection = "bottom"), r.placement === "right" && (this.pointerDirection = "right"), r.placement === "left" && (this.pointerDirection = "left");
        }
      };
      Qy(this.target, t, {
        placement: this.pointerDirection,
        modifiers: [
          {
            ...Ty,
            phase: "main",
            enabled: !0,
            options: {
              offset: () => [0, 14]
            }
          },
          {
            ...n
          },
          { ...My },
          {
            ...Ly
          },
          {
            ...uy,
            options: {
              element: e,
              padding: 16
            }
          }
        ]
      });
    }
  }
};
function Zy(t, e, n, r, a, i) {
  const o = z("c-ui");
  return n.content ? (b(), M("div", {
    key: 0,
    ref: "c-tooltip-ref",
    class: "c-tooltip-background",
    style: Ut(i.tooltipStyle)
  }, [
    R("div", {
      class: H(["c-tooltip-pointer", i.pointerStyle]),
      ref: "c-tooltip-arrow"
    }, null, 2),
    T(o, {
      type: "four",
      class: "c-tooltip-content"
    }, {
      default: W(() => [
        V(j(n.content), 1)
      ]),
      _: 1
    })
  ], 4)) : E("", !0);
}
const Jy = /* @__PURE__ */ B(Gy, [["render", Zy], ["__scopeId", "data-v-3f3fa75e"]]), e1 = {
  [F.cs]: {
    "CTable.noRecords": "No record to display"
  },
  [F.da]: {
    "CTable.noRecords": "Ingen registrering at vise"
  },
  [F.de]: {
    "CTable.noRecords": "Kein Datensatz zum Anzeigen"
  },
  [F.en]: {
    "CTable.showMore": "More information",
    "CTable.showLess": "Less Information",
    "CTable.noRecords": "No record to display"
  },
  [F.es]: {
    "CTable.noRecords": "No hay registro para mostrar"
  },
  [F.fi]: {
    "CTable.noRecords": "Ei näytettävää tietuetta"
  },
  [F.fr]: {
    "CTable.noRecords": "Aucun enregistrement à afficher"
  },
  [F.it]: {
    "CTable.noRecords": "Nessun record da visualizzare"
  },
  [F.nl]: {
    "CTable.noRecords": "Geen record om weer te geven"
  },
  [F.no]: {
    "CTable.noRecords": "Ingen post å vise"
  },
  [F.sv]: {
    "CTable.noRecords": "Žiadny záznam na zobrazenie"
  }
}, t1 = {
  [F.cs]: {
    "navBottom.quickActions": "Rychlé akce"
  },
  [F.da]: {
    "navBottom.quickActions": "Hurtige handlinger"
  },
  [F.de]: {
    "navBottom.quickActions": "Schnelle Aktionen"
  },
  [F.en]: {
    "navBottom.quickActions": "Quick actions"
  },
  [F.es]: {
    "navBottom.quickActions": "Acciones rápidas"
  },
  [F.fi]: {
    "navBottom.quickActions": "Mabilis na pagkilos"
  },
  [F.fr]: {
    "navBottom.quickActions": "Actions rapides"
  },
  [F.it]: {
    "navBottom.quickActions": "Azioni rapide"
  },
  [F.nl]: {
    "navBottom.quickActions": "Snelle acties"
  },
  [F.no]: {
    "navBottom.quickActions": "Raske handlinger"
  },
  [F.sv]: {
    "navBottom.quickActions": "Snabba åtgärder"
  }
}, n1 = {
  [F.cs]: {
    "CCopyToClipboard.onHover": "Klikněte pro kopírování"
  },
  [F.da]: {
    "CCopyToClipboard.onHover": "Klik for at kopiere"
  },
  [F.no]: {
    "CCopyToClipboard.onHover": "Klikk for å kopiere"
  },
  [F.it]: {
    "CCopyToClipboard.onHover": "Clicca per copiare"
  },
  [F.fi]: {
    "CCopyToClipboard.onHover": "Napsauta kopioidaksesi"
  },
  [F.en]: {
    "CCopyToClipboard.onHover": "Click to copy"
  },
  [F.de]: {
    "CCopyToClipboard.onHover": "Zum Kopieren klicken"
  },
  [F.es]: {
    "CCopyToClipboard.onHover": "Haga clic para copiar"
  },
  [F.fr]: {
    "CCopyToClipboard.onHover": "Cliquez pour copier"
  },
  [F.sv]: {
    "CCopyToClipboard.onHover": "Klicka för att kopiera"
  }
}, r1 = {
  [F.cs]: {
    "CDropdown.placeHolder": "Vybrat"
  },
  [F.da]: {
    "CDropdown.placeHolder": "Vælg"
  },
  [F.no]: {
    "CDropdown.placeHolder": "Velg"
  },
  [F.it]: {
    "CDropdown.placeHolder": "Seleziona"
  },
  [F.fi]: {
    "CDropdown.placeHolder": "Valitse"
  },
  [F.en]: {
    "CDropdown.placeHolder": "Select"
  },
  [F.de]: {
    "CDropdown.placeHolder": "Wählen"
  },
  [F.es]: {
    "CDropdown.placeHolder": "Seleccionar"
  },
  [F.fr]: {
    "CDropdown.placeHolder": "Sélectionner"
  },
  [F.sv]: {
    "CDropdown.placeHolder": "Välj"
  }
}, a1 = {
  [F.cs]: {
    "CDatePicker.tomorrow": "zítra",
    "CDatePicker.nextWeek": "příští týden",
    "CDatePicker.nextMonth": "příští měsíc"
  },
  [F.da]: {
    "CDatePicker.tomorrow": "i morgen",
    "CDatePicker.nextWeek": "næste uge",
    "CDatePicker.nextMonth": "næste måned"
  },
  [F.no]: {
    "CDatePicker.tomorrow": "i morgen",
    "CDatePicker.nextWeek": "neste uke",
    "CDatePicker.nextMonth": "neste måned"
  },
  [F.it]: {
    "CDatePicker.tomorrow": "domani",
    "CDatePicker.nextWeek": "prossima settimana",
    "CDatePicker.nextMonth": "mese prossimo"
  },
  [F.fi]: {
    "CDatePicker.tomorrow": "huomenna",
    "CDatePicker.nextWeek": "ensi viikko",
    "CDatePicker.nextMonth": "ensikuussa"
  },
  [F.en]: {
    "CDatePicker.tomorrow": "tomorrow",
    "CDatePicker.nextWeek": "next week",
    "CDatePicker.nextMonth": "next month"
  },
  [F.de]: {
    "CDatePicker.tomorrow": "morgen",
    "CDatePicker.nextWeek": "nächste Woche",
    "CDatePicker.nextMonth": "nächsten Monat"
  },
  [F.es]: {
    "CDatePicker.tomorrow": "mañana",
    "CDatePicker.nextWeek": "la próxima semana",
    "CDatePicker.nextMonth": "próximo mes"
  },
  [F.fr]: {
    "CDatePicker.tomorrow": "demain",
    "CDatePicker.nextWeek": "la semaine prochaine",
    "CDatePicker.nextMonth": "le mois prochain"
  },
  [F.sv]: {
    "CDatePicker.tomorrow": "i morgon",
    "CDatePicker.nextWeek": "nästa vecka",
    "CDatePicker.nextMonth": "nästa månad"
  }
}, i1 = {
  [F.cs]: {
    "CMultipleSearchSelection.Clear": "Vyčistit"
  },
  [F.da]: {
    "CMultipleSearchSelection.Clear": "Ryd"
  },
  [F.no]: {
    "CMultipleSearchSelection.Clear": "Tøm"
  },
  [F.it]: {
    "CMultipleSearchSelection.Clear": "Svuota"
  },
  [F.fi]: {
    "CMultipleSearchSelection.Clear": "Tyhjennä"
  },
  [F.en]: {
    "CMultipleSearchSelection.Clear": "Clear"
  },
  [F.de]: {
    "CMultipleSearchSelection.Clear": "Leeren"
  },
  [F.es]: {
    "CMultipleSearchSelection.Clear": "Limpiar"
  },
  [F.fr]: {
    "CMultipleSearchSelection.Clear": "Vider"
  },
  [F.sv]: {
    "CMultipleSearchSelection.Clear": "Rensa"
  }
};
let dn = {};
for (const t in F)
  dn[t] = {}, dn[t] = {
    ...n1[t],
    ...a1[t],
    ...e1[t],
    ...t1[t],
    ...r1[t],
    ...i1[t]
  };
const Wl = U(F.en), dh = () => Wl.value, o1 = (t) => {
  F[t] && (Wl.value = F[t]);
}, s1 = (t) => {
  dn = Object.assign(dn, t);
}, rt = (t) => ({ CTranslate: (n) => {
  var a;
  const r = t ?? Wl.value;
  return ((a = dn == null ? void 0 : dn[r]) == null ? void 0 : a[n]) ?? n;
}, getApplicationLocale: dh });
let Mo;
const l1 = {
  name: "CCopyToClipboard",
  components: {
    ClipboardCopy: cg,
    ClipboardCheck: sg,
    ClipboardX: dg
  },
  data() {
    return {
      copied: !1,
      errored: !1
    };
  },
  props: {
    textToCopy: {
      type: String,
      required: !0
    },
    locale: {
      type: String,
      required: !1,
      default: null
    },
    stateDuration: {
      type: Number,
      default: 2e3,
      required: !1
    }
  },
  setup(t) {
    const { CTranslate: e } = rt(t.locale);
    return { CTranslate: e };
  },
  emits: ["copy-success", "copy-failed"],
  computed: {
    currentIcon() {
      return this.copied ? "ClipboardCheck" : this.errored ? "ClipboardX" : "ClipboardCopy";
    },
    iconClass() {
      return this.copied ? "success" : this.errored ? "error" : "";
    }
  },
  methods: {
    copy() {
      const { textToCopy: t } = this;
      if (!navigator.clipboard) {
        this.errored = !0, this.cleanCurrentState(), this.$emit("copy-failed");
        return;
      }
      navigator.clipboard.writeText(t).then(() => {
        this.copied = !0, this.cleanCurrentState(), this.$emit("copy-success");
      }).catch(() => {
        this.errored = !0, this.cleanCurrentState(), this.$emit("copy-failed");
      });
    },
    cleanCurrentState() {
      Mo && clearTimeout(Mo), Mo = setTimeout(() => {
        this.copied = !1, this.errored = !1;
      }, this.stateDuration);
    }
  }
}, c1 = ["title"];
function u1(t, e, n, r, a, i) {
  return b(), M("span", {
    title: r.CTranslate("CCopyToClipboard.onHover"),
    class: "c-copy-to-clipboard-container"
  }, [
    (b(), L(_t(i.currentIcon), {
      class: H(["c-copy-to-clipboard c-icon-s", i.iconClass]),
      onClick: i.copy
    }, null, 8, ["class", "onClick"]))
  ], 8, c1);
}
const d1 = /* @__PURE__ */ B(l1, [["render", u1], ["__scopeId", "data-v-2b7bbec2"]]);
var Go = /* @__PURE__ */ ((t) => (t.STARTS_WITH = "startsWith", t.CONTAINS = "contains", t))(Go || {}), Ct = /* @__PURE__ */ ((t) => (t.UPDATE_SELECTED_OPTION = "update:selectedOption", t.UPDATE_SEARCH_QUERY = "update:searchQuery", t.DROPDOWN_OPEN = "dropdown:open", t.DROPDOWN_CLOSE = "dropdown:close", t))(Ct || {});
const f1 = 200;
let Rc;
const vn = {
  beforeMount: (t, e) => {
    t.clickOutsideEvent = (n) => {
      t === n.target || t.contains(n.target) || e.value();
    }, Rc = setTimeout(() => {
      document.addEventListener("click", t.clickOutsideEvent);
    }, f1);
  },
  unmounted: (t) => {
    clearTimeout(Rc), document.removeEventListener("click", t.clickOutsideEvent);
  }
}, h1 = /* @__PURE__ */ ne({
  __name: "CDropdownOption",
  props: {
    option: null,
    selected: { type: Boolean },
    highlighted: { type: Boolean }
  },
  setup(t) {
    return (e, n) => (b(), M("li", {
      class: H(["c-dropdown-option", { selected: t.selected, highlighted: t.highlighted }]),
      key: t.option.value
    }, [
      T(we, {
        type: "four",
        class: "c-dropdown-option-label"
      }, {
        default: W(() => [
          V(j(t.option.label), 1)
        ]),
        _: 1
      }),
      t.selected ? (b(), L(S(tg), {
        key: 0,
        class: "c-selected-icon c-icon-s"
      })) : E("", !0)
    ], 2));
  }
});
const Ec = /* @__PURE__ */ B(h1, [["__scopeId", "data-v-32f4748e"]]), p1 = { class: "c-dropdown-wrapper" }, m1 = ["onKeydown"], g1 = ["onClick"], v1 = ["placeholder", "onKeyup"], y1 = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    options: null,
    selectedOption: null,
    maxHeight: { default: 0 },
    emptyMessage: null,
    placeHolder: null,
    closeOnSelected: { type: Boolean, default: !0 },
    allowSearch: { type: Boolean, default: !1 },
    locale: null,
    searchStrategy: { default: Go.STARTS_WITH },
    openDropdown: { default: "bottom" }
  },
  emits: [
    Ct.UPDATE_SELECTED_OPTION,
    Ct.UPDATE_SEARCH_QUERY,
    Ct.DROPDOWN_OPEN,
    Ct.DROPDOWN_CLOSE
  ],
  setup(t, { emit: e }) {
    const n = t;
    so((k) => ({
      "0f9a38f6": S(f),
      "1dfdc1e0": S(y)
    }));
    const r = vn, { CTranslate: a } = rt(n.locale), i = U(!1), o = U(null), s = U(null), l = U(null), c = U(""), u = I(() => n.selectedOption && n.selectedOption.label ? n.selectedOption.label : typeof n.placeHolder < "u" ? n.placeHolder : a("CDropdown.placeHolder")), f = I(() => `${n.maxHeight}px`), d = async () => {
      i.value = !1, await So(), e(Ct.DROPDOWN_CLOSE), c.value = "", v.value = null;
    }, h = async () => {
      var k, P;
      i.value = !0, await So(), e(Ct.DROPDOWN_OPEN), (k = l.value) == null || k.focus(), (P = o.value) == null || P.focus();
    }, m = () => {
      i.value ? d() : h();
    }, p = (k) => {
      n.closeOnSelected && d(), e(Ct.UPDATE_SELECTED_OPTION, k);
    }, g = I(() => i.value ? "expanded " + n.openDropdown : n.openDropdown), v = U(null), w = (k) => {
      var $;
      if (["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "Enter", "Escape", "Tab"].includes(k.key))
        return;
      if (c.value = (($ = o.value) == null ? void 0 : $.value) || "", e(Ct.UPDATE_SEARCH_QUERY, c.value), c.value === "") {
        v.value = null;
        return;
      }
      if (n.searchStrategy === Go.STARTS_WITH) {
        const O = n.options.find((D) => D.label.toLowerCase().startsWith(c.value.toLowerCase()));
        O && (v.value = O);
        return;
      }
      const P = n.options.find((O) => O.label.toLowerCase().includes(c.value.toLowerCase()));
      P && (v.value = P);
    }, C = () => {
      if (v.value === null) {
        v.value = n.options[0];
        return;
      }
      const k = n.options.findIndex((P) => {
        var $;
        return P.value === (($ = v.value) == null ? void 0 : $.value);
      });
      k !== n.options.length - 1 && (v.value = n.options[k + 1]);
    }, x = () => {
      v.value || (v.value = n.options[n.options.length - 1]);
      const k = n.options.findIndex((P) => {
        var $;
        return P.value === (($ = v.value) == null ? void 0 : $.value);
      });
      k !== 0 && (v.value = n.options[k - 1]);
    }, y = I(() => n.options.length), _ = I(() => n.allowSearch && i.value);
    return Yt(() => v.value, async () => {
      if (await So(), !s.value)
        return;
      const k = s.value.querySelector(".highlighted");
      k && k.scrollIntoView({
        block: "nearest",
        behavior: "smooth"
      });
    }), (k, P) => (b(), M("div", p1, [
      Ve((b(), M("div", {
        class: H(["c-dropdown-container c-layer-flat", S(g)]),
        ref_key: "dropDownContainer",
        ref: l,
        onKeydown: [
          st(ve(d, ["stop"]), ["esc"]),
          P[0] || (P[0] = st(ve(($) => v.value ? p(v.value) : d, ["stop"]), ["enter"])),
          st(ve(C, ["stop"]), ["down"]),
          st(ve(x, ["stop"]), ["up"]),
          P[1] || (P[1] = st(ve(() => {
          }, ["stop"]), ["left"])),
          P[2] || (P[2] = st(ve(() => {
          }, ["stop"]), ["right"])),
          st(ve(d, ["stop"]), ["tab"])
        ]
      }, [
        i.value && t.openDropdown === "top" ? (b(), M("ul", {
          key: 0,
          ref_key: "dropDownList",
          ref: s,
          class: H({ "height-limited": t.maxHeight > 0 })
        }, [
          (b(!0), M(de, null, xe(t.options, ($) => {
            var O, D;
            return b(), L(Ec, {
              key: $.value,
              option: $,
              selected: $.value === ((O = t.selectedOption) == null ? void 0 : O.value),
              highlighted: $.value === ((D = v.value) == null ? void 0 : D.value),
              onClick: (N) => p($)
            }, null, 8, ["option", "selected", "highlighted", "onClick"]);
          }), 128))
        ], 2)) : E("", !0),
        R("div", {
          class: "c-dropdown-option",
          onClick: ve(m, ["stop"])
        }, [
          S(_) ? (b(), M("input", {
            key: 1,
            ref_key: "searchInput",
            ref: o,
            class: "c-input",
            placeholder: S(u),
            onKeyup: ve(w, ["stop"])
          }, null, 40, v1)) : (b(), L(we, {
            key: 0,
            type: "four",
            class: "c-dropdown-option-label"
          }, {
            default: W(() => [
              V(j(S(u)), 1)
            ]),
            _: 1
          })),
          i.value ? E("", !0) : (b(), L(S(fo), {
            key: 2,
            class: "c-icon-s c-interactive",
            onClick: ve(h, ["stop"])
          }, null, 8, ["onClick"])),
          i.value ? (b(), L(S(mo), {
            key: 3,
            class: "c-icon-s c-interactive",
            onClick: ve(d, ["stop"])
          }, null, 8, ["onClick"])) : E("", !0)
        ], 8, g1),
        i.value && t.openDropdown === "bottom" ? (b(), M("ul", {
          key: 1,
          ref_key: "dropDownList",
          ref: s,
          class: H({ "height-limited": t.maxHeight > 0 })
        }, [
          (b(!0), M(de, null, xe(t.options, ($) => {
            var O, D;
            return b(), L(Ec, {
              key: $.value,
              option: $,
              selected: $.value === ((O = t.selectedOption) == null ? void 0 : O.value),
              highlighted: $.value === ((D = v.value) == null ? void 0 : D.value),
              onClick: (N) => p($)
            }, null, 8, ["option", "selected", "highlighted", "onClick"]);
          }), 128))
        ], 2)) : E("", !0)
      ], 42, m1)), [
        [S(r), d]
      ])
    ]));
  }
});
const R$ = /* @__PURE__ */ B(y1, [["__scopeId", "data-v-b7cb1468"]]);
const b1 = {
  name: "SearchResultItem",
  components: {
    CSeparator: lo,
    CBadge: ur,
    CSubheading: Ne,
    CUi: we,
    Ticket: Zg,
    Compass: mg,
    Voucher: sv,
    Calendar: uo
  },
  props: {
    label: {
      required: !0,
      type: String
    },
    headBadges: {
      type: Array,
      required: !1,
      default: () => []
    },
    belowTitleLabels: {
      type: Array,
      required: !1,
      default: () => []
    },
    orderCode: {
      type: String,
      required: !1,
      default: ""
    },
    orderDate: {
      type: String,
      required: !1,
      default: ""
    },
    mainInfoHero: {
      required: !0,
      type: Object
    }
  },
  emits: ["action-onResultItem"],
  data() {
    return {
      CoppiIntents: G
    };
  },
  computed: {
    showBelowLabels() {
      return this.belowTitleLabels.length > 0;
    },
    attrs() {
      return {
        ...this.$attrs,
        div: (t) => this.$emit("action-onResultItem", t.target.value)
      };
    }
  }
}, _1 = (t) => (In("data-v-395a1e1c"), t = t(), Nn(), t), w1 = { class: "c-search-result" }, k1 = { class: "c-search-result-head" }, x1 = { class: "c-head-badges" }, C1 = { class: "c-date-code-block" }, P1 = { class: "c-search-result-body" }, S1 = {
  key: 0,
  class: "c-search-content-below-the-line"
}, M1 = { class: "c-search-content-bl-icon" }, O1 = { class: "c-search-content-bl-body" }, D1 = /* @__PURE__ */ _1(() => /* @__PURE__ */ R("span", null, "·", -1)), T1 = { class: "c-search-result-main-information" }, $1 = { class: "c-main-info-badge" };
function R1(t, e, n, r, a, i) {
  const o = z("c-badge"), s = z("c-subheading"), l = z("calendar"), c = z("c-ui"), u = z("c-separator");
  return b(), M("div", w1, [
    R("div", He({ class: "c-search-result-wrapper" }, Vp(i.attrs, !0)), [
      R("div", k1, [
        R("div", x1, [
          (b(!0), M(de, null, xe(n.headBadges, (f) => (b(), L(o, {
            key: f.label,
            intent: f.type ?? a.CoppiIntents.neutral,
            value: f.label
          }, null, 8, ["intent", "value"]))), 128))
        ]),
        R("div", C1, [
          T(s, {
            type: "four",
            class: "c-result-date"
          }, {
            default: W(() => [
              V(j(n.orderDate), 1)
            ]),
            _: 1
          }),
          n.orderDate && n.orderCode ? (b(), L(s, {
            key: 0,
            type: "four",
            class: "c-result-date-code-separator"
          }, {
            default: W(() => [
              V(" · ")
            ]),
            _: 1
          })) : E("", !0),
          T(s, {
            type: "four",
            class: "c-result-code"
          }, {
            default: W(() => [
              V(j(n.orderCode), 1)
            ]),
            _: 1
          })
        ])
      ]),
      R("div", P1, [
        R("div", null, [
          T(s, {
            type: "three",
            class: "c-search-result-label"
          }, {
            default: W(() => [
              V(j(n.label), 1)
            ]),
            _: 1
          }),
          i.showBelowLabels ? (b(), M("div", S1, [
            R("div", M1, [
              T(l, { class: "c-icon-xs" })
            ]),
            R("div", O1, [
              (b(!0), M(de, null, xe(n.belowTitleLabels, (f, d) => (b(), M(de, { key: d }, [
                T(c, { type: "five" }, {
                  default: W(() => [
                    V(j(f), 1)
                  ]),
                  _: 2
                }, 1024),
                d + 1 < n.belowTitleLabels.length ? (b(), L(c, {
                  key: 0,
                  type: "five"
                }, {
                  default: W(() => [
                    D1
                  ]),
                  _: 1
                })) : E("", !0)
              ], 64))), 128))
            ])
          ])) : E("", !0)
        ]),
        R("div", T1, [
          T(s, {
            type: "three",
            class: "c-main-info-hero"
          }, {
            default: W(() => [
              V(j(n.mainInfoHero.label) + " ", 1),
              n.mainInfoHero.icon ? (b(), L(_t(n.mainInfoHero.icon), {
                key: 0,
                class: "c-icon-xs c-main-info-icon"
              })) : E("", !0)
            ]),
            _: 1
          }),
          R("div", $1, [
            n.mainInfoHero.badge ? (b(), L(o, {
              key: 0,
              intent: n.mainInfoHero.badge.type ?? "",
              value: n.mainInfoHero.badge.label
            }, null, 8, ["intent", "value"])) : E("", !0)
          ])
        ])
      ])
    ], 16),
    T(u, { class: "c-bottom-separator" })
  ]);
}
const E$ = /* @__PURE__ */ B(b1, [["render", R1], ["__scopeId", "data-v-395a1e1c"]]);
const E1 = {}, A1 = /* @__PURE__ */ Tl('<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-f5ecbae1><path d="M14.167 9.16667L17.5003 5.83333L14.167 2.5" stroke="#005DEA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-v-f5ecbae1></path><path d="M17.5 5.83337H7.5" stroke="#005DEA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-v-f5ecbae1></path><path d="M5.83333 17.5L2.5 14.1667L5.83333 10.8334" stroke="#005DEA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-v-f5ecbae1></path><path d="M12.5 14.1666H2.5" stroke="#005DEA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-v-f5ecbae1></path></svg>', 1), L1 = [
  A1
];
function I1(t, e) {
  return b(), M("span", null, L1);
}
const N1 = /* @__PURE__ */ B(E1, [["render", I1], ["__scopeId", "data-v-f5ecbae1"]]), W1 = { class: "c-drop-down-wrapper" }, z1 = { class: "c-list-hour" }, B1 = ["onClick"], F1 = { class: "c-list-minute" }, H1 = ["onClick"], j1 = { class: "c-dropdown-option-label" }, V1 = /* @__PURE__ */ ne({
  __name: "CTimePickerModal",
  props: {
    hourMinValue: { default: 0 },
    hourMaxValue: { default: 24 },
    minuteMinValue: { default: 0 },
    minuteMaxValue: { default: 60 },
    hours: null,
    minutes: null
  },
  emits: ["handleHourSelection", "handleMinuteSelection"],
  setup(t, { emit: e }) {
    const n = t, r = (u, f, d) => Array.from(
      { length: (f - u) / d + 1 },
      (h, m) => {
        const p = u + m * d;
        return p < 10 ? "0" + p : p;
      }
    ), a = I(() => r(n.hourMinValue, n.hourMaxValue, 1)), i = I(() => r(n.minuteMinValue, n.minuteMaxValue, 1)), o = I({
      get() {
        return n.hours;
      },
      set(u) {
        e("handleHourSelection", u);
      }
    }), s = I({
      get() {
        return n.minutes;
      },
      set(u) {
        e("handleMinuteSelection", u);
      }
    }), l = (u) => {
      o.value = u;
    }, c = (u) => {
      s.value = u;
    };
    return (u, f) => (b(), M("div", W1, [
      R("div", z1, [
        (b(!0), M(de, null, xe(S(a), (d) => (b(), M("li", {
          key: d,
          class: H(["c-list", d === S(o) ? "selected" : ""]),
          onClick: (h) => l(d)
        }, [
          T(Ne, {
            type: "three",
            class: "c-dropdown-option-label"
          }, {
            default: W(() => [
              V(j(d), 1)
            ]),
            _: 2
          }, 1024)
        ], 10, B1))), 128))
      ]),
      R("div", F1, [
        (b(!0), M(de, null, xe(S(i), (d) => (b(), M("li", {
          key: d,
          class: H(["c-list", d === S(s) ? "selected" : ""]),
          onClick: (h) => c(d)
        }, [
          R("p", j1, [
            T(Ne, { type: "three" }, {
              default: W(() => [
                V(j(d), 1)
              ]),
              _: 2
            }, 1024)
          ])
        ], 10, H1))), 128))
      ])
    ]));
  }
});
const q1 = /* @__PURE__ */ B(V1, [["__scopeId", "data-v-1596c1ad"]]);
class fh {
  constructor(e, n = "hh:mm") {
    A(this, "separator");
    A(this, "format");
    A(this, "value", "");
    this.separator = e, this.format = n;
  }
  getDoubleDigitedValue(e) {
    return e ? Number(e).toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: !1 }) : "";
  }
  getMinuteValue(e) {
    return (e == null ? void 0 : e.length) === 1 && Number(e) >= 6 ? this.getDoubleDigitedValue(e) : e ?? "";
  }
  getAsTime(e = "", n = "") {
    return e === "" && n === "" ? this.value = "" : n === "" && ((e == null ? void 0 : e.length) === 1 && Number(e) > 2 || (e == null ? void 0 : e.length) === 2 && Number(e) <= 23) ? (this.value = this.getDoubleDigitedValue(e) + this.separator, this.value) : n === "" && Number(e) >= 23 ? (this.value = this.getDoubleDigitedValue(e.slice(0, 1)) + this.separator + this.getMinuteValue(e.slice(1)), this.value) : n === "" ? (this.value = e, this.value) : (this.value = this.getDoubleDigitedValue(e) + this.separator + this.getMinuteValue(n), this.value);
  }
  formatTimeInputValue(e) {
    return this.value = e, { hours: this.value.split(this.separator)[0] ?? "", minutes: this.value.split(this.separator)[1] ?? "" };
  }
}
function re(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function Z(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function va(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? va = function(n) {
    return typeof n;
  } : va = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, va(t);
}
function ie(t) {
  Z(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || va(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function hr(t, e) {
  Z(2, arguments);
  var n = ie(t), r = re(e);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function zl(t, e) {
  Z(2, arguments);
  var n = ie(t), r = re(e);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var a = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var o = i.getDate();
  return a >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), a), n);
}
function ya(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ya = function(n) {
    return typeof n;
  } : ya = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ya(t);
}
function mi(t, e) {
  if (Z(2, arguments), !e || ya(e) !== "object")
    return /* @__PURE__ */ new Date(NaN);
  var n = e.years ? re(e.years) : 0, r = e.months ? re(e.months) : 0, a = e.weeks ? re(e.weeks) : 0, i = e.days ? re(e.days) : 0, o = e.hours ? re(e.hours) : 0, s = e.minutes ? re(e.minutes) : 0, l = e.seconds ? re(e.seconds) : 0, c = ie(t), u = r || n ? zl(c, r + n * 12) : c, f = i || a ? hr(u, i + a * 7) : u, d = s + o * 60, h = l + d * 60, m = h * 1e3, p = new Date(f.getTime() + m);
  return p;
}
function U1(t, e) {
  Z(2, arguments);
  var n = ie(t).getTime(), r = re(e);
  return new Date(n + r);
}
var Y1 = {};
function yn() {
  return Y1;
}
function hh(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
function Bt(t) {
  Z(1, arguments);
  var e = ie(t);
  return e.setHours(0, 0, 0, 0), e;
}
function ph(t, e) {
  Z(2, arguments);
  var n = re(e);
  return zl(t, n * 12);
}
var Bl = 6e4, Fl = 36e5, X1 = 1e3;
function ze(t, e) {
  Z(2, arguments);
  var n = Bt(t), r = Bt(e);
  return n.getTime() === r.getTime();
}
function ba(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ba = function(n) {
    return typeof n;
  } : ba = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ba(t);
}
function K1(t) {
  return Z(1, arguments), t instanceof Date || ba(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Hl(t) {
  if (Z(1, arguments), !K1(t) && typeof t != "number")
    return !1;
  var e = ie(t);
  return !isNaN(Number(e));
}
function Q1(t) {
  Z(1, arguments);
  var e = ie(t);
  return e.setHours(23, 59, 59, 999), e;
}
function _n(t) {
  Z(1, arguments);
  var e = ie(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function G1(t, e) {
  var n, r, a, i, o, s, l, c;
  Z(1, arguments);
  var u = yn(), f = re((n = (r = (a = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = ie(t), h = d.getDay(), m = (h < f ? -7 : 0) + 6 - (h - f);
  return d.setDate(d.getDate() + m), d.setHours(23, 59, 59, 999), d;
}
function mh(t, e) {
  Z(2, arguments);
  var n = re(e);
  return U1(t, -n);
}
var Z1 = 864e5;
function J1(t) {
  Z(1, arguments);
  var e = ie(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), a = n - r;
  return Math.floor(a / Z1) + 1;
}
function $n(t) {
  Z(1, arguments);
  var e = 1, n = ie(t), r = n.getUTCDay(), a = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function gh(t) {
  Z(1, arguments);
  var e = ie(t), n = e.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = $n(r), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = $n(i);
  return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function eb(t) {
  Z(1, arguments);
  var e = gh(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = $n(n);
  return r;
}
var tb = 6048e5;
function vh(t) {
  Z(1, arguments);
  var e = ie(t), n = $n(e).getTime() - eb(e).getTime();
  return Math.round(n / tb) + 1;
}
function Lt(t, e) {
  var n, r, a, i, o, s, l, c;
  Z(1, arguments);
  var u = yn(), f = re((n = (r = (a = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = ie(t), h = d.getUTCDay(), m = (h < f ? 7 : 0) + h - f;
  return d.setUTCDate(d.getUTCDate() - m), d.setUTCHours(0, 0, 0, 0), d;
}
function jl(t, e) {
  var n, r, a, i, o, s, l, c;
  Z(1, arguments);
  var u = ie(t), f = u.getUTCFullYear(), d = yn(), h = re((n = (r = (a = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : d.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(f + 1, 0, h), m.setUTCHours(0, 0, 0, 0);
  var p = Lt(m, e), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(f, 0, h), g.setUTCHours(0, 0, 0, 0);
  var v = Lt(g, e);
  return u.getTime() >= p.getTime() ? f + 1 : u.getTime() >= v.getTime() ? f : f - 1;
}
function nb(t, e) {
  var n, r, a, i, o, s, l, c;
  Z(1, arguments);
  var u = yn(), f = re((n = (r = (a = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), d = jl(t, e), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(d, 0, f), h.setUTCHours(0, 0, 0, 0);
  var m = Lt(h, e);
  return m;
}
var rb = 6048e5;
function yh(t, e) {
  Z(1, arguments);
  var n = ie(t), r = Lt(n, e).getTime() - nb(n, e).getTime();
  return Math.round(r / rb) + 1;
}
function fe(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var ab = {
  // Year
  y: function(e, n) {
    var r = e.getUTCFullYear(), a = r > 0 ? r : 1 - r;
    return fe(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M: function(e, n) {
    var r = e.getUTCMonth();
    return n === "M" ? String(r + 1) : fe(r + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return fe(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return fe(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return fe(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return fe(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return fe(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var r = n.length, a = e.getUTCMilliseconds(), i = Math.floor(a * Math.pow(10, r - 3));
    return fe(i, n.length);
  }
};
const zt = ab;
var wn = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ib = {
  // Era
  G: function(e, n, r) {
    var a = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, r) {
    if (n === "yo") {
      var a = e.getUTCFullYear(), i = a > 0 ? a : 1 - a;
      return r.ordinalNumber(i, {
        unit: "year"
      });
    }
    return zt.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, r, a) {
    var i = jl(e, a), o = i > 0 ? i : 1 - i;
    if (n === "YY") {
      var s = o % 100;
      return fe(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(o, {
      unit: "year"
    }) : fe(o, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var r = gh(e);
    return fe(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var r = e.getUTCFullYear();
    return fe(r, n.length);
  },
  // Quarter
  Q: function(e, n, r) {
    var a = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(a);
      case "QQ":
        return fe(a, 2);
      case "Qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, r) {
    var a = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(a);
      case "qq":
        return fe(a, 2);
      case "qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, r) {
    var a = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return zt.M(e, n);
      case "Mo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, r) {
    var a = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(a + 1);
      case "LL":
        return fe(a + 1, 2);
      case "Lo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, r, a) {
    var i = yh(e, a);
    return n === "wo" ? r.ordinalNumber(i, {
      unit: "week"
    }) : fe(i, n.length);
  },
  // ISO week of year
  I: function(e, n, r) {
    var a = vh(e);
    return n === "Io" ? r.ordinalNumber(a, {
      unit: "week"
    }) : fe(a, n.length);
  },
  // Day of the month
  d: function(e, n, r) {
    return n === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : zt.d(e, n);
  },
  // Day of year
  D: function(e, n, r) {
    var a = J1(e);
    return n === "Do" ? r.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : fe(a, n.length);
  },
  // Day of week
  E: function(e, n, r) {
    var a = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, r, a) {
    var i = e.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(o);
      case "ee":
        return fe(o, 2);
      case "eo":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, r, a) {
    var i = e.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(o);
      case "cc":
        return fe(o, n.length);
      case "co":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, r) {
    var a = e.getUTCDay(), i = a === 0 ? 7 : a;
    switch (n) {
      case "i":
        return String(i);
      case "ii":
        return fe(i, n.length);
      case "io":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, r) {
    var a = e.getUTCHours(), i = a / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, r) {
    var a = e.getUTCHours(), i;
    switch (a === 12 ? i = wn.noon : a === 0 ? i = wn.midnight : i = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, r) {
    var a = e.getUTCHours(), i;
    switch (a >= 17 ? i = wn.evening : a >= 12 ? i = wn.afternoon : a >= 4 ? i = wn.morning : i = wn.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, r) {
    if (n === "ho") {
      var a = e.getUTCHours() % 12;
      return a === 0 && (a = 12), r.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return zt.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, r) {
    return n === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : zt.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, r) {
    var a = e.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : fe(a, n.length);
  },
  // Hour [1-24]
  k: function(e, n, r) {
    var a = e.getUTCHours();
    return a === 0 && (a = 24), n === "ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : fe(a, n.length);
  },
  // Minute
  m: function(e, n, r) {
    return n === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : zt.m(e, n);
  },
  // Second
  s: function(e, n, r) {
    return n === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : zt.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return zt.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, r, a) {
    var i = a._originalDate || e, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (n) {
      case "X":
        return Lc(o);
      case "XXXX":
      case "XX":
        return on(o);
      case "XXXXX":
      case "XXX":
      default:
        return on(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, r, a) {
    var i = a._originalDate || e, o = i.getTimezoneOffset();
    switch (n) {
      case "x":
        return Lc(o);
      case "xxxx":
      case "xx":
        return on(o);
      case "xxxxx":
      case "xxx":
      default:
        return on(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, r, a) {
    var i = a._originalDate || e, o = i.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ac(o, ":");
      case "OOOO":
      default:
        return "GMT" + on(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, r, a) {
    var i = a._originalDate || e, o = i.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ac(o, ":");
      case "zzzz":
      default:
        return "GMT" + on(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, r, a) {
    var i = a._originalDate || e, o = Math.floor(i.getTime() / 1e3);
    return fe(o, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, r, a) {
    var i = a._originalDate || e, o = i.getTime();
    return fe(o, n.length);
  }
};
function Ac(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(a);
  var o = e || "";
  return n + String(a) + o + fe(i, 2);
}
function Lc(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + fe(Math.abs(t) / 60, 2);
  }
  return on(t, e);
}
function on(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", a = Math.abs(t), i = fe(Math.floor(a / 60), 2), o = fe(a % 60, 2);
  return r + i + n + o;
}
const ob = ib;
var Ic = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, bh = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, sb = function(e, n) {
  var r = e.match(/(P+)(p+)?/) || [], a = r[1], i = r[2];
  if (!i)
    return Ic(e, n);
  var o;
  switch (a) {
    case "P":
      o = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = n.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Ic(a, n)).replace("{{time}}", bh(i, n));
}, lb = {
  p: bh,
  P: sb
};
const Zo = lb;
var cb = ["D", "DD"], ub = ["YY", "YYYY"];
function _h(t) {
  return cb.indexOf(t) !== -1;
}
function wh(t) {
  return ub.indexOf(t) !== -1;
}
function gi(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var db = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, fb = function(e, n, r) {
  var a, i = db[e];
  return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : a + " ago" : a;
};
const kh = fb;
function oe(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var hb = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, pb = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, mb = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, gb = {
  date: oe({
    formats: hb,
    defaultWidth: "full"
  }),
  time: oe({
    formats: pb,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: mb,
    defaultWidth: "full"
  })
};
const vb = gb;
var yb = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, bb = function(e, n, r, a) {
  return yb[e];
};
const xh = bb;
function X(t) {
  return function(e, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", a;
    if (r === "formatting" && t.formattingValues) {
      var i = t.defaultFormattingWidth || t.defaultWidth, o = n != null && n.width ? String(n.width) : i;
      a = t.formattingValues[o] || t.formattingValues[i];
    } else {
      var s = t.defaultWidth, l = n != null && n.width ? String(n.width) : t.defaultWidth;
      a = t.values[l] || t.values[s];
    }
    var c = t.argumentCallback ? t.argumentCallback(e) : e;
    return a[c];
  };
}
var _b = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, wb = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, kb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, xb = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Cb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Pb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Sb = function(e, n) {
  var r = Number(e), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Mb = {
  ordinalNumber: Sb,
  era: X({
    values: _b,
    defaultWidth: "wide"
  }),
  quarter: X({
    values: wb,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: X({
    values: kb,
    defaultWidth: "wide"
  }),
  day: X({
    values: xb,
    defaultWidth: "wide"
  }),
  dayPeriod: X({
    values: Cb,
    defaultWidth: "wide",
    formattingValues: Pb,
    defaultFormattingWidth: "wide"
  })
};
const Ch = Mb;
function K(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, a = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], i = e.match(a);
    if (!i)
      return null;
    var o = i[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? Db(s, function(f) {
      return f.test(o);
    }) : Ob(s, function(f) {
      return f.test(o);
    }), c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var u = e.slice(o.length);
    return {
      value: c,
      rest: u
    };
  };
}
function Ob(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function Db(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function pt(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r)
      return null;
    var a = r[0], i = e.match(t.parsePattern);
    if (!i)
      return null;
    var o = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var s = e.slice(a.length);
    return {
      value: o,
      rest: s
    };
  };
}
var Tb = /^(\d+)(th|st|nd|rd)?/i, $b = /\d+/i, Rb = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Eb = {
  any: [/^b/i, /^(a|c)/i]
}, Ab = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Lb = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ib = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Nb = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Wb = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, zb = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Bb = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Fb = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Hb = {
  ordinalNumber: pt({
    matchPattern: Tb,
    parsePattern: $b,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: K({
    matchPatterns: Rb,
    defaultMatchWidth: "wide",
    parsePatterns: Eb,
    defaultParseWidth: "any"
  }),
  quarter: K({
    matchPatterns: Ab,
    defaultMatchWidth: "wide",
    parsePatterns: Lb,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: K({
    matchPatterns: Ib,
    defaultMatchWidth: "wide",
    parsePatterns: Nb,
    defaultParseWidth: "any"
  }),
  day: K({
    matchPatterns: Wb,
    defaultMatchWidth: "wide",
    parsePatterns: zb,
    defaultParseWidth: "any"
  }),
  dayPeriod: K({
    matchPatterns: Bb,
    defaultMatchWidth: "any",
    parsePatterns: Fb,
    defaultParseWidth: "any"
  })
};
const Ph = Hb;
var jb = {
  code: "en-US",
  formatDistance: kh,
  formatLong: vb,
  formatRelative: xh,
  localize: Ch,
  match: Ph,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Sh = jb;
var Vb = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, qb = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ub = /^'([^]*?)'?$/, Yb = /''/g, Xb = /[a-zA-Z]/;
function Et(t, e, n) {
  var r, a, i, o, s, l, c, u, f, d, h, m, p, g, v, w, C, x;
  Z(2, arguments);
  var y = String(e), _ = yn(), k = (r = (a = n == null ? void 0 : n.locale) !== null && a !== void 0 ? a : _.locale) !== null && r !== void 0 ? r : Sh, P = re((i = (o = (s = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && s !== void 0 ? s : _.firstWeekContainsDate) !== null && o !== void 0 ? o : (f = _.locale) === null || f === void 0 || (d = f.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(P >= 1 && P <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var $ = re((h = (m = (p = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (v = n.locale) === null || v === void 0 || (w = v.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && p !== void 0 ? p : _.weekStartsOn) !== null && m !== void 0 ? m : (C = _.locale) === null || C === void 0 || (x = C.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!($ >= 0 && $ <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!k.localize)
    throw new RangeError("locale must contain localize property");
  if (!k.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var O = ie(t);
  if (!Hl(O))
    throw new RangeError("Invalid time value");
  var D = hh(O), N = mh(O, D), q = {
    firstWeekContainsDate: P,
    weekStartsOn: $,
    locale: k,
    _originalDate: O
  }, le = y.match(qb).map(function(Y) {
    var Q = Y[0];
    if (Q === "p" || Q === "P") {
      var te = Zo[Q];
      return te(Y, k.formatLong);
    }
    return Y;
  }).join("").match(Vb).map(function(Y) {
    if (Y === "''")
      return "'";
    var Q = Y[0];
    if (Q === "'")
      return Kb(Y);
    var te = ob[Q];
    if (te)
      return !(n != null && n.useAdditionalWeekYearTokens) && wh(Y) && gi(Y, e, String(t)), !(n != null && n.useAdditionalDayOfYearTokens) && _h(Y) && gi(Y, e, String(t)), te(N, Y, k.localize, q);
    if (Q.match(Xb))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Q + "`");
    return Y;
  }).join("");
  return le;
}
function Kb(t) {
  var e = t.match(Ub);
  return e ? e[1].replace(Yb, "'") : t;
}
function Qb(t, e) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t;
}
function Gb(t) {
  Z(1, arguments);
  var e = ie(t), n = e.getDay();
  return n;
}
function Mh(t) {
  Z(1, arguments);
  var e = ie(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function pr(t, e) {
  Z(2, arguments);
  var n = ie(t), r = ie(e);
  return n.getTime() > r.getTime();
}
function mr(t, e) {
  Z(2, arguments);
  var n = ie(t), r = ie(e);
  return n.getTime() < r.getTime();
}
function Zb(t) {
  return Z(1, arguments), ie(t).getTime() > Date.now();
}
function _a(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _a = function(n) {
    return typeof n;
  } : _a = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _a(t);
}
function Oh(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Jo(t, e);
}
function Jo(t, e) {
  return Jo = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Jo(t, e);
}
function Dh(t) {
  var e = e0();
  return function() {
    var r = vi(t), a;
    if (e) {
      var i = vi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Jb(this, a);
  };
}
function Jb(t, e) {
  return e && (_a(e) === "object" || typeof e == "function") ? e : es(t);
}
function es(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function e0() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function vi(t) {
  return vi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, vi(t);
}
function Vl(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Nc(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function ql(t, e, n) {
  return e && Nc(t.prototype, e), n && Nc(t, n), t;
}
function ts(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var t0 = 10, Th = /* @__PURE__ */ function() {
  function t() {
    Vl(this, t), ts(this, "subPriority", 0);
  }
  return ql(t, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), t;
}(), n0 = /* @__PURE__ */ function(t) {
  Oh(n, t);
  var e = Dh(n);
  function n(r, a, i, o, s) {
    var l;
    return Vl(this, n), l = e.call(this), l.value = r, l.validateValue = a, l.setValue = i, l.priority = o, s && (l.subPriority = s), l;
  }
  return ql(n, [{
    key: "validate",
    value: function(a, i) {
      return this.validateValue(a, this.value, i);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return this.setValue(a, i, this.value, o);
    }
  }]), n;
}(Th), r0 = /* @__PURE__ */ function(t) {
  Oh(n, t);
  var e = Dh(n);
  function n() {
    var r;
    Vl(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), ts(es(r), "priority", t0), ts(es(r), "subPriority", -1), r;
  }
  return ql(n, [{
    key: "set",
    value: function(a, i) {
      if (i.timestampIsSet)
        return a;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), o.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), o;
    }
  }]), n;
}(Th);
function a0(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Wc(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function i0(t, e, n) {
  return e && Wc(t.prototype, e), n && Wc(t, n), t;
}
var ce = /* @__PURE__ */ function() {
  function t() {
    a0(this, t);
  }
  return i0(t, [{
    key: "run",
    value: function(n, r, a, i) {
      var o = this.parse(n, r, a, i);
      return o ? {
        setter: new n0(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, a) {
      return !0;
    }
  }]), t;
}();
function wa(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? wa = function(n) {
    return typeof n;
  } : wa = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, wa(t);
}
function o0(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function zc(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function s0(t, e, n) {
  return e && zc(t.prototype, e), n && zc(t, n), t;
}
function l0(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && ns(t, e);
}
function ns(t, e) {
  return ns = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, ns(t, e);
}
function c0(t) {
  var e = d0();
  return function() {
    var r = yi(t), a;
    if (e) {
      var i = yi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return u0(this, a);
  };
}
function u0(t, e) {
  return e && (wa(e) === "object" || typeof e == "function") ? e : rs(t);
}
function rs(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function d0() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function yi(t) {
  return yi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, yi(t);
}
function Bc(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var f0 = /* @__PURE__ */ function(t) {
  l0(n, t);
  var e = c0(n);
  function n() {
    var r;
    o0(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Bc(rs(r), "priority", 140), Bc(rs(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return s0(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(a, {
            width: "abbreviated"
          }) || o.era(a, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(a, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(a, {
            width: "wide"
          }) || o.era(a, {
            width: "abbreviated"
          }) || o.era(a, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.era = o, a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce), Oe = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, vt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function De(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function Ce(t, e) {
  var n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function yt(t, e) {
  var n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, a = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (a * Fl + i * Bl + o * X1),
    rest: e.slice(n[0].length)
  };
}
function $h(t) {
  return Ce(Oe.anyDigitsSigned, t);
}
function Me(t, e) {
  switch (t) {
    case 1:
      return Ce(Oe.singleDigit, e);
    case 2:
      return Ce(Oe.twoDigits, e);
    case 3:
      return Ce(Oe.threeDigits, e);
    case 4:
      return Ce(Oe.fourDigits, e);
    default:
      return Ce(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function bi(t, e) {
  switch (t) {
    case 1:
      return Ce(Oe.singleDigitSigned, e);
    case 2:
      return Ce(Oe.twoDigitsSigned, e);
    case 3:
      return Ce(Oe.threeDigitsSigned, e);
    case 4:
      return Ce(Oe.fourDigitsSigned, e);
    default:
      return Ce(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function Ul(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Rh(t, e) {
  var n = e > 0, r = n ? e : 1 - e, a;
  if (r <= 50)
    a = t || 100;
  else {
    var i = r + 50, o = Math.floor(i / 100) * 100, s = t >= i % 100;
    a = t + o - (s ? 100 : 0);
  }
  return n ? a : 1 - a;
}
function Eh(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function ka(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ka = function(n) {
    return typeof n;
  } : ka = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ka(t);
}
function h0(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Fc(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function p0(t, e, n) {
  return e && Fc(t.prototype, e), n && Fc(t, n), t;
}
function m0(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && as(t, e);
}
function as(t, e) {
  return as = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, as(t, e);
}
function g0(t) {
  var e = y0();
  return function() {
    var r = _i(t), a;
    if (e) {
      var i = _i(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return v0(this, a);
  };
}
function v0(t, e) {
  return e && (ka(e) === "object" || typeof e == "function") ? e : is(t);
}
function is(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function y0() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _i(t) {
  return _i = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _i(t);
}
function Hc(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var b0 = /* @__PURE__ */ function(t) {
  m0(n, t);
  var e = g0(n);
  function n() {
    var r;
    h0(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Hc(is(r), "priority", 130), Hc(is(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return p0(n, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return De(Me(4, a), s);
        case "yo":
          return De(o.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return De(Me(i.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var l = Rh(o.year, s);
        return a.setUTCFullYear(l, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
      }
      var c = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(c, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function xa(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? xa = function(n) {
    return typeof n;
  } : xa = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, xa(t);
}
function _0(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function jc(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function w0(t, e, n) {
  return e && jc(t.prototype, e), n && jc(t, n), t;
}
function k0(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && os(t, e);
}
function os(t, e) {
  return os = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, os(t, e);
}
function x0(t) {
  var e = P0();
  return function() {
    var r = wi(t), a;
    if (e) {
      var i = wi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return C0(this, a);
  };
}
function C0(t, e) {
  return e && (xa(e) === "object" || typeof e == "function") ? e : ss(t);
}
function ss(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function P0() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function wi(t) {
  return wi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, wi(t);
}
function Vc(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var S0 = /* @__PURE__ */ function(t) {
  k0(n, t);
  var e = x0(n);
  function n() {
    var r;
    _0(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Vc(ss(r), "priority", 130), Vc(ss(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return w0(n, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return De(Me(4, a), s);
        case "Yo":
          return De(o.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return De(Me(i.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      var l = jl(a, s);
      if (o.isTwoDigitYear) {
        var c = Rh(o.year, l);
        return a.setUTCFullYear(c, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), Lt(a, s);
      }
      var u = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(u, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), Lt(a, s);
    }
  }]), n;
}(ce);
function Ca(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ca = function(n) {
    return typeof n;
  } : Ca = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ca(t);
}
function M0(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function qc(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function O0(t, e, n) {
  return e && qc(t.prototype, e), n && qc(t, n), t;
}
function D0(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && ls(t, e);
}
function ls(t, e) {
  return ls = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, ls(t, e);
}
function T0(t) {
  var e = R0();
  return function() {
    var r = ki(t), a;
    if (e) {
      var i = ki(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return $0(this, a);
  };
}
function $0(t, e) {
  return e && (Ca(e) === "object" || typeof e == "function") ? e : cs(t);
}
function cs(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function R0() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ki(t) {
  return ki = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ki(t);
}
function Uc(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var E0 = /* @__PURE__ */ function(t) {
  D0(n, t);
  var e = T0(n);
  function n() {
    var r;
    M0(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Uc(cs(r), "priority", 130), Uc(cs(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return O0(n, [{
    key: "parse",
    value: function(a, i) {
      return bi(i === "R" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), $n(s);
    }
  }]), n;
}(ce);
function Pa(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Pa = function(n) {
    return typeof n;
  } : Pa = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Pa(t);
}
function A0(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Yc(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function L0(t, e, n) {
  return e && Yc(t.prototype, e), n && Yc(t, n), t;
}
function I0(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && us(t, e);
}
function us(t, e) {
  return us = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, us(t, e);
}
function N0(t) {
  var e = z0();
  return function() {
    var r = xi(t), a;
    if (e) {
      var i = xi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return W0(this, a);
  };
}
function W0(t, e) {
  return e && (Pa(e) === "object" || typeof e == "function") ? e : ds(t);
}
function ds(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function z0() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function xi(t) {
  return xi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, xi(t);
}
function Xc(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var B0 = /* @__PURE__ */ function(t) {
  I0(n, t);
  var e = N0(n);
  function n() {
    var r;
    A0(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Xc(ds(r), "priority", 130), Xc(ds(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return L0(n, [{
    key: "parse",
    value: function(a, i) {
      return bi(i === "u" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Sa(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Sa = function(n) {
    return typeof n;
  } : Sa = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Sa(t);
}
function F0(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Kc(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function H0(t, e, n) {
  return e && Kc(t.prototype, e), n && Kc(t, n), t;
}
function j0(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && fs(t, e);
}
function fs(t, e) {
  return fs = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, fs(t, e);
}
function V0(t) {
  var e = U0();
  return function() {
    var r = Ci(t), a;
    if (e) {
      var i = Ci(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return q0(this, a);
  };
}
function q0(t, e) {
  return e && (Sa(e) === "object" || typeof e == "function") ? e : hs(t);
}
function hs(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function U0() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ci(t) {
  return Ci = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ci(t);
}
function Qc(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Y0 = /* @__PURE__ */ function(t) {
  j0(n, t);
  var e = V0(n);
  function n() {
    var r;
    F0(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Qc(hs(r), "priority", 120), Qc(hs(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return H0(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "Q":
        case "QQ":
          return Me(i.length, a);
        case "Qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Ma(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ma = function(n) {
    return typeof n;
  } : Ma = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ma(t);
}
function X0(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Gc(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function K0(t, e, n) {
  return e && Gc(t.prototype, e), n && Gc(t, n), t;
}
function Q0(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && ps(t, e);
}
function ps(t, e) {
  return ps = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, ps(t, e);
}
function G0(t) {
  var e = J0();
  return function() {
    var r = Pi(t), a;
    if (e) {
      var i = Pi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Z0(this, a);
  };
}
function Z0(t, e) {
  return e && (Ma(e) === "object" || typeof e == "function") ? e : ms(t);
}
function ms(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function J0() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Pi(t) {
  return Pi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Pi(t);
}
function Zc(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var e_ = /* @__PURE__ */ function(t) {
  Q0(n, t);
  var e = G0(n);
  function n() {
    var r;
    X0(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Zc(ms(r), "priority", 120), Zc(ms(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return K0(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "q":
        case "qq":
          return Me(i.length, a);
        case "qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Oa(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Oa = function(n) {
    return typeof n;
  } : Oa = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Oa(t);
}
function t_(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Jc(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function n_(t, e, n) {
  return e && Jc(t.prototype, e), n && Jc(t, n), t;
}
function r_(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && gs(t, e);
}
function gs(t, e) {
  return gs = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, gs(t, e);
}
function a_(t) {
  var e = o_();
  return function() {
    var r = Si(t), a;
    if (e) {
      var i = Si(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return i_(this, a);
  };
}
function i_(t, e) {
  return e && (Oa(e) === "object" || typeof e == "function") ? e : vs(t);
}
function vs(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function o_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Si(t) {
  return Si = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Si(t);
}
function eu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var s_ = /* @__PURE__ */ function(t) {
  r_(n, t);
  var e = a_(n);
  function n() {
    var r;
    t_(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), eu(vs(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), eu(vs(r), "priority", 110), r;
  }
  return n_(n, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return c - 1;
      };
      switch (i) {
        case "M":
          return De(Ce(Oe.month, a), s);
        case "MM":
          return De(Me(2, a), s);
        case "Mo":
          return De(o.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "MMM":
          return o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(a, {
            width: "wide",
            context: "formatting"
          }) || o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Da(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Da = function(n) {
    return typeof n;
  } : Da = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Da(t);
}
function l_(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function tu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function c_(t, e, n) {
  return e && tu(t.prototype, e), n && tu(t, n), t;
}
function u_(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && ys(t, e);
}
function ys(t, e) {
  return ys = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, ys(t, e);
}
function d_(t) {
  var e = h_();
  return function() {
    var r = Mi(t), a;
    if (e) {
      var i = Mi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return f_(this, a);
  };
}
function f_(t, e) {
  return e && (Da(e) === "object" || typeof e == "function") ? e : bs(t);
}
function bs(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function h_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Mi(t) {
  return Mi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Mi(t);
}
function nu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var p_ = /* @__PURE__ */ function(t) {
  u_(n, t);
  var e = d_(n);
  function n() {
    var r;
    l_(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), nu(bs(r), "priority", 110), nu(bs(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return c_(n, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return c - 1;
      };
      switch (i) {
        case "L":
          return De(Ce(Oe.month, a), s);
        case "LL":
          return De(Me(2, a), s);
        case "Lo":
          return De(o.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "LLL":
          return o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(a, {
            width: "wide",
            context: "standalone"
          }) || o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function m_(t, e, n) {
  Z(2, arguments);
  var r = ie(t), a = re(e), i = yh(r, n) - a;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
function Ta(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ta = function(n) {
    return typeof n;
  } : Ta = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ta(t);
}
function g_(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ru(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function v_(t, e, n) {
  return e && ru(t.prototype, e), n && ru(t, n), t;
}
function y_(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && _s(t, e);
}
function _s(t, e) {
  return _s = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, _s(t, e);
}
function b_(t) {
  var e = w_();
  return function() {
    var r = Oi(t), a;
    if (e) {
      var i = Oi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return __(this, a);
  };
}
function __(t, e) {
  return e && (Ta(e) === "object" || typeof e == "function") ? e : ws(t);
}
function ws(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function w_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Oi(t) {
  return Oi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Oi(t);
}
function au(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var k_ = /* @__PURE__ */ function(t) {
  y_(n, t);
  var e = b_(n);
  function n() {
    var r;
    g_(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), au(ws(r), "priority", 100), au(ws(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return v_(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "w":
          return Ce(Oe.week, a);
        case "wo":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return Me(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return Lt(m_(a, o, s), s);
    }
  }]), n;
}(ce);
function x_(t, e) {
  Z(2, arguments);
  var n = ie(t), r = re(e), a = vh(n) - r;
  return n.setUTCDate(n.getUTCDate() - a * 7), n;
}
function $a(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? $a = function(n) {
    return typeof n;
  } : $a = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, $a(t);
}
function C_(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function iu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function P_(t, e, n) {
  return e && iu(t.prototype, e), n && iu(t, n), t;
}
function S_(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && ks(t, e);
}
function ks(t, e) {
  return ks = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, ks(t, e);
}
function M_(t) {
  var e = D_();
  return function() {
    var r = Di(t), a;
    if (e) {
      var i = Di(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return O_(this, a);
  };
}
function O_(t, e) {
  return e && ($a(e) === "object" || typeof e == "function") ? e : xs(t);
}
function xs(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function D_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Di(t) {
  return Di = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Di(t);
}
function ou(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var T_ = /* @__PURE__ */ function(t) {
  S_(n, t);
  var e = M_(n);
  function n() {
    var r;
    C_(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), ou(xs(r), "priority", 100), ou(xs(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return P_(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "I":
          return Ce(Oe.week, a);
        case "Io":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return Me(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return $n(x_(a, o));
    }
  }]), n;
}(ce);
function Ra(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ra = function(n) {
    return typeof n;
  } : Ra = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ra(t);
}
function $_(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function su(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function R_(t, e, n) {
  return e && su(t.prototype, e), n && su(t, n), t;
}
function E_(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Cs(t, e);
}
function Cs(t, e) {
  return Cs = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Cs(t, e);
}
function A_(t) {
  var e = I_();
  return function() {
    var r = Ti(t), a;
    if (e) {
      var i = Ti(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return L_(this, a);
  };
}
function L_(t, e) {
  return e && (Ra(e) === "object" || typeof e == "function") ? e : Ea(t);
}
function Ea(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function I_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ti(t) {
  return Ti = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ti(t);
}
function Oo(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var N_ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], W_ = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], z_ = /* @__PURE__ */ function(t) {
  E_(n, t);
  var e = A_(n);
  function n() {
    var r;
    $_(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Oo(Ea(r), "priority", 90), Oo(Ea(r), "subPriority", 1), Oo(Ea(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return R_(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "d":
          return Ce(Oe.date, a);
        case "do":
          return o.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return Me(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var o = a.getUTCFullYear(), s = Eh(o), l = a.getUTCMonth();
      return s ? i >= 1 && i <= W_[l] : i >= 1 && i <= N_[l];
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCDate(o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Aa(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Aa = function(n) {
    return typeof n;
  } : Aa = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Aa(t);
}
function B_(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function lu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function F_(t, e, n) {
  return e && lu(t.prototype, e), n && lu(t, n), t;
}
function H_(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Ps(t, e);
}
function Ps(t, e) {
  return Ps = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Ps(t, e);
}
function j_(t) {
  var e = q_();
  return function() {
    var r = $i(t), a;
    if (e) {
      var i = $i(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return V_(this, a);
  };
}
function V_(t, e) {
  return e && (Aa(e) === "object" || typeof e == "function") ? e : La(t);
}
function La(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function q_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function $i(t) {
  return $i = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, $i(t);
}
function Do(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var U_ = /* @__PURE__ */ function(t) {
  H_(n, t);
  var e = j_(n);
  function n() {
    var r;
    B_(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Do(La(r), "priority", 90), Do(La(r), "subpriority", 1), Do(La(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return F_(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return Ce(Oe.dayOfYear, a);
        case "Do":
          return o.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return Me(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var o = a.getUTCFullYear(), s = Eh(o);
      return s ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(0, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Yl(t, e, n) {
  var r, a, i, o, s, l, c, u;
  Z(2, arguments);
  var f = yn(), d = re((r = (a = (i = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (s = n.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && a !== void 0 ? a : (c = f.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ie(t), m = re(e), p = h.getUTCDay(), g = m % 7, v = (g + 7) % 7, w = (v < d ? 7 : 0) + m - p;
  return h.setUTCDate(h.getUTCDate() + w), h;
}
function Ia(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ia = function(n) {
    return typeof n;
  } : Ia = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ia(t);
}
function Y_(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function cu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function X_(t, e, n) {
  return e && cu(t.prototype, e), n && cu(t, n), t;
}
function K_(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Ss(t, e);
}
function Ss(t, e) {
  return Ss = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Ss(t, e);
}
function Q_(t) {
  var e = Z_();
  return function() {
    var r = Ri(t), a;
    if (e) {
      var i = Ri(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return G_(this, a);
  };
}
function G_(t, e) {
  return e && (Ia(e) === "object" || typeof e == "function") ? e : Ms(t);
}
function Ms(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Z_() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ri(t) {
  return Ri = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ri(t);
}
function uu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var J_ = /* @__PURE__ */ function(t) {
  K_(n, t);
  var e = Q_(n);
  function n() {
    var r;
    Y_(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), uu(Ms(r), "priority", 90), uu(Ms(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return X_(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = Yl(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Na(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Na = function(n) {
    return typeof n;
  } : Na = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Na(t);
}
function ew(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function du(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function tw(t, e, n) {
  return e && du(t.prototype, e), n && du(t, n), t;
}
function nw(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Os(t, e);
}
function Os(t, e) {
  return Os = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Os(t, e);
}
function rw(t) {
  var e = iw();
  return function() {
    var r = Ei(t), a;
    if (e) {
      var i = Ei(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return aw(this, a);
  };
}
function aw(t, e) {
  return e && (Na(e) === "object" || typeof e == "function") ? e : Ds(t);
}
function Ds(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function iw() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ei(t) {
  return Ei = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ei(t);
}
function fu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var ow = /* @__PURE__ */ function(t) {
  nw(n, t);
  var e = rw(n);
  function n() {
    var r;
    ew(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), fu(Ds(r), "priority", 90), fu(Ds(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return tw(n, [{
    key: "parse",
    value: function(a, i, o, s) {
      var l = function(u) {
        var f = Math.floor((u - 1) / 7) * 7;
        return (u + s.weekStartsOn + 6) % 7 + f;
      };
      switch (i) {
        case "e":
        case "ee":
          return De(Me(i.length, a), l);
        case "eo":
          return De(o.ordinalNumber(a, {
            unit: "day"
          }), l);
        case "eee":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = Yl(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Wa(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Wa = function(n) {
    return typeof n;
  } : Wa = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Wa(t);
}
function sw(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function hu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function lw(t, e, n) {
  return e && hu(t.prototype, e), n && hu(t, n), t;
}
function cw(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Ts(t, e);
}
function Ts(t, e) {
  return Ts = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Ts(t, e);
}
function uw(t) {
  var e = fw();
  return function() {
    var r = Ai(t), a;
    if (e) {
      var i = Ai(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return dw(this, a);
  };
}
function dw(t, e) {
  return e && (Wa(e) === "object" || typeof e == "function") ? e : $s(t);
}
function $s(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function fw() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ai(t) {
  return Ai = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ai(t);
}
function pu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var hw = /* @__PURE__ */ function(t) {
  cw(n, t);
  var e = uw(n);
  function n() {
    var r;
    sw(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), pu($s(r), "priority", 90), pu($s(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return lw(n, [{
    key: "parse",
    value: function(a, i, o, s) {
      var l = function(u) {
        var f = Math.floor((u - 1) / 7) * 7;
        return (u + s.weekStartsOn + 6) % 7 + f;
      };
      switch (i) {
        case "c":
        case "cc":
          return De(Me(i.length, a), l);
        case "co":
          return De(o.ordinalNumber(a, {
            unit: "day"
          }), l);
        case "ccc":
          return o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(a, {
            width: "wide",
            context: "standalone"
          }) || o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, s) {
      return a = Yl(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function pw(t, e) {
  Z(2, arguments);
  var n = re(e);
  n % 7 === 0 && (n = n - 7);
  var r = 1, a = ie(t), i = a.getUTCDay(), o = n % 7, s = (o + 7) % 7, l = (s < r ? 7 : 0) + n - i;
  return a.setUTCDate(a.getUTCDate() + l), a;
}
function za(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? za = function(n) {
    return typeof n;
  } : za = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, za(t);
}
function mw(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function mu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function gw(t, e, n) {
  return e && mu(t.prototype, e), n && mu(t, n), t;
}
function vw(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Rs(t, e);
}
function Rs(t, e) {
  return Rs = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Rs(t, e);
}
function yw(t) {
  var e = _w();
  return function() {
    var r = Li(t), a;
    if (e) {
      var i = Li(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return bw(this, a);
  };
}
function bw(t, e) {
  return e && (za(e) === "object" || typeof e == "function") ? e : Es(t);
}
function Es(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function _w() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Li(t) {
  return Li = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Li(t);
}
function gu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var ww = /* @__PURE__ */ function(t) {
  vw(n, t);
  var e = yw(n);
  function n() {
    var r;
    mw(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), gu(Es(r), "priority", 90), gu(Es(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return gw(n, [{
    key: "parse",
    value: function(a, i, o) {
      var s = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (i) {
        case "i":
        case "ii":
          return Me(i.length, a);
        case "io":
          return o.ordinalNumber(a, {
            unit: "day"
          });
        case "iii":
          return De(o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return De(o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return De(o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return De(o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a = pw(a, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Ba(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ba = function(n) {
    return typeof n;
  } : Ba = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ba(t);
}
function kw(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function vu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function xw(t, e, n) {
  return e && vu(t.prototype, e), n && vu(t, n), t;
}
function Cw(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && As(t, e);
}
function As(t, e) {
  return As = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, As(t, e);
}
function Pw(t) {
  var e = Mw();
  return function() {
    var r = Ii(t), a;
    if (e) {
      var i = Ii(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Sw(this, a);
  };
}
function Sw(t, e) {
  return e && (Ba(e) === "object" || typeof e == "function") ? e : Ls(t);
}
function Ls(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Mw() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ii(t) {
  return Ii = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ii(t);
}
function yu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Ow = /* @__PURE__ */ function(t) {
  Cw(n, t);
  var e = Pw(n);
  function n() {
    var r;
    kw(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), yu(Ls(r), "priority", 80), yu(Ls(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return xw(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(Ul(o), 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Fa(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Fa = function(n) {
    return typeof n;
  } : Fa = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Fa(t);
}
function Dw(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function bu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Tw(t, e, n) {
  return e && bu(t.prototype, e), n && bu(t, n), t;
}
function $w(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Is(t, e);
}
function Is(t, e) {
  return Is = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Is(t, e);
}
function Rw(t) {
  var e = Aw();
  return function() {
    var r = Ni(t), a;
    if (e) {
      var i = Ni(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Ew(this, a);
  };
}
function Ew(t, e) {
  return e && (Fa(e) === "object" || typeof e == "function") ? e : Ns(t);
}
function Ns(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Aw() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ni(t) {
  return Ni = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ni(t);
}
function _u(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Lw = /* @__PURE__ */ function(t) {
  $w(n, t);
  var e = Rw(n);
  function n() {
    var r;
    Dw(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), _u(Ns(r), "priority", 80), _u(Ns(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return Tw(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(Ul(o), 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Ha(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ha = function(n) {
    return typeof n;
  } : Ha = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ha(t);
}
function Iw(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function wu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Nw(t, e, n) {
  return e && wu(t.prototype, e), n && wu(t, n), t;
}
function Ww(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Ws(t, e);
}
function Ws(t, e) {
  return Ws = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Ws(t, e);
}
function zw(t) {
  var e = Fw();
  return function() {
    var r = Wi(t), a;
    if (e) {
      var i = Wi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Bw(this, a);
  };
}
function Bw(t, e) {
  return e && (Ha(e) === "object" || typeof e == "function") ? e : zs(t);
}
function zs(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Fw() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Wi(t) {
  return Wi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Wi(t);
}
function ku(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Hw = /* @__PURE__ */ function(t) {
  Ww(n, t);
  var e = zw(n);
  function n() {
    var r;
    Iw(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), ku(zs(r), "priority", 80), ku(zs(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return Nw(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(Ul(o), 0, 0, 0), a;
    }
  }]), n;
}(ce);
function ja(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ja = function(n) {
    return typeof n;
  } : ja = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ja(t);
}
function jw(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function xu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Vw(t, e, n) {
  return e && xu(t.prototype, e), n && xu(t, n), t;
}
function qw(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Bs(t, e);
}
function Bs(t, e) {
  return Bs = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Bs(t, e);
}
function Uw(t) {
  var e = Xw();
  return function() {
    var r = zi(t), a;
    if (e) {
      var i = zi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return Yw(this, a);
  };
}
function Yw(t, e) {
  return e && (ja(e) === "object" || typeof e == "function") ? e : Fs(t);
}
function Fs(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Xw() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function zi(t) {
  return zi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, zi(t);
}
function Cu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Kw = /* @__PURE__ */ function(t) {
  qw(n, t);
  var e = Uw(n);
  function n() {
    var r;
    jw(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Cu(Fs(r), "priority", 70), Cu(Fs(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return Vw(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "h":
          return Ce(Oe.hour12h, a);
        case "ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return Me(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCHours() >= 12;
      return s && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? a.setUTCHours(0, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Va(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Va = function(n) {
    return typeof n;
  } : Va = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Va(t);
}
function Qw(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Pu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Gw(t, e, n) {
  return e && Pu(t.prototype, e), n && Pu(t, n), t;
}
function Zw(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Hs(t, e);
}
function Hs(t, e) {
  return Hs = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Hs(t, e);
}
function Jw(t) {
  var e = t2();
  return function() {
    var r = Bi(t), a;
    if (e) {
      var i = Bi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return e2(this, a);
  };
}
function e2(t, e) {
  return e && (Va(e) === "object" || typeof e == "function") ? e : js(t);
}
function js(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function t2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Bi(t) {
  return Bi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Bi(t);
}
function Su(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var n2 = /* @__PURE__ */ function(t) {
  Zw(n, t);
  var e = Jw(n);
  function n() {
    var r;
    Qw(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Su(js(r), "priority", 70), Su(js(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return Gw(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "H":
          return Ce(Oe.hour23h, a);
        case "Ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return Me(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function qa(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? qa = function(n) {
    return typeof n;
  } : qa = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, qa(t);
}
function r2(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Mu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function a2(t, e, n) {
  return e && Mu(t.prototype, e), n && Mu(t, n), t;
}
function i2(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Vs(t, e);
}
function Vs(t, e) {
  return Vs = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Vs(t, e);
}
function o2(t) {
  var e = l2();
  return function() {
    var r = Fi(t), a;
    if (e) {
      var i = Fi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return s2(this, a);
  };
}
function s2(t, e) {
  return e && (qa(e) === "object" || typeof e == "function") ? e : qs(t);
}
function qs(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function l2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Fi(t) {
  return Fi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Fi(t);
}
function Ou(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var c2 = /* @__PURE__ */ function(t) {
  i2(n, t);
  var e = o2(n);
  function n() {
    var r;
    r2(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ou(qs(r), "priority", 70), Ou(qs(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return a2(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "K":
          return Ce(Oe.hour11h, a);
        case "Ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return Me(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = a.getUTCHours() >= 12;
      return s && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Ua(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ua = function(n) {
    return typeof n;
  } : Ua = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ua(t);
}
function u2(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Du(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function d2(t, e, n) {
  return e && Du(t.prototype, e), n && Du(t, n), t;
}
function f2(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Us(t, e);
}
function Us(t, e) {
  return Us = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Us(t, e);
}
function h2(t) {
  var e = m2();
  return function() {
    var r = Hi(t), a;
    if (e) {
      var i = Hi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return p2(this, a);
  };
}
function p2(t, e) {
  return e && (Ua(e) === "object" || typeof e == "function") ? e : Ys(t);
}
function Ys(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function m2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Hi(t) {
  return Hi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Hi(t);
}
function Tu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var g2 = /* @__PURE__ */ function(t) {
  f2(n, t);
  var e = h2(n);
  function n() {
    var r;
    u2(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Tu(Ys(r), "priority", 70), Tu(Ys(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return d2(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "k":
          return Ce(Oe.hour24h, a);
        case "ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return Me(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var s = o <= 24 ? o % 24 : o;
      return a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), n;
}(ce);
function Ya(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ya = function(n) {
    return typeof n;
  } : Ya = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ya(t);
}
function v2(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function $u(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function y2(t, e, n) {
  return e && $u(t.prototype, e), n && $u(t, n), t;
}
function b2(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Xs(t, e);
}
function Xs(t, e) {
  return Xs = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Xs(t, e);
}
function _2(t) {
  var e = k2();
  return function() {
    var r = ji(t), a;
    if (e) {
      var i = ji(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return w2(this, a);
  };
}
function w2(t, e) {
  return e && (Ya(e) === "object" || typeof e == "function") ? e : Ks(t);
}
function Ks(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function k2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ji(t) {
  return ji = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ji(t);
}
function Ru(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var x2 = /* @__PURE__ */ function(t) {
  b2(n, t);
  var e = _2(n);
  function n() {
    var r;
    v2(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Ru(Ks(r), "priority", 60), Ru(Ks(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return y2(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "m":
          return Ce(Oe.minute, a);
        case "mo":
          return o.ordinalNumber(a, {
            unit: "minute"
          });
        default:
          return Me(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMinutes(o, 0, 0), a;
    }
  }]), n;
}(ce);
function Xa(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xa = function(n) {
    return typeof n;
  } : Xa = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Xa(t);
}
function C2(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Eu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function P2(t, e, n) {
  return e && Eu(t.prototype, e), n && Eu(t, n), t;
}
function S2(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Qs(t, e);
}
function Qs(t, e) {
  return Qs = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Qs(t, e);
}
function M2(t) {
  var e = D2();
  return function() {
    var r = Vi(t), a;
    if (e) {
      var i = Vi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return O2(this, a);
  };
}
function O2(t, e) {
  return e && (Xa(e) === "object" || typeof e == "function") ? e : Gs(t);
}
function Gs(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function D2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Vi(t) {
  return Vi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Vi(t);
}
function Au(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var T2 = /* @__PURE__ */ function(t) {
  S2(n, t);
  var e = M2(n);
  function n() {
    var r;
    C2(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Au(Gs(r), "priority", 50), Au(Gs(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return P2(n, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "s":
          return Ce(Oe.second, a);
        case "so":
          return o.ordinalNumber(a, {
            unit: "second"
          });
        default:
          return Me(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCSeconds(o, 0), a;
    }
  }]), n;
}(ce);
function Ka(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ka = function(n) {
    return typeof n;
  } : Ka = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ka(t);
}
function $2(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Lu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function R2(t, e, n) {
  return e && Lu(t.prototype, e), n && Lu(t, n), t;
}
function E2(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Zs(t, e);
}
function Zs(t, e) {
  return Zs = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, Zs(t, e);
}
function A2(t) {
  var e = I2();
  return function() {
    var r = qi(t), a;
    if (e) {
      var i = qi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return L2(this, a);
  };
}
function L2(t, e) {
  return e && (Ka(e) === "object" || typeof e == "function") ? e : Js(t);
}
function Js(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function I2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function qi(t) {
  return qi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, qi(t);
}
function Iu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var N2 = /* @__PURE__ */ function(t) {
  E2(n, t);
  var e = A2(n);
  function n() {
    var r;
    $2(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Iu(Js(r), "priority", 30), Iu(Js(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return R2(n, [{
    key: "parse",
    value: function(a, i) {
      var o = function(l) {
        return Math.floor(l * Math.pow(10, -i.length + 3));
      };
      return De(Me(i.length, a), o);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMilliseconds(o), a;
    }
  }]), n;
}(ce);
function Qa(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Qa = function(n) {
    return typeof n;
  } : Qa = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Qa(t);
}
function W2(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Nu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function z2(t, e, n) {
  return e && Nu(t.prototype, e), n && Nu(t, n), t;
}
function B2(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && el(t, e);
}
function el(t, e) {
  return el = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, el(t, e);
}
function F2(t) {
  var e = j2();
  return function() {
    var r = Ui(t), a;
    if (e) {
      var i = Ui(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return H2(this, a);
  };
}
function H2(t, e) {
  return e && (Qa(e) === "object" || typeof e == "function") ? e : tl(t);
}
function tl(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function j2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ui(t) {
  return Ui = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ui(t);
}
function Wu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var V2 = /* @__PURE__ */ function(t) {
  B2(n, t);
  var e = F2(n);
  function n() {
    var r;
    W2(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Wu(tl(r), "priority", 10), Wu(tl(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return z2(n, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "X":
          return yt(vt.basicOptionalMinutes, a);
        case "XX":
          return yt(vt.basic, a);
        case "XXXX":
          return yt(vt.basicOptionalSeconds, a);
        case "XXXXX":
          return yt(vt.extendedOptionalSeconds, a);
        case "XXX":
        default:
          return yt(vt.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), n;
}(ce);
function Ga(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ga = function(n) {
    return typeof n;
  } : Ga = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ga(t);
}
function q2(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function zu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function U2(t, e, n) {
  return e && zu(t.prototype, e), n && zu(t, n), t;
}
function Y2(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && nl(t, e);
}
function nl(t, e) {
  return nl = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, nl(t, e);
}
function X2(t) {
  var e = Q2();
  return function() {
    var r = Yi(t), a;
    if (e) {
      var i = Yi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return K2(this, a);
  };
}
function K2(t, e) {
  return e && (Ga(e) === "object" || typeof e == "function") ? e : rl(t);
}
function rl(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Q2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Yi(t) {
  return Yi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Yi(t);
}
function Bu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var G2 = /* @__PURE__ */ function(t) {
  Y2(n, t);
  var e = X2(n);
  function n() {
    var r;
    q2(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Bu(rl(r), "priority", 10), Bu(rl(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return U2(n, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "x":
          return yt(vt.basicOptionalMinutes, a);
        case "xx":
          return yt(vt.basic, a);
        case "xxxx":
          return yt(vt.basicOptionalSeconds, a);
        case "xxxxx":
          return yt(vt.extendedOptionalSeconds, a);
        case "xxx":
        default:
          return yt(vt.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), n;
}(ce);
function Za(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Za = function(n) {
    return typeof n;
  } : Za = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Za(t);
}
function Z2(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Fu(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function J2(t, e, n) {
  return e && Fu(t.prototype, e), n && Fu(t, n), t;
}
function ek(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && al(t, e);
}
function al(t, e) {
  return al = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, al(t, e);
}
function tk(t) {
  var e = rk();
  return function() {
    var r = Xi(t), a;
    if (e) {
      var i = Xi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return nk(this, a);
  };
}
function nk(t, e) {
  return e && (Za(e) === "object" || typeof e == "function") ? e : il(t);
}
function il(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function rk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Xi(t) {
  return Xi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Xi(t);
}
function Hu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var ak = /* @__PURE__ */ function(t) {
  ek(n, t);
  var e = tk(n);
  function n() {
    var r;
    Z2(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Hu(il(r), "priority", 40), Hu(il(r), "incompatibleTokens", "*"), r;
  }
  return J2(n, [{
    key: "parse",
    value: function(a) {
      return $h(a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(ce);
function Ja(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ja = function(n) {
    return typeof n;
  } : Ja = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ja(t);
}
function ik(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ju(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function ok(t, e, n) {
  return e && ju(t.prototype, e), n && ju(t, n), t;
}
function sk(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && ol(t, e);
}
function ol(t, e) {
  return ol = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, ol(t, e);
}
function lk(t) {
  var e = uk();
  return function() {
    var r = Ki(t), a;
    if (e) {
      var i = Ki(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return ck(this, a);
  };
}
function ck(t, e) {
  return e && (Ja(e) === "object" || typeof e == "function") ? e : sl(t);
}
function sl(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function uk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ki(t) {
  return Ki = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ki(t);
}
function Vu(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var dk = /* @__PURE__ */ function(t) {
  sk(n, t);
  var e = lk(n);
  function n() {
    var r;
    ik(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)), Vu(sl(r), "priority", 20), Vu(sl(r), "incompatibleTokens", "*"), r;
  }
  return ok(n, [{
    key: "parse",
    value: function(a) {
      return $h(a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(ce), fk = {
  G: new f0(),
  y: new b0(),
  Y: new S0(),
  R: new E0(),
  u: new B0(),
  Q: new Y0(),
  q: new e_(),
  M: new s_(),
  L: new p_(),
  w: new k_(),
  I: new T_(),
  d: new z_(),
  D: new U_(),
  E: new J_(),
  e: new ow(),
  c: new hw(),
  i: new ww(),
  a: new Ow(),
  b: new Lw(),
  B: new Hw(),
  h: new Kw(),
  H: new n2(),
  K: new c2(),
  k: new g2(),
  m: new x2(),
  s: new T2(),
  S: new N2(),
  X: new V2(),
  x: new G2(),
  t: new ak(),
  T: new dk()
};
function ei(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ei = function(n) {
    return typeof n;
  } : ei = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ei(t);
}
function qu(t, e) {
  var n;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (n = hk(t)) || e && t && typeof t.length == "number") {
      n && (t = n);
      var r = 0, a = function() {
      };
      return { s: a, n: function() {
        return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
      }, e: function(c) {
        throw c;
      }, f: a };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, o = !1, s;
  return { s: function() {
    n = t[Symbol.iterator]();
  }, n: function() {
    var c = n.next();
    return i = c.done, c;
  }, e: function(c) {
    o = !0, s = c;
  }, f: function() {
    try {
      !i && n.return != null && n.return();
    } finally {
      if (o)
        throw s;
    }
  } };
}
function hk(t, e) {
  if (t) {
    if (typeof t == "string")
      return Uu(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Uu(t, e);
  }
}
function Uu(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
var pk = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, mk = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, gk = /^'([^]*?)'?$/, vk = /''/g, yk = /\S/, bk = /[a-zA-Z]/;
function _k(t, e, n, r) {
  var a, i, o, s, l, c, u, f, d, h, m, p, g, v, w, C, x, y;
  Z(3, arguments);
  var _ = String(t), k = String(e), P = yn(), $ = (a = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : P.locale) !== null && a !== void 0 ? a : Sh;
  if (!$.match)
    throw new RangeError("locale must contain match property");
  var O = re((o = (s = (l = (c = r == null ? void 0 : r.firstWeekContainsDate) !== null && c !== void 0 ? c : r == null || (u = r.locale) === null || u === void 0 || (f = u.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && l !== void 0 ? l : P.firstWeekContainsDate) !== null && s !== void 0 ? s : (d = P.locale) === null || d === void 0 || (h = d.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(O >= 1 && O <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var D = re((m = (p = (g = (v = r == null ? void 0 : r.weekStartsOn) !== null && v !== void 0 ? v : r == null || (w = r.locale) === null || w === void 0 || (C = w.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && g !== void 0 ? g : P.weekStartsOn) !== null && p !== void 0 ? p : (x = P.locale) === null || x === void 0 || (y = x.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(D >= 0 && D <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (k === "")
    return _ === "" ? ie(n) : /* @__PURE__ */ new Date(NaN);
  var N = {
    firstWeekContainsDate: O,
    weekStartsOn: D,
    locale: $
  }, q = [new r0()], le = k.match(mk).map(function(me) {
    var ue = me[0];
    if (ue in Zo) {
      var Ue = Zo[ue];
      return Ue(me, $.formatLong);
    }
    return me;
  }).join("").match(pk), Y = [], Q = qu(le), te;
  try {
    var Re = function() {
      var ue = te.value;
      !(r != null && r.useAdditionalWeekYearTokens) && wh(ue) && gi(ue, k, t), !(r != null && r.useAdditionalDayOfYearTokens) && _h(ue) && gi(ue, k, t);
      var Ue = ue[0], Nt = fk[Ue];
      if (Nt) {
        var qr = Nt.incompatibleTokens;
        if (Array.isArray(qr)) {
          var Fn = Y.find(function(Ur) {
            return qr.includes(Ur.token) || Ur.token === Ue;
          });
          if (Fn)
            throw new RangeError("The format string mustn't contain `".concat(Fn.fullToken, "` and `").concat(ue, "` at the same time"));
        } else if (Nt.incompatibleTokens === "*" && Y.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(ue, "` and any other token at the same time"));
        Y.push({
          token: Ue,
          fullToken: ue
        });
        var Hn = Nt.run(_, ue, $.match, N);
        if (!Hn)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        q.push(Hn.setter), _ = Hn.rest;
      } else {
        if (Ue.match(bk))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + Ue + "`");
        if (ue === "''" ? ue = "'" : Ue === "'" && (ue = wk(ue)), _.indexOf(ue) === 0)
          _ = _.slice(ue.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (Q.s(); !(te = Q.n()).done; ) {
      var pe = Re();
      if (ei(pe) === "object")
        return pe.v;
    }
  } catch (me) {
    Q.e(me);
  } finally {
    Q.f();
  }
  if (_.length > 0 && yk.test(_))
    return /* @__PURE__ */ new Date(NaN);
  var Ke = q.map(function(me) {
    return me.priority;
  }).sort(function(me, ue) {
    return ue - me;
  }).filter(function(me, ue, Ue) {
    return Ue.indexOf(me) === ue;
  }).map(function(me) {
    return q.filter(function(ue) {
      return ue.priority === me;
    }).sort(function(ue, Ue) {
      return Ue.subPriority - ue.subPriority;
    });
  }).map(function(me) {
    return me[0];
  }), at = ie(n);
  if (isNaN(at.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var Ee = mh(at, hh(at)), Qe = {}, Le = qu(Ke), Ie;
  try {
    for (Le.s(); !(Ie = Le.n()).done; ) {
      var qe = Ie.value;
      if (!qe.validate(Ee, N))
        return /* @__PURE__ */ new Date(NaN);
      var kt = qe.set(Ee, Qe, N);
      Array.isArray(kt) ? (Ee = kt[0], Qb(Qe, kt[1])) : Ee = kt;
    }
  } catch (me) {
    Le.e(me);
  } finally {
    Le.f();
  }
  return Ee;
}
function wk(t) {
  return t.match(gk)[1].replace(vk, "'");
}
function kk(t, e, n) {
  return Z(2, arguments), Hl(_k(t, e, /* @__PURE__ */ new Date(), n));
}
function xk(t) {
  return Z(1, arguments), ie(t).getTime() < Date.now();
}
function Qi(t, e) {
  Z(2, arguments);
  var n = ie(t), r = ie(e);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function Ah(t) {
  return Z(1, arguments), ze(t, Date.now());
}
function Ck(t) {
  return Z(1, arguments), ze(t, hr(Date.now(), 1));
}
function Pk(t, e) {
  Z(2, arguments);
  var n = ie(t).getTime(), r = ie(e.start).getTime(), a = ie(e.end).getTime();
  if (!(r <= a))
    throw new RangeError("Invalid interval");
  return n >= r && n <= a;
}
function Sk(t, e) {
  Z(2, arguments);
  var n = re(e);
  return hr(t, -n);
}
function Mk(t, e) {
  var n;
  Z(1, arguments);
  var r = re((n = e == null ? void 0 : e.additionalDigits) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = $k(t), i;
  if (a.date) {
    var o = Rk(a.date, r);
    i = Ek(o.restDateString, o.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = i.getTime(), l = 0, c;
  if (a.time && (l = Ak(a.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (a.timezone) {
    if (c = Lk(a.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var u = new Date(s + l), f = /* @__PURE__ */ new Date(0);
    return f.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), f.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), f;
  }
  return new Date(s + l + c);
}
var Gr = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Ok = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Dk = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Tk = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $k(t) {
  var e = {}, n = t.split(Gr.dateTimeDelimiter), r;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? r = n[0] : (e.date = n[0], r = n[1], Gr.timeZoneDelimiter.test(e.date) && (e.date = t.split(Gr.timeZoneDelimiter)[0], r = t.substr(e.date.length, t.length))), r) {
    var a = Gr.timezone.exec(r);
    a ? (e.time = r.replace(a[1], ""), e.timezone = a[1]) : e.time = r;
  }
  return e;
}
function Rk(t, e) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"), r = t.match(n);
  if (!r)
    return {
      year: NaN,
      restDateString: ""
    };
  var a = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? a : i * 100,
    restDateString: t.slice((r[1] || r[2]).length)
  };
}
function Ek(t, e) {
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = t.match(Ok);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], a = Vn(n[1]), i = Vn(n[2]) - 1, o = Vn(n[3]), s = Vn(n[4]), l = Vn(n[5]) - 1;
  if (r)
    return Bk(e, s, l) ? Ik(e, s, l) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !Wk(e, i, o) || !zk(e, a) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(e, i, Math.max(a, o)), c);
}
function Vn(t) {
  return t ? parseInt(t) : 1;
}
function Ak(t) {
  var e = t.match(Dk);
  if (!e)
    return NaN;
  var n = To(e[1]), r = To(e[2]), a = To(e[3]);
  return Fk(n, r, a) ? n * Fl + r * Bl + a * 1e3 : NaN;
}
function To(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function Lk(t) {
  if (t === "Z")
    return 0;
  var e = t.match(Tk);
  if (!e)
    return 0;
  var n = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), a = e[3] && parseInt(e[3]) || 0;
  return Hk(r, a) ? n * (r * Fl + a * Bl) : NaN;
}
function Ik(t, e, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var a = r.getUTCDay() || 7, i = (e - 1) * 7 + n + 1 - a;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var Nk = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Lh(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function Wk(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (Nk[e] || (Lh(t) ? 29 : 28));
}
function zk(t, e) {
  return e >= 1 && e <= (Lh(t) ? 366 : 365);
}
function Bk(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function Fk(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function Hk(t, e) {
  return e >= 0 && e <= 59;
}
function jk() {
  var t = /* @__PURE__ */ new Date(), e = t.getFullYear(), n = t.getMonth(), r = t.getDate(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(e, n, r + 1), a.setHours(0, 0, 0, 0), a;
}
function Vk(t, e) {
  Z(2, arguments);
  var n = re(e);
  return zl(t, -n);
}
function ti(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ti = function(n) {
    return typeof n;
  } : ti = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ti(t);
}
function $o(t, e) {
  if (Z(2, arguments), !e || ti(e) !== "object")
    return /* @__PURE__ */ new Date(NaN);
  var n = e.years ? re(e.years) : 0, r = e.months ? re(e.months) : 0, a = e.weeks ? re(e.weeks) : 0, i = e.days ? re(e.days) : 0, o = e.hours ? re(e.hours) : 0, s = e.minutes ? re(e.minutes) : 0, l = e.seconds ? re(e.seconds) : 0, c = Vk(t, r + n * 12), u = Sk(c, i + a * 7), f = s + o * 60, d = l + f * 60, h = d * 1e3, m = new Date(u.getTime() - h);
  return m;
}
function qk(t, e) {
  Z(2, arguments);
  var n = re(e);
  return ph(t, -n);
}
const Uk = {
  required: "required",
  type: "type",
  dateBefore: "dateBefore",
  dateAfter: "dateAfter",
  date: "date",
  moneyAmount: "moneyAmount"
}, Yk = {
  isEmpty: "isEmpty",
  notAValidEmail: "notAValidEmail",
  notAValidDate: "notAValidDate",
  notAValidMoneyAmount: "notAValidMoneyAmount",
  isNotANumber: "isNotANumber"
}, Rn = "validation-update", Xk = "dd/MM/yyyy", Kk = (t) => String(t).toLowerCase().match(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
) !== null, Xl = {
  props: {
    validationRules: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    validationOptions: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  }
}, Tr = ({ props: t }, { emit: e }) => {
  const n = U(!0), r = U(!1), a = (t == null ? void 0 : t.validationRules) ?? {}, i = t.validationOptions ?? {}, o = U(""), s = (h) => {
    if (typeof h != "string")
      return !1;
    const m = a.dateFormat ?? Xk;
    return h.length !== m.length ? !1 : kk(h, m);
  }, l = (h) => typeof h != "string" ? !1 : String(h).match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ) !== null, c = (h) => {
    const m = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/, p = /^[1-9]\d*(((.\d{3}){1})?(\,\d{0,2})?)$/;
    return i != null && i.useCommaAsDecimalSeparator ? p.test(h) : m.test(h);
  }, u = (h) => !isNaN(h), f = (h) => {
    const m = h.type === "focusin";
    n.value = !1, r.value = m, d(o.value);
  }, d = (h) => {
    o.value = h;
    const { required: m, type: p } = Uk, { isEmpty: g, notAValidEmail: v, notAValidDate: w, notAValidMoneyAmount: C, isNotANumber: x } = Yk, y = [];
    if (a[m] && !(h != null && h.length) && y.push(g), !a[m] && !h) {
      e(Rn, { errors: y, isPristine: n.value, hasFocus: r.value });
      return;
    }
    a[p] === "email" && (!h || !Kk(h)) && y.push(v), a[p] === "date" && (!h || !s(h)) && y.push(w), a[p] === "time" && (!h || !l(h)) && y.push(w), a[p] === "moneyAmount" && (!h || !c(h)) && y.push(C), a[p] === "number" && (u(h) || y.push(x)), e(Rn, { errors: y, isPristine: n.value, hasFocus: r.value });
  };
  return { validate: d, handleFocus: f };
}, Qk = ["disabled"], Gk = /* @__PURE__ */ ne({
  __name: "CTimePickerField",
  props: {
    hours: { default: void 0 },
    minutes: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    errorMessage: { default: void 0 },
    size: { default: "default" },
    separator: { default: ":" }
  },
  emits: ["update:value", "handleClockIcon", "validation-update"],
  setup(t, { emit: e }) {
    const n = t, r = new fh(n.separator), { validate: a } = Tr({ props: n }, { emit: e }), i = I({
      get: function() {
        return r.getAsTime(n.hours, n.minutes);
      },
      set(c) {
        a(c), e("update:value", r.formatTimeInputValue(c));
      }
    }), o = I(() => i.value ? "c-icon-primary" : ""), s = () => {
      e("handleClockIcon");
    }, l = (c) => {
      /^[A-Za-z]$/.test(c.key) && c.preventDefault();
    };
    return (c, u) => (b(), M("div", {
      class: H(["c-input-container", n.size])
    }, [
      T(S(hg), {
        class: H(["c-icon-m c-input-icon", S(o)]),
        onclick: s
      }, null, 8, ["class"]),
      Ve(R("input", He({
        type: "text",
        inputmode: "numeric",
        "onUpdate:modelValue": u[0] || (u[0] = (f) => je(i) ? i.value = f : null),
        ref: "textInput",
        disabled: t.disabled,
        class: "c-input",
        placeholder: "00:00"
      }, c.$attrs, {
        maxlength: 5,
        onKeydown: l
      }), null, 16, Qk), [
        [Mr, S(i)]
      ])
    ], 2));
  }
});
const Zk = /* @__PURE__ */ B(Gk, [["__scopeId", "data-v-5ef0db1e"]]), A$ = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    hours: { default: void 0 },
    minutes: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    errorMessage: { default: void 0 },
    hourMinValue: { default: 0 },
    hourMaxValue: { default: 23 },
    minuteMinValue: { default: 0 },
    minuteMaxValue: { default: 59 },
    size: { default: "default" },
    separator: { default: ":" }
  },
  emits: ["update:selectedHour", "update:selectedMinute"],
  setup(t, { emit: e }) {
    const n = t, r = vn, a = U(), i = U(), o = new fh(n.separator), s = U(!1), l = () => {
      s.value = !s.value;
    }, c = () => {
      s.value = !1;
    }, u = I({
      get() {
        return a.value;
      },
      set(p) {
        a.value = p, e("update:selectedHour", p);
      }
    }), f = I({
      get() {
        return i.value;
      },
      set(p) {
        i.value = p, e("update:selectedMinute", p);
      }
    }), d = (p) => {
      f.value = p;
    }, h = (p) => {
      u.value = p;
    }, m = (p) => {
      u.value = p.hours, f.value = p.minutes;
    };
    return Wn(() => {
      var p;
      a.value = n.hours, i.value = o.getDoubleDigitedValue((p = n.minutes) == null ? void 0 : p.toString());
    }), (p, g) => (b(), M(de, null, [
      s.value ? Ve((b(), L(q1, {
        key: 0,
        "hour-min-value": n.hourMinValue,
        "hour-max-value": n.hourMaxValue,
        "minute-min-value": n.minuteMinValue,
        "minute-max-value": n.minuteMaxValue,
        hours: a.value,
        "onUpdate:hours": g[0] || (g[0] = (v) => a.value = v),
        minutes: i.value,
        "onUpdate:minutes": g[1] || (g[1] = (v) => i.value = v),
        onHandleMinuteSelection: d,
        onHandleHourSelection: h
      }, null, 8, ["hour-min-value", "hour-max-value", "minute-min-value", "minute-max-value", "hours", "minutes"])), [
        [S(r), c]
      ]) : E("", !0),
      T(Zk, {
        hours: S(u),
        "onUpdate:hours": g[2] || (g[2] = (v) => je(u) ? u.value = v : null),
        minutes: S(f),
        "onUpdate:minutes": g[3] || (g[3] = (v) => je(f) ? f.value = v : null),
        disabled: n.disabled,
        "hour-min-value": n.hourMinValue,
        "error-message": n.errorMessage,
        size: n.size,
        onHandleClockIcon: l,
        separator: n.separator,
        "onUpdate:value": m
      }, null, 8, ["hours", "minutes", "disabled", "hour-min-value", "error-message", "size", "separator"])
    ], 64));
  }
}), gr = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    intent: { default: G.primary },
    size: { default: "default" },
    loading: { type: Boolean, default: !1 },
    hasBoxShadow: { type: Boolean, default: !0 }
  },
  setup(t) {
    const e = t, n = I(() => `${e.intent} ${e.size} ${e.hasBoxShadow ? "c-action-button-boxshadow" : ""}`);
    return (r, a) => (b(), M("button", {
      class: H([S(n), "c-action-button-component-action-icon-slot"])
    }, [
      t.loading ? E("", !0) : _e(r.$slots, "default", { key: 0 }),
      t.loading ? (b(), L(vo, {
        key: 1,
        class: H(t.intent)
      }, null, 8, ["class"])) : E("", !0)
    ], 2));
  }
});
function Yu(t, e, n) {
  Z(2, arguments);
  var r = Lt(t, n), a = Lt(e, n);
  return r.getTime() === a.getTime();
}
var Jk = {
  lessThanXSeconds: {
    one: {
      regular: "méně než sekunda",
      past: "před méně než sekundou",
      future: "za méně než sekundu"
    },
    few: {
      regular: "méně než {{count}} sekundy",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekundy"
    },
    many: {
      regular: "méně než {{count}} sekund",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekund"
    }
  },
  xSeconds: {
    one: {
      regular: "sekunda",
      past: "před sekundou",
      future: "za sekundu"
    },
    few: {
      regular: "{{count}} sekundy",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekundy"
    },
    many: {
      regular: "{{count}} sekund",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekund"
    }
  },
  halfAMinute: {
    type: "other",
    other: {
      regular: "půl minuty",
      past: "před půl minutou",
      future: "za půl minuty"
    }
  },
  lessThanXMinutes: {
    one: {
      regular: "méně než minuta",
      past: "před méně než minutou",
      future: "za méně než minutu"
    },
    few: {
      regular: "méně než {{count}} minuty",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minuty"
    },
    many: {
      regular: "méně než {{count}} minut",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minut"
    }
  },
  xMinutes: {
    one: {
      regular: "minuta",
      past: "před minutou",
      future: "za minutu"
    },
    few: {
      regular: "{{count}} minuty",
      past: "před {{count}} minutami",
      future: "za {{count}} minuty"
    },
    many: {
      regular: "{{count}} minut",
      past: "před {{count}} minutami",
      future: "za {{count}} minut"
    }
  },
  aboutXHours: {
    one: {
      regular: "přibližně hodina",
      past: "přibližně před hodinou",
      future: "přibližně za hodinu"
    },
    few: {
      regular: "přibližně {{count}} hodiny",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodiny"
    },
    many: {
      regular: "přibližně {{count}} hodin",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodin"
    }
  },
  xHours: {
    one: {
      regular: "hodina",
      past: "před hodinou",
      future: "za hodinu"
    },
    few: {
      regular: "{{count}} hodiny",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodiny"
    },
    many: {
      regular: "{{count}} hodin",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodin"
    }
  },
  xDays: {
    one: {
      regular: "den",
      past: "před dnem",
      future: "za den"
    },
    few: {
      regular: "{{count}} dny",
      past: "před {{count}} dny",
      future: "za {{count}} dny"
    },
    many: {
      regular: "{{count}} dní",
      past: "před {{count}} dny",
      future: "za {{count}} dní"
    }
  },
  aboutXWeeks: {
    one: {
      regular: "přibližně týden",
      past: "přibližně před týdnem",
      future: "přibližně za týden"
    },
    few: {
      regular: "přibližně {{count}} týdny",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdny"
    },
    many: {
      regular: "přibližně {{count}} týdnů",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdnů"
    }
  },
  xWeeks: {
    one: {
      regular: "týden",
      past: "před týdnem",
      future: "za týden"
    },
    few: {
      regular: "{{count}} týdny",
      past: "před {{count}} týdny",
      future: "za {{count}} týdny"
    },
    many: {
      regular: "{{count}} týdnů",
      past: "před {{count}} týdny",
      future: "za {{count}} týdnů"
    }
  },
  aboutXMonths: {
    one: {
      regular: "přibližně měsíc",
      past: "přibližně před měsícem",
      future: "přibližně za měsíc"
    },
    few: {
      regular: "přibližně {{count}} měsíce",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíce"
    },
    many: {
      regular: "přibližně {{count}} měsíců",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíců"
    }
  },
  xMonths: {
    one: {
      regular: "měsíc",
      past: "před měsícem",
      future: "za měsíc"
    },
    few: {
      regular: "{{count}} měsíce",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíce"
    },
    many: {
      regular: "{{count}} měsíců",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíců"
    }
  },
  aboutXYears: {
    one: {
      regular: "přibližně rok",
      past: "přibližně před rokem",
      future: "přibližně za rok"
    },
    few: {
      regular: "přibližně {{count}} roky",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roky"
    },
    many: {
      regular: "přibližně {{count}} roků",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roků"
    }
  },
  xYears: {
    one: {
      regular: "rok",
      past: "před rokem",
      future: "za rok"
    },
    few: {
      regular: "{{count}} roky",
      past: "před {{count}} roky",
      future: "za {{count}} roky"
    },
    many: {
      regular: "{{count}} roků",
      past: "před {{count}} roky",
      future: "za {{count}} roků"
    }
  },
  overXYears: {
    one: {
      regular: "více než rok",
      past: "před více než rokem",
      future: "za více než rok"
    },
    few: {
      regular: "více než {{count}} roky",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roky"
    },
    many: {
      regular: "více než {{count}} roků",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roků"
    }
  },
  almostXYears: {
    one: {
      regular: "skoro rok",
      past: "skoro před rokem",
      future: "skoro za rok"
    },
    few: {
      regular: "skoro {{count}} roky",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roky"
    },
    many: {
      regular: "skoro {{count}} roků",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roků"
    }
  }
}, ex = function(e, n, r) {
  var a, i = Jk[e];
  i.type === "other" ? a = i.other : n === 1 ? a = i.one : n > 1 && n < 5 ? a = i.few : a = i.many;
  var o = (r == null ? void 0 : r.addSuffix) === !0, s = r == null ? void 0 : r.comparison, l;
  return o && s === -1 ? l = a.past : o && s === 1 ? l = a.future : l = a.regular, l.replace("{{count}}", String(n));
};
const tx = ex;
var nx = {
  full: "EEEE, d. MMMM yyyy",
  long: "d. MMMM yyyy",
  medium: "d. M. yyyy",
  short: "dd.MM.yyyy"
}, rx = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, ax = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ix = {
  date: oe({
    formats: nx,
    defaultWidth: "full"
  }),
  time: oe({
    formats: rx,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: ax,
    defaultWidth: "full"
  })
};
const ox = ix;
var sx = ["neděli", "pondělí", "úterý", "středu", "čtvrtek", "pátek", "sobotu"], lx = {
  lastWeek: "'poslední' eeee 've' p",
  yesterday: "'včera v' p",
  today: "'dnes v' p",
  tomorrow: "'zítra v' p",
  nextWeek: function(e) {
    var n = e.getUTCDay();
    return "'v " + sx[n] + " o' p";
  },
  other: "P"
}, cx = function(e, n) {
  var r = lx[e];
  return typeof r == "function" ? r(n) : r;
};
const ux = cx;
var dx = {
  narrow: ["př. n. l.", "n. l."],
  abbreviated: ["př. n. l.", "n. l."],
  wide: ["před naším letopočtem", "našeho letopočtu"]
}, fx = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"],
  wide: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"]
}, hx = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: ["led", "úno", "bře", "dub", "kvě", "čvn", "čvc", "srp", "zář", "říj", "lis", "pro"],
  wide: ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"]
}, px = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: ["led", "úno", "bře", "dub", "kvě", "čvn", "čvc", "srp", "zář", "říj", "lis", "pro"],
  wide: ["ledna", "února", "března", "dubna", "května", "června", "července", "srpna", "září", "října", "listopadu", "prosince"]
}, mx = {
  narrow: ["ne", "po", "út", "st", "čt", "pá", "so"],
  short: ["ne", "po", "út", "st", "čt", "pá", "so"],
  abbreviated: ["ned", "pon", "úte", "stř", "čtv", "pát", "sob"],
  wide: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"]
}, gx = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, vx = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, yx = function(e, n) {
  var r = Number(e);
  return r + ".";
}, bx = {
  ordinalNumber: yx,
  era: X({
    values: dx,
    defaultWidth: "wide"
  }),
  quarter: X({
    values: fx,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: X({
    values: hx,
    defaultWidth: "wide",
    formattingValues: px,
    defaultFormattingWidth: "wide"
  }),
  day: X({
    values: mx,
    defaultWidth: "wide"
  }),
  dayPeriod: X({
    values: gx,
    defaultWidth: "wide",
    formattingValues: vx,
    defaultFormattingWidth: "wide"
  })
};
const _x = bx;
var wx = /^(\d+)\.?/i, kx = /\d+/i, xx = {
  narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
}, Cx = {
  any: [/^p[řr]/i, /^(po|n)/i]
}, Px = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i
}, Sx = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Mx = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
}, Ox = {
  narrow: [/^l/i, /^[úu]/i, /^b/i, /^d/i, /^k/i, /^[čc]/i, /^[čc]/i, /^s/i, /^z/i, /^[řr]/i, /^l/i, /^p/i],
  any: [/^led/i, /^[úu]n/i, /^b[řr]e/i, /^dub/i, /^kv[ěe]/i, /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i, /^[čc]vc|[čc]erven(ec|ce)/i, /^srp/i, /^z[áa][řr]/i, /^[řr][íi]j/i, /^lis/i, /^pro/i]
}, Dx = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
}, Tx = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^[úu]t/i, /^st/i, /^[čc]t/i, /^p[áa]/i, /^so/i]
}, $x = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
}, Rx = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i
  }
}, Ex = {
  ordinalNumber: pt({
    matchPattern: wx,
    parsePattern: kx,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: K({
    matchPatterns: xx,
    defaultMatchWidth: "wide",
    parsePatterns: Cx,
    defaultParseWidth: "any"
  }),
  quarter: K({
    matchPatterns: Px,
    defaultMatchWidth: "wide",
    parsePatterns: Sx,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: K({
    matchPatterns: Mx,
    defaultMatchWidth: "wide",
    parsePatterns: Ox,
    defaultParseWidth: "any"
  }),
  day: K({
    matchPatterns: Dx,
    defaultMatchWidth: "wide",
    parsePatterns: Tx,
    defaultParseWidth: "any"
  }),
  dayPeriod: K({
    matchPatterns: $x,
    defaultMatchWidth: "any",
    parsePatterns: Rx,
    defaultParseWidth: "any"
  })
};
const Ax = Ex;
var Lx = {
  code: "cs",
  formatDistance: tx,
  formatLong: ox,
  formatRelative: ux,
  localize: _x,
  match: Ax,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const $r = Lx;
var Ix = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, Nx = function(e, n, r) {
  var a, i = Ix[e];
  return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + a : a + " siden" : a;
};
const Wx = Nx;
var zx = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, Bx = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Fx = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Hx = {
  date: oe({
    formats: zx,
    defaultWidth: "full"
  }),
  time: oe({
    formats: Bx,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: Fx,
    defaultWidth: "full"
  })
};
const jx = Hx;
var Vx = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, qx = function(e, n, r, a) {
  return Vx[e];
};
const Ux = qx;
var Yx = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, Xx = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Kx = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
}, Qx = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, Gx = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, Zx = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, Jx = function(e, n) {
  var r = Number(e);
  return r + ".";
}, eC = {
  ordinalNumber: Jx,
  era: X({
    values: Yx,
    defaultWidth: "wide"
  }),
  quarter: X({
    values: Xx,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: X({
    values: Kx,
    defaultWidth: "wide"
  }),
  day: X({
    values: Qx,
    defaultWidth: "wide"
  }),
  dayPeriod: X({
    values: Gx,
    defaultWidth: "wide",
    formattingValues: Zx,
    defaultFormattingWidth: "wide"
  })
};
const tC = eC;
var nC = /^(\d+)(\.)?/i, rC = /\d+/i, aC = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, iC = {
  any: [/^f/i, /^(v|e)/i]
}, oC = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, sC = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, lC = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, cC = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, uC = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, dC = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, fC = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, hC = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, pC = {
  ordinalNumber: pt({
    matchPattern: nC,
    parsePattern: rC,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: K({
    matchPatterns: aC,
    defaultMatchWidth: "wide",
    parsePatterns: iC,
    defaultParseWidth: "any"
  }),
  quarter: K({
    matchPatterns: oC,
    defaultMatchWidth: "wide",
    parsePatterns: sC,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: K({
    matchPatterns: lC,
    defaultMatchWidth: "wide",
    parsePatterns: cC,
    defaultParseWidth: "any"
  }),
  day: K({
    matchPatterns: uC,
    defaultMatchWidth: "wide",
    parsePatterns: dC,
    defaultParseWidth: "any"
  }),
  dayPeriod: K({
    matchPatterns: fC,
    defaultMatchWidth: "any",
    parsePatterns: hC,
    defaultParseWidth: "any"
  })
};
const mC = pC;
var gC = {
  code: "da",
  formatDistance: Wx,
  formatLong: jx,
  formatRelative: Ux,
  localize: tC,
  match: mC,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Rr = gC;
var Xu = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, vC = function(e, n, r) {
  var a, i = r != null && r.addSuffix ? Xu[e].withPreposition : Xu[e].standalone;
  return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : "vor " + a : a;
};
const yC = vC;
var bC = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, _C = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, wC = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, kC = {
  date: oe({
    formats: bC,
    defaultWidth: "full"
  }),
  time: oe({
    formats: _C,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: wC,
    defaultWidth: "full"
  })
};
const xC = kC;
var CC = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, PC = function(e, n, r, a) {
  return CC[e];
};
const SC = PC;
var MC = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, OC = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, ll = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, DC = {
  narrow: ll.narrow,
  abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: ll.wide
}, TC = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, $C = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, RC = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, EC = function(e) {
  var n = Number(e);
  return n + ".";
}, AC = {
  ordinalNumber: EC,
  era: X({
    values: MC,
    defaultWidth: "wide"
  }),
  quarter: X({
    values: OC,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: X({
    values: ll,
    formattingValues: DC,
    defaultWidth: "wide"
  }),
  day: X({
    values: TC,
    defaultWidth: "wide"
  }),
  dayPeriod: X({
    values: $C,
    defaultWidth: "wide",
    formattingValues: RC,
    defaultFormattingWidth: "wide"
  })
};
const LC = AC;
var IC = /^(\d+)(\.)?/i, NC = /\d+/i, WC = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, zC = {
  any: [/^v/i, /^n/i]
}, BC = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, FC = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, HC = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, jC = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, VC = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, qC = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, UC = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, YC = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, XC = {
  ordinalNumber: pt({
    matchPattern: IC,
    parsePattern: NC,
    valueCallback: function(e) {
      return parseInt(e);
    }
  }),
  era: K({
    matchPatterns: WC,
    defaultMatchWidth: "wide",
    parsePatterns: zC,
    defaultParseWidth: "any"
  }),
  quarter: K({
    matchPatterns: BC,
    defaultMatchWidth: "wide",
    parsePatterns: FC,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: K({
    matchPatterns: HC,
    defaultMatchWidth: "wide",
    parsePatterns: jC,
    defaultParseWidth: "any"
  }),
  day: K({
    matchPatterns: VC,
    defaultMatchWidth: "wide",
    parsePatterns: qC,
    defaultParseWidth: "any"
  }),
  dayPeriod: K({
    matchPatterns: UC,
    defaultMatchWidth: "wide",
    parsePatterns: YC,
    defaultParseWidth: "any"
  })
};
const KC = XC;
var QC = {
  code: "de",
  formatDistance: yC,
  formatLong: xC,
  formatRelative: SC,
  localize: LC,
  match: KC,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Er = QC;
var GC = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, ZC = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, JC = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, e3 = {
  date: oe({
    formats: GC,
    defaultWidth: "full"
  }),
  time: oe({
    formats: ZC,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: JC,
    defaultWidth: "full"
  })
};
const t3 = e3;
var n3 = {
  code: "en-GB",
  formatDistance: kh,
  formatLong: t3,
  formatRelative: xh,
  localize: Ch,
  match: Ph,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Ar = n3;
var r3 = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, a3 = function(e, n, r) {
  var a, i = r3[e];
  return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "en " + a : "hace " + a : a;
};
const i3 = a3;
var o3 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, s3 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, l3 = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, c3 = {
  date: oe({
    formats: o3,
    defaultWidth: "full"
  }),
  time: oe({
    formats: s3,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: l3,
    defaultWidth: "full"
  })
};
const u3 = c3;
var d3 = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, f3 = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, h3 = function(e, n, r, a) {
  return n.getUTCHours() !== 1 ? f3[e] : d3[e];
};
const p3 = h3;
var m3 = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, g3 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, v3 = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
}, y3 = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
}, b3 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, _3 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, w3 = function(e, n) {
  var r = Number(e);
  return r + "º";
}, k3 = {
  ordinalNumber: w3,
  era: X({
    values: m3,
    defaultWidth: "wide"
  }),
  quarter: X({
    values: g3,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return Number(e) - 1;
    }
  }),
  month: X({
    values: v3,
    defaultWidth: "wide"
  }),
  day: X({
    values: y3,
    defaultWidth: "wide"
  }),
  dayPeriod: X({
    values: b3,
    defaultWidth: "wide",
    formattingValues: _3,
    defaultFormattingWidth: "wide"
  })
};
const x3 = k3;
var C3 = /^(\d+)(º)?/i, P3 = /\d+/i, S3 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, M3 = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
}, O3 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, D3 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, T3 = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, $3 = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
}, R3 = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, E3 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, A3 = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, L3 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, I3 = {
  ordinalNumber: pt({
    matchPattern: C3,
    parsePattern: P3,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: K({
    matchPatterns: S3,
    defaultMatchWidth: "wide",
    parsePatterns: M3,
    defaultParseWidth: "any"
  }),
  quarter: K({
    matchPatterns: O3,
    defaultMatchWidth: "wide",
    parsePatterns: D3,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: K({
    matchPatterns: T3,
    defaultMatchWidth: "wide",
    parsePatterns: $3,
    defaultParseWidth: "any"
  }),
  day: K({
    matchPatterns: R3,
    defaultMatchWidth: "wide",
    parsePatterns: E3,
    defaultParseWidth: "any"
  }),
  dayPeriod: K({
    matchPatterns: A3,
    defaultMatchWidth: "any",
    parsePatterns: L3,
    defaultParseWidth: "any"
  })
};
const N3 = I3;
var W3 = {
  code: "es",
  formatDistance: i3,
  formatLong: u3,
  formatRelative: p3,
  localize: x3,
  match: N3,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const Lr = W3;
function Ku(t) {
  return t.replace(/sekuntia?/, "sekunnin");
}
function Qu(t) {
  return t.replace(/minuuttia?/, "minuutin");
}
function Gu(t) {
  return t.replace(/tuntia?/, "tunnin");
}
function z3(t) {
  return t.replace(/päivää?/, "päivän");
}
function Zu(t) {
  return t.replace(/(viikko|viikkoa)/, "viikon");
}
function Ju(t) {
  return t.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function Zr(t) {
  return t.replace(/(vuosi|vuotta)/, "vuoden");
}
var B3 = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: Ku
  },
  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: Ku
  },
  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: function(e) {
      return "puolen minuutin";
    }
  },
  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: Qu
  },
  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: Qu
  },
  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: Gu
  },
  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: Gu
  },
  xDays: {
    one: "päivä",
    other: "{{count}} päivää",
    futureTense: z3
  },
  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: Zu
  },
  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: Zu
  },
  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: Ju
  },
  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: Ju
  },
  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: Zr
  },
  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: Zr
  },
  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: Zr
  },
  almostXYears: {
    one: "lähes vuosi",
    other: "lähes {{count}} vuotta",
    futureTense: Zr
  }
}, F3 = function(e, n, r) {
  var a = B3[e], i = n === 1 ? a.one : a.other.replace("{{count}}", String(n));
  return r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? a.futureTense(i) + " kuluttua" : i + " sitten" : i;
};
const H3 = F3;
var j3 = {
  full: "eeee d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "d.M.y"
}, V3 = {
  full: "HH.mm.ss zzzz",
  long: "HH.mm.ss z",
  medium: "HH.mm.ss",
  short: "HH.mm"
}, q3 = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, U3 = {
  date: oe({
    formats: j3,
    defaultWidth: "full"
  }),
  time: oe({
    formats: V3,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: q3,
    defaultWidth: "full"
  })
};
const Y3 = U3;
var X3 = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'tänään klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: "P"
}, K3 = function(e, n, r, a) {
  return X3[e];
};
const Q3 = K3;
var G3 = {
  narrow: ["eaa.", "jaa."],
  abbreviated: ["eaa.", "jaa."],
  wide: ["ennen ajanlaskun alkua", "jälkeen ajanlaskun alun"]
}, Z3 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
}, cl = {
  narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
  abbreviated: ["tammi", "helmi", "maalis", "huhti", "touko", "kesä", "heinä", "elo", "syys", "loka", "marras", "joulu"],
  wide: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kesäkuu", "heinäkuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"]
}, J3 = {
  narrow: cl.narrow,
  abbreviated: cl.abbreviated,
  wide: ["tammikuuta", "helmikuuta", "maaliskuuta", "huhtikuuta", "toukokuuta", "kesäkuuta", "heinäkuuta", "elokuuta", "syyskuuta", "lokakuuta", "marraskuuta", "joulukuuta"]
}, ni = {
  narrow: ["S", "M", "T", "K", "T", "P", "L"],
  short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
  abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
  wide: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
}, e5 = {
  narrow: ni.narrow,
  short: ni.short,
  abbreviated: ni.abbreviated,
  wide: ["sunnuntaina", "maanantaina", "tiistaina", "keskiviikkona", "torstaina", "perjantaina", "lauantaina"]
}, t5 = {
  narrow: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  abbreviated: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  wide: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyöllä",
    noon: "keskipäivällä",
    morning: "aamupäivällä",
    afternoon: "iltapäivällä",
    evening: "illalla",
    night: "yöllä"
  }
}, n5 = function(e, n) {
  var r = Number(e);
  return r + ".";
}, r5 = {
  ordinalNumber: n5,
  era: X({
    values: G3,
    defaultWidth: "wide"
  }),
  quarter: X({
    values: Z3,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: X({
    values: cl,
    defaultWidth: "wide",
    formattingValues: J3,
    defaultFormattingWidth: "wide"
  }),
  day: X({
    values: ni,
    defaultWidth: "wide",
    formattingValues: e5,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: X({
    values: t5,
    defaultWidth: "wide"
  })
};
const a5 = r5;
var i5 = /^(\d+)(\.)/i, o5 = /\d+/i, s5 = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
}, l5 = {
  any: [/^e/i, /^j/i]
}, c5 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i
}, u5 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, d5 = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
}, f5 = {
  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
}, h5 = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
}, p5 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
}, m5 = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
}, g5 = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
}, v5 = {
  ordinalNumber: pt({
    matchPattern: i5,
    parsePattern: o5,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: K({
    matchPatterns: s5,
    defaultMatchWidth: "wide",
    parsePatterns: l5,
    defaultParseWidth: "any"
  }),
  quarter: K({
    matchPatterns: c5,
    defaultMatchWidth: "wide",
    parsePatterns: u5,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: K({
    matchPatterns: d5,
    defaultMatchWidth: "wide",
    parsePatterns: f5,
    defaultParseWidth: "any"
  }),
  day: K({
    matchPatterns: h5,
    defaultMatchWidth: "wide",
    parsePatterns: p5,
    defaultParseWidth: "any"
  }),
  dayPeriod: K({
    matchPatterns: m5,
    defaultMatchWidth: "any",
    parsePatterns: g5,
    defaultParseWidth: "any"
  })
};
const y5 = v5;
var b5 = {
  code: "fi",
  formatDistance: H3,
  formatLong: Y3,
  formatRelative: Q3,
  localize: a5,
  match: y5,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Ir = b5;
var _5 = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, w5 = function(e, n, r) {
  var a, i = _5[e];
  return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "dans " + a : "il y a " + a : a;
};
const k5 = w5;
var x5 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, C5 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, P5 = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, S5 = {
  date: oe({
    formats: x5,
    defaultWidth: "full"
  }),
  time: oe({
    formats: C5,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: P5,
    defaultWidth: "full"
  })
};
const M5 = S5;
var O5 = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, D5 = function(e, n, r, a) {
  return O5[e];
};
const T5 = D5;
var $5 = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, R5 = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, E5 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
}, A5 = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
}, L5 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, I5 = function(e, n) {
  var r = Number(e), a = n == null ? void 0 : n.unit;
  if (r === 0)
    return "0";
  var i = ["year", "week", "hour", "minute", "second"], o;
  return r === 1 ? o = a && i.includes(a) ? "ère" : "er" : o = "ème", r + o;
}, N5 = {
  ordinalNumber: I5,
  era: X({
    values: $5,
    defaultWidth: "wide"
  }),
  quarter: X({
    values: R5,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: X({
    values: E5,
    defaultWidth: "wide"
  }),
  day: X({
    values: A5,
    defaultWidth: "wide"
  }),
  dayPeriod: X({
    values: L5,
    defaultWidth: "wide"
  })
};
const W5 = N5;
var z5 = /^(\d+)(ième|ère|ème|er|e)?/i, B5 = /\d+/i, F5 = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, H5 = {
  any: [/^av/i, /^ap/i]
}, j5 = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, V5 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, q5 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, U5 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Y5 = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, X5 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, K5 = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, Q5 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, G5 = {
  ordinalNumber: pt({
    matchPattern: z5,
    parsePattern: B5,
    valueCallback: function(e) {
      return parseInt(e);
    }
  }),
  era: K({
    matchPatterns: F5,
    defaultMatchWidth: "wide",
    parsePatterns: H5,
    defaultParseWidth: "any"
  }),
  quarter: K({
    matchPatterns: j5,
    defaultMatchWidth: "wide",
    parsePatterns: V5,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: K({
    matchPatterns: q5,
    defaultMatchWidth: "wide",
    parsePatterns: U5,
    defaultParseWidth: "any"
  }),
  day: K({
    matchPatterns: Y5,
    defaultMatchWidth: "wide",
    parsePatterns: X5,
    defaultParseWidth: "any"
  }),
  dayPeriod: K({
    matchPatterns: K5,
    defaultMatchWidth: "any",
    parsePatterns: Q5,
    defaultParseWidth: "any"
  })
};
const Z5 = G5;
var J5 = {
  code: "fr",
  formatDistance: k5,
  formatLong: M5,
  formatRelative: T5,
  localize: W5,
  match: Z5,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Nr = J5;
var e4 = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, t4 = function(e, n, r) {
  var a, i = e4[e];
  return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "tra " + a : a + " fa" : a;
};
const n4 = t4;
var r4 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, a4 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, i4 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, o4 = {
  date: oe({
    formats: r4,
    defaultWidth: "full"
  }),
  time: oe({
    formats: a4,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: i4,
    defaultWidth: "full"
  })
};
const s4 = o4;
var Kl = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
function l4(t) {
  switch (t) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + Kl[t] + " scorso alle' p";
  }
}
function ed(t) {
  return "'" + Kl[t] + " alle' p";
}
function c4(t) {
  switch (t) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + Kl[t] + " prossimo alle' p";
  }
}
var u4 = {
  lastWeek: function(e, n, r) {
    var a = e.getUTCDay();
    return Yu(e, n, r) ? ed(a) : l4(a);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function(e, n, r) {
    var a = e.getUTCDay();
    return Yu(e, n, r) ? ed(a) : c4(a);
  },
  other: "P"
}, d4 = function(e, n, r, a) {
  var i = u4[e];
  return typeof i == "function" ? i(n, r, a) : i;
};
const f4 = d4;
var h4 = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, p4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, m4 = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
}, g4 = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
}, v4 = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, y4 = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, b4 = function(e, n) {
  var r = Number(e);
  return String(r);
}, _4 = {
  ordinalNumber: b4,
  era: X({
    values: h4,
    defaultWidth: "wide"
  }),
  quarter: X({
    values: p4,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: X({
    values: m4,
    defaultWidth: "wide"
  }),
  day: X({
    values: g4,
    defaultWidth: "wide"
  }),
  dayPeriod: X({
    values: v4,
    defaultWidth: "wide",
    formattingValues: y4,
    defaultFormattingWidth: "wide"
  })
};
const w4 = _4;
var k4 = /^(\d+)(º)?/i, x4 = /\d+/i, C4 = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, P4 = {
  any: [/^a/i, /^(d|e)/i]
}, S4 = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, M4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, O4 = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, D4 = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, T4 = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, $4 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, R4 = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, E4 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, A4 = {
  ordinalNumber: pt({
    matchPattern: k4,
    parsePattern: x4,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: K({
    matchPatterns: C4,
    defaultMatchWidth: "wide",
    parsePatterns: P4,
    defaultParseWidth: "any"
  }),
  quarter: K({
    matchPatterns: S4,
    defaultMatchWidth: "wide",
    parsePatterns: M4,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: K({
    matchPatterns: O4,
    defaultMatchWidth: "wide",
    parsePatterns: D4,
    defaultParseWidth: "any"
  }),
  day: K({
    matchPatterns: T4,
    defaultMatchWidth: "wide",
    parsePatterns: $4,
    defaultParseWidth: "any"
  }),
  dayPeriod: K({
    matchPatterns: R4,
    defaultMatchWidth: "any",
    parsePatterns: E4,
    defaultParseWidth: "any"
  })
};
const L4 = A4;
var I4 = {
  code: "it",
  formatDistance: n4,
  formatLong: s4,
  formatRelative: f4,
  localize: w4,
  match: L4,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Wr = I4;
var N4 = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en måned",
    other: "omtrent {{count}} måneder"
  },
  xMonths: {
    one: "en måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "omtrent ett år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over ett år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten ett år",
    other: "nesten {{count}} år"
  }
}, W4 = function(e, n, r) {
  var a, i = N4[e];
  return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + a : a + " siden" : a;
};
const z4 = W4;
var B4 = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, F4 = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, H4 = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, j4 = {
  date: oe({
    formats: B4,
    defaultWidth: "full"
  }),
  time: oe({
    formats: F4,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: H4,
    defaultWidth: "full"
  })
};
const V4 = j4;
var q4 = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, U4 = function(e, n, r, a) {
  return q4[e];
};
const Y4 = U4;
var X4 = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, K4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Q4 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
}, G4 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, Z4 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgenen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natten"
  }
}, J4 = function(e, n) {
  var r = Number(e);
  return r + ".";
}, e8 = {
  ordinalNumber: J4,
  era: X({
    values: X4,
    defaultWidth: "wide"
  }),
  quarter: X({
    values: K4,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: X({
    values: Q4,
    defaultWidth: "wide"
  }),
  day: X({
    values: G4,
    defaultWidth: "wide"
  }),
  dayPeriod: X({
    values: Z4,
    defaultWidth: "wide"
  })
};
const t8 = e8;
var n8 = /^(\d+)\.?/i, r8 = /\d+/i, a8 = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, i8 = {
  any: [/^f/i, /^e/i]
}, o8 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, s8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, l8 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, c8 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, u8 = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, d8 = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, f8 = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
}, h8 = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, p8 = {
  ordinalNumber: pt({
    matchPattern: n8,
    parsePattern: r8,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: K({
    matchPatterns: a8,
    defaultMatchWidth: "wide",
    parsePatterns: i8,
    defaultParseWidth: "any"
  }),
  quarter: K({
    matchPatterns: o8,
    defaultMatchWidth: "wide",
    parsePatterns: s8,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: K({
    matchPatterns: l8,
    defaultMatchWidth: "wide",
    parsePatterns: c8,
    defaultParseWidth: "any"
  }),
  day: K({
    matchPatterns: u8,
    defaultMatchWidth: "wide",
    parsePatterns: d8,
    defaultParseWidth: "any"
  }),
  dayPeriod: K({
    matchPatterns: f8,
    defaultMatchWidth: "any",
    parsePatterns: h8,
    defaultParseWidth: "any"
  })
};
const m8 = p8;
var g8 = {
  code: "nb",
  formatDistance: z4,
  formatLong: V4,
  formatRelative: Y4,
  localize: t8,
  match: m8,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const zr = g8;
var v8 = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, y8 = function(e, n, r) {
  var a, i = v8[e];
  return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "over " + a : a + " geleden" : a;
};
const b8 = y8;
var _8 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, w8 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, k8 = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, x8 = {
  date: oe({
    formats: _8,
    defaultWidth: "full"
  }),
  time: oe({
    formats: w8,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: k8,
    defaultWidth: "full"
  })
};
const C8 = x8;
var P8 = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, S8 = function(e, n, r, a) {
  return P8[e];
};
const M8 = S8;
var O8 = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, D8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, T8 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
}, $8 = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
}, R8 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, E8 = function(e, n) {
  var r = Number(e);
  return r + "e";
}, A8 = {
  ordinalNumber: E8,
  era: X({
    values: O8,
    defaultWidth: "wide"
  }),
  quarter: X({
    values: D8,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: X({
    values: T8,
    defaultWidth: "wide"
  }),
  day: X({
    values: $8,
    defaultWidth: "wide"
  }),
  dayPeriod: X({
    values: R8,
    defaultWidth: "wide"
  })
};
const L8 = A8;
var I8 = /^(\d+)e?/i, N8 = /\d+/i, W8 = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, z8 = {
  any: [/^v/, /^n/]
}, B8 = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, F8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, H8 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, j8 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
}, V8 = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, q8 = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, U8 = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, Y8 = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, X8 = {
  ordinalNumber: pt({
    matchPattern: I8,
    parsePattern: N8,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: K({
    matchPatterns: W8,
    defaultMatchWidth: "wide",
    parsePatterns: z8,
    defaultParseWidth: "any"
  }),
  quarter: K({
    matchPatterns: B8,
    defaultMatchWidth: "wide",
    parsePatterns: F8,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: K({
    matchPatterns: H8,
    defaultMatchWidth: "wide",
    parsePatterns: j8,
    defaultParseWidth: "any"
  }),
  day: K({
    matchPatterns: V8,
    defaultMatchWidth: "wide",
    parsePatterns: q8,
    defaultParseWidth: "any"
  }),
  dayPeriod: K({
    matchPatterns: U8,
    defaultMatchWidth: "any",
    parsePatterns: Y8,
    defaultParseWidth: "any"
  })
};
const K8 = X8;
var Q8 = {
  code: "nl",
  formatDistance: b8,
  formatLong: C8,
  formatRelative: M8,
  localize: L8,
  match: K8,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Br = Q8;
var G8 = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, Z8 = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], J8 = function(e, n, r) {
  var a, i = G8[e];
  return typeof i == "string" ? a = i : n === 1 ? a = i.one : r && r.onlyNumeric ? a = i.other.replace("{{count}}", String(n)) : a = i.other.replace("{{count}}", n < 13 ? Z8[n] : String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + a : a + " sedan" : a;
};
const e7 = J8;
var t7 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, n7 = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, r7 = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, a7 = {
  date: oe({
    formats: t7,
    defaultWidth: "full"
  }),
  time: oe({
    formats: n7,
    defaultWidth: "full"
  }),
  dateTime: oe({
    formats: r7,
    defaultWidth: "full"
  })
};
const i7 = a7;
var o7 = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, s7 = function(e, n, r, a) {
  return o7[e];
};
const l7 = s7;
var c7 = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, u7 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, d7 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
}, f7 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, h7 = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, p7 = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, m7 = function(e, n) {
  var r = Number(e), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
      case 2:
        return r + ":a";
    }
  return r + ":e";
}, g7 = {
  ordinalNumber: m7,
  era: X({
    values: c7,
    defaultWidth: "wide"
  }),
  quarter: X({
    values: u7,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: X({
    values: d7,
    defaultWidth: "wide"
  }),
  day: X({
    values: f7,
    defaultWidth: "wide"
  }),
  dayPeriod: X({
    values: h7,
    defaultWidth: "wide",
    formattingValues: p7,
    defaultFormattingWidth: "wide"
  })
};
const v7 = g7;
var y7 = /^(\d+)(:a|:e)?/i, b7 = /\d+/i, _7 = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, w7 = {
  any: [/^f/i, /^[ev]/i]
}, k7 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, x7 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, C7 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, P7 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, S7 = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, M7 = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, O7 = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, D7 = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, T7 = {
  ordinalNumber: pt({
    matchPattern: y7,
    parsePattern: b7,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: K({
    matchPatterns: _7,
    defaultMatchWidth: "wide",
    parsePatterns: w7,
    defaultParseWidth: "any"
  }),
  quarter: K({
    matchPatterns: k7,
    defaultMatchWidth: "wide",
    parsePatterns: x7,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: K({
    matchPatterns: C7,
    defaultMatchWidth: "wide",
    parsePatterns: P7,
    defaultParseWidth: "any"
  }),
  day: K({
    matchPatterns: S7,
    defaultMatchWidth: "wide",
    parsePatterns: M7,
    defaultParseWidth: "any"
  }),
  dayPeriod: K({
    matchPatterns: O7,
    defaultMatchWidth: "any",
    parsePatterns: D7,
    defaultParseWidth: "any"
  })
};
const $7 = T7;
var R7 = {
  code: "sv",
  formatDistance: e7,
  formatLong: i7,
  formatRelative: l7,
  localize: v7,
  match: $7,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Fr = R7, E7 = { class: "c-day-nav-wrapper" }, A7 = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    locale: null,
    canNavigateToPreviousDay: { type: Boolean, default: !0 },
    canNavigateToFutureDay: { type: Boolean, default: !0 },
    date: { default: /* @__PURE__ */ new Date() }
  },
  emits: ["update:date"],
  setup(t, { emit: e }) {
    const n = t, { getApplicationLocale: r } = rt(), a = { it: Wr, fr: Nr, de: Er, es: Lr, en: Ar, cs: $r, da: Rr, no: zr, nl: Br, fi: Ir, sv: Fr }, i = () => {
      l.value = hr(l.value, -1);
    }, o = () => {
      l.value = hr(l.value, 1);
    }, s = (u, f = "dd MMMM") => {
      const d = n.locale ?? r();
      return Et(u, f, { locale: a[d] });
    }, l = I({
      get() {
        return n.date;
      },
      set(u) {
        e("update:date", u);
      }
    }), c = I(() => s(l.value));
    return (u, f) => (b(), M("div", E7, [
      T(gr, {
        size: "small",
        disabled: !t.canNavigateToPreviousDay,
        intent: S(G).secondary,
        onClick: i
      }, {
        default: W(() => [
          T(S(ho))
        ]),
        _: 1
      }, 8, ["disabled", "intent"]),
      T(S(qf), {
        type: "five",
        class: "c-day-nav-date"
      }, {
        default: W(() => [
          V(j(S(c)), 1)
        ]),
        _: 1
      }),
      T(gr, {
        size: "small",
        disabled: !t.canNavigateToFutureDay,
        intent: S(G).secondary,
        onClick: o
      }, {
        default: W(() => [
          T(S(po))
        ]),
        _: 1
      }, 8, ["disabled", "intent"])
    ]));
  }
});
const L$ = /* @__PURE__ */ B(A7, [["__scopeId", "data-v-acca5fc3"]]), L7 = { class: "c-drop-down-wrapper" }, I7 = { class: "c-drop-down-modal-wrapper" }, N7 = { class: "c-drop-down-month-view" }, W7 = /* @__PURE__ */ ne({
  __name: "CMonthYearPickerModal",
  props: {
    locale: null,
    date: null,
    canNavigateToPreviousYear: { type: Boolean },
    canNavigateToFutureDayYear: { type: Boolean },
    disablePastMonths: { type: Boolean }
  },
  emits: ["update:date", "onSelectMonth"],
  setup(t, { emit: e }) {
    const n = t, { getApplicationLocale: r } = rt(), a = { it: Wr, fr: Nr, de: Er, es: Lr, en: Ar, cs: $r, da: Rr, no: zr, nl: Br, fi: Ir, sv: Fr }, i = (w, C = "MMMM yyyy") => {
      const x = n.locale ?? r();
      return Et(w, C, { locale: a[x] });
    }, o = U(n.date), s = U(n.date.getMonth()), l = I(() => i(o.value, "yyyy")), c = I({
      get() {
        return n.date;
      },
      set(w) {
        e("update:date", w);
      }
    }), u = () => {
      o.value = qk(o.value, 1);
    }, f = () => {
      o.value = ph(o.value, 1);
    }, d = I(() => {
      const w = n.locale ?? r(), C = a[w];
      return [...Array(12).keys()].map((y) => {
        var _;
        return (_ = C.localize) == null ? void 0 : _.month(y, { width: "abbreviated" });
      });
    }), h = I(() => [d.value.slice(0, 3), d.value.slice(3, 6), d.value.slice(6, 9), d.value.slice(9, 12)]), m = (w) => {
      s.value = w, c.value = new Date(Number(l.value), w, 1), e("onSelectMonth", w);
    }, p = I(() => i(o.value, "yyyy") === i(c.value, "yyyy")), g = (w) => {
      const C = /* @__PURE__ */ new Date(), x = C.getMonth(), y = C.getFullYear(), _ = Number(i(o.value, "yyyy"));
      if (n.disablePastMonths) {
        if (_ < y)
          return !0;
        if (_ > y)
          return !1;
        if (w < x)
          return !0;
      }
      return !1;
    }, v = (w) => `${g(w) ? "disabled" : ""}
                  ${w === s.value && p.value ? "selected" : ""}`;
    return (w, C) => (b(), M("div", L7, [
      R("div", I7, [
        T(gr, {
          "has-box-shadow": !1,
          size: "small",
          disabled: !t.canNavigateToPreviousYear,
          intent: S(G).secondary,
          onClick: u
        }, {
          default: W(() => [
            T(S(ho))
          ]),
          _: 1
        }, 8, ["disabled", "intent"]),
        T(Ne, {
          type: "two",
          class: "c-year"
        }, {
          default: W(() => [
            V(j(S(l)), 1)
          ]),
          _: 1
        }),
        T(gr, {
          "has-box-shadow": !1,
          size: "small",
          disabled: !t.canNavigateToFutureDayYear,
          intent: S(G).secondary,
          onClick: f
        }, {
          default: W(() => [
            T(S(po))
          ]),
          _: 1
        }, 8, ["disabled", "intent"])
      ]),
      R("div", N7, [
        (b(!0), M(de, null, xe(S(h), (x, y) => (b(), M("div", {
          class: "c-drop-down-modal-month-row",
          key: y
        }, [
          (b(!0), M(de, null, xe(x, (_, k) => (b(), L(Ne, {
            type: "three",
            class: H(["c-month", v(k + y * 3)]),
            onClick: (P) => m(k + y * 3),
            key: k + y * 3
          }, {
            default: W(() => [
              V(j(_), 1)
            ]),
            _: 2
          }, 1032, ["onClick", "class"]))), 128))
        ]))), 128))
      ])
    ]));
  }
});
const z7 = /* @__PURE__ */ B(W7, [["__scopeId", "data-v-6f59c86e"]]), B7 = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    locale: { default: void 0 },
    date: { default: /* @__PURE__ */ new Date() },
    canNavigateToPreviousYear: { type: Boolean, default: !0 },
    canNavigateToFutureDayYear: { type: Boolean, default: !0 },
    disablePastMonths: { type: Boolean, default: !0 },
    type: { default: "two" }
  },
  emits: ["update:date"],
  setup(t, { emit: e }) {
    const n = t, r = vn, { getApplicationLocale: a } = rt(), i = { it: Wr, fr: Nr, de: Er, es: Lr, en: Ar, cs: $r, da: Rr, no: zr, nl: Br, fi: Ir, sv: Fr }, o = U(!1), s = U(!1), l = () => {
      o.value = !1, s.value = !1;
    }, c = () => {
      o.value = !o.value, s.value = o.value;
    }, u = () => {
      o.value = !o.value;
    }, f = (p, g = "MMMM yyyy") => {
      const v = n.locale ?? a();
      return Et(p, g, { locale: i[v] });
    }, d = I({
      get() {
        return n.date;
      },
      set(p) {
        e("update:date", p);
      }
    }), h = I(() => f(d.value)), m = (p) => {
      d.value = p;
    };
    return (p, g) => (b(), M(de, null, [
      o.value ? Ve((b(), L(z7, {
        key: 0,
        locale: t.locale,
        date: S(d),
        "onUpdate:date": g[0] || (g[0] = (v) => je(d) ? d.value = v : null),
        "can-navigate-to-future-day-year": t.canNavigateToFutureDayYear,
        "can-navigate-to-previous-year": t.canNavigateToPreviousYear,
        "onOnUpdate:date": m,
        "disable-past-months": t.disablePastMonths,
        onOnSelectMonth: l
      }, null, 8, ["locale", "date", "can-navigate-to-future-day-year", "can-navigate-to-previous-year", "disable-past-months"])), [
        [S(r), l]
      ]) : E("", !0),
      R("div", {
        class: "c-month-year-picker-wrapper",
        onClick: c
      }, [
        T(S(qf), {
          type: t.type,
          class: "c-day-nav-date"
        }, {
          default: W(() => [
            V(j(S(h)), 1)
          ]),
          _: 1
        }, 8, ["type"]),
        T(S(Xt), {
          "chevron-direction": s.value ? "up" : "bottom",
          onInteracted: u
        }, null, 8, ["chevron-direction"])
      ])
    ], 64));
  }
});
const I$ = /* @__PURE__ */ B(B7, [["__scopeId", "data-v-2c7dfd46"]]), F7 = /* @__PURE__ */ ne({
  __name: "CMultipleSelectionDropdownChildElement",
  props: {
    option: null
  },
  emits: ["update:child-option"],
  setup(t, { emit: e }) {
    const n = t, r = I({
      get() {
        return n.option.checked;
      },
      set(a) {
        e("update:child-option", { ...n.option, checked: a });
      }
    });
    return (a, i) => (b(), L(S(Lp), {
      label: t.option.label,
      value: t.option.value,
      "active-value": S(r),
      "onUpdate:activeValue": i[0] || (i[0] = (o) => je(r) ? r.value = o : null)
    }, null, 8, ["label", "value", "active-value"]));
  }
}), H7 = { class: "c-option-wrapper" }, j7 = {
  key: 0,
  class: "c-child-options-wrapper"
}, V7 = /* @__PURE__ */ ne({
  __name: "CMultipleSelectionDropdownElement",
  props: {
    option: null
  },
  emits: ["update:option", "update:child-option", "update:availableList"],
  setup(t, { emit: e }) {
    const n = t, r = I({
      get() {
        return i.value.checked;
      },
      set(o) {
        e("update:option", { ...n.option, checked: o });
      }
    }), a = (o) => {
      var l;
      const s = (l = i.value.children) == null ? void 0 : l.map((c) => c.value === o.value ? { ...c, checked: o.checked } : c);
      i.value = { ...i.value, children: s }, e("update:child-option", o);
    }, i = I({
      get() {
        return n.option;
      },
      set(o) {
        e("update:availableList", o);
      }
    });
    return (o, s) => (b(), M("div", H7, [
      T(S(Lp), {
        label: S(i).label,
        value: S(i).value,
        "active-value": S(r),
        "onUpdate:activeValue": s[0] || (s[0] = (l) => je(r) ? r.value = l : null),
        indeterminate: S(i).inDeterminate
      }, null, 8, ["label", "value", "active-value", "indeterminate"]),
      S(i).children ? (b(), M("div", j7, [
        (b(!0), M(de, null, xe(S(i).children, (l, c) => (b(), M("div", {
          key: c,
          class: "c-child-option-wrapper"
        }, [
          T(F7, {
            option: l,
            "onUpdate:childOption": a
          }, null, 8, ["option"])
        ]))), 128))
      ])) : E("", !0)
    ]));
  }
});
const q7 = /* @__PURE__ */ B(V7, [["__scopeId", "data-v-c1eec462"]]), U7 = { key: 0 }, Y7 = {
  key: 1,
  class: "c-options-wrapper"
}, X7 = /* @__PURE__ */ ne({
  __name: "CMultipleSelectionDropdown",
  props: {
    isDropdownOpened: { type: Boolean, default: !1 },
    searchListOptions: null,
    emptyMessage: null,
    displayParentOptionInBadge: { type: Boolean, default: !1 },
    strategy: { default: "absolute" },
    maxHeight: null
  },
  emits: ["update:searchList", "update:searchListOptions"],
  setup(t, { expose: e, emit: n }) {
    const r = t;
    so((d) => ({
      b444c3c6: t.strategy,
      "7c6f1ee0": S(a)
    }));
    const a = I(() => `${r.maxHeight}px`);
    e({
      updateParentOptionCheckedStatus: l
    });
    const i = I(() => `${r.isDropdownOpened ? "c-dropdown-expanded" : ""}${r.strategy === "absolute" ? " c-drop-down-expanded-absolute" : ""}`), o = I({
      get() {
        return r.searchListOptions;
      },
      set(d) {
        n("update:searchListOptions", d);
      }
    }), s = I(() => !r.searchListOptions || r.searchListOptions && r.searchListOptions.length === 0);
    function l(d) {
      const h = (d == null ? void 0 : d.filter((m) => m.checked === !1)) ?? void 0;
      return !(h && h.length > 0);
    }
    function c(d) {
      const h = (d == null ? void 0 : d.filter((p) => p.checked === !0)) ?? void 0, m = (d == null ? void 0 : d.filter((p) => p.checked === !1)) ?? void 0;
      return !!(h && h.length > 0 && m && m.length > 0);
    }
    const u = ({ checked: d, value: h }) => {
      var m;
      o.value = (m = o.value) == null ? void 0 : m.map((p) => {
        if (p.value === h) {
          const g = p.children ? p.children.map((v) => ({
            label: v.label,
            value: v.value,
            checked: d
          })) : void 0;
          return {
            label: p.label,
            value: p.value,
            checked: d,
            children: g
          };
        }
        return p;
      });
    }, f = ({ checked: d, value: h }) => {
      var m;
      o.value = (m = o.value) == null ? void 0 : m.map((p) => {
        const g = p.children ? p.children.map((v) => v.value === h ? {
          label: v.label,
          value: v.value,
          checked: d
        } : v) : void 0;
        return {
          label: p.label,
          value: p.value,
          checked: g ? l(g) : p.checked,
          inDeterminate: g ? c(g) : !1,
          children: g
        };
      });
    };
    return (d, h) => (b(), M("div", {
      class: H(["c-drop-down-wrapper", S(i)])
    }, [
      S(s) ? (b(), M("div", U7, [
        T(S(we), {
          type: "four",
          class: "c-empty-message"
        }, {
          default: W(() => [
            V(j(t.emptyMessage), 1)
          ]),
          _: 1
        })
      ])) : E("", !0),
      S(s) ? E("", !0) : (b(), M("div", Y7, [
        (b(!0), M(de, null, xe(t.searchListOptions, (m, p) => (b(), L(q7, {
          key: p,
          "onUpdate:option": u,
          "onUpdate:childOption": f,
          option: m
        }, null, 8, ["option"]))), 128))
      ]))
    ], 2));
  }
});
const K7 = /* @__PURE__ */ B(X7, [["__scopeId", "data-v-dd8997b7"]]), Q7 = { class: "c-badges-wrapper" }, G7 = { class: "c-selected-badges" }, Z7 = {
  key: 0,
  class: "c-badge-option-span-label"
}, J7 = {
  key: 1,
  class: "c-badge-option-span-count"
}, e6 = /* @__PURE__ */ ne({
  __name: "CMultipleSelectionBadges",
  props: {
    selectedList: null
  },
  emits: ["de-select-option"],
  setup(t, { emit: e }) {
    const n = t, r = I(() => {
      var s;
      return n.selectedList ? {
        firstSelectedLabel: ((s = n.selectedList) == null ? void 0 : s[0]) ?? void 0,
        numberOfOtherSelectedLabels: n.selectedList && n.selectedList.length > 0 ? n.selectedList.length - 1 : void 0
      } : {
        firstSelectedLabel: void 0,
        numberOfOtherSelectedLabels: void 0
      };
    }), a = I(() => r.value.firstSelectedLabel), i = I(() => r.value.numberOfOtherSelectedLabels), o = () => {
      e("de-select-option", a.value);
    };
    return (s, l) => (b(), M("div", Q7, [
      R("span", G7, [
        S(a) ? (b(), M("span", Z7, [
          T(S(we), {
            type: "four",
            class: "c-badge-label"
          }, {
            default: W(() => [
              V(j(S(a).label), 1)
            ]),
            _: 1
          }),
          T(S(Bn), {
            class: "c-close-icon",
            onClick: ve(o, ["stop"])
          }, null, 8, ["onClick"])
        ])) : E("", !0),
        S(i) ? (b(), M("span", J7, [
          T(S(we), {
            type: "four",
            class: "c-badge-number"
          }, {
            default: W(() => [
              V("+ " + j(S(i)), 1)
            ]),
            _: 1
          })
        ])) : E("", !0)
      ])
    ]));
  }
});
const t6 = /* @__PURE__ */ B(e6, [["__scopeId", "data-v-5c724296"]]), n6 = {
  class: "c-multi-selection",
  tabindex: "0"
}, r6 = { class: "c-multi-selection-wrapper" }, a6 = { class: "c-input-wrap" }, i6 = ["placeholder", "onKeyup"], o6 = {
  key: 0,
  class: "c-slot-badges-post"
}, s6 = { class: "c-slot-icon-post" }, l6 = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    placeHolder: { default: "" },
    searchList: null,
    value: { default: "" },
    minLengthToTriggerSearch: { default: 1 },
    delayOnTypeSearch: { default: 300 },
    emptyMessage: null,
    displayParentOptionInBadge: { type: Boolean, default: !1 },
    strategy: { default: "absolute" },
    maxHeight: { default: 580 },
    locale: null
  },
  emits: ["update:searchList", "update:value", "trigger-search", "on:clear"],
  setup(t, { emit: e }) {
    const n = t, r = vn, a = I(() => o.value ? n.strategy === "absolute" ? "c-input-expanded-absolute" : "c-input-expanded-relative " : ""), i = I(() => {
      const y = [];
      return n.searchList.forEach((_) => {
        if (_.checked)
          if (_.children) {
            const k = _.children.map((P) => n.displayParentOptionInBadge ? { ...P, label: `${_.label} - ${P.label}` } : P);
            y.push(...k);
          } else
            y.push(_);
        !_.checked && _.children && _.children.forEach((k) => {
          k.checked && y.push(n.displayParentOptionInBadge ? { ...k, label: `${_.label} - ${k.label}` } : k);
        });
      }), y;
    }), o = U(!1), s = U(null);
    U(void 0);
    const l = I(() => i.value && i.value.length > 0), c = I(() => i.value && i.value.length > 0), u = (y) => {
      o.value = y;
    }, f = () => {
      o.value = !1;
    }, d = I({
      get() {
        return n.searchList;
      },
      set(y) {
        e("update:searchList", y);
      }
    }), h = () => {
      u(!0), e("trigger-search", n.value);
    }, m = I({
      get() {
        return n.value;
      },
      set(y) {
        e("update:value", y), h();
      }
    }), p = (y, _) => {
      var O;
      let k = !1, P = !1, $ = !1;
      d.value = ((O = d.value) == null ? void 0 : O.map((D) => {
        k = !1, P = !1, $ = !1;
        const N = D.children ? D.children.map((q) => (q.checked && q.value !== y && (P = !0), y && q.value === y || !y ? ($ = !0, _ || (k = !0), {
          label: q.label,
          value: q.value,
          checked: _
        }) : q)) : void 0;
        return {
          label: D.label,
          value: D.value,
          checked: k ? !1 : y && D.value === y || !y ? _ : D.checked,
          inDeterminate: y && N ? P && $ : !1,
          children: N
        };
      })) ?? void 0;
    }, g = () => {
      m.value = "", n.strategy === "absolute" && u(!1), e("on:clear");
    }, v = I(() => i.value && i.value.length > 0 ? "" : n.placeHolder);
    function w(y) {
      if (i.value) {
        const _ = i.value.findIndex((k) => k.value === y.value);
        _ > -1 && i.value.splice(_, 1);
      }
    }
    const C = (y) => {
      w(y), p(y.value, !1);
    }, { CTranslate: x } = rt(n.locale);
    return (y, _) => (b(), M("div", n6, [
      Ve((b(), M("div", r6, [
        R("span", a6, [
          Ve(R("input", {
            ref: "searchInput",
            class: H(["c-input", S(a)]),
            placeholder: S(v),
            "onUpdate:modelValue": _[0] || (_[0] = (k) => je(m) ? m.value = k : null),
            onKeyup: st(ve(h, ["stop"]), ["enter"]),
            onClick: _[1] || (_[1] = (k) => u(!0)),
            tabindex: "-1"
          }, null, 42, i6), [
            [Mr, S(m)]
          ]),
          S(c) ? (b(), M("span", o6, [
            T(t6, {
              "selected-list": S(i),
              "onUpdate:selectedList": _[2] || (_[2] = (k) => je(i) ? i.value = k : null),
              onDeSelectOption: C
            }, null, 8, ["selected-list"])
          ])) : E("", !0),
          R("span", s6, [
            S(l) ? (b(), M("span", {
              key: 0,
              class: "c-link-clear",
              onClick: _[3] || (_[3] = ve((k) => g(), ["stop"]))
            }, j(S(x)("CMultipleSearchSelection.Clear")), 1)) : E("", !0),
            o.value ? E("", !0) : (b(), L(S(fo), {
              key: 1,
              class: "c-icon-m c-interactive",
              onClick: _[4] || (_[4] = ve((k) => u(!0), ["stop"]))
            })),
            o.value ? (b(), L(S(mo), {
              key: 2,
              class: "c-icon-m c-interactive",
              onClick: _[5] || (_[5] = ve((k) => u(!1), ["stop"]))
            })) : E("", !0)
          ])
        ]),
        o.value ? (b(), L(K7, {
          key: 0,
          "is-dropdown-opened": o.value,
          "search-list-options": S(d),
          "onUpdate:searchListOptions": _[6] || (_[6] = (k) => je(d) ? d.value = k : null),
          ref_key: "multiSelectionDropdownEl",
          ref: s,
          "empty-message": t.emptyMessage,
          "display-parent-option-in-badge": t.displayParentOptionInBadge,
          strategy: t.strategy,
          "max-height": t.maxHeight
        }, null, 8, ["is-dropdown-opened", "search-list-options", "empty-message", "display-parent-option-in-badge", "strategy", "max-height"])) : E("", !0)
      ])), [
        [S(r), f]
      ])
    ]));
  }
});
const N$ = /* @__PURE__ */ B(l6, [["__scopeId", "data-v-8100363e"]]), Ih = (t) => (In("data-v-473821ae"), t = t(), Nn(), t), c6 = { class: "c-number-range-wrapper" }, u6 = { class: "grid-item" }, d6 = ["disabled"], f6 = { class: "c-pre-icon" }, h6 = { class: "c-post-icon" }, p6 = /* @__PURE__ */ Ih(() => /* @__PURE__ */ R("span", { class: "grid-item" }, null, -1)), m6 = /* @__PURE__ */ Ih(() => /* @__PURE__ */ R("span", { class: "grid-item" }, null, -1)), g6 = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    capacity: { default: 0 },
    disabled: { type: Boolean, default: !1 },
    availableCapacity: { default: void 0 },
    validationRules: { default: {
      required: !0,
      type: "number"
    } },
    allowNegativeCapacity: { type: Boolean, default: !1 }
  },
  emits: ["update:inputNumber", Rn, "on:enter-key-press"],
  setup(t, { emit: e }) {
    const n = t, r = U(!1), a = U(void 0), i = U(void 0), o = U(void 0), s = U(n.capacity), { validate: l, handleFocus: c } = Tr({ props: n, valueToValidate: s.value }, { emit: e }), u = (y) => {
      isNaN(s.value) || (y ? s.value = Number(s.value) + 1 : s.value = Number(s.value) - 1);
    }, f = (y) => {
      r.value || (r.value = !1, u(y));
    }, d = (y) => {
      e("on:enter-key-press", y);
    }, h = () => {
      a.value && clearTimeout(a.value), o.value && clearInterval(o.value), i.value && clearInterval(i.value);
    }, m = (y) => {
      o.value = setInterval(() => {
        u(y);
      }, 200), i.value = setTimeout(() => {
        clearInterval(o.value), o.value = setInterval(() => {
          u(y);
        }, 100);
      }, 3e3);
    }, p = (y) => {
      r.value = !1, h(), a.value = setTimeout(() => {
        r.value = !0, m(y);
      }, 300);
    }, g = (y) => {
      p(y);
    }, v = (y) => {
      h();
    }, w = U(n.disabled), C = (y) => {
      !n.allowNegativeCapacity && y <= 0 || n.disabled || n.availableCapacity >= y ? w.value = !0 : w.value = !1;
    };
    Yt(s, (y) => {
      l(y), C(y), e("update:inputNumber", y);
    }), Wn(() => {
      C(s.value);
    });
    const x = (y) => {
      /^[A-Za-z]$/.test(y.key) && y.preventDefault();
    };
    return (y, _) => (b(), M("div", c6, [
      R("span", u6, [
        Ve(R("input", {
          "onUpdate:modelValue": _[0] || (_[0] = (k) => s.value = k),
          class: "c-input-number-range",
          disabled: t.disabled,
          onKeyup: _[1] || (_[1] = st(ve((k) => d(s.value), ["stop"]), ["enter"])),
          onKeydown: x
        }, null, 40, d6), [
          [Mr, s.value]
        ]),
        R("span", f6, [
          T(S(Ig), {
            class: H([{ disabled: w.value }, "c-icon-s c-icon-minus"]),
            onClick: _[2] || (_[2] = ve((k) => f(!1), ["stop"])),
            onMousedown: _[3] || (_[3] = (k) => g(!1)),
            onMouseup: _[4] || (_[4] = ve((k) => v(), ["stop"])),
            onMouseleave: ve(h, ["stop"])
          }, null, 8, ["class", "onMouseleave"])
        ]),
        R("span", h6, [
          T(S(Jf), {
            class: H(["c-icon-s c-icon-plus", { disabled: t.disabled }]),
            onClick: _[5] || (_[5] = ve((k) => f(!0), ["stop"])),
            onMousedown: _[6] || (_[6] = (k) => g(!0)),
            onMouseup: _[7] || (_[7] = ve((k) => v(), ["stop"])),
            onMouseleave: ve(h, ["stop"])
          }, null, 8, ["class", "onMouseleave"])
        ])
      ]),
      p6,
      m6
    ]));
  }
});
const v6 = /* @__PURE__ */ B(g6, [["__scopeId", "data-v-473821ae"]]), y6 = { class: "c-number-input-wrapper" }, b6 = { class: "c-number-wrapper" }, _6 = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    capacity: null,
    totalCapacity: null,
    disabled: { type: Boolean, default: !1 },
    errorMessage: { default: "" },
    allowNegativeCapacity: { type: Boolean, default: !1 }
  },
  emits: ["update:totalCapacity", "on-validation-fail", "on:click-disabled-icon"],
  setup(t, { emit: e }) {
    const n = t, r = vn, a = U(!1), i = U(n.totalCapacity), o = U(!1), s = U(void 0), l = U(void 0), c = U(), u = U(""), f = () => {
      if (i.value && n.capacity && i.value < n.capacity) {
        o.value = !0, e("on-validation-fail");
        return;
      }
      o.value || (o.value = !1, u.value = "c-number-input-range-fadeout", l.value && clearTimeout(l.value), l.value = setTimeout(function() {
        a.value = !1, u.value = "";
      }, 250), m.value = i.value);
    }, d = () => {
      f();
    }, h = () => {
      n.disabled ? e("on:click-disabled-icon") : a.value = !0;
    }, m = I({
      get() {
        return n.totalCapacity;
      },
      set(C) {
        e("update:totalCapacity", C);
      }
    }), p = (C) => {
      i.value = C;
    }, g = (C) => {
      var x;
      if ((x = C.errors) != null && x.includes("isNotANumber")) {
        o.value = !0, e("on-validation-fail");
        return;
      }
      o.value = !1;
    }, v = () => {
      s.value && clearTimeout(s.value);
    }, w = () => {
      v(), s.value = setTimeout(f, 3e3);
    };
    return Wn(() => {
      c.value && (c.value.onmousemove = w, c.value.onkeydown = w);
    }), (C, x) => (b(), M("div", null, [
      R("div", y6, [
        T(S(ev), {
          class: "c-icon-s total-pax-icon",
          size: "20"
        }),
        R("span", b6, [
          t.capacity !== void 0 ? (b(), L(S(we), {
            key: 0,
            type: "three"
          }, {
            default: W(() => [
              V(j(t.capacity) + "/", 1)
            ]),
            _: 1
          })) : E("", !0),
          a.value ? E("", !0) : (b(), L(S(we), {
            key: 1,
            type: "three"
          }, {
            default: W(() => [
              V(j(S(m)), 1)
            ]),
            _: 1
          }))
        ]),
        a.value ? E("", !0) : (b(), L(S(wg), {
          key: 0,
          class: H(["c-icon-edit", { disabled: t.disabled }]),
          size: "20",
          onClick: h
        }, null, 8, ["class"])),
        R("div", {
          ref_key: "numberInputEl",
          ref: c
        }, [
          a.value ? Ve((b(), L(S(v6), {
            key: 0,
            class: H(u.value),
            capacity: S(m),
            "onUpdate:capacity": x[0] || (x[0] = (y) => je(m) ? m.value = y : null),
            "onUpdate:inputNumber": p,
            "onOn:enterKeyPress": d,
            disabled: t.disabled,
            "available-capacity": t.capacity,
            onValidationUpdate: g,
            onMousedown: v
          }, null, 8, ["class", "capacity", "disabled", "available-capacity"])), [
            [S(r), f]
          ]) : E("", !0)
        ], 512)
      ]),
      o.value ? (b(), L(S(we), {
        key: 0,
        type: "five",
        class: "c-error-mesaage"
      }, {
        default: W(() => [
          V(j(t.errorMessage), 1)
        ]),
        _: 1
      })) : E("", !0)
    ]));
  }
});
const W$ = /* @__PURE__ */ B(_6, [["__scopeId", "data-v-6e10cc57"]]);
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function Hr(t) {
  return t + 0.5 | 0;
}
const Ft = (t, e, n) => Math.max(Math.min(t, n), e);
function Qn(t) {
  return Ft(Hr(t * 2.55), 0, 255);
}
function qt(t) {
  return Ft(Hr(t * 255), 0, 255);
}
function Mt(t) {
  return Ft(Hr(t / 2.55) / 100, 0, 1);
}
function td(t) {
  return Ft(Hr(t * 100), 0, 100);
}
const it = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, ul = [..."0123456789ABCDEF"], w6 = (t) => ul[t & 15], k6 = (t) => ul[(t & 240) >> 4] + ul[t & 15], Jr = (t) => (t & 240) >> 4 === (t & 15), x6 = (t) => Jr(t.r) && Jr(t.g) && Jr(t.b) && Jr(t.a);
function C6(t) {
  var e = t.length, n;
  return t[0] === "#" && (e === 4 || e === 5 ? n = {
    r: 255 & it[t[1]] * 17,
    g: 255 & it[t[2]] * 17,
    b: 255 & it[t[3]] * 17,
    a: e === 5 ? it[t[4]] * 17 : 255
  } : (e === 7 || e === 9) && (n = {
    r: it[t[1]] << 4 | it[t[2]],
    g: it[t[3]] << 4 | it[t[4]],
    b: it[t[5]] << 4 | it[t[6]],
    a: e === 9 ? it[t[7]] << 4 | it[t[8]] : 255
  })), n;
}
const P6 = (t, e) => t < 255 ? e(t) : "";
function S6(t) {
  var e = x6(t) ? w6 : k6;
  return t ? "#" + e(t.r) + e(t.g) + e(t.b) + P6(t.a, e) : void 0;
}
const M6 = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function Nh(t, e, n) {
  const r = e * Math.min(n, 1 - n), a = (i, o = (i + t / 30) % 12) => n - r * Math.max(Math.min(o - 3, 9 - o, 1), -1);
  return [a(0), a(8), a(4)];
}
function O6(t, e, n) {
  const r = (a, i = (a + t / 60) % 6) => n - n * e * Math.max(Math.min(i, 4 - i, 1), 0);
  return [r(5), r(3), r(1)];
}
function D6(t, e, n) {
  const r = Nh(t, 1, 0.5);
  let a;
  for (e + n > 1 && (a = 1 / (e + n), e *= a, n *= a), a = 0; a < 3; a++)
    r[a] *= 1 - e - n, r[a] += e;
  return r;
}
function T6(t, e, n, r, a) {
  return t === a ? (e - n) / r + (e < n ? 6 : 0) : e === a ? (n - t) / r + 2 : (t - e) / r + 4;
}
function Ql(t) {
  const n = t.r / 255, r = t.g / 255, a = t.b / 255, i = Math.max(n, r, a), o = Math.min(n, r, a), s = (i + o) / 2;
  let l, c, u;
  return i !== o && (u = i - o, c = s > 0.5 ? u / (2 - i - o) : u / (i + o), l = T6(n, r, a, u, i), l = l * 60 + 0.5), [l | 0, c || 0, s];
}
function Gl(t, e, n, r) {
  return (Array.isArray(e) ? t(e[0], e[1], e[2]) : t(e, n, r)).map(qt);
}
function Zl(t, e, n) {
  return Gl(Nh, t, e, n);
}
function $6(t, e, n) {
  return Gl(D6, t, e, n);
}
function R6(t, e, n) {
  return Gl(O6, t, e, n);
}
function Wh(t) {
  return (t % 360 + 360) % 360;
}
function E6(t) {
  const e = M6.exec(t);
  let n = 255, r;
  if (!e)
    return;
  e[5] !== r && (n = e[6] ? Qn(+e[5]) : qt(+e[5]));
  const a = Wh(+e[2]), i = +e[3] / 100, o = +e[4] / 100;
  return e[1] === "hwb" ? r = $6(a, i, o) : e[1] === "hsv" ? r = R6(a, i, o) : r = Zl(a, i, o), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: n
  };
}
function A6(t, e) {
  var n = Ql(t);
  n[0] = Wh(n[0] + e), n = Zl(n), t.r = n[0], t.g = n[1], t.b = n[2];
}
function L6(t) {
  if (!t)
    return;
  const e = Ql(t), n = e[0], r = td(e[1]), a = td(e[2]);
  return t.a < 255 ? `hsla(${n}, ${r}%, ${a}%, ${Mt(t.a)})` : `hsl(${n}, ${r}%, ${a}%)`;
}
const nd = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, rd = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function I6() {
  const t = {}, e = Object.keys(rd), n = Object.keys(nd);
  let r, a, i, o, s;
  for (r = 0; r < e.length; r++) {
    for (o = s = e[r], a = 0; a < n.length; a++)
      i = n[a], s = s.replace(i, nd[i]);
    i = parseInt(rd[o], 16), t[s] = [i >> 16 & 255, i >> 8 & 255, i & 255];
  }
  return t;
}
let ea;
function N6(t) {
  ea || (ea = I6(), ea.transparent = [0, 0, 0, 0]);
  const e = ea[t.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const W6 = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function z6(t) {
  const e = W6.exec(t);
  let n = 255, r, a, i;
  if (e) {
    if (e[7] !== r) {
      const o = +e[7];
      n = e[8] ? Qn(o) : Ft(o * 255, 0, 255);
    }
    return r = +e[1], a = +e[3], i = +e[5], r = 255 & (e[2] ? Qn(r) : Ft(r, 0, 255)), a = 255 & (e[4] ? Qn(a) : Ft(a, 0, 255)), i = 255 & (e[6] ? Qn(i) : Ft(i, 0, 255)), {
      r,
      g: a,
      b: i,
      a: n
    };
  }
}
function B6(t) {
  return t && (t.a < 255 ? `rgba(${t.r}, ${t.g}, ${t.b}, ${Mt(t.a)})` : `rgb(${t.r}, ${t.g}, ${t.b})`);
}
const Ro = (t) => t <= 31308e-7 ? t * 12.92 : Math.pow(t, 1 / 2.4) * 1.055 - 0.055, kn = (t) => t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
function F6(t, e, n) {
  const r = kn(Mt(t.r)), a = kn(Mt(t.g)), i = kn(Mt(t.b));
  return {
    r: qt(Ro(r + n * (kn(Mt(e.r)) - r))),
    g: qt(Ro(a + n * (kn(Mt(e.g)) - a))),
    b: qt(Ro(i + n * (kn(Mt(e.b)) - i))),
    a: t.a + n * (e.a - t.a)
  };
}
function ta(t, e, n) {
  if (t) {
    let r = Ql(t);
    r[e] = Math.max(0, Math.min(r[e] + r[e] * n, e === 0 ? 360 : 1)), r = Zl(r), t.r = r[0], t.g = r[1], t.b = r[2];
  }
}
function zh(t, e) {
  return t && Object.assign(e || {}, t);
}
function ad(t) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(t) ? t.length >= 3 && (e = { r: t[0], g: t[1], b: t[2], a: 255 }, t.length > 3 && (e.a = qt(t[3]))) : (e = zh(t, { r: 0, g: 0, b: 0, a: 1 }), e.a = qt(e.a)), e;
}
function H6(t) {
  return t.charAt(0) === "r" ? z6(t) : E6(t);
}
class vr {
  constructor(e) {
    if (e instanceof vr)
      return e;
    const n = typeof e;
    let r;
    n === "object" ? r = ad(e) : n === "string" && (r = C6(e) || N6(e) || H6(e)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = zh(this._rgb);
    return e && (e.a = Mt(e.a)), e;
  }
  set rgb(e) {
    this._rgb = ad(e);
  }
  rgbString() {
    return this._valid ? B6(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? S6(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? L6(this._rgb) : void 0;
  }
  mix(e, n) {
    if (e) {
      const r = this.rgb, a = e.rgb;
      let i;
      const o = n === i ? 0.5 : n, s = 2 * o - 1, l = r.a - a.a, c = ((s * l === -1 ? s : (s + l) / (1 + s * l)) + 1) / 2;
      i = 1 - c, r.r = 255 & c * r.r + i * a.r + 0.5, r.g = 255 & c * r.g + i * a.g + 0.5, r.b = 255 & c * r.b + i * a.b + 0.5, r.a = o * r.a + (1 - o) * a.a, this.rgb = r;
    }
    return this;
  }
  interpolate(e, n) {
    return e && (this._rgb = F6(this._rgb, e._rgb, n)), this;
  }
  clone() {
    return new vr(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = qt(e), this;
  }
  clearer(e) {
    const n = this._rgb;
    return n.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, n = Hr(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = n, this;
  }
  opaquer(e) {
    const n = this._rgb;
    return n.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return ta(this._rgb, 2, e), this;
  }
  darken(e) {
    return ta(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return ta(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return ta(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return A6(this._rgb, e), this;
  }
}
/*!
 * Chart.js v4.4.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function xt() {
}
const j6 = (() => {
  let t = 0;
  return () => t++;
})();
function se(t) {
  return t === null || typeof t > "u";
}
function ye(t) {
  if (Array.isArray && Array.isArray(t))
    return !0;
  const e = Object.prototype.toString.call(t);
  return e.slice(0, 7) === "[object" && e.slice(-6) === "Array]";
}
function ae(t) {
  return t !== null && Object.prototype.toString.call(t) === "[object Object]";
}
function Pe(t) {
  return (typeof t == "number" || t instanceof Number) && isFinite(+t);
}
function Ge(t, e) {
  return Pe(t) ? t : e;
}
function ee(t, e) {
  return typeof t > "u" ? e : t;
}
const V6 = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 : +t / e, Bh = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 * e : +t;
function ge(t, e, n) {
  if (t && typeof t.call == "function")
    return t.apply(n, e);
}
function he(t, e, n, r) {
  let a, i, o;
  if (ye(t))
    if (i = t.length, r)
      for (a = i - 1; a >= 0; a--)
        e.call(n, t[a], a);
    else
      for (a = 0; a < i; a++)
        e.call(n, t[a], a);
  else if (ae(t))
    for (o = Object.keys(t), i = o.length, a = 0; a < i; a++)
      e.call(n, t[o[a]], o[a]);
}
function Gi(t, e) {
  let n, r, a, i;
  if (!t || !e || t.length !== e.length)
    return !1;
  for (n = 0, r = t.length; n < r; ++n)
    if (a = t[n], i = e[n], a.datasetIndex !== i.datasetIndex || a.index !== i.index)
      return !1;
  return !0;
}
function Zi(t) {
  if (ye(t))
    return t.map(Zi);
  if (ae(t)) {
    const e = /* @__PURE__ */ Object.create(null), n = Object.keys(t), r = n.length;
    let a = 0;
    for (; a < r; ++a)
      e[n[a]] = Zi(t[n[a]]);
    return e;
  }
  return t;
}
function Fh(t) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(t) === -1;
}
function q6(t, e, n, r) {
  if (!Fh(t))
    return;
  const a = e[t], i = n[t];
  ae(a) && ae(i) ? yr(a, i, r) : e[t] = Zi(i);
}
function yr(t, e, n) {
  const r = ye(e) ? e : [
    e
  ], a = r.length;
  if (!ae(t))
    return t;
  n = n || {};
  const i = n.merger || q6;
  let o;
  for (let s = 0; s < a; ++s) {
    if (o = r[s], !ae(o))
      continue;
    const l = Object.keys(o);
    for (let c = 0, u = l.length; c < u; ++c)
      i(l[c], t, o, n);
  }
  return t;
}
function ir(t, e) {
  return yr(t, e, {
    merger: U6
  });
}
function U6(t, e, n) {
  if (!Fh(t))
    return;
  const r = e[t], a = n[t];
  ae(r) && ae(a) ? ir(r, a) : Object.prototype.hasOwnProperty.call(e, t) || (e[t] = Zi(a));
}
const id = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (t) => t,
  // default resolvers
  x: (t) => t.x,
  y: (t) => t.y
};
function Y6(t) {
  const e = t.split("."), n = [];
  let r = "";
  for (const a of e)
    r += a, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
  return n;
}
function X6(t) {
  const e = Y6(t);
  return (n) => {
    for (const r of e) {
      if (r === "")
        break;
      n = n && n[r];
    }
    return n;
  };
}
function Kt(t, e) {
  return (id[e] || (id[e] = X6(e)))(t);
}
function Jl(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
const br = (t) => typeof t < "u", Qt = (t) => typeof t == "function", od = (t, e) => {
  if (t.size !== e.size)
    return !1;
  for (const n of t)
    if (!e.has(n))
      return !1;
  return !0;
};
function K6(t) {
  return t.type === "mouseup" || t.type === "click" || t.type === "contextmenu";
}
const ke = Math.PI, be = 2 * ke, Q6 = be + ke, Ji = Number.POSITIVE_INFINITY, G6 = ke / 180, Te = ke / 2, tn = ke / 4, sd = ke * 2 / 3, Ht = Math.log10, bt = Math.sign;
function or(t, e, n) {
  return Math.abs(t - e) < n;
}
function ld(t) {
  const e = Math.round(t);
  t = or(t, e, t / 1e3) ? e : t;
  const n = Math.pow(10, Math.floor(Ht(t))), r = t / n;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
}
function Z6(t) {
  const e = [], n = Math.sqrt(t);
  let r;
  for (r = 1; r < n; r++)
    t % r === 0 && (e.push(r), e.push(t / r));
  return n === (n | 0) && e.push(n), e.sort((a, i) => a - i).pop(), e;
}
function En(t) {
  return !isNaN(parseFloat(t)) && isFinite(t);
}
function J6(t, e) {
  const n = Math.round(t);
  return n - e <= t && n + e >= t;
}
function Hh(t, e, n) {
  let r, a, i;
  for (r = 0, a = t.length; r < a; r++)
    i = t[r][n], isNaN(i) || (e.min = Math.min(e.min, i), e.max = Math.max(e.max, i));
}
function lt(t) {
  return t * (ke / 180);
}
function ec(t) {
  return t * (180 / ke);
}
function cd(t) {
  if (!Pe(t))
    return;
  let e = 1, n = 0;
  for (; Math.round(t * e) / e !== t; )
    e *= 10, n++;
  return n;
}
function jh(t, e) {
  const n = e.x - t.x, r = e.y - t.y, a = Math.sqrt(n * n + r * r);
  let i = Math.atan2(r, n);
  return i < -0.5 * ke && (i += be), {
    angle: i,
    distance: a
  };
}
function dl(t, e) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function eP(t, e) {
  return (t - e + Q6) % be - ke;
}
function Ze(t) {
  return (t % be + be) % be;
}
function _r(t, e, n, r) {
  const a = Ze(t), i = Ze(e), o = Ze(n), s = Ze(i - a), l = Ze(o - a), c = Ze(a - i), u = Ze(a - o);
  return a === i || a === o || r && i === o || s > l && c < u;
}
function Ae(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function tP(t) {
  return Ae(t, -32768, 32767);
}
function Tt(t, e, n, r = 1e-6) {
  return t >= Math.min(e, n) - r && t <= Math.max(e, n) + r;
}
function tc(t, e, n) {
  n = n || ((o) => t[o] < e);
  let r = t.length - 1, a = 0, i;
  for (; r - a > 1; )
    i = a + r >> 1, n(i) ? a = i : r = i;
  return {
    lo: a,
    hi: r
  };
}
const $t = (t, e, n, r) => tc(t, n, r ? (a) => {
  const i = t[a][e];
  return i < n || i === n && t[a + 1][e] === n;
} : (a) => t[a][e] < n), nP = (t, e, n) => tc(t, n, (r) => t[r][e] >= n);
function rP(t, e, n) {
  let r = 0, a = t.length;
  for (; r < a && t[r] < e; )
    r++;
  for (; a > r && t[a - 1] > n; )
    a--;
  return r > 0 || a < t.length ? t.slice(r, a) : t;
}
const Vh = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function aP(t, e) {
  if (t._chartjs) {
    t._chartjs.listeners.push(e);
    return;
  }
  Object.defineProperty(t, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        e
      ]
    }
  }), Vh.forEach((n) => {
    const r = "_onData" + Jl(n), a = t[n];
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const o = a.apply(this, i);
        return t._chartjs.listeners.forEach((s) => {
          typeof s[r] == "function" && s[r](...i);
        }), o;
      }
    });
  });
}
function ud(t, e) {
  const n = t._chartjs;
  if (!n)
    return;
  const r = n.listeners, a = r.indexOf(e);
  a !== -1 && r.splice(a, 1), !(r.length > 0) && (Vh.forEach((i) => {
    delete t[i];
  }), delete t._chartjs);
}
function qh(t) {
  const e = new Set(t);
  return e.size === t.length ? t : Array.from(e);
}
const Uh = function() {
  return typeof window > "u" ? function(t) {
    return t();
  } : window.requestAnimationFrame;
}();
function Yh(t, e) {
  let n = [], r = !1;
  return function(...a) {
    n = a, r || (r = !0, Uh.call(window, () => {
      r = !1, t.apply(e, n);
    }));
  };
}
function iP(t, e) {
  let n;
  return function(...r) {
    return e ? (clearTimeout(n), n = setTimeout(t, e, r)) : t.apply(this, r), e;
  };
}
const nc = (t) => t === "start" ? "left" : t === "end" ? "right" : "center", We = (t, e, n) => t === "start" ? e : t === "end" ? n : (e + n) / 2, oP = (t, e, n, r) => t === (r ? "left" : "right") ? n : t === "center" ? (e + n) / 2 : e;
function Xh(t, e, n) {
  const r = e.length;
  let a = 0, i = r;
  if (t._sorted) {
    const { iScale: o, _parsed: s } = t, l = o.axis, { min: c, max: u, minDefined: f, maxDefined: d } = o.getUserBounds();
    f && (a = Ae(Math.min(
      // @ts-expect-error Need to type _parsed
      $t(s, l, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? r : $t(e, l, o.getPixelForValue(c)).lo
    ), 0, r - 1)), d ? i = Ae(Math.max(
      // @ts-expect-error Need to type _parsed
      $t(s, o.axis, u, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? 0 : $t(e, l, o.getPixelForValue(u), !0).hi + 1
    ), a, r) - a : i = r - a;
  }
  return {
    start: a,
    count: i
  };
}
function Kh(t) {
  const { xScale: e, yScale: n, _scaleRanges: r } = t, a = {
    xmin: e.min,
    xmax: e.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!r)
    return t._scaleRanges = a, !0;
  const i = r.xmin !== e.min || r.xmax !== e.max || r.ymin !== n.min || r.ymax !== n.max;
  return Object.assign(r, a), i;
}
const na = (t) => t === 0 || t === 1, dd = (t, e, n) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * be / n)), fd = (t, e, n) => Math.pow(2, -10 * t) * Math.sin((t - e) * be / n) + 1, sr = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * Te) + 1,
  easeOutSine: (t) => Math.sin(t * Te),
  easeInOutSine: (t) => -0.5 * (Math.cos(ke * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => na(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => na(t) ? t : dd(t, 0.075, 0.3),
  easeOutElastic: (t) => na(t) ? t : fd(t, 0.075, 0.3),
  easeInOutElastic(t) {
    return na(t) ? t : t < 0.5 ? 0.5 * dd(t * 2, 0.1125, 0.45) : 0.5 + 0.5 * fd(t * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(t) {
    return t * t * ((1.70158 + 1) * t - 1.70158);
  },
  easeOutBack(t) {
    return (t -= 1) * t * ((1.70158 + 1) * t + 1.70158) + 1;
  },
  easeInOutBack(t) {
    let e = 1.70158;
    return (t /= 0.5) < 1 ? 0.5 * (t * t * (((e *= 1.525) + 1) * t - e)) : 0.5 * ((t -= 2) * t * (((e *= 1.525) + 1) * t + e) + 2);
  },
  easeInBounce: (t) => 1 - sr.easeOutBounce(1 - t),
  easeOutBounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? sr.easeInBounce(t * 2) * 0.5 : sr.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function rc(t) {
  if (t && typeof t == "object") {
    const e = t.toString();
    return e === "[object CanvasPattern]" || e === "[object CanvasGradient]";
  }
  return !1;
}
function hd(t) {
  return rc(t) ? t : new vr(t);
}
function Eo(t) {
  return rc(t) ? t : new vr(t).saturate(0.5).darken(0.1).hexString();
}
const sP = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], lP = [
  "color",
  "borderColor",
  "backgroundColor"
];
function cP(t) {
  t.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), t.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
  }), t.set("animations", {
    colors: {
      type: "color",
      properties: lP
    },
    numbers: {
      type: "number",
      properties: sP
    }
  }), t.describe("animations", {
    _fallback: "animation"
  }), t.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (e) => e | 0
        }
      }
    }
  });
}
function uP(t) {
  t.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const pd = /* @__PURE__ */ new Map();
function dP(t, e) {
  e = e || {};
  const n = t + JSON.stringify(e);
  let r = pd.get(n);
  return r || (r = new Intl.NumberFormat(t, e), pd.set(n, r)), r;
}
function jr(t, e, n) {
  return dP(e, n).format(t);
}
const Qh = {
  values(t) {
    return ye(t) ? t : "" + t;
  },
  numeric(t, e, n) {
    if (t === 0)
      return "0";
    const r = this.chart.options.locale;
    let a, i = t;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (a = "scientific"), i = fP(t, n);
    }
    const o = Ht(Math.abs(i)), s = isNaN(o) ? 1 : Math.max(Math.min(-1 * Math.floor(o), 20), 0), l = {
      notation: a,
      minimumFractionDigits: s,
      maximumFractionDigits: s
    };
    return Object.assign(l, this.options.ticks.format), jr(t, r, l);
  },
  logarithmic(t, e, n) {
    if (t === 0)
      return "0";
    const r = n[e].significand || t / Math.pow(10, Math.floor(Ht(t)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(r) || e > 0.8 * n.length ? Qh.numeric.call(this, t, e, n) : "";
  }
};
function fP(t, e) {
  let n = e.length > 3 ? e[2].value - e[1].value : e[1].value - e[0].value;
  return Math.abs(n) >= 1 && t !== Math.floor(t) && (n = t - Math.floor(t)), n;
}
var _o = {
  formatters: Qh
};
function hP(t) {
  t.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (e, n) => n.lineWidth,
      tickColor: (e, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: _o.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), t.route("scale.ticks", "color", "", "color"), t.route("scale.grid", "color", "", "borderColor"), t.route("scale.border", "color", "", "borderColor"), t.route("scale.title", "color", "", "color"), t.describe("scale", {
    _fallback: !1,
    _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
    _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash" && e !== "dash"
  }), t.describe("scales", {
    _fallback: "scale"
  }), t.describe("scale.ticks", {
    _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
    _indexable: (e) => e !== "backdropPadding"
  });
}
const mn = /* @__PURE__ */ Object.create(null), fl = /* @__PURE__ */ Object.create(null);
function lr(t, e) {
  if (!e)
    return t;
  const n = e.split(".");
  for (let r = 0, a = n.length; r < a; ++r) {
    const i = n[r];
    t = t[i] || (t[i] = /* @__PURE__ */ Object.create(null));
  }
  return t;
}
function Ao(t, e, n) {
  return typeof e == "string" ? yr(lr(t, e), n) : yr(lr(t, ""), e);
}
class pP {
  constructor(e, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (r) => r.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (r, a) => Eo(a.backgroundColor), this.hoverBorderColor = (r, a) => Eo(a.borderColor), this.hoverColor = (r, a) => Eo(a.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(e), this.apply(n);
  }
  set(e, n) {
    return Ao(this, e, n);
  }
  get(e) {
    return lr(this, e);
  }
  describe(e, n) {
    return Ao(fl, e, n);
  }
  override(e, n) {
    return Ao(mn, e, n);
  }
  route(e, n, r, a) {
    const i = lr(this, e), o = lr(this, r), s = "_" + n;
    Object.defineProperties(i, {
      [s]: {
        value: i[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[s], c = o[a];
          return ae(l) ? Object.assign({}, c, l) : ee(l, c);
        },
        set(l) {
          this[s] = l;
        }
      }
    });
  }
  apply(e) {
    e.forEach((n) => n(this));
  }
}
var Se = /* @__PURE__ */ new pP({
  _scriptable: (t) => !t.startsWith("on"),
  _indexable: (t) => t !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  cP,
  uP,
  hP
]);
function mP(t) {
  return !t || se(t.size) || se(t.family) ? null : (t.style ? t.style + " " : "") + (t.weight ? t.weight + " " : "") + t.size + "px " + t.family;
}
function eo(t, e, n, r, a) {
  let i = e[a];
  return i || (i = e[a] = t.measureText(a).width, n.push(a)), i > r && (r = i), r;
}
function gP(t, e, n, r) {
  r = r || {};
  let a = r.data = r.data || {}, i = r.garbageCollect = r.garbageCollect || [];
  r.font !== e && (a = r.data = {}, i = r.garbageCollect = [], r.font = e), t.save(), t.font = e;
  let o = 0;
  const s = n.length;
  let l, c, u, f, d;
  for (l = 0; l < s; l++)
    if (f = n[l], f != null && !ye(f))
      o = eo(t, a, i, o, f);
    else if (ye(f))
      for (c = 0, u = f.length; c < u; c++)
        d = f[c], d != null && !ye(d) && (o = eo(t, a, i, o, d));
  t.restore();
  const h = i.length / 2;
  if (h > n.length) {
    for (l = 0; l < h; l++)
      delete a[i[l]];
    i.splice(0, h);
  }
  return o;
}
function nn(t, e, n) {
  const r = t.currentDevicePixelRatio, a = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((e - a) * r) / r + a;
}
function md(t, e) {
  e = e || t.getContext("2d"), e.save(), e.resetTransform(), e.clearRect(0, 0, t.width, t.height), e.restore();
}
function hl(t, e, n, r) {
  Gh(t, e, n, r, null);
}
function Gh(t, e, n, r, a) {
  let i, o, s, l, c, u, f, d;
  const h = e.pointStyle, m = e.rotation, p = e.radius;
  let g = (m || 0) * G6;
  if (h && typeof h == "object" && (i = h.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    t.save(), t.translate(n, r), t.rotate(g), t.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), t.restore();
    return;
  }
  if (!(isNaN(p) || p <= 0)) {
    switch (t.beginPath(), h) {
      default:
        a ? t.ellipse(n, r, a / 2, p, 0, 0, be) : t.arc(n, r, p, 0, be), t.closePath();
        break;
      case "triangle":
        u = a ? a / 2 : p, t.moveTo(n + Math.sin(g) * u, r - Math.cos(g) * p), g += sd, t.lineTo(n + Math.sin(g) * u, r - Math.cos(g) * p), g += sd, t.lineTo(n + Math.sin(g) * u, r - Math.cos(g) * p), t.closePath();
        break;
      case "rectRounded":
        c = p * 0.516, l = p - c, o = Math.cos(g + tn) * l, f = Math.cos(g + tn) * (a ? a / 2 - c : l), s = Math.sin(g + tn) * l, d = Math.sin(g + tn) * (a ? a / 2 - c : l), t.arc(n - f, r - s, c, g - ke, g - Te), t.arc(n + d, r - o, c, g - Te, g), t.arc(n + f, r + s, c, g, g + Te), t.arc(n - d, r + o, c, g + Te, g + ke), t.closePath();
        break;
      case "rect":
        if (!m) {
          l = Math.SQRT1_2 * p, u = a ? a / 2 : l, t.rect(n - u, r - l, 2 * u, 2 * l);
          break;
        }
        g += tn;
      case "rectRot":
        f = Math.cos(g) * (a ? a / 2 : p), o = Math.cos(g) * p, s = Math.sin(g) * p, d = Math.sin(g) * (a ? a / 2 : p), t.moveTo(n - f, r - s), t.lineTo(n + d, r - o), t.lineTo(n + f, r + s), t.lineTo(n - d, r + o), t.closePath();
        break;
      case "crossRot":
        g += tn;
      case "cross":
        f = Math.cos(g) * (a ? a / 2 : p), o = Math.cos(g) * p, s = Math.sin(g) * p, d = Math.sin(g) * (a ? a / 2 : p), t.moveTo(n - f, r - s), t.lineTo(n + f, r + s), t.moveTo(n + d, r - o), t.lineTo(n - d, r + o);
        break;
      case "star":
        f = Math.cos(g) * (a ? a / 2 : p), o = Math.cos(g) * p, s = Math.sin(g) * p, d = Math.sin(g) * (a ? a / 2 : p), t.moveTo(n - f, r - s), t.lineTo(n + f, r + s), t.moveTo(n + d, r - o), t.lineTo(n - d, r + o), g += tn, f = Math.cos(g) * (a ? a / 2 : p), o = Math.cos(g) * p, s = Math.sin(g) * p, d = Math.sin(g) * (a ? a / 2 : p), t.moveTo(n - f, r - s), t.lineTo(n + f, r + s), t.moveTo(n + d, r - o), t.lineTo(n - d, r + o);
        break;
      case "line":
        o = a ? a / 2 : Math.cos(g) * p, s = Math.sin(g) * p, t.moveTo(n - o, r - s), t.lineTo(n + o, r + s);
        break;
      case "dash":
        t.moveTo(n, r), t.lineTo(n + Math.cos(g) * (a ? a / 2 : p), r + Math.sin(g) * p);
        break;
      case !1:
        t.closePath();
        break;
    }
    t.fill(), e.borderWidth > 0 && t.stroke();
  }
}
function Rt(t, e, n) {
  return n = n || 0.5, !e || t && t.x > e.left - n && t.x < e.right + n && t.y > e.top - n && t.y < e.bottom + n;
}
function wo(t, e) {
  t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip();
}
function ko(t) {
  t.restore();
}
function vP(t, e, n, r, a) {
  if (!e)
    return t.lineTo(n.x, n.y);
  if (a === "middle") {
    const i = (e.x + n.x) / 2;
    t.lineTo(i, e.y), t.lineTo(i, n.y);
  } else
    a === "after" != !!r ? t.lineTo(e.x, n.y) : t.lineTo(n.x, e.y);
  t.lineTo(n.x, n.y);
}
function yP(t, e, n, r) {
  if (!e)
    return t.lineTo(n.x, n.y);
  t.bezierCurveTo(r ? e.cp1x : e.cp2x, r ? e.cp1y : e.cp2y, r ? n.cp2x : n.cp1x, r ? n.cp2y : n.cp1y, n.x, n.y);
}
function bP(t, e) {
  e.translation && t.translate(e.translation[0], e.translation[1]), se(e.rotation) || t.rotate(e.rotation), e.color && (t.fillStyle = e.color), e.textAlign && (t.textAlign = e.textAlign), e.textBaseline && (t.textBaseline = e.textBaseline);
}
function _P(t, e, n, r, a) {
  if (a.strikethrough || a.underline) {
    const i = t.measureText(r), o = e - i.actualBoundingBoxLeft, s = e + i.actualBoundingBoxRight, l = n - i.actualBoundingBoxAscent, c = n + i.actualBoundingBoxDescent, u = a.strikethrough ? (l + c) / 2 : c;
    t.strokeStyle = t.fillStyle, t.beginPath(), t.lineWidth = a.decorationWidth || 2, t.moveTo(o, u), t.lineTo(s, u), t.stroke();
  }
}
function wP(t, e) {
  const n = t.fillStyle;
  t.fillStyle = e.color, t.fillRect(e.left, e.top, e.width, e.height), t.fillStyle = n;
}
function gn(t, e, n, r, a, i = {}) {
  const o = ye(e) ? e : [
    e
  ], s = i.strokeWidth > 0 && i.strokeColor !== "";
  let l, c;
  for (t.save(), t.font = a.string, bP(t, i), l = 0; l < o.length; ++l)
    c = o[l], i.backdrop && wP(t, i.backdrop), s && (i.strokeColor && (t.strokeStyle = i.strokeColor), se(i.strokeWidth) || (t.lineWidth = i.strokeWidth), t.strokeText(c, n, r, i.maxWidth)), t.fillText(c, n, r, i.maxWidth), _P(t, n, r, c, i), r += Number(a.lineHeight);
  t.restore();
}
function wr(t, e) {
  const { x: n, y: r, w: a, h: i, radius: o } = e;
  t.arc(n + o.topLeft, r + o.topLeft, o.topLeft, 1.5 * ke, ke, !0), t.lineTo(n, r + i - o.bottomLeft), t.arc(n + o.bottomLeft, r + i - o.bottomLeft, o.bottomLeft, ke, Te, !0), t.lineTo(n + a - o.bottomRight, r + i), t.arc(n + a - o.bottomRight, r + i - o.bottomRight, o.bottomRight, Te, 0, !0), t.lineTo(n + a, r + o.topRight), t.arc(n + a - o.topRight, r + o.topRight, o.topRight, 0, -Te, !0), t.lineTo(n + o.topLeft, r);
}
const kP = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, xP = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function CP(t, e) {
  const n = ("" + t).match(kP);
  if (!n || n[1] === "normal")
    return e * 1.2;
  switch (t = +n[2], n[3]) {
    case "px":
      return t;
    case "%":
      t /= 100;
      break;
  }
  return e * t;
}
const PP = (t) => +t || 0;
function ac(t, e) {
  const n = {}, r = ae(e), a = r ? Object.keys(e) : e, i = ae(t) ? r ? (o) => ee(t[o], t[e[o]]) : (o) => t[o] : () => t;
  for (const o of a)
    n[o] = PP(i(o));
  return n;
}
function Zh(t) {
  return ac(t, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function fn(t) {
  return ac(t, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function Fe(t) {
  const e = Zh(t);
  return e.width = e.left + e.right, e.height = e.top + e.bottom, e;
}
function $e(t, e) {
  t = t || {}, e = e || Se.font;
  let n = ee(t.size, e.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let r = ee(t.style, e.style);
  r && !("" + r).match(xP) && (console.warn('Invalid font style specified: "' + r + '"'), r = void 0);
  const a = {
    family: ee(t.family, e.family),
    lineHeight: CP(ee(t.lineHeight, e.lineHeight), n),
    size: n,
    style: r,
    weight: ee(t.weight, e.weight),
    string: ""
  };
  return a.string = mP(a), a;
}
function Gn(t, e, n, r) {
  let a = !0, i, o, s;
  for (i = 0, o = t.length; i < o; ++i)
    if (s = t[i], s !== void 0 && (e !== void 0 && typeof s == "function" && (s = s(e), a = !1), n !== void 0 && ye(s) && (s = s[n % s.length], a = !1), s !== void 0))
      return r && !a && (r.cacheable = !1), s;
}
function SP(t, e, n) {
  const { min: r, max: a } = t, i = Bh(e, (a - r) / 2), o = (s, l) => n && s === 0 ? 0 : s + l;
  return {
    min: o(r, -Math.abs(i)),
    max: o(a, i)
  };
}
function Zt(t, e) {
  return Object.assign(Object.create(t), e);
}
function ic(t, e = [
  ""
], n, r, a = () => t[0]) {
  const i = n || t;
  typeof r > "u" && (r = np("_fallback", t));
  const o = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: t,
    _rootScopes: i,
    _fallback: r,
    _getTarget: a,
    override: (s) => ic([
      s,
      ...t
    ], e, i, r)
  };
  return new Proxy(o, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(s, l) {
      return delete s[l], delete s._keys, delete t[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(s, l) {
      return ep(s, l, () => AP(l, e, t, s));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(s, l) {
      return Reflect.getOwnPropertyDescriptor(s._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(s, l) {
      return vd(s).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(s) {
      return vd(s);
    },
    /**
    * A trap for setting property values.
    */
    set(s, l, c) {
      const u = s._storage || (s._storage = a());
      return s[l] = u[l] = c, delete s._keys, !0;
    }
  });
}
function An(t, e, n, r) {
  const a = {
    _cacheable: !1,
    _proxy: t,
    _context: e,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: Jh(t, r),
    setContext: (i) => An(t, i, n, r),
    override: (i) => An(t.override(i), e, n, r)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, o) {
      return delete i[o], delete t[o], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, o, s) {
      return ep(i, o, () => OP(i, o, s));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, o) {
      return i._descriptors.allKeys ? Reflect.has(t, o) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(t, o);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t);
    },
    /**
    * A trap for the in operator.
    */
    has(i, o) {
      return Reflect.has(t, o);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(t);
    },
    /**
    * A trap for setting property values.
    */
    set(i, o, s) {
      return t[o] = s, delete i[o], !0;
    }
  });
}
function Jh(t, e = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = e.scriptable, _indexable: r = e.indexable, _allKeys: a = e.allKeys } = t;
  return {
    allKeys: a,
    scriptable: n,
    indexable: r,
    isScriptable: Qt(n) ? n : () => n,
    isIndexable: Qt(r) ? r : () => r
  };
}
const MP = (t, e) => t ? t + Jl(e) : e, oc = (t, e) => ae(e) && t !== "adapters" && (Object.getPrototypeOf(e) === null || e.constructor === Object);
function ep(t, e, n) {
  if (Object.prototype.hasOwnProperty.call(t, e))
    return t[e];
  const r = n();
  return t[e] = r, r;
}
function OP(t, e, n) {
  const { _proxy: r, _context: a, _subProxy: i, _descriptors: o } = t;
  let s = r[e];
  return Qt(s) && o.isScriptable(e) && (s = DP(e, s, t, n)), ye(s) && s.length && (s = TP(e, s, t, o.isIndexable)), oc(e, s) && (s = An(s, a, i && i[e], o)), s;
}
function DP(t, e, n, r) {
  const { _proxy: a, _context: i, _subProxy: o, _stack: s } = n;
  if (s.has(t))
    throw new Error("Recursion detected: " + Array.from(s).join("->") + "->" + t);
  s.add(t);
  let l = e(i, o || r);
  return s.delete(t), oc(t, l) && (l = sc(a._scopes, a, t, l)), l;
}
function TP(t, e, n, r) {
  const { _proxy: a, _context: i, _subProxy: o, _descriptors: s } = n;
  if (typeof i.index < "u" && r(t))
    return e[i.index % e.length];
  if (ae(e[0])) {
    const l = e, c = a._scopes.filter((u) => u !== l);
    e = [];
    for (const u of l) {
      const f = sc(c, a, t, u);
      e.push(An(f, i, o && o[t], s));
    }
  }
  return e;
}
function tp(t, e, n) {
  return Qt(t) ? t(e, n) : t;
}
const $P = (t, e) => t === !0 ? e : typeof t == "string" ? Kt(e, t) : void 0;
function RP(t, e, n, r, a) {
  for (const i of e) {
    const o = $P(n, i);
    if (o) {
      t.add(o);
      const s = tp(o._fallback, n, a);
      if (typeof s < "u" && s !== n && s !== r)
        return s;
    } else if (o === !1 && typeof r < "u" && n !== r)
      return null;
  }
  return !1;
}
function sc(t, e, n, r) {
  const a = e._rootScopes, i = tp(e._fallback, n, r), o = [
    ...t,
    ...a
  ], s = /* @__PURE__ */ new Set();
  s.add(r);
  let l = gd(s, o, n, i || n, r);
  return l === null || typeof i < "u" && i !== n && (l = gd(s, o, i, l, r), l === null) ? !1 : ic(Array.from(s), [
    ""
  ], a, i, () => EP(e, n, r));
}
function gd(t, e, n, r, a) {
  for (; n; )
    n = RP(t, e, n, r, a);
  return n;
}
function EP(t, e, n) {
  const r = t._getTarget();
  e in r || (r[e] = {});
  const a = r[e];
  return ye(a) && ae(n) ? n : a || {};
}
function AP(t, e, n, r) {
  let a;
  for (const i of e)
    if (a = np(MP(i, t), n), typeof a < "u")
      return oc(t, a) ? sc(n, r, t, a) : a;
}
function np(t, e) {
  for (const n of e) {
    if (!n)
      continue;
    const r = n[t];
    if (typeof r < "u")
      return r;
  }
}
function vd(t) {
  let e = t._keys;
  return e || (e = t._keys = LP(t._scopes)), e;
}
function LP(t) {
  const e = /* @__PURE__ */ new Set();
  for (const n of t)
    for (const r of Object.keys(n).filter((a) => !a.startsWith("_")))
      e.add(r);
  return Array.from(e);
}
function rp(t, e, n, r) {
  const { iScale: a } = t, { key: i = "r" } = this._parsing, o = new Array(r);
  let s, l, c, u;
  for (s = 0, l = r; s < l; ++s)
    c = s + n, u = e[c], o[s] = {
      r: a.parse(Kt(u, i), c)
    };
  return o;
}
const IP = Number.EPSILON || 1e-14, Ln = (t, e) => e < t.length && !t[e].skip && t[e], ap = (t) => t === "x" ? "y" : "x";
function NP(t, e, n, r) {
  const a = t.skip ? e : t, i = e, o = n.skip ? e : n, s = dl(i, a), l = dl(o, i);
  let c = s / (s + l), u = l / (s + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const f = r * c, d = r * u;
  return {
    previous: {
      x: i.x - f * (o.x - a.x),
      y: i.y - f * (o.y - a.y)
    },
    next: {
      x: i.x + d * (o.x - a.x),
      y: i.y + d * (o.y - a.y)
    }
  };
}
function WP(t, e, n) {
  const r = t.length;
  let a, i, o, s, l, c = Ln(t, 0);
  for (let u = 0; u < r - 1; ++u)
    if (l = c, c = Ln(t, u + 1), !(!l || !c)) {
      if (or(e[u], 0, IP)) {
        n[u] = n[u + 1] = 0;
        continue;
      }
      a = n[u] / e[u], i = n[u + 1] / e[u], s = Math.pow(a, 2) + Math.pow(i, 2), !(s <= 9) && (o = 3 / Math.sqrt(s), n[u] = a * o * e[u], n[u + 1] = i * o * e[u]);
    }
}
function zP(t, e, n = "x") {
  const r = ap(n), a = t.length;
  let i, o, s, l = Ln(t, 0);
  for (let c = 0; c < a; ++c) {
    if (o = s, s = l, l = Ln(t, c + 1), !s)
      continue;
    const u = s[n], f = s[r];
    o && (i = (u - o[n]) / 3, s[`cp1${n}`] = u - i, s[`cp1${r}`] = f - i * e[c]), l && (i = (l[n] - u) / 3, s[`cp2${n}`] = u + i, s[`cp2${r}`] = f + i * e[c]);
  }
}
function BP(t, e = "x") {
  const n = ap(e), r = t.length, a = Array(r).fill(0), i = Array(r);
  let o, s, l, c = Ln(t, 0);
  for (o = 0; o < r; ++o)
    if (s = l, l = c, c = Ln(t, o + 1), !!l) {
      if (c) {
        const u = c[e] - l[e];
        a[o] = u !== 0 ? (c[n] - l[n]) / u : 0;
      }
      i[o] = s ? c ? bt(a[o - 1]) !== bt(a[o]) ? 0 : (a[o - 1] + a[o]) / 2 : a[o - 1] : a[o];
    }
  WP(t, a, i), zP(t, i, e);
}
function ra(t, e, n) {
  return Math.max(Math.min(t, n), e);
}
function FP(t, e) {
  let n, r, a, i, o, s = Rt(t[0], e);
  for (n = 0, r = t.length; n < r; ++n)
    o = i, i = s, s = n < r - 1 && Rt(t[n + 1], e), i && (a = t[n], o && (a.cp1x = ra(a.cp1x, e.left, e.right), a.cp1y = ra(a.cp1y, e.top, e.bottom)), s && (a.cp2x = ra(a.cp2x, e.left, e.right), a.cp2y = ra(a.cp2y, e.top, e.bottom)));
}
function HP(t, e, n, r, a) {
  let i, o, s, l;
  if (e.spanGaps && (t = t.filter((c) => !c.skip)), e.cubicInterpolationMode === "monotone")
    BP(t, a);
  else {
    let c = r ? t[t.length - 1] : t[0];
    for (i = 0, o = t.length; i < o; ++i)
      s = t[i], l = NP(c, s, t[Math.min(i + 1, o - (r ? 0 : 1)) % o], e.tension), s.cp1x = l.previous.x, s.cp1y = l.previous.y, s.cp2x = l.next.x, s.cp2y = l.next.y, c = s;
  }
  e.capBezierPoints && FP(t, n);
}
function ip() {
  return typeof window < "u" && typeof document < "u";
}
function lc(t) {
  let e = t.parentNode;
  return e && e.toString() === "[object ShadowRoot]" && (e = e.host), e;
}
function to(t, e, n) {
  let r;
  return typeof t == "string" ? (r = parseInt(t, 10), t.indexOf("%") !== -1 && (r = r / 100 * e.parentNode[n])) : r = t, r;
}
const xo = (t) => t.ownerDocument.defaultView.getComputedStyle(t, null);
function jP(t, e) {
  return xo(t).getPropertyValue(e);
}
const VP = [
  "top",
  "right",
  "bottom",
  "left"
];
function hn(t, e, n) {
  const r = {};
  n = n ? "-" + n : "";
  for (let a = 0; a < 4; a++) {
    const i = VP[a];
    r[i] = parseFloat(t[e + "-" + i + n]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const qP = (t, e, n) => (t > 0 || e > 0) && (!n || !n.shadowRoot);
function UP(t, e) {
  const n = t.touches, r = n && n.length ? n[0] : t, { offsetX: a, offsetY: i } = r;
  let o = !1, s, l;
  if (qP(a, i, t.target))
    s = a, l = i;
  else {
    const c = e.getBoundingClientRect();
    s = r.clientX - c.left, l = r.clientY - c.top, o = !0;
  }
  return {
    x: s,
    y: l,
    box: o
  };
}
function sn(t, e) {
  if ("native" in t)
    return t;
  const { canvas: n, currentDevicePixelRatio: r } = e, a = xo(n), i = a.boxSizing === "border-box", o = hn(a, "padding"), s = hn(a, "border", "width"), { x: l, y: c, box: u } = UP(t, n), f = o.left + (u && s.left), d = o.top + (u && s.top);
  let { width: h, height: m } = e;
  return i && (h -= o.width + s.width, m -= o.height + s.height), {
    x: Math.round((l - f) / h * n.width / r),
    y: Math.round((c - d) / m * n.height / r)
  };
}
function YP(t, e, n) {
  let r, a;
  if (e === void 0 || n === void 0) {
    const i = lc(t);
    if (!i)
      e = t.clientWidth, n = t.clientHeight;
    else {
      const o = i.getBoundingClientRect(), s = xo(i), l = hn(s, "border", "width"), c = hn(s, "padding");
      e = o.width - c.width - l.width, n = o.height - c.height - l.height, r = to(s.maxWidth, i, "clientWidth"), a = to(s.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: e,
    height: n,
    maxWidth: r || Ji,
    maxHeight: a || Ji
  };
}
const aa = (t) => Math.round(t * 10) / 10;
function XP(t, e, n, r) {
  const a = xo(t), i = hn(a, "margin"), o = to(a.maxWidth, t, "clientWidth") || Ji, s = to(a.maxHeight, t, "clientHeight") || Ji, l = YP(t, e, n);
  let { width: c, height: u } = l;
  if (a.boxSizing === "content-box") {
    const d = hn(a, "border", "width"), h = hn(a, "padding");
    c -= h.width + d.width, u -= h.height + d.height;
  }
  return c = Math.max(0, c - i.width), u = Math.max(0, r ? c / r : u - i.height), c = aa(Math.min(c, o, l.maxWidth)), u = aa(Math.min(u, s, l.maxHeight)), c && !u && (u = aa(c / 2)), (e !== void 0 || n !== void 0) && r && l.height && u > l.height && (u = l.height, c = aa(Math.floor(u * r))), {
    width: c,
    height: u
  };
}
function yd(t, e, n) {
  const r = e || 1, a = Math.floor(t.height * r), i = Math.floor(t.width * r);
  t.height = Math.floor(t.height), t.width = Math.floor(t.width);
  const o = t.canvas;
  return o.style && (n || !o.style.height && !o.style.width) && (o.style.height = `${t.height}px`, o.style.width = `${t.width}px`), t.currentDevicePixelRatio !== r || o.height !== a || o.width !== i ? (t.currentDevicePixelRatio = r, o.height = a, o.width = i, t.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const KP = function() {
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    };
    window.addEventListener("test", null, e), window.removeEventListener("test", null, e);
  } catch {
  }
  return t;
}();
function bd(t, e) {
  const n = jP(t, e), r = n && n.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function ln(t, e, n, r) {
  return {
    x: t.x + n * (e.x - t.x),
    y: t.y + n * (e.y - t.y)
  };
}
function QP(t, e, n, r) {
  return {
    x: t.x + n * (e.x - t.x),
    y: r === "middle" ? n < 0.5 ? t.y : e.y : r === "after" ? n < 1 ? t.y : e.y : n > 0 ? e.y : t.y
  };
}
function GP(t, e, n, r) {
  const a = {
    x: t.cp2x,
    y: t.cp2y
  }, i = {
    x: e.cp1x,
    y: e.cp1y
  }, o = ln(t, a, n), s = ln(a, i, n), l = ln(i, e, n), c = ln(o, s, n), u = ln(s, l, n);
  return ln(c, u, n);
}
const ZP = function(t, e) {
  return {
    x(n) {
      return t + t + e - n;
    },
    setWidth(n) {
      e = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, r) {
      return n - r;
    },
    leftForLtr(n, r) {
      return n - r;
    }
  };
}, JP = function() {
  return {
    x(t) {
      return t;
    },
    setWidth(t) {
    },
    textAlign(t) {
      return t;
    },
    xPlus(t, e) {
      return t + e;
    },
    leftForLtr(t, e) {
      return t;
    }
  };
};
function Sn(t, e, n) {
  return t ? ZP(e, n) : JP();
}
function op(t, e) {
  let n, r;
  (e === "ltr" || e === "rtl") && (n = t.canvas.style, r = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", e, "important"), t.prevTextDirection = r);
}
function sp(t, e) {
  e !== void 0 && (delete t.prevTextDirection, t.canvas.style.setProperty("direction", e[0], e[1]));
}
function lp(t) {
  return t === "angle" ? {
    between: _r,
    compare: eP,
    normalize: Ze
  } : {
    between: Tt,
    compare: (e, n) => e - n,
    normalize: (e) => e
  };
}
function _d({ start: t, end: e, count: n, loop: r, style: a }) {
  return {
    start: t % n,
    end: e % n,
    loop: r && (e - t + 1) % n === 0,
    style: a
  };
}
function eS(t, e, n) {
  const { property: r, start: a, end: i } = n, { between: o, normalize: s } = lp(r), l = e.length;
  let { start: c, end: u, loop: f } = t, d, h;
  if (f) {
    for (c += l, u += l, d = 0, h = l; d < h && o(s(e[c % l][r]), a, i); ++d)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), {
    start: c,
    end: u,
    loop: f,
    style: t.style
  };
}
function cp(t, e, n) {
  if (!n)
    return [
      t
    ];
  const { property: r, start: a, end: i } = n, o = e.length, { compare: s, between: l, normalize: c } = lp(r), { start: u, end: f, loop: d, style: h } = eS(t, e, n), m = [];
  let p = !1, g = null, v, w, C;
  const x = () => l(a, C, v) && s(a, C) !== 0, y = () => s(i, v) === 0 || l(i, C, v), _ = () => p || x(), k = () => !p || y();
  for (let P = u, $ = u; P <= f; ++P)
    w = e[P % o], !w.skip && (v = c(w[r]), v !== C && (p = l(v, a, i), g === null && _() && (g = s(v, a) === 0 ? P : $), g !== null && k() && (m.push(_d({
      start: g,
      end: P,
      loop: d,
      count: o,
      style: h
    })), g = null), $ = P, C = v));
  return g !== null && m.push(_d({
    start: g,
    end: f,
    loop: d,
    count: o,
    style: h
  })), m;
}
function up(t, e) {
  const n = [], r = t.segments;
  for (let a = 0; a < r.length; a++) {
    const i = cp(r[a], t.points, e);
    i.length && n.push(...i);
  }
  return n;
}
function tS(t, e, n, r) {
  let a = 0, i = e - 1;
  if (n && !r)
    for (; a < e && !t[a].skip; )
      a++;
  for (; a < e && t[a].skip; )
    a++;
  for (a %= e, n && (i += a); i > a && t[i % e].skip; )
    i--;
  return i %= e, {
    start: a,
    end: i
  };
}
function nS(t, e, n, r) {
  const a = t.length, i = [];
  let o = e, s = t[e], l;
  for (l = e + 1; l <= n; ++l) {
    const c = t[l % a];
    c.skip || c.stop ? s.skip || (r = !1, i.push({
      start: e % a,
      end: (l - 1) % a,
      loop: r
    }), e = o = c.stop ? l : null) : (o = l, s.skip && (e = l)), s = c;
  }
  return o !== null && i.push({
    start: e % a,
    end: o % a,
    loop: r
  }), i;
}
function rS(t, e) {
  const n = t.points, r = t.options.spanGaps, a = n.length;
  if (!a)
    return [];
  const i = !!t._loop, { start: o, end: s } = tS(n, a, i, r);
  if (r === !0)
    return wd(t, [
      {
        start: o,
        end: s,
        loop: i
      }
    ], n, e);
  const l = s < o ? s + a : s, c = !!t._fullLoop && o === 0 && s === a - 1;
  return wd(t, nS(n, o, l, c), n, e);
}
function wd(t, e, n, r) {
  return !r || !r.setContext || !n ? e : aS(t, e, n, r);
}
function aS(t, e, n, r) {
  const a = t._chart.getContext(), i = kd(t.options), { _datasetIndex: o, options: { spanGaps: s } } = t, l = n.length, c = [];
  let u = i, f = e[0].start, d = f;
  function h(m, p, g, v) {
    const w = s ? -1 : 1;
    if (m !== p) {
      for (m += l; n[m % l].skip; )
        m -= w;
      for (; n[p % l].skip; )
        p += w;
      m % l !== p % l && (c.push({
        start: m % l,
        end: p % l,
        loop: g,
        style: v
      }), u = v, f = p % l);
    }
  }
  for (const m of e) {
    f = s ? f : m.start;
    let p = n[f % l], g;
    for (d = f + 1; d <= m.end; d++) {
      const v = n[d % l];
      g = kd(r.setContext(Zt(a, {
        type: "segment",
        p0: p,
        p1: v,
        p0DataIndex: (d - 1) % l,
        p1DataIndex: d % l,
        datasetIndex: o
      }))), iS(g, u) && h(f, d - 1, m.loop, u), p = v, u = g;
    }
    f < d - 1 && h(f, d - 1, m.loop, u);
  }
  return c;
}
function kd(t) {
  return {
    backgroundColor: t.backgroundColor,
    borderCapStyle: t.borderCapStyle,
    borderDash: t.borderDash,
    borderDashOffset: t.borderDashOffset,
    borderJoinStyle: t.borderJoinStyle,
    borderWidth: t.borderWidth,
    borderColor: t.borderColor
  };
}
function iS(t, e) {
  if (!e)
    return !1;
  const n = [], r = function(a, i) {
    return rc(i) ? (n.includes(i) || n.push(i), n.indexOf(i)) : i;
  };
  return JSON.stringify(t, r) !== JSON.stringify(e, r);
}
/*!
 * Chart.js v4.4.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
class oS {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(e, n, r, a) {
    const i = n.listeners[a], o = n.duration;
    i.forEach((s) => s({
      chart: e,
      initial: n.initial,
      numSteps: o,
      currentStep: Math.min(r - n.start, o)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Uh.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(e = Date.now()) {
    let n = 0;
    this._charts.forEach((r, a) => {
      if (!r.running || !r.items.length)
        return;
      const i = r.items;
      let o = i.length - 1, s = !1, l;
      for (; o >= 0; --o)
        l = i[o], l._active ? (l._total > r.duration && (r.duration = l._total), l.tick(e), s = !0) : (i[o] = i[i.length - 1], i.pop());
      s && (a.draw(), this._notify(a, r, e, "progress")), i.length || (r.running = !1, this._notify(a, r, e, "complete"), r.initial = !1), n += i.length;
    }), this._lastDate = e, n === 0 && (this._running = !1);
  }
  _getAnims(e) {
    const n = this._charts;
    let r = n.get(e);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(e, r)), r;
  }
  listen(e, n, r) {
    this._getAnims(e).listeners[n].push(r);
  }
  add(e, n) {
    !n || !n.length || this._getAnims(e).items.push(...n);
  }
  has(e) {
    return this._getAnims(e).items.length > 0;
  }
  start(e) {
    const n = this._charts.get(e);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((r, a) => Math.max(r, a._duration), 0), this._refresh());
  }
  running(e) {
    if (!this._running)
      return !1;
    const n = this._charts.get(e);
    return !(!n || !n.running || !n.items.length);
  }
  stop(e) {
    const n = this._charts.get(e);
    if (!n || !n.items.length)
      return;
    const r = n.items;
    let a = r.length - 1;
    for (; a >= 0; --a)
      r[a].cancel();
    n.items = [], this._notify(e, n, Date.now(), "complete");
  }
  remove(e) {
    return this._charts.delete(e);
  }
}
var Pt = /* @__PURE__ */ new oS();
const xd = "transparent", sS = {
  boolean(t, e, n) {
    return n > 0.5 ? e : t;
  },
  color(t, e, n) {
    const r = hd(t || xd), a = r.valid && hd(e || xd);
    return a && a.valid ? a.mix(r, n).hexString() : e;
  },
  number(t, e, n) {
    return t + (e - t) * n;
  }
};
class lS {
  constructor(e, n, r, a) {
    const i = n[r];
    a = Gn([
      e.to,
      a,
      i,
      e.from
    ]);
    const o = Gn([
      e.from,
      i,
      a
    ]);
    this._active = !0, this._fn = e.fn || sS[e.type || typeof o], this._easing = sr[e.easing] || sr.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = n, this._prop = r, this._from = o, this._to = a, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(e, n, r) {
    if (this._active) {
      this._notify(!1);
      const a = this._target[this._prop], i = r - this._start, o = this._duration - i;
      this._start = r, this._duration = Math.floor(Math.max(o, e.duration)), this._total += i, this._loop = !!e.loop, this._to = Gn([
        e.to,
        n,
        a,
        e.from
      ]), this._from = Gn([
        e.from,
        a,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(e) {
    const n = e - this._start, r = this._duration, a = this._prop, i = this._from, o = this._loop, s = this._to;
    let l;
    if (this._active = i !== s && (o || n < r), !this._active) {
      this._target[a] = s, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[a] = i;
      return;
    }
    l = n / r % 2, l = o && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[a] = this._fn(i, s, l);
  }
  wait() {
    const e = this._promises || (this._promises = []);
    return new Promise((n, r) => {
      e.push({
        res: n,
        rej: r
      });
    });
  }
  _notify(e) {
    const n = e ? "res" : "rej", r = this._promises || [];
    for (let a = 0; a < r.length; a++)
      r[a][n]();
  }
}
class dp {
  constructor(e, n) {
    this._chart = e, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(e) {
    if (!ae(e))
      return;
    const n = Object.keys(Se.animation), r = this._properties;
    Object.getOwnPropertyNames(e).forEach((a) => {
      const i = e[a];
      if (!ae(i))
        return;
      const o = {};
      for (const s of n)
        o[s] = i[s];
      (ye(i.properties) && i.properties || [
        a
      ]).forEach((s) => {
        (s === a || !r.has(s)) && r.set(s, o);
      });
    });
  }
  _animateOptions(e, n) {
    const r = n.options, a = uS(e, r);
    if (!a)
      return [];
    const i = this._createAnimations(a, r);
    return r.$shared && cS(e.options.$animations, r).then(() => {
      e.options = r;
    }, () => {
    }), i;
  }
  _createAnimations(e, n) {
    const r = this._properties, a = [], i = e.$animations || (e.$animations = {}), o = Object.keys(n), s = Date.now();
    let l;
    for (l = o.length - 1; l >= 0; --l) {
      const c = o[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        a.push(...this._animateOptions(e, n));
        continue;
      }
      const u = n[c];
      let f = i[c];
      const d = r.get(c);
      if (f)
        if (d && f.active()) {
          f.update(d, u, s);
          continue;
        } else
          f.cancel();
      if (!d || !d.duration) {
        e[c] = u;
        continue;
      }
      i[c] = f = new lS(d, e, c, u), a.push(f);
    }
    return a;
  }
  update(e, n) {
    if (this._properties.size === 0) {
      Object.assign(e, n);
      return;
    }
    const r = this._createAnimations(e, n);
    if (r.length)
      return Pt.add(this._chart, r), !0;
  }
}
function cS(t, e) {
  const n = [], r = Object.keys(e);
  for (let a = 0; a < r.length; a++) {
    const i = t[r[a]];
    i && i.active() && n.push(i.wait());
  }
  return Promise.all(n);
}
function uS(t, e) {
  if (!e)
    return;
  let n = t.options;
  if (!n) {
    t.options = e;
    return;
  }
  return n.$shared && (t.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function Cd(t, e) {
  const n = t && t.options || {}, r = n.reverse, a = n.min === void 0 ? e : 0, i = n.max === void 0 ? e : 0;
  return {
    start: r ? i : a,
    end: r ? a : i
  };
}
function dS(t, e, n) {
  if (n === !1)
    return !1;
  const r = Cd(t, n), a = Cd(e, n);
  return {
    top: a.end,
    right: r.end,
    bottom: a.start,
    left: r.start
  };
}
function fS(t) {
  let e, n, r, a;
  return ae(t) ? (e = t.top, n = t.right, r = t.bottom, a = t.left) : e = n = r = a = t, {
    top: e,
    right: n,
    bottom: r,
    left: a,
    disabled: t === !1
  };
}
function fp(t, e) {
  const n = [], r = t._getSortedDatasetMetas(e);
  let a, i;
  for (a = 0, i = r.length; a < i; ++a)
    n.push(r[a].index);
  return n;
}
function Pd(t, e, n, r = {}) {
  const a = t.keys, i = r.mode === "single";
  let o, s, l, c;
  if (e !== null) {
    for (o = 0, s = a.length; o < s; ++o) {
      if (l = +a[o], l === n) {
        if (r.all)
          continue;
        break;
      }
      c = t.values[l], Pe(c) && (i || e === 0 || bt(e) === bt(c)) && (e += c);
    }
    return e;
  }
}
function hS(t) {
  const e = Object.keys(t), n = new Array(e.length);
  let r, a, i;
  for (r = 0, a = e.length; r < a; ++r)
    i = e[r], n[r] = {
      x: i,
      y: t[i]
    };
  return n;
}
function Sd(t, e) {
  const n = t && t.options.stacked;
  return n || n === void 0 && e.stack !== void 0;
}
function pS(t, e, n) {
  return `${t.id}.${e.id}.${n.stack || n.type}`;
}
function mS(t) {
  const { min: e, max: n, minDefined: r, maxDefined: a } = t.getUserBounds();
  return {
    min: r ? e : Number.NEGATIVE_INFINITY,
    max: a ? n : Number.POSITIVE_INFINITY
  };
}
function gS(t, e, n) {
  const r = t[e] || (t[e] = {});
  return r[n] || (r[n] = {});
}
function Md(t, e, n, r) {
  for (const a of e.getMatchingVisibleMetas(r).reverse()) {
    const i = t[a.index];
    if (n && i > 0 || !n && i < 0)
      return a.index;
  }
  return null;
}
function Od(t, e) {
  const { chart: n, _cachedMeta: r } = t, a = n._stacks || (n._stacks = {}), { iScale: i, vScale: o, index: s } = r, l = i.axis, c = o.axis, u = pS(i, o, r), f = e.length;
  let d;
  for (let h = 0; h < f; ++h) {
    const m = e[h], { [l]: p, [c]: g } = m, v = m._stacks || (m._stacks = {});
    d = v[c] = gS(a, u, p), d[s] = g, d._top = Md(d, o, !0, r.type), d._bottom = Md(d, o, !1, r.type);
    const w = d._visualValues || (d._visualValues = {});
    w[s] = g;
  }
}
function Lo(t, e) {
  const n = t.scales;
  return Object.keys(n).filter((r) => n[r].axis === e).shift();
}
function vS(t, e) {
  return Zt(t, {
    active: !1,
    dataset: void 0,
    datasetIndex: e,
    index: e,
    mode: "default",
    type: "dataset"
  });
}
function yS(t, e, n) {
  return Zt(t, {
    active: !1,
    dataIndex: e,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: e,
    mode: "default",
    type: "data"
  });
}
function qn(t, e) {
  const n = t.controller.index, r = t.vScale && t.vScale.axis;
  if (r) {
    e = e || t._parsed;
    for (const a of e) {
      const i = a._stacks;
      if (!i || i[r] === void 0 || i[r][n] === void 0)
        return;
      delete i[r][n], i[r]._visualValues !== void 0 && i[r]._visualValues[n] !== void 0 && delete i[r]._visualValues[n];
    }
  }
}
const Io = (t) => t === "reset" || t === "none", Dd = (t, e) => e ? t : Object.assign({}, t), bS = (t, e, n) => t && !e.hidden && e._stacked && {
  keys: fp(n, !0),
  values: null
};
class ut {
  constructor(e, n) {
    this.chart = e, this._ctx = e.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const e = this._cachedMeta;
    this.configure(), this.linkScales(), e._stacked = Sd(e.vScale, e), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(e) {
    this.index !== e && qn(this._cachedMeta), this.index = e;
  }
  linkScales() {
    const e = this.chart, n = this._cachedMeta, r = this.getDataset(), a = (f, d, h, m) => f === "x" ? d : f === "r" ? m : h, i = n.xAxisID = ee(r.xAxisID, Lo(e, "x")), o = n.yAxisID = ee(r.yAxisID, Lo(e, "y")), s = n.rAxisID = ee(r.rAxisID, Lo(e, "r")), l = n.indexAxis, c = n.iAxisID = a(l, i, o, s), u = n.vAxisID = a(l, o, i, s);
    n.xScale = this.getScaleForId(i), n.yScale = this.getScaleForId(o), n.rScale = this.getScaleForId(s), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(e) {
    return this.chart.scales[e];
  }
  _getOtherScale(e) {
    const n = this._cachedMeta;
    return e === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const e = this._cachedMeta;
    this._data && ud(this._data, this), e._stacked && qn(e);
  }
  _dataCheck() {
    const e = this.getDataset(), n = e.data || (e.data = []), r = this._data;
    if (ae(n))
      this._data = hS(n);
    else if (r !== n) {
      if (r) {
        ud(r, this);
        const a = this._cachedMeta;
        qn(a), a._parsed = [];
      }
      n && Object.isExtensible(n) && aP(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const e = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (e.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(e) {
    const n = this._cachedMeta, r = this.getDataset();
    let a = !1;
    this._dataCheck();
    const i = n._stacked;
    n._stacked = Sd(n.vScale, n), n.stack !== r.stack && (a = !0, qn(n), n.stack = r.stack), this._resyncElements(e), (a || i !== n._stacked) && Od(this, n._parsed);
  }
  configure() {
    const e = this.chart.config, n = e.datasetScopeKeys(this._type), r = e.getOptionScopes(this.getDataset(), n, !0);
    this.options = e.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(e, n) {
    const { _cachedMeta: r, _data: a } = this, { iScale: i, _stacked: o } = r, s = i.axis;
    let l = e === 0 && n === a.length ? !0 : r._sorted, c = e > 0 && r._parsed[e - 1], u, f, d;
    if (this._parsing === !1)
      r._parsed = a, r._sorted = !0, d = a;
    else {
      ye(a[e]) ? d = this.parseArrayData(r, a, e, n) : ae(a[e]) ? d = this.parseObjectData(r, a, e, n) : d = this.parsePrimitiveData(r, a, e, n);
      const h = () => f[s] === null || c && f[s] < c[s];
      for (u = 0; u < n; ++u)
        r._parsed[u + e] = f = d[u], l && (h() && (l = !1), c = f);
      r._sorted = l;
    }
    o && Od(this, d);
  }
  parsePrimitiveData(e, n, r, a) {
    const { iScale: i, vScale: o } = e, s = i.axis, l = o.axis, c = i.getLabels(), u = i === o, f = new Array(a);
    let d, h, m;
    for (d = 0, h = a; d < h; ++d)
      m = d + r, f[d] = {
        [s]: u || i.parse(c[m], m),
        [l]: o.parse(n[m], m)
      };
    return f;
  }
  parseArrayData(e, n, r, a) {
    const { xScale: i, yScale: o } = e, s = new Array(a);
    let l, c, u, f;
    for (l = 0, c = a; l < c; ++l)
      u = l + r, f = n[u], s[l] = {
        x: i.parse(f[0], u),
        y: o.parse(f[1], u)
      };
    return s;
  }
  parseObjectData(e, n, r, a) {
    const { xScale: i, yScale: o } = e, { xAxisKey: s = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(a);
    let u, f, d, h;
    for (u = 0, f = a; u < f; ++u)
      d = u + r, h = n[d], c[u] = {
        x: i.parse(Kt(h, s), d),
        y: o.parse(Kt(h, l), d)
      };
    return c;
  }
  getParsed(e) {
    return this._cachedMeta._parsed[e];
  }
  getDataElement(e) {
    return this._cachedMeta.data[e];
  }
  applyStack(e, n, r) {
    const a = this.chart, i = this._cachedMeta, o = n[e.axis], s = {
      keys: fp(a, !0),
      values: n._stacks[e.axis]._visualValues
    };
    return Pd(s, o, i.index, {
      mode: r
    });
  }
  updateRangeFromParsed(e, n, r, a) {
    const i = r[n.axis];
    let o = i === null ? NaN : i;
    const s = a && r._stacks[n.axis];
    a && s && (a.values = s, o = Pd(a, i, this._cachedMeta.index)), e.min = Math.min(e.min, o), e.max = Math.max(e.max, o);
  }
  getMinMax(e, n) {
    const r = this._cachedMeta, a = r._parsed, i = r._sorted && e === r.iScale, o = a.length, s = this._getOtherScale(e), l = bS(n, r, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: f } = mS(s);
    let d, h;
    function m() {
      h = a[d];
      const p = h[s.axis];
      return !Pe(h[e.axis]) || u > p || f < p;
    }
    for (d = 0; d < o && !(!m() && (this.updateRangeFromParsed(c, e, h, l), i)); ++d)
      ;
    if (i) {
      for (d = o - 1; d >= 0; --d)
        if (!m()) {
          this.updateRangeFromParsed(c, e, h, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(e) {
    const n = this._cachedMeta._parsed, r = [];
    let a, i, o;
    for (a = 0, i = n.length; a < i; ++a)
      o = n[a][e.axis], Pe(o) && r.push(o);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, r = n.iScale, a = n.vScale, i = this.getParsed(e);
    return {
      label: r ? "" + r.getLabelForValue(i[r.axis]) : "",
      value: a ? "" + a.getLabelForValue(i[a.axis]) : ""
    };
  }
  _update(e) {
    const n = this._cachedMeta;
    this.update(e || "default"), n._clip = fS(ee(this.options.clip, dS(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(e) {
  }
  draw() {
    const e = this._ctx, n = this.chart, r = this._cachedMeta, a = r.data || [], i = n.chartArea, o = [], s = this._drawStart || 0, l = this._drawCount || a.length - s, c = this.options.drawActiveElementsOnTop;
    let u;
    for (r.dataset && r.dataset.draw(e, i, s, l), u = s; u < s + l; ++u) {
      const f = a[u];
      f.hidden || (f.active && c ? o.push(f) : f.draw(e, i));
    }
    for (u = 0; u < o.length; ++u)
      o[u].draw(e, i);
  }
  getStyle(e, n) {
    const r = n ? "active" : "default";
    return e === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(e || 0, r);
  }
  getContext(e, n, r) {
    const a = this.getDataset();
    let i;
    if (e >= 0 && e < this._cachedMeta.data.length) {
      const o = this._cachedMeta.data[e];
      i = o.$context || (o.$context = yS(this.getContext(), e, o)), i.parsed = this.getParsed(e), i.raw = a.data[e], i.index = i.dataIndex = e;
    } else
      i = this.$context || (this.$context = vS(this.chart.getContext(), this.index)), i.dataset = a, i.index = i.datasetIndex = this.index;
    return i.active = !!n, i.mode = r, i;
  }
  resolveDatasetElementOptions(e) {
    return this._resolveElementOptions(this.datasetElementType.id, e);
  }
  resolveDataElementOptions(e, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, e);
  }
  _resolveElementOptions(e, n = "default", r) {
    const a = n === "active", i = this._cachedDataOpts, o = e + "-" + n, s = i[o], l = this.enableOptionSharing && br(r);
    if (s)
      return Dd(s, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, e), f = a ? [
      `${e}Hover`,
      "hover",
      e,
      ""
    ] : [
      e,
      ""
    ], d = c.getOptionScopes(this.getDataset(), u), h = Object.keys(Se.elements[e]), m = () => this.getContext(r, a, n), p = c.resolveNamedOptions(d, h, m, f);
    return p.$shared && (p.$shared = l, i[o] = Object.freeze(Dd(p, l))), p;
  }
  _resolveAnimations(e, n, r) {
    const a = this.chart, i = this._cachedDataOpts, o = `animation-${n}`, s = i[o];
    if (s)
      return s;
    let l;
    if (a.options.animation !== !1) {
      const u = this.chart.config, f = u.datasetAnimationScopeKeys(this._type, n), d = u.getOptionScopes(this.getDataset(), f);
      l = u.createResolver(d, this.getContext(e, r, n));
    }
    const c = new dp(a, l && l.animations);
    return l && l._cacheable && (i[o] = Object.freeze(c)), c;
  }
  getSharedOptions(e) {
    if (e.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, e));
  }
  includeOptions(e, n) {
    return !n || Io(e) || this.chart._animationsDisabled;
  }
  _getSharedOptions(e, n) {
    const r = this.resolveDataElementOptions(e, n), a = this._sharedOptions, i = this.getSharedOptions(r), o = this.includeOptions(n, i) || i !== a;
    return this.updateSharedOptions(i, n, r), {
      sharedOptions: i,
      includeOptions: o
    };
  }
  updateElement(e, n, r, a) {
    Io(a) ? Object.assign(e, r) : this._resolveAnimations(n, a).update(e, r);
  }
  updateSharedOptions(e, n, r) {
    e && !Io(n) && this._resolveAnimations(void 0, n).update(e, r);
  }
  _setStyle(e, n, r, a) {
    e.active = a;
    const i = this.getStyle(n, a);
    this._resolveAnimations(n, r, a).update(e, {
      options: !a && this.getSharedOptions(i) || i
    });
  }
  removeHoverStyle(e, n, r) {
    this._setStyle(e, r, "active", !1);
  }
  setHoverStyle(e, n, r) {
    this._setStyle(e, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !0);
  }
  _resyncElements(e) {
    const n = this._data, r = this._cachedMeta.data;
    for (const [s, l, c] of this._syncList)
      this[s](l, c);
    this._syncList = [];
    const a = r.length, i = n.length, o = Math.min(i, a);
    o && this.parse(0, o), i > a ? this._insertElements(a, i - a, e) : i < a && this._removeElements(i, a - i);
  }
  _insertElements(e, n, r = !0) {
    const a = this._cachedMeta, i = a.data, o = e + n;
    let s;
    const l = (c) => {
      for (c.length += n, s = c.length - 1; s >= o; s--)
        c[s] = c[s - n];
    };
    for (l(i), s = e; s < o; ++s)
      i[s] = new this.dataElementType();
    this._parsing && l(a._parsed), this.parse(e, n), r && this.updateElements(i, e, n, "reset");
  }
  updateElements(e, n, r, a) {
  }
  _removeElements(e, n) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const a = r._parsed.splice(e, n);
      r._stacked && qn(r, a);
    }
    r.data.splice(e, n);
  }
  _sync(e) {
    if (this._parsing)
      this._syncList.push(e);
    else {
      const [n, r, a] = e;
      this[n](r, a);
    }
    this.chart._dataChanges.push([
      this.index,
      ...e
    ]);
  }
  _onDataPush() {
    const e = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - e,
      e
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(e, n) {
    n && this._sync([
      "_removeElements",
      e,
      n
    ]);
    const r = arguments.length - 2;
    r && this._sync([
      "_insertElements",
      e,
      r
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
A(ut, "defaults", {}), A(ut, "datasetElementType", null), A(ut, "dataElementType", null);
function _S(t, e) {
  if (!t._cache.$bar) {
    const n = t.getMatchingVisibleMetas(e);
    let r = [];
    for (let a = 0, i = n.length; a < i; a++)
      r = r.concat(n[a].controller.getAllParsedValues(t));
    t._cache.$bar = qh(r.sort((a, i) => a - i));
  }
  return t._cache.$bar;
}
function wS(t) {
  const e = t.iScale, n = _S(e, t.type);
  let r = e._length, a, i, o, s;
  const l = () => {
    o === 32767 || o === -32768 || (br(s) && (r = Math.min(r, Math.abs(o - s) || r)), s = o);
  };
  for (a = 0, i = n.length; a < i; ++a)
    o = e.getPixelForValue(n[a]), l();
  for (s = void 0, a = 0, i = e.ticks.length; a < i; ++a)
    o = e.getPixelForTick(a), l();
  return r;
}
function kS(t, e, n, r) {
  const a = n.barThickness;
  let i, o;
  return se(a) ? (i = e.min * n.categoryPercentage, o = n.barPercentage) : (i = a * r, o = 1), {
    chunk: i / r,
    ratio: o,
    start: e.pixels[t] - i / 2
  };
}
function xS(t, e, n, r) {
  const a = e.pixels, i = a[t];
  let o = t > 0 ? a[t - 1] : null, s = t < a.length - 1 ? a[t + 1] : null;
  const l = n.categoryPercentage;
  o === null && (o = i - (s === null ? e.end - e.start : s - i)), s === null && (s = i + i - o);
  const c = i - (i - Math.min(o, s)) / 2 * l;
  return {
    chunk: Math.abs(s - o) / 2 * l / r,
    ratio: n.barPercentage,
    start: c
  };
}
function CS(t, e, n, r) {
  const a = n.parse(t[0], r), i = n.parse(t[1], r), o = Math.min(a, i), s = Math.max(a, i);
  let l = o, c = s;
  Math.abs(o) > Math.abs(s) && (l = s, c = o), e[n.axis] = c, e._custom = {
    barStart: l,
    barEnd: c,
    start: a,
    end: i,
    min: o,
    max: s
  };
}
function hp(t, e, n, r) {
  return ye(t) ? CS(t, e, n, r) : e[n.axis] = n.parse(t, r), e;
}
function Td(t, e, n, r) {
  const a = t.iScale, i = t.vScale, o = a.getLabels(), s = a === i, l = [];
  let c, u, f, d;
  for (c = n, u = n + r; c < u; ++c)
    d = e[c], f = {}, f[a.axis] = s || a.parse(o[c], c), l.push(hp(d, f, i, c));
  return l;
}
function No(t) {
  return t && t.barStart !== void 0 && t.barEnd !== void 0;
}
function PS(t, e, n) {
  return t !== 0 ? bt(t) : (e.isHorizontal() ? 1 : -1) * (e.min >= n ? 1 : -1);
}
function SS(t) {
  let e, n, r, a, i;
  return t.horizontal ? (e = t.base > t.x, n = "left", r = "right") : (e = t.base < t.y, n = "bottom", r = "top"), e ? (a = "end", i = "start") : (a = "start", i = "end"), {
    start: n,
    end: r,
    reverse: e,
    top: a,
    bottom: i
  };
}
function MS(t, e, n, r) {
  let a = e.borderSkipped;
  const i = {};
  if (!a) {
    t.borderSkipped = i;
    return;
  }
  if (a === !0) {
    t.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: o, end: s, reverse: l, top: c, bottom: u } = SS(t);
  a === "middle" && n && (t.enableBorderRadius = !0, (n._top || 0) === r ? a = c : (n._bottom || 0) === r ? a = u : (i[$d(u, o, s, l)] = !0, a = c)), i[$d(a, o, s, l)] = !0, t.borderSkipped = i;
}
function $d(t, e, n, r) {
  return r ? (t = OS(t, e, n), t = Rd(t, n, e)) : t = Rd(t, e, n), t;
}
function OS(t, e, n) {
  return t === e ? n : t === n ? e : t;
}
function Rd(t, e, n) {
  return t === "start" ? e : t === "end" ? n : t;
}
function DS(t, { inflateAmount: e }, n) {
  t.inflateAmount = e === "auto" ? n === 1 ? 0.33 : 0 : e;
}
class ri extends ut {
  parsePrimitiveData(e, n, r, a) {
    return Td(e, n, r, a);
  }
  parseArrayData(e, n, r, a) {
    return Td(e, n, r, a);
  }
  parseObjectData(e, n, r, a) {
    const { iScale: i, vScale: o } = e, { xAxisKey: s = "x", yAxisKey: l = "y" } = this._parsing, c = i.axis === "x" ? s : l, u = o.axis === "x" ? s : l, f = [];
    let d, h, m, p;
    for (d = r, h = r + a; d < h; ++d)
      p = n[d], m = {}, m[i.axis] = i.parse(Kt(p, c), d), f.push(hp(Kt(p, u), m, o, d));
    return f;
  }
  updateRangeFromParsed(e, n, r, a) {
    super.updateRangeFromParsed(e, n, r, a);
    const i = r._custom;
    i && n === this._cachedMeta.vScale && (e.min = Math.min(e.min, i.min), e.max = Math.max(e.max, i.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, { iScale: r, vScale: a } = n, i = this.getParsed(e), o = i._custom, s = No(o) ? "[" + o.start + ", " + o.end + "]" : "" + a.getLabelForValue(i[a.axis]);
    return {
      label: "" + r.getLabelForValue(i[r.axis]),
      value: s
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const e = this._cachedMeta;
    e.stack = this.getDataset().stack;
  }
  update(e) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, e);
  }
  updateElements(e, n, r, a) {
    const i = a === "reset", { index: o, _cachedMeta: { vScale: s } } = this, l = s.getBasePixel(), c = s.isHorizontal(), u = this._getRuler(), { sharedOptions: f, includeOptions: d } = this._getSharedOptions(n, a);
    for (let h = n; h < n + r; h++) {
      const m = this.getParsed(h), p = i || se(m[s.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(h), g = this._calculateBarIndexPixels(h, u), v = (m._stacks || {})[s.axis], w = {
        horizontal: c,
        base: p.base,
        enableBorderRadius: !v || No(m._custom) || o === v._top || o === v._bottom,
        x: c ? p.head : g.center,
        y: c ? g.center : p.head,
        height: c ? g.size : Math.abs(p.size),
        width: c ? Math.abs(p.size) : g.size
      };
      d && (w.options = f || this.resolveDataElementOptions(h, e[h].active ? "active" : a));
      const C = w.options || e[h].options;
      MS(w, C, v, o), DS(w, C, u.ratio), this.updateElement(e[h], h, w, a);
    }
  }
  _getStacks(e, n) {
    const { iScale: r } = this._cachedMeta, a = r.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), i = r.options.stacked, o = [], s = (l) => {
      const c = l.controller.getParsed(n), u = c && c[l.vScale.axis];
      if (se(u) || isNaN(u))
        return !0;
    };
    for (const l of a)
      if (!(n !== void 0 && s(l)) && ((i === !1 || o.indexOf(l.stack) === -1 || i === void 0 && l.stack === void 0) && o.push(l.stack), l.index === e))
        break;
    return o.length || o.push(void 0), o;
  }
  _getStackCount(e) {
    return this._getStacks(void 0, e).length;
  }
  _getStackIndex(e, n, r) {
    const a = this._getStacks(e, r), i = n !== void 0 ? a.indexOf(n) : -1;
    return i === -1 ? a.length - 1 : i;
  }
  _getRuler() {
    const e = this.options, n = this._cachedMeta, r = n.iScale, a = [];
    let i, o;
    for (i = 0, o = n.data.length; i < o; ++i)
      a.push(r.getPixelForValue(this.getParsed(i)[r.axis], i));
    const s = e.barThickness;
    return {
      min: s || wS(n),
      pixels: a,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: e.grouped,
      ratio: s ? 1 : e.categoryPercentage * e.barPercentage
    };
  }
  _calculateBarValuePixels(e) {
    const { _cachedMeta: { vScale: n, _stacked: r, index: a }, options: { base: i, minBarLength: o } } = this, s = i || 0, l = this.getParsed(e), c = l._custom, u = No(c);
    let f = l[n.axis], d = 0, h = r ? this.applyStack(n, l, r) : f, m, p;
    h !== f && (d = h - f, h = f), u && (f = c.barStart, h = c.barEnd - c.barStart, f !== 0 && bt(f) !== bt(c.barEnd) && (d = 0), d += f);
    const g = !se(i) && !u ? i : d;
    let v = n.getPixelForValue(g);
    if (this.chart.getDataVisibility(e) ? m = n.getPixelForValue(d + h) : m = v, p = m - v, Math.abs(p) < o) {
      p = PS(p, n, s) * o, f === s && (v -= p / 2);
      const w = n.getPixelForDecimal(0), C = n.getPixelForDecimal(1), x = Math.min(w, C), y = Math.max(w, C);
      v = Math.max(Math.min(v, y), x), m = v + p, r && !u && (l._stacks[n.axis]._visualValues[a] = n.getValueForPixel(m) - n.getValueForPixel(v));
    }
    if (v === n.getPixelForValue(s)) {
      const w = bt(p) * n.getLineWidthForValue(s) / 2;
      v += w, p -= w;
    }
    return {
      size: p,
      base: v,
      head: m,
      center: m + p / 2
    };
  }
  _calculateBarIndexPixels(e, n) {
    const r = n.scale, a = this.options, i = a.skipNull, o = ee(a.maxBarThickness, 1 / 0);
    let s, l;
    if (n.grouped) {
      const c = i ? this._getStackCount(e) : n.stackCount, u = a.barThickness === "flex" ? xS(e, n, a, c) : kS(e, n, a, c), f = this._getStackIndex(this.index, this._cachedMeta.stack, i ? e : void 0);
      s = u.start + u.chunk * f + u.chunk / 2, l = Math.min(o, u.chunk * u.ratio);
    } else
      s = r.getPixelForValue(this.getParsed(e)[r.axis], e), l = Math.min(o, n.min * n.ratio);
    return {
      base: s - l / 2,
      head: s + l / 2,
      center: s,
      size: l
    };
  }
  draw() {
    const e = this._cachedMeta, n = e.vScale, r = e.data, a = r.length;
    let i = 0;
    for (; i < a; ++i)
      this.getParsed(i)[n.axis] !== null && r[i].draw(this._ctx);
  }
}
A(ri, "id", "bar"), A(ri, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), A(ri, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class ai extends ut {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(e, n, r, a) {
    const i = super.parsePrimitiveData(e, n, r, a);
    for (let o = 0; o < i.length; o++)
      i[o]._custom = this.resolveDataElementOptions(o + r).radius;
    return i;
  }
  parseArrayData(e, n, r, a) {
    const i = super.parseArrayData(e, n, r, a);
    for (let o = 0; o < i.length; o++) {
      const s = n[r + o];
      i[o]._custom = ee(s[2], this.resolveDataElementOptions(o + r).radius);
    }
    return i;
  }
  parseObjectData(e, n, r, a) {
    const i = super.parseObjectData(e, n, r, a);
    for (let o = 0; o < i.length; o++) {
      const s = n[r + o];
      i[o]._custom = ee(s && s.r && +s.r, this.resolveDataElementOptions(o + r).radius);
    }
    return i;
  }
  getMaxOverflow() {
    const e = this._cachedMeta.data;
    let n = 0;
    for (let r = e.length - 1; r >= 0; --r)
      n = Math.max(n, e[r].size(this.resolveDataElementOptions(r)) / 2);
    return n > 0 && n;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, r = this.chart.data.labels || [], { xScale: a, yScale: i } = n, o = this.getParsed(e), s = a.getLabelForValue(o.x), l = i.getLabelForValue(o.y), c = o._custom;
    return {
      label: r[e] || "",
      value: "(" + s + ", " + l + (c ? ", " + c : "") + ")"
    };
  }
  update(e) {
    const n = this._cachedMeta.data;
    this.updateElements(n, 0, n.length, e);
  }
  updateElements(e, n, r, a) {
    const i = a === "reset", { iScale: o, vScale: s } = this._cachedMeta, { sharedOptions: l, includeOptions: c } = this._getSharedOptions(n, a), u = o.axis, f = s.axis;
    for (let d = n; d < n + r; d++) {
      const h = e[d], m = !i && this.getParsed(d), p = {}, g = p[u] = i ? o.getPixelForDecimal(0.5) : o.getPixelForValue(m[u]), v = p[f] = i ? s.getBasePixel() : s.getPixelForValue(m[f]);
      p.skip = isNaN(g) || isNaN(v), c && (p.options = l || this.resolveDataElementOptions(d, h.active ? "active" : a), i && (p.options.radius = 0)), this.updateElement(h, d, p, a);
    }
  }
  resolveDataElementOptions(e, n) {
    const r = this.getParsed(e);
    let a = super.resolveDataElementOptions(e, n);
    a.$shared && (a = Object.assign({}, a, {
      $shared: !1
    }));
    const i = a.radius;
    return n !== "active" && (a.radius = 0), a.radius += ee(r && r._custom, i), a;
  }
}
A(ai, "id", "bubble"), A(ai, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), A(ai, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function TS(t, e, n) {
  let r = 1, a = 1, i = 0, o = 0;
  if (e < be) {
    const s = t, l = s + e, c = Math.cos(s), u = Math.sin(s), f = Math.cos(l), d = Math.sin(l), h = (C, x, y) => _r(C, s, l, !0) ? 1 : Math.max(x, x * n, y, y * n), m = (C, x, y) => _r(C, s, l, !0) ? -1 : Math.min(x, x * n, y, y * n), p = h(0, c, f), g = h(Te, u, d), v = m(ke, c, f), w = m(ke + Te, u, d);
    r = (p - v) / 2, a = (g - w) / 2, i = -(p + v) / 2, o = -(g + w) / 2;
  }
  return {
    ratioX: r,
    ratioY: a,
    offsetX: i,
    offsetY: o
  };
}
class cn extends ut {
  constructor(e, n) {
    super(e, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(e, n) {
    const r = this.getDataset().data, a = this._cachedMeta;
    if (this._parsing === !1)
      a._parsed = r;
    else {
      let i = (l) => +r[l];
      if (ae(r[e])) {
        const { key: l = "value" } = this._parsing;
        i = (c) => +Kt(r[c], l);
      }
      let o, s;
      for (o = e, s = e + n; o < s; ++o)
        a._parsed[o] = i(o);
    }
  }
  _getRotation() {
    return lt(this.options.rotation - 90);
  }
  _getCircumference() {
    return lt(this.options.circumference);
  }
  _getRotationExtents() {
    let e = be, n = -be;
    for (let r = 0; r < this.chart.data.datasets.length; ++r)
      if (this.chart.isDatasetVisible(r) && this.chart.getDatasetMeta(r).type === this._type) {
        const a = this.chart.getDatasetMeta(r).controller, i = a._getRotation(), o = a._getCircumference();
        e = Math.min(e, i), n = Math.max(n, i + o);
      }
    return {
      rotation: e,
      circumference: n - e
    };
  }
  update(e) {
    const n = this.chart, { chartArea: r } = n, a = this._cachedMeta, i = a.data, o = this.getMaxBorderWidth() + this.getMaxOffset(i) + this.options.spacing, s = Math.max((Math.min(r.width, r.height) - o) / 2, 0), l = Math.min(V6(this.options.cutout, s), 1), c = this._getRingWeight(this.index), { circumference: u, rotation: f } = this._getRotationExtents(), { ratioX: d, ratioY: h, offsetX: m, offsetY: p } = TS(f, u, l), g = (r.width - o) / d, v = (r.height - o) / h, w = Math.max(Math.min(g, v) / 2, 0), C = Bh(this.options.radius, w), x = Math.max(C * l, 0), y = (C - x) / this._getVisibleDatasetWeightTotal();
    this.offsetX = m * C, this.offsetY = p * C, a.total = this.calculateTotal(), this.outerRadius = C - y * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - y * c, 0), this.updateElements(i, 0, i.length, e);
  }
  _circumference(e, n) {
    const r = this.options, a = this._cachedMeta, i = this._getCircumference();
    return n && r.animation.animateRotate || !this.chart.getDataVisibility(e) || a._parsed[e] === null || a.data[e].hidden ? 0 : this.calculateCircumference(a._parsed[e] * i / be);
  }
  updateElements(e, n, r, a) {
    const i = a === "reset", o = this.chart, s = o.chartArea, c = o.options.animation, u = (s.left + s.right) / 2, f = (s.top + s.bottom) / 2, d = i && c.animateScale, h = d ? 0 : this.innerRadius, m = d ? 0 : this.outerRadius, { sharedOptions: p, includeOptions: g } = this._getSharedOptions(n, a);
    let v = this._getRotation(), w;
    for (w = 0; w < n; ++w)
      v += this._circumference(w, i);
    for (w = n; w < n + r; ++w) {
      const C = this._circumference(w, i), x = e[w], y = {
        x: u + this.offsetX,
        y: f + this.offsetY,
        startAngle: v,
        endAngle: v + C,
        circumference: C,
        outerRadius: m,
        innerRadius: h
      };
      g && (y.options = p || this.resolveDataElementOptions(w, x.active ? "active" : a)), v += C, this.updateElement(x, w, y, a);
    }
  }
  calculateTotal() {
    const e = this._cachedMeta, n = e.data;
    let r = 0, a;
    for (a = 0; a < n.length; a++) {
      const i = e._parsed[a];
      i !== null && !isNaN(i) && this.chart.getDataVisibility(a) && !n[a].hidden && (r += Math.abs(i));
    }
    return r;
  }
  calculateCircumference(e) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(e) ? be * (Math.abs(e) / n) : 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, r = this.chart, a = r.data.labels || [], i = jr(n._parsed[e], r.options.locale);
    return {
      label: a[e] || "",
      value: i
    };
  }
  getMaxBorderWidth(e) {
    let n = 0;
    const r = this.chart;
    let a, i, o, s, l;
    if (!e) {
      for (a = 0, i = r.data.datasets.length; a < i; ++a)
        if (r.isDatasetVisible(a)) {
          o = r.getDatasetMeta(a), e = o.data, s = o.controller;
          break;
        }
    }
    if (!e)
      return 0;
    for (a = 0, i = e.length; a < i; ++a)
      l = s.resolveDataElementOptions(a), l.borderAlign !== "inner" && (n = Math.max(n, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(e) {
    let n = 0;
    for (let r = 0, a = e.length; r < a; ++r) {
      const i = this.resolveDataElementOptions(r);
      n = Math.max(n, i.offset || 0, i.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(e) {
    let n = 0;
    for (let r = 0; r < e; ++r)
      this.chart.isDatasetVisible(r) && (n += this._getRingWeight(r));
    return n;
  }
  _getRingWeight(e) {
    return Math.max(ee(this.chart.data.datasets[e].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
A(cn, "id", "doughnut"), A(cn, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), A(cn, "descriptors", {
  _scriptable: (e) => e !== "spacing",
  _indexable: (e) => e !== "spacing" && !e.startsWith("borderDash") && !e.startsWith("hoverBorderDash")
}), A(cn, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const n = e.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: r, color: a } } = e.legend.options;
            return n.labels.map((i, o) => {
              const l = e.getDatasetMeta(0).controller.getStyle(o);
              return {
                text: i,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: a,
                lineWidth: l.borderWidth,
                pointStyle: r,
                hidden: !e.getDataVisibility(o),
                index: o
              };
            });
          }
          return [];
        }
      },
      onClick(e, n, r) {
        r.chart.toggleDataVisibility(n.index), r.chart.update();
      }
    }
  }
});
class ii extends ut {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(e) {
    const n = this._cachedMeta, { dataset: r, data: a = [], _dataset: i } = n, o = this.chart._animationsDisabled;
    let { start: s, count: l } = Xh(n, a, o);
    this._drawStart = s, this._drawCount = l, Kh(n) && (s = 0, l = a.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!i._decimated, r.points = a;
    const c = this.resolveDatasetElementOptions(e);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !o,
      options: c
    }, e), this.updateElements(a, s, l, e);
  }
  updateElements(e, n, r, a) {
    const i = a === "reset", { iScale: o, vScale: s, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: f } = this._getSharedOptions(n, a), d = o.axis, h = s.axis, { spanGaps: m, segment: p } = this.options, g = En(m) ? m : Number.POSITIVE_INFINITY, v = this.chart._animationsDisabled || i || a === "none", w = n + r, C = e.length;
    let x = n > 0 && this.getParsed(n - 1);
    for (let y = 0; y < C; ++y) {
      const _ = e[y], k = v ? _ : {};
      if (y < n || y >= w) {
        k.skip = !0;
        continue;
      }
      const P = this.getParsed(y), $ = se(P[h]), O = k[d] = o.getPixelForValue(P[d], y), D = k[h] = i || $ ? s.getBasePixel() : s.getPixelForValue(l ? this.applyStack(s, P, l) : P[h], y);
      k.skip = isNaN(O) || isNaN(D) || $, k.stop = y > 0 && Math.abs(P[d] - x[d]) > g, p && (k.parsed = P, k.raw = c.data[y]), f && (k.options = u || this.resolveDataElementOptions(y, _.active ? "active" : a)), v || this.updateElement(_, y, k, a), x = P;
    }
  }
  getMaxOverflow() {
    const e = this._cachedMeta, n = e.dataset, r = n.options && n.options.borderWidth || 0, a = e.data || [];
    if (!a.length)
      return r;
    const i = a[0].size(this.resolveDataElementOptions(0)), o = a[a.length - 1].size(this.resolveDataElementOptions(a.length - 1));
    return Math.max(r, i, o) / 2;
  }
  draw() {
    const e = this._cachedMeta;
    e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis), super.draw();
  }
}
A(ii, "id", "line"), A(ii, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), A(ii, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class cr extends ut {
  constructor(e, n) {
    super(e, n), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, r = this.chart, a = r.data.labels || [], i = jr(n._parsed[e].r, r.options.locale);
    return {
      label: a[e] || "",
      value: i
    };
  }
  parseObjectData(e, n, r, a) {
    return rp.bind(this)(e, n, r, a);
  }
  update(e) {
    const n = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(n, 0, n.length, e);
  }
  getMinMax() {
    const e = this._cachedMeta, n = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return e.data.forEach((r, a) => {
      const i = this.getParsed(a).r;
      !isNaN(i) && this.chart.getDataVisibility(a) && (i < n.min && (n.min = i), i > n.max && (n.max = i));
    }), n;
  }
  _updateRadius() {
    const e = this.chart, n = e.chartArea, r = e.options, a = Math.min(n.right - n.left, n.bottom - n.top), i = Math.max(a / 2, 0), o = Math.max(r.cutoutPercentage ? i / 100 * r.cutoutPercentage : 1, 0), s = (i - o) / e.getVisibleDatasetCount();
    this.outerRadius = i - s * this.index, this.innerRadius = this.outerRadius - s;
  }
  updateElements(e, n, r, a) {
    const i = a === "reset", o = this.chart, l = o.options.animation, c = this._cachedMeta.rScale, u = c.xCenter, f = c.yCenter, d = c.getIndexAngle(0) - 0.5 * ke;
    let h = d, m;
    const p = 360 / this.countVisibleElements();
    for (m = 0; m < n; ++m)
      h += this._computeAngle(m, a, p);
    for (m = n; m < n + r; m++) {
      const g = e[m];
      let v = h, w = h + this._computeAngle(m, a, p), C = o.getDataVisibility(m) ? c.getDistanceFromCenterForValue(this.getParsed(m).r) : 0;
      h = w, i && (l.animateScale && (C = 0), l.animateRotate && (v = w = d));
      const x = {
        x: u,
        y: f,
        innerRadius: 0,
        outerRadius: C,
        startAngle: v,
        endAngle: w,
        options: this.resolveDataElementOptions(m, g.active ? "active" : a)
      };
      this.updateElement(g, m, x, a);
    }
  }
  countVisibleElements() {
    const e = this._cachedMeta;
    let n = 0;
    return e.data.forEach((r, a) => {
      !isNaN(this.getParsed(a).r) && this.chart.getDataVisibility(a) && n++;
    }), n;
  }
  _computeAngle(e, n, r) {
    return this.chart.getDataVisibility(e) ? lt(this.resolveDataElementOptions(e, n).angle || r) : 0;
  }
}
A(cr, "id", "polarArea"), A(cr, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), A(cr, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const n = e.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: r, color: a } } = e.legend.options;
            return n.labels.map((i, o) => {
              const l = e.getDatasetMeta(0).controller.getStyle(o);
              return {
                text: i,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: a,
                lineWidth: l.borderWidth,
                pointStyle: r,
                hidden: !e.getDataVisibility(o),
                index: o
              };
            });
          }
          return [];
        }
      },
      onClick(e, n, r) {
        r.chart.toggleDataVisibility(n.index), r.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class pl extends cn {
}
A(pl, "id", "pie"), A(pl, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class oi extends ut {
  getLabelAndValue(e) {
    const n = this._cachedMeta.vScale, r = this.getParsed(e);
    return {
      label: n.getLabels()[e],
      value: "" + n.getLabelForValue(r[n.axis])
    };
  }
  parseObjectData(e, n, r, a) {
    return rp.bind(this)(e, n, r, a);
  }
  update(e) {
    const n = this._cachedMeta, r = n.dataset, a = n.data || [], i = n.iScale.getLabels();
    if (r.points = a, e !== "resize") {
      const o = this.resolveDatasetElementOptions(e);
      this.options.showLine || (o.borderWidth = 0);
      const s = {
        _loop: !0,
        _fullLoop: i.length === a.length,
        options: o
      };
      this.updateElement(r, void 0, s, e);
    }
    this.updateElements(a, 0, a.length, e);
  }
  updateElements(e, n, r, a) {
    const i = this._cachedMeta.rScale, o = a === "reset";
    for (let s = n; s < n + r; s++) {
      const l = e[s], c = this.resolveDataElementOptions(s, l.active ? "active" : a), u = i.getPointPositionForValue(s, this.getParsed(s).r), f = o ? i.xCenter : u.x, d = o ? i.yCenter : u.y, h = {
        x: f,
        y: d,
        angle: u.angle,
        skip: isNaN(f) || isNaN(d),
        options: c
      };
      this.updateElement(l, s, h, a);
    }
  }
}
A(oi, "id", "radar"), A(oi, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), A(oi, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class si extends ut {
  getLabelAndValue(e) {
    const n = this._cachedMeta, r = this.chart.data.labels || [], { xScale: a, yScale: i } = n, o = this.getParsed(e), s = a.getLabelForValue(o.x), l = i.getLabelForValue(o.y);
    return {
      label: r[e] || "",
      value: "(" + s + ", " + l + ")"
    };
  }
  update(e) {
    const n = this._cachedMeta, { data: r = [] } = n, a = this.chart._animationsDisabled;
    let { start: i, count: o } = Xh(n, r, a);
    if (this._drawStart = i, this._drawCount = o, Kh(n) && (i = 0, o = r.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: s, _dataset: l } = n;
      s._chart = this.chart, s._datasetIndex = this.index, s._decimated = !!l._decimated, s.points = r;
      const c = this.resolveDatasetElementOptions(e);
      c.segment = this.options.segment, this.updateElement(s, void 0, {
        animated: !a,
        options: c
      }, e);
    } else
      this.datasetElementType && (delete n.dataset, this.datasetElementType = !1);
    this.updateElements(r, i, o, e);
  }
  addElements() {
    const { showLine: e } = this.options;
    !this.datasetElementType && e && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(e, n, r, a) {
    const i = a === "reset", { iScale: o, vScale: s, _stacked: l, _dataset: c } = this._cachedMeta, u = this.resolveDataElementOptions(n, a), f = this.getSharedOptions(u), d = this.includeOptions(a, f), h = o.axis, m = s.axis, { spanGaps: p, segment: g } = this.options, v = En(p) ? p : Number.POSITIVE_INFINITY, w = this.chart._animationsDisabled || i || a === "none";
    let C = n > 0 && this.getParsed(n - 1);
    for (let x = n; x < n + r; ++x) {
      const y = e[x], _ = this.getParsed(x), k = w ? y : {}, P = se(_[m]), $ = k[h] = o.getPixelForValue(_[h], x), O = k[m] = i || P ? s.getBasePixel() : s.getPixelForValue(l ? this.applyStack(s, _, l) : _[m], x);
      k.skip = isNaN($) || isNaN(O) || P, k.stop = x > 0 && Math.abs(_[h] - C[h]) > v, g && (k.parsed = _, k.raw = c.data[x]), d && (k.options = f || this.resolveDataElementOptions(x, y.active ? "active" : a)), w || this.updateElement(y, x, k, a), C = _;
    }
    this.updateSharedOptions(f, a, u);
  }
  getMaxOverflow() {
    const e = this._cachedMeta, n = e.data || [];
    if (!this.options.showLine) {
      let s = 0;
      for (let l = n.length - 1; l >= 0; --l)
        s = Math.max(s, n[l].size(this.resolveDataElementOptions(l)) / 2);
      return s > 0 && s;
    }
    const r = e.dataset, a = r.options && r.options.borderWidth || 0;
    if (!n.length)
      return a;
    const i = n[0].size(this.resolveDataElementOptions(0)), o = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(a, i, o) / 2;
  }
}
A(si, "id", "scatter"), A(si, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), A(si, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var $S = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: ri,
  BubbleController: ai,
  DoughnutController: cn,
  LineController: ii,
  PieController: pl,
  PolarAreaController: cr,
  RadarController: oi,
  ScatterController: si
});
function rn() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class cc {
  constructor(e) {
    A(this, "options");
    this.options = e || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(e) {
    Object.assign(cc.prototype, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return rn();
  }
  parse() {
    return rn();
  }
  format() {
    return rn();
  }
  add() {
    return rn();
  }
  diff() {
    return rn();
  }
  startOf() {
    return rn();
  }
  endOf() {
    return rn();
  }
}
var RS = {
  _date: cc
};
function ES(t, e, n, r) {
  const { controller: a, data: i, _sorted: o } = t, s = a._cachedMeta.iScale;
  if (s && e === s.axis && e !== "r" && o && i.length) {
    const l = s._reversePixels ? nP : $t;
    if (r) {
      if (a._sharedOptions) {
        const c = i[0], u = typeof c.getRange == "function" && c.getRange(e);
        if (u) {
          const f = l(i, e, n - u), d = l(i, e, n + u);
          return {
            lo: f.lo,
            hi: d.hi
          };
        }
      }
    } else
      return l(i, e, n);
  }
  return {
    lo: 0,
    hi: i.length - 1
  };
}
function Vr(t, e, n, r, a) {
  const i = t.getSortedVisibleDatasetMetas(), o = n[e];
  for (let s = 0, l = i.length; s < l; ++s) {
    const { index: c, data: u } = i[s], { lo: f, hi: d } = ES(i[s], e, o, a);
    for (let h = f; h <= d; ++h) {
      const m = u[h];
      m.skip || r(m, c, h);
    }
  }
}
function AS(t) {
  const e = t.indexOf("x") !== -1, n = t.indexOf("y") !== -1;
  return function(r, a) {
    const i = e ? Math.abs(r.x - a.x) : 0, o = n ? Math.abs(r.y - a.y) : 0;
    return Math.sqrt(Math.pow(i, 2) + Math.pow(o, 2));
  };
}
function Wo(t, e, n, r, a) {
  const i = [];
  return !a && !t.isPointInArea(e) || Vr(t, n, e, function(s, l, c) {
    !a && !Rt(s, t.chartArea, 0) || s.inRange(e.x, e.y, r) && i.push({
      element: s,
      datasetIndex: l,
      index: c
    });
  }, !0), i;
}
function LS(t, e, n, r) {
  let a = [];
  function i(o, s, l) {
    const { startAngle: c, endAngle: u } = o.getProps([
      "startAngle",
      "endAngle"
    ], r), { angle: f } = jh(o, {
      x: e.x,
      y: e.y
    });
    _r(f, c, u) && a.push({
      element: o,
      datasetIndex: s,
      index: l
    });
  }
  return Vr(t, n, e, i), a;
}
function IS(t, e, n, r, a, i) {
  let o = [];
  const s = AS(n);
  let l = Number.POSITIVE_INFINITY;
  function c(u, f, d) {
    const h = u.inRange(e.x, e.y, a);
    if (r && !h)
      return;
    const m = u.getCenterPoint(a);
    if (!(!!i || t.isPointInArea(m)) && !h)
      return;
    const g = s(e, m);
    g < l ? (o = [
      {
        element: u,
        datasetIndex: f,
        index: d
      }
    ], l = g) : g === l && o.push({
      element: u,
      datasetIndex: f,
      index: d
    });
  }
  return Vr(t, n, e, c), o;
}
function zo(t, e, n, r, a, i) {
  return !i && !t.isPointInArea(e) ? [] : n === "r" && !r ? LS(t, e, n, a) : IS(t, e, n, r, a, i);
}
function Ed(t, e, n, r, a) {
  const i = [], o = n === "x" ? "inXRange" : "inYRange";
  let s = !1;
  return Vr(t, n, e, (l, c, u) => {
    l[o](e[n], a) && (i.push({
      element: l,
      datasetIndex: c,
      index: u
    }), s = s || l.inRange(e.x, e.y, a));
  }), r && !s ? [] : i;
}
var NS = {
  evaluateInteractionItems: Vr,
  modes: {
    index(t, e, n, r) {
      const a = sn(e, t), i = n.axis || "x", o = n.includeInvisible || !1, s = n.intersect ? Wo(t, a, i, r, o) : zo(t, a, i, !1, r, o), l = [];
      return s.length ? (t.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = s[0].index, f = c.data[u];
        f && !f.skip && l.push({
          element: f,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(t, e, n, r) {
      const a = sn(e, t), i = n.axis || "xy", o = n.includeInvisible || !1;
      let s = n.intersect ? Wo(t, a, i, r, o) : zo(t, a, i, !1, r, o);
      if (s.length > 0) {
        const l = s[0].datasetIndex, c = t.getDatasetMeta(l).data;
        s = [];
        for (let u = 0; u < c.length; ++u)
          s.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return s;
    },
    point(t, e, n, r) {
      const a = sn(e, t), i = n.axis || "xy", o = n.includeInvisible || !1;
      return Wo(t, a, i, r, o);
    },
    nearest(t, e, n, r) {
      const a = sn(e, t), i = n.axis || "xy", o = n.includeInvisible || !1;
      return zo(t, a, i, n.intersect, r, o);
    },
    x(t, e, n, r) {
      const a = sn(e, t);
      return Ed(t, a, "x", n.intersect, r);
    },
    y(t, e, n, r) {
      const a = sn(e, t);
      return Ed(t, a, "y", n.intersect, r);
    }
  }
};
const pp = [
  "left",
  "top",
  "right",
  "bottom"
];
function Un(t, e) {
  return t.filter((n) => n.pos === e);
}
function Ad(t, e) {
  return t.filter((n) => pp.indexOf(n.pos) === -1 && n.box.axis === e);
}
function Yn(t, e) {
  return t.sort((n, r) => {
    const a = e ? r : n, i = e ? n : r;
    return a.weight === i.weight ? a.index - i.index : a.weight - i.weight;
  });
}
function WS(t) {
  const e = [];
  let n, r, a, i, o, s;
  for (n = 0, r = (t || []).length; n < r; ++n)
    a = t[n], { position: i, options: { stack: o, stackWeight: s = 1 } } = a, e.push({
      index: n,
      box: a,
      pos: i,
      horizontal: a.isHorizontal(),
      weight: a.weight,
      stack: o && i + o,
      stackWeight: s
    });
  return e;
}
function zS(t) {
  const e = {};
  for (const n of t) {
    const { stack: r, pos: a, stackWeight: i } = n;
    if (!r || !pp.includes(a))
      continue;
    const o = e[r] || (e[r] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    o.count++, o.weight += i;
  }
  return e;
}
function BS(t, e) {
  const n = zS(t), { vBoxMaxWidth: r, hBoxMaxHeight: a } = e;
  let i, o, s;
  for (i = 0, o = t.length; i < o; ++i) {
    s = t[i];
    const { fullSize: l } = s.box, c = n[s.stack], u = c && s.stackWeight / c.weight;
    s.horizontal ? (s.width = u ? u * r : l && e.availableWidth, s.height = a) : (s.width = r, s.height = u ? u * a : l && e.availableHeight);
  }
  return n;
}
function FS(t) {
  const e = WS(t), n = Yn(e.filter((c) => c.box.fullSize), !0), r = Yn(Un(e, "left"), !0), a = Yn(Un(e, "right")), i = Yn(Un(e, "top"), !0), o = Yn(Un(e, "bottom")), s = Ad(e, "x"), l = Ad(e, "y");
  return {
    fullSize: n,
    leftAndTop: r.concat(i),
    rightAndBottom: a.concat(l).concat(o).concat(s),
    chartArea: Un(e, "chartArea"),
    vertical: r.concat(a).concat(l),
    horizontal: i.concat(o).concat(s)
  };
}
function Ld(t, e, n, r) {
  return Math.max(t[n], e[n]) + Math.max(t[r], e[r]);
}
function mp(t, e) {
  t.top = Math.max(t.top, e.top), t.left = Math.max(t.left, e.left), t.bottom = Math.max(t.bottom, e.bottom), t.right = Math.max(t.right, e.right);
}
function HS(t, e, n, r) {
  const { pos: a, box: i } = n, o = t.maxPadding;
  if (!ae(a)) {
    n.size && (t[a] -= n.size);
    const f = r[n.stack] || {
      size: 0,
      count: 1
    };
    f.size = Math.max(f.size, n.horizontal ? i.height : i.width), n.size = f.size / f.count, t[a] += n.size;
  }
  i.getPadding && mp(o, i.getPadding());
  const s = Math.max(0, e.outerWidth - Ld(o, t, "left", "right")), l = Math.max(0, e.outerHeight - Ld(o, t, "top", "bottom")), c = s !== t.w, u = l !== t.h;
  return t.w = s, t.h = l, n.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function jS(t) {
  const e = t.maxPadding;
  function n(r) {
    const a = Math.max(e[r] - t[r], 0);
    return t[r] += a, a;
  }
  t.y += n("top"), t.x += n("left"), n("right"), n("bottom");
}
function VS(t, e) {
  const n = e.maxPadding;
  function r(a) {
    const i = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return a.forEach((o) => {
      i[o] = Math.max(e[o], n[o]);
    }), i;
  }
  return r(t ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Zn(t, e, n, r) {
  const a = [];
  let i, o, s, l, c, u;
  for (i = 0, o = t.length, c = 0; i < o; ++i) {
    s = t[i], l = s.box, l.update(s.width || e.w, s.height || e.h, VS(s.horizontal, e));
    const { same: f, other: d } = HS(e, n, s, r);
    c |= f && a.length, u = u || d, l.fullSize || a.push(s);
  }
  return c && Zn(a, e, n, r) || u;
}
function ia(t, e, n, r, a) {
  t.top = n, t.left = e, t.right = e + r, t.bottom = n + a, t.width = r, t.height = a;
}
function Id(t, e, n, r) {
  const a = n.padding;
  let { x: i, y: o } = e;
  for (const s of t) {
    const l = s.box, c = r[s.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, u = s.stackWeight / c.weight || 1;
    if (s.horizontal) {
      const f = e.w * u, d = c.size || l.height;
      br(c.start) && (o = c.start), l.fullSize ? ia(l, a.left, o, n.outerWidth - a.right - a.left, d) : ia(l, e.left + c.placed, o, f, d), c.start = o, c.placed += f, o = l.bottom;
    } else {
      const f = e.h * u, d = c.size || l.width;
      br(c.start) && (i = c.start), l.fullSize ? ia(l, i, a.top, d, n.outerHeight - a.bottom - a.top) : ia(l, i, e.top + c.placed, d, f), c.start = i, c.placed += f, i = l.right;
    }
  }
  e.x = i, e.y = o;
}
var Be = {
  addBox(t, e) {
    t.boxes || (t.boxes = []), e.fullSize = e.fullSize || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            e.draw(n);
          }
        }
      ];
    }, t.boxes.push(e);
  },
  removeBox(t, e) {
    const n = t.boxes ? t.boxes.indexOf(e) : -1;
    n !== -1 && t.boxes.splice(n, 1);
  },
  configure(t, e, n) {
    e.fullSize = n.fullSize, e.position = n.position, e.weight = n.weight;
  },
  update(t, e, n, r) {
    if (!t)
      return;
    const a = Fe(t.options.layout.padding), i = Math.max(e - a.width, 0), o = Math.max(n - a.height, 0), s = FS(t.boxes), l = s.vertical, c = s.horizontal;
    he(t.boxes, (p) => {
      typeof p.beforeLayout == "function" && p.beforeLayout();
    });
    const u = l.reduce((p, g) => g.box.options && g.box.options.display === !1 ? p : p + 1, 0) || 1, f = Object.freeze({
      outerWidth: e,
      outerHeight: n,
      padding: a,
      availableWidth: i,
      availableHeight: o,
      vBoxMaxWidth: i / 2 / u,
      hBoxMaxHeight: o / 2
    }), d = Object.assign({}, a);
    mp(d, Fe(r));
    const h = Object.assign({
      maxPadding: d,
      w: i,
      h: o,
      x: a.left,
      y: a.top
    }, a), m = BS(l.concat(c), f);
    Zn(s.fullSize, h, f, m), Zn(l, h, f, m), Zn(c, h, f, m) && Zn(l, h, f, m), jS(h), Id(s.leftAndTop, h, f, m), h.x += h.w, h.y += h.h, Id(s.rightAndBottom, h, f, m), t.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, he(s.chartArea, (p) => {
      const g = p.box;
      Object.assign(g, t.chartArea), g.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class gp {
  acquireContext(e, n) {
  }
  releaseContext(e) {
    return !1;
  }
  addEventListener(e, n, r) {
  }
  removeEventListener(e, n, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(e, n, r, a) {
    return n = Math.max(0, n || e.width), r = r || e.height, {
      width: n,
      height: Math.max(0, a ? Math.floor(n / a) : r)
    };
  }
  isAttached(e) {
    return !0;
  }
  updateConfig(e) {
  }
}
class qS extends gp {
  acquireContext(e) {
    return e && e.getContext && e.getContext("2d") || null;
  }
  updateConfig(e) {
    e.options.animation = !1;
  }
}
const li = "$chartjs", US = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Nd = (t) => t === null || t === "";
function YS(t, e) {
  const n = t.style, r = t.getAttribute("height"), a = t.getAttribute("width");
  if (t[li] = {
    initial: {
      height: r,
      width: a,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", Nd(a)) {
    const i = bd(t, "width");
    i !== void 0 && (t.width = i);
  }
  if (Nd(r))
    if (t.style.height === "")
      t.height = t.width / (e || 2);
    else {
      const i = bd(t, "height");
      i !== void 0 && (t.height = i);
    }
  return t;
}
const vp = KP ? {
  passive: !0
} : !1;
function XS(t, e, n) {
  t.addEventListener(e, n, vp);
}
function KS(t, e, n) {
  t.canvas.removeEventListener(e, n, vp);
}
function QS(t, e) {
  const n = US[t.type] || t.type, { x: r, y: a } = sn(t, e);
  return {
    type: n,
    chart: e,
    native: t,
    x: r !== void 0 ? r : null,
    y: a !== void 0 ? a : null
  };
}
function no(t, e) {
  for (const n of t)
    if (n === e || n.contains(e))
      return !0;
}
function GS(t, e, n) {
  const r = t.canvas, a = new MutationObserver((i) => {
    let o = !1;
    for (const s of i)
      o = o || no(s.addedNodes, r), o = o && !no(s.removedNodes, r);
    o && n();
  });
  return a.observe(document, {
    childList: !0,
    subtree: !0
  }), a;
}
function ZS(t, e, n) {
  const r = t.canvas, a = new MutationObserver((i) => {
    let o = !1;
    for (const s of i)
      o = o || no(s.removedNodes, r), o = o && !no(s.addedNodes, r);
    o && n();
  });
  return a.observe(document, {
    childList: !0,
    subtree: !0
  }), a;
}
const kr = /* @__PURE__ */ new Map();
let Wd = 0;
function yp() {
  const t = window.devicePixelRatio;
  t !== Wd && (Wd = t, kr.forEach((e, n) => {
    n.currentDevicePixelRatio !== t && e();
  }));
}
function JS(t, e) {
  kr.size || window.addEventListener("resize", yp), kr.set(t, e);
}
function eM(t) {
  kr.delete(t), kr.size || window.removeEventListener("resize", yp);
}
function tM(t, e, n) {
  const r = t.canvas, a = r && lc(r);
  if (!a)
    return;
  const i = Yh((s, l) => {
    const c = a.clientWidth;
    n(s, l), c < a.clientWidth && n();
  }, window), o = new ResizeObserver((s) => {
    const l = s[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || i(c, u);
  });
  return o.observe(a), JS(t, i), o;
}
function Bo(t, e, n) {
  n && n.disconnect(), e === "resize" && eM(t);
}
function nM(t, e, n) {
  const r = t.canvas, a = Yh((i) => {
    t.ctx !== null && n(QS(i, t));
  }, t);
  return XS(r, e, a), a;
}
class rM extends gp {
  acquireContext(e, n) {
    const r = e && e.getContext && e.getContext("2d");
    return r && r.canvas === e ? (YS(e, n), r) : null;
  }
  releaseContext(e) {
    const n = e.canvas;
    if (!n[li])
      return !1;
    const r = n[li].initial;
    [
      "height",
      "width"
    ].forEach((i) => {
      const o = r[i];
      se(o) ? n.removeAttribute(i) : n.setAttribute(i, o);
    });
    const a = r.style || {};
    return Object.keys(a).forEach((i) => {
      n.style[i] = a[i];
    }), n.width = n.width, delete n[li], !0;
  }
  addEventListener(e, n, r) {
    this.removeEventListener(e, n);
    const a = e.$proxies || (e.$proxies = {}), o = {
      attach: GS,
      detach: ZS,
      resize: tM
    }[n] || nM;
    a[n] = o(e, n, r);
  }
  removeEventListener(e, n) {
    const r = e.$proxies || (e.$proxies = {}), a = r[n];
    if (!a)
      return;
    ({
      attach: Bo,
      detach: Bo,
      resize: Bo
    }[n] || KS)(e, n, a), r[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(e, n, r, a) {
    return XP(e, n, r, a);
  }
  isAttached(e) {
    const n = lc(e);
    return !!(n && n.isConnected);
  }
}
function aM(t) {
  return !ip() || typeof OffscreenCanvas < "u" && t instanceof OffscreenCanvas ? qS : rM;
}
var ma;
let It = (ma = class {
  constructor() {
    A(this, "x");
    A(this, "y");
    A(this, "active", !1);
    A(this, "options");
    A(this, "$animations");
  }
  tooltipPosition(e) {
    const { x: n, y: r } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: n,
      y: r
    };
  }
  hasValue() {
    return En(this.x) && En(this.y);
  }
  getProps(e, n) {
    const r = this.$animations;
    if (!n || !r)
      return this;
    const a = {};
    return e.forEach((i) => {
      a[i] = r[i] && r[i].active() ? r[i]._to : this[i];
    }), a;
  }
}, A(ma, "defaults", {}), A(ma, "defaultRoutes"), ma);
function iM(t, e) {
  const n = t.options.ticks, r = oM(t), a = Math.min(n.maxTicksLimit || r, r), i = n.major.enabled ? lM(e) : [], o = i.length, s = i[0], l = i[o - 1], c = [];
  if (o > a)
    return cM(e, c, i, o / a), c;
  const u = sM(i, e, a);
  if (o > 0) {
    let f, d;
    const h = o > 1 ? Math.round((l - s) / (o - 1)) : null;
    for (oa(e, c, u, se(h) ? 0 : s - h, s), f = 0, d = o - 1; f < d; f++)
      oa(e, c, u, i[f], i[f + 1]);
    return oa(e, c, u, l, se(h) ? e.length : l + h), c;
  }
  return oa(e, c, u), c;
}
function oM(t) {
  const e = t.options.offset, n = t._tickSize(), r = t._length / n + (e ? 0 : 1), a = t._maxLength / n;
  return Math.floor(Math.min(r, a));
}
function sM(t, e, n) {
  const r = uM(t), a = e.length / n;
  if (!r)
    return Math.max(a, 1);
  const i = Z6(r);
  for (let o = 0, s = i.length - 1; o < s; o++) {
    const l = i[o];
    if (l > a)
      return l;
  }
  return Math.max(a, 1);
}
function lM(t) {
  const e = [];
  let n, r;
  for (n = 0, r = t.length; n < r; n++)
    t[n].major && e.push(n);
  return e;
}
function cM(t, e, n, r) {
  let a = 0, i = n[0], o;
  for (r = Math.ceil(r), o = 0; o < t.length; o++)
    o === i && (e.push(t[o]), a++, i = n[a * r]);
}
function oa(t, e, n, r, a) {
  const i = ee(r, 0), o = Math.min(ee(a, t.length), t.length);
  let s = 0, l, c, u;
  for (n = Math.ceil(n), a && (l = a - r, n = l / Math.floor(l / n)), u = i; u < 0; )
    s++, u = Math.round(i + s * n);
  for (c = Math.max(i, 0); c < o; c++)
    c === u && (e.push(t[c]), s++, u = Math.round(i + s * n));
}
function uM(t) {
  const e = t.length;
  let n, r;
  if (e < 2)
    return !1;
  for (r = t[0], n = 1; n < e; ++n)
    if (t[n] - t[n - 1] !== r)
      return !1;
  return r;
}
const dM = (t) => t === "left" ? "right" : t === "right" ? "left" : t, zd = (t, e, n) => e === "top" || e === "left" ? t[e] + n : t[e] - n, Bd = (t, e) => Math.min(e || t, t);
function Fd(t, e) {
  const n = [], r = t.length / e, a = t.length;
  let i = 0;
  for (; i < a; i += r)
    n.push(t[Math.floor(i)]);
  return n;
}
function fM(t, e, n) {
  const r = t.ticks.length, a = Math.min(e, r - 1), i = t._startPixel, o = t._endPixel, s = 1e-6;
  let l = t.getPixelForTick(a), c;
  if (!(n && (r === 1 ? c = Math.max(l - i, o - l) : e === 0 ? c = (t.getPixelForTick(1) - l) / 2 : c = (l - t.getPixelForTick(a - 1)) / 2, l += a < e ? c : -c, l < i - s || l > o + s)))
    return l;
}
function hM(t, e) {
  he(t, (n) => {
    const r = n.gc, a = r.length / 2;
    let i;
    if (a > e) {
      for (i = 0; i < a; ++i)
        delete n.data[r[i]];
      r.splice(0, a);
    }
  });
}
function Xn(t) {
  return t.drawTicks ? t.tickLength : 0;
}
function Hd(t, e) {
  if (!t.display)
    return 0;
  const n = $e(t.font, e), r = Fe(t.padding);
  return (ye(t.text) ? t.text.length : 1) * n.lineHeight + r.height;
}
function pM(t, e) {
  return Zt(t, {
    scale: e,
    type: "scale"
  });
}
function mM(t, e, n) {
  return Zt(t, {
    tick: n,
    index: e,
    type: "tick"
  });
}
function gM(t, e, n) {
  let r = nc(t);
  return (n && e !== "right" || !n && e === "right") && (r = dM(r)), r;
}
function vM(t, e, n, r) {
  const { top: a, left: i, bottom: o, right: s, chart: l } = t, { chartArea: c, scales: u } = l;
  let f = 0, d, h, m;
  const p = o - a, g = s - i;
  if (t.isHorizontal()) {
    if (h = We(r, i, s), ae(n)) {
      const v = Object.keys(n)[0], w = n[v];
      m = u[v].getPixelForValue(w) + p - e;
    } else
      n === "center" ? m = (c.bottom + c.top) / 2 + p - e : m = zd(t, n, e);
    d = s - i;
  } else {
    if (ae(n)) {
      const v = Object.keys(n)[0], w = n[v];
      h = u[v].getPixelForValue(w) - g + e;
    } else
      n === "center" ? h = (c.left + c.right) / 2 - g + e : h = zd(t, n, e);
    m = We(r, o, a), f = n === "left" ? -Te : Te;
  }
  return {
    titleX: h,
    titleY: m,
    maxWidth: d,
    rotation: f
  };
}
class bn extends It {
  constructor(e) {
    super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(e) {
    this.options = e.setContext(this.getContext()), this.axis = e.axis, this._userMin = this.parse(e.min), this._userMax = this.parse(e.max), this._suggestedMin = this.parse(e.suggestedMin), this._suggestedMax = this.parse(e.suggestedMax);
  }
  parse(e, n) {
    return e;
  }
  getUserBounds() {
    let { _userMin: e, _userMax: n, _suggestedMin: r, _suggestedMax: a } = this;
    return e = Ge(e, Number.POSITIVE_INFINITY), n = Ge(n, Number.NEGATIVE_INFINITY), r = Ge(r, Number.POSITIVE_INFINITY), a = Ge(a, Number.NEGATIVE_INFINITY), {
      min: Ge(e, r),
      max: Ge(n, a),
      minDefined: Pe(e),
      maxDefined: Pe(n)
    };
  }
  getMinMax(e) {
    let { min: n, max: r, minDefined: a, maxDefined: i } = this.getUserBounds(), o;
    if (a && i)
      return {
        min: n,
        max: r
      };
    const s = this.getMatchingVisibleMetas();
    for (let l = 0, c = s.length; l < c; ++l)
      o = s[l].controller.getMinMax(this, e), a || (n = Math.min(n, o.min)), i || (r = Math.max(r, o.max));
    return n = i && n > r ? r : n, r = a && n > r ? n : r, {
      min: Ge(n, Ge(r, n)),
      max: Ge(r, Ge(n, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const e = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || [];
  }
  getLabelItems(e = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(e));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    ge(this.options.beforeUpdate, [
      this
    ]);
  }
  update(e, n, r) {
    const { beginAtZero: a, grace: i, ticks: o } = this.options, s = o.sampleSize;
    this.beforeUpdate(), this.maxWidth = e, this.maxHeight = n, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = SP(this, i, a), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = s < this.ticks.length;
    this._convertTicksToLabels(l ? Fd(this.ticks, s) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), o.display && (o.autoSkip || o.source === "auto") && (this.ticks = iM(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let e = this.options.reverse, n, r;
    this.isHorizontal() ? (n = this.left, r = this.right) : (n = this.top, r = this.bottom, e = !e), this._startPixel = n, this._endPixel = r, this._reversePixels = e, this._length = r - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    ge(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    ge(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    ge(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(e) {
    this.chart.notifyPlugins(e, this.getContext()), ge(this.options[e], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    ge(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(e) {
    const n = this.options.ticks;
    let r, a, i;
    for (r = 0, a = e.length; r < a; r++)
      i = e[r], i.label = ge(n.callback, [
        i.value,
        r,
        e
      ], this);
  }
  afterTickToLabelConversion() {
    ge(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    ge(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const e = this.options, n = e.ticks, r = Bd(this.ticks.length, e.ticks.maxTicksLimit), a = n.minRotation || 0, i = n.maxRotation;
    let o = a, s, l, c;
    if (!this._isVisible() || !n.display || a >= i || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = a;
      return;
    }
    const u = this._getLabelSizes(), f = u.widest.width, d = u.highest.height, h = Ae(this.chart.width - f, 0, this.maxWidth);
    s = e.offset ? this.maxWidth / r : h / (r - 1), f + 6 > s && (s = h / (r - (e.offset ? 0.5 : 1)), l = this.maxHeight - Xn(e.grid) - n.padding - Hd(e.title, this.chart.options.font), c = Math.sqrt(f * f + d * d), o = ec(Math.min(Math.asin(Ae((u.highest.height + 6) / s, -1, 1)), Math.asin(Ae(l / c, -1, 1)) - Math.asin(Ae(d / c, -1, 1)))), o = Math.max(a, Math.min(i, o))), this.labelRotation = o;
  }
  afterCalculateLabelRotation() {
    ge(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    ge(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const e = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: r, title: a, grid: i } } = this, o = this._isVisible(), s = this.isHorizontal();
    if (o) {
      const l = Hd(a, n.options.font);
      if (s ? (e.width = this.maxWidth, e.height = Xn(i) + l) : (e.height = this.maxHeight, e.width = Xn(i) + l), r.display && this.ticks.length) {
        const { first: c, last: u, widest: f, highest: d } = this._getLabelSizes(), h = r.padding * 2, m = lt(this.labelRotation), p = Math.cos(m), g = Math.sin(m);
        if (s) {
          const v = r.mirror ? 0 : g * f.width + p * d.height;
          e.height = Math.min(this.maxHeight, e.height + v + h);
        } else {
          const v = r.mirror ? 0 : p * f.width + g * d.height;
          e.width = Math.min(this.maxWidth, e.width + v + h);
        }
        this._calculatePadding(c, u, g, p);
      }
    }
    this._handleMargins(), s ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = e.height) : (this.width = e.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(e, n, r, a) {
    const { ticks: { align: i, padding: o }, position: s } = this.options, l = this.labelRotation !== 0, c = s !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, f = this.right - this.getPixelForTick(this.ticks.length - 1);
      let d = 0, h = 0;
      l ? c ? (d = a * e.width, h = r * n.height) : (d = r * e.height, h = a * n.width) : i === "start" ? h = n.width : i === "end" ? d = e.width : i !== "inner" && (d = e.width / 2, h = n.width / 2), this.paddingLeft = Math.max((d - u + o) * this.width / (this.width - u), 0), this.paddingRight = Math.max((h - f + o) * this.width / (this.width - f), 0);
    } else {
      let u = n.height / 2, f = e.height / 2;
      i === "start" ? (u = 0, f = e.height) : i === "end" && (u = n.height, f = 0), this.paddingTop = u + o, this.paddingBottom = f + o;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    ge(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: e, position: n } = this.options;
    return n === "top" || n === "bottom" || e === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(e) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(e);
    let n, r;
    for (n = 0, r = e.length; n < r; n++)
      se(e[n].label) && (e.splice(n, 1), r--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let e = this._labelSizes;
    if (!e) {
      const n = this.options.ticks.sampleSize;
      let r = this.ticks;
      n < r.length && (r = Fd(r, n)), this._labelSizes = e = this._computeLabelSizes(r, r.length, this.options.ticks.maxTicksLimit);
    }
    return e;
  }
  _computeLabelSizes(e, n, r) {
    const { ctx: a, _longestTextCache: i } = this, o = [], s = [], l = Math.floor(n / Bd(n, r));
    let c = 0, u = 0, f, d, h, m, p, g, v, w, C, x, y;
    for (f = 0; f < n; f += l) {
      if (m = e[f].label, p = this._resolveTickFontOptions(f), a.font = g = p.string, v = i[g] = i[g] || {
        data: {},
        gc: []
      }, w = p.lineHeight, C = x = 0, !se(m) && !ye(m))
        C = eo(a, v.data, v.gc, C, m), x = w;
      else if (ye(m))
        for (d = 0, h = m.length; d < h; ++d)
          y = m[d], !se(y) && !ye(y) && (C = eo(a, v.data, v.gc, C, y), x += w);
      o.push(C), s.push(x), c = Math.max(C, c), u = Math.max(x, u);
    }
    hM(i, n);
    const _ = o.indexOf(c), k = s.indexOf(u), P = ($) => ({
      width: o[$] || 0,
      height: s[$] || 0
    });
    return {
      first: P(0),
      last: P(n - 1),
      widest: P(_),
      highest: P(k),
      widths: o,
      heights: s
    };
  }
  getLabelForValue(e) {
    return e;
  }
  getPixelForValue(e, n) {
    return NaN;
  }
  getValueForPixel(e) {
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getPixelForDecimal(e) {
    this._reversePixels && (e = 1 - e);
    const n = this._startPixel + e * this._length;
    return tP(this._alignToPixels ? nn(this.chart, n, 0) : n);
  }
  getDecimalForPixel(e) {
    const n = (e - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: e, max: n } = this;
    return e < 0 && n < 0 ? n : e > 0 && n > 0 ? e : 0;
  }
  getContext(e) {
    const n = this.ticks || [];
    if (e >= 0 && e < n.length) {
      const r = n[e];
      return r.$context || (r.$context = mM(this.getContext(), e, r));
    }
    return this.$context || (this.$context = pM(this.chart.getContext(), this));
  }
  _tickSize() {
    const e = this.options.ticks, n = lt(this.labelRotation), r = Math.abs(Math.cos(n)), a = Math.abs(Math.sin(n)), i = this._getLabelSizes(), o = e.autoSkipPadding || 0, s = i ? i.widest.width + o : 0, l = i ? i.highest.height + o : 0;
    return this.isHorizontal() ? l * r > s * a ? s / r : l / a : l * a < s * r ? l / r : s / a;
  }
  _isVisible() {
    const e = this.options.display;
    return e !== "auto" ? !!e : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(e) {
    const n = this.axis, r = this.chart, a = this.options, { grid: i, position: o, border: s } = a, l = i.offset, c = this.isHorizontal(), f = this.ticks.length + (l ? 1 : 0), d = Xn(i), h = [], m = s.setContext(this.getContext()), p = m.display ? m.width : 0, g = p / 2, v = function(Q) {
      return nn(r, Q, p);
    };
    let w, C, x, y, _, k, P, $, O, D, N, q;
    if (o === "top")
      w = v(this.bottom), k = this.bottom - d, $ = w - g, D = v(e.top) + g, q = e.bottom;
    else if (o === "bottom")
      w = v(this.top), D = e.top, q = v(e.bottom) - g, k = w + g, $ = this.top + d;
    else if (o === "left")
      w = v(this.right), _ = this.right - d, P = w - g, O = v(e.left) + g, N = e.right;
    else if (o === "right")
      w = v(this.left), O = e.left, N = v(e.right) - g, _ = w + g, P = this.left + d;
    else if (n === "x") {
      if (o === "center")
        w = v((e.top + e.bottom) / 2 + 0.5);
      else if (ae(o)) {
        const Q = Object.keys(o)[0], te = o[Q];
        w = v(this.chart.scales[Q].getPixelForValue(te));
      }
      D = e.top, q = e.bottom, k = w + g, $ = k + d;
    } else if (n === "y") {
      if (o === "center")
        w = v((e.left + e.right) / 2);
      else if (ae(o)) {
        const Q = Object.keys(o)[0], te = o[Q];
        w = v(this.chart.scales[Q].getPixelForValue(te));
      }
      _ = w - g, P = _ - d, O = e.left, N = e.right;
    }
    const le = ee(a.ticks.maxTicksLimit, f), Y = Math.max(1, Math.ceil(f / le));
    for (C = 0; C < f; C += Y) {
      const Q = this.getContext(C), te = i.setContext(Q), Re = s.setContext(Q), pe = te.lineWidth, Ke = te.color, at = Re.dash || [], Ee = Re.dashOffset, Qe = te.tickWidth, Le = te.tickColor, Ie = te.tickBorderDash || [], qe = te.tickBorderDashOffset;
      x = fM(this, C, l), x !== void 0 && (y = nn(r, x, pe), c ? _ = P = O = N = y : k = $ = D = q = y, h.push({
        tx1: _,
        ty1: k,
        tx2: P,
        ty2: $,
        x1: O,
        y1: D,
        x2: N,
        y2: q,
        width: pe,
        color: Ke,
        borderDash: at,
        borderDashOffset: Ee,
        tickWidth: Qe,
        tickColor: Le,
        tickBorderDash: Ie,
        tickBorderDashOffset: qe
      }));
    }
    return this._ticksLength = f, this._borderValue = w, h;
  }
  _computeLabelItems(e) {
    const n = this.axis, r = this.options, { position: a, ticks: i } = r, o = this.isHorizontal(), s = this.ticks, { align: l, crossAlign: c, padding: u, mirror: f } = i, d = Xn(r.grid), h = d + u, m = f ? -u : h, p = -lt(this.labelRotation), g = [];
    let v, w, C, x, y, _, k, P, $, O, D, N, q = "middle";
    if (a === "top")
      _ = this.bottom - m, k = this._getXAxisLabelAlignment();
    else if (a === "bottom")
      _ = this.top + m, k = this._getXAxisLabelAlignment();
    else if (a === "left") {
      const Y = this._getYAxisLabelAlignment(d);
      k = Y.textAlign, y = Y.x;
    } else if (a === "right") {
      const Y = this._getYAxisLabelAlignment(d);
      k = Y.textAlign, y = Y.x;
    } else if (n === "x") {
      if (a === "center")
        _ = (e.top + e.bottom) / 2 + h;
      else if (ae(a)) {
        const Y = Object.keys(a)[0], Q = a[Y];
        _ = this.chart.scales[Y].getPixelForValue(Q) + h;
      }
      k = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (a === "center")
        y = (e.left + e.right) / 2 - h;
      else if (ae(a)) {
        const Y = Object.keys(a)[0], Q = a[Y];
        y = this.chart.scales[Y].getPixelForValue(Q);
      }
      k = this._getYAxisLabelAlignment(d).textAlign;
    }
    n === "y" && (l === "start" ? q = "top" : l === "end" && (q = "bottom"));
    const le = this._getLabelSizes();
    for (v = 0, w = s.length; v < w; ++v) {
      C = s[v], x = C.label;
      const Y = i.setContext(this.getContext(v));
      P = this.getPixelForTick(v) + i.labelOffset, $ = this._resolveTickFontOptions(v), O = $.lineHeight, D = ye(x) ? x.length : 1;
      const Q = D / 2, te = Y.color, Re = Y.textStrokeColor, pe = Y.textStrokeWidth;
      let Ke = k;
      o ? (y = P, k === "inner" && (v === w - 1 ? Ke = this.options.reverse ? "left" : "right" : v === 0 ? Ke = this.options.reverse ? "right" : "left" : Ke = "center"), a === "top" ? c === "near" || p !== 0 ? N = -D * O + O / 2 : c === "center" ? N = -le.highest.height / 2 - Q * O + O : N = -le.highest.height + O / 2 : c === "near" || p !== 0 ? N = O / 2 : c === "center" ? N = le.highest.height / 2 - Q * O : N = le.highest.height - D * O, f && (N *= -1), p !== 0 && !Y.showLabelBackdrop && (y += O / 2 * Math.sin(p))) : (_ = P, N = (1 - D) * O / 2);
      let at;
      if (Y.showLabelBackdrop) {
        const Ee = Fe(Y.backdropPadding), Qe = le.heights[v], Le = le.widths[v];
        let Ie = N - Ee.top, qe = 0 - Ee.left;
        switch (q) {
          case "middle":
            Ie -= Qe / 2;
            break;
          case "bottom":
            Ie -= Qe;
            break;
        }
        switch (k) {
          case "center":
            qe -= Le / 2;
            break;
          case "right":
            qe -= Le;
            break;
        }
        at = {
          left: qe,
          top: Ie,
          width: Le + Ee.width,
          height: Qe + Ee.height,
          color: Y.backdropColor
        };
      }
      g.push({
        label: x,
        font: $,
        textOffset: N,
        options: {
          rotation: p,
          color: te,
          strokeColor: Re,
          strokeWidth: pe,
          textAlign: Ke,
          textBaseline: q,
          translation: [
            y,
            _
          ],
          backdrop: at
        }
      });
    }
    return g;
  }
  _getXAxisLabelAlignment() {
    const { position: e, ticks: n } = this.options;
    if (-lt(this.labelRotation))
      return e === "top" ? "left" : "right";
    let a = "center";
    return n.align === "start" ? a = "left" : n.align === "end" ? a = "right" : n.align === "inner" && (a = "inner"), a;
  }
  _getYAxisLabelAlignment(e) {
    const { position: n, ticks: { crossAlign: r, mirror: a, padding: i } } = this.options, o = this._getLabelSizes(), s = e + i, l = o.widest.width;
    let c, u;
    return n === "left" ? a ? (u = this.right + i, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - s, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : n === "right" ? a ? (u = this.left + i, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + s, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const e = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: e.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: e.width
      };
  }
  drawBackground() {
    const { ctx: e, options: { backgroundColor: n }, left: r, top: a, width: i, height: o } = this;
    n && (e.save(), e.fillStyle = n, e.fillRect(r, a, i, o), e.restore());
  }
  getLineWidthForValue(e) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const a = this.ticks.findIndex((i) => i.value === e);
    return a >= 0 ? n.setContext(this.getContext(a)).lineWidth : 0;
  }
  drawGrid(e) {
    const n = this.options.grid, r = this.ctx, a = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(e));
    let i, o;
    const s = (l, c, u) => {
      !u.width || !u.color || (r.save(), r.lineWidth = u.width, r.strokeStyle = u.color, r.setLineDash(u.borderDash || []), r.lineDashOffset = u.borderDashOffset, r.beginPath(), r.moveTo(l.x, l.y), r.lineTo(c.x, c.y), r.stroke(), r.restore());
    };
    if (n.display)
      for (i = 0, o = a.length; i < o; ++i) {
        const l = a[i];
        n.drawOnChartArea && s({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), n.drawTicks && s({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: e, ctx: n, options: { border: r, grid: a } } = this, i = r.setContext(this.getContext()), o = r.display ? i.width : 0;
    if (!o)
      return;
    const s = a.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, f, d;
    this.isHorizontal() ? (c = nn(e, this.left, o) - o / 2, u = nn(e, this.right, s) + s / 2, f = d = l) : (f = nn(e, this.top, o) - o / 2, d = nn(e, this.bottom, s) + s / 2, c = u = l), n.save(), n.lineWidth = i.width, n.strokeStyle = i.color, n.beginPath(), n.moveTo(c, f), n.lineTo(u, d), n.stroke(), n.restore();
  }
  drawLabels(e) {
    if (!this.options.ticks.display)
      return;
    const r = this.ctx, a = this._computeLabelArea();
    a && wo(r, a);
    const i = this.getLabelItems(e);
    for (const o of i) {
      const s = o.options, l = o.font, c = o.label, u = o.textOffset;
      gn(r, c, 0, u, l, s);
    }
    a && ko(r);
  }
  drawTitle() {
    const { ctx: e, options: { position: n, title: r, reverse: a } } = this;
    if (!r.display)
      return;
    const i = $e(r.font), o = Fe(r.padding), s = r.align;
    let l = i.lineHeight / 2;
    n === "bottom" || n === "center" || ae(n) ? (l += o.bottom, ye(r.text) && (l += i.lineHeight * (r.text.length - 1))) : l += o.top;
    const { titleX: c, titleY: u, maxWidth: f, rotation: d } = vM(this, l, n, s);
    gn(e, r.text, 0, 0, i, {
      color: r.color,
      maxWidth: f,
      rotation: d,
      textAlign: gM(s, n, a),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(e) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(e), this.drawBorder(), this.drawTitle(), this.drawLabels(e));
  }
  _layers() {
    const e = this.options, n = e.ticks && e.ticks.z || 0, r = ee(e.grid && e.grid.z, -1), a = ee(e.border && e.border.z, 0);
    return !this._isVisible() || this.draw !== bn.prototype.draw ? [
      {
        z: n,
        draw: (i) => {
          this.draw(i);
        }
      }
    ] : [
      {
        z: r,
        draw: (i) => {
          this.drawBackground(), this.drawGrid(i), this.drawTitle();
        }
      },
      {
        z: a,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (i) => {
          this.drawLabels(i);
        }
      }
    ];
  }
  getMatchingVisibleMetas(e) {
    const n = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", a = [];
    let i, o;
    for (i = 0, o = n.length; i < o; ++i) {
      const s = n[i];
      s[r] === this.id && (!e || s.type === e) && a.push(s);
    }
    return a;
  }
  _resolveTickFontOptions(e) {
    const n = this.options.ticks.setContext(this.getContext(e));
    return $e(n.font);
  }
  _maxDigits() {
    const e = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / e;
  }
}
class sa {
  constructor(e, n, r) {
    this.type = e, this.scope = n, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(e) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype);
  }
  register(e) {
    const n = Object.getPrototypeOf(e);
    let r;
    _M(n) && (r = this.register(n));
    const a = this.items, i = e.id, o = this.scope + "." + i;
    if (!i)
      throw new Error("class does not have id: " + e);
    return i in a || (a[i] = e, yM(e, o, r), this.override && Se.override(e.id, e.overrides)), o;
  }
  get(e) {
    return this.items[e];
  }
  unregister(e) {
    const n = this.items, r = e.id, a = this.scope;
    r in n && delete n[r], a && r in Se[a] && (delete Se[a][r], this.override && delete mn[r]);
  }
}
function yM(t, e, n) {
  const r = yr(/* @__PURE__ */ Object.create(null), [
    n ? Se.get(n) : {},
    Se.get(e),
    t.defaults
  ]);
  Se.set(e, r), t.defaultRoutes && bM(e, t.defaultRoutes), t.descriptors && Se.describe(e, t.descriptors);
}
function bM(t, e) {
  Object.keys(e).forEach((n) => {
    const r = n.split("."), a = r.pop(), i = [
      t
    ].concat(r).join("."), o = e[n].split("."), s = o.pop(), l = o.join(".");
    Se.route(i, a, l, s);
  });
}
function _M(t) {
  return "id" in t && "defaults" in t;
}
class wM {
  constructor() {
    this.controllers = new sa(ut, "datasets", !0), this.elements = new sa(It, "elements"), this.plugins = new sa(Object, "plugins"), this.scales = new sa(bn, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...e) {
    this._each("register", e);
  }
  remove(...e) {
    this._each("unregister", e);
  }
  addControllers(...e) {
    this._each("register", e, this.controllers);
  }
  addElements(...e) {
    this._each("register", e, this.elements);
  }
  addPlugins(...e) {
    this._each("register", e, this.plugins);
  }
  addScales(...e) {
    this._each("register", e, this.scales);
  }
  getController(e) {
    return this._get(e, this.controllers, "controller");
  }
  getElement(e) {
    return this._get(e, this.elements, "element");
  }
  getPlugin(e) {
    return this._get(e, this.plugins, "plugin");
  }
  getScale(e) {
    return this._get(e, this.scales, "scale");
  }
  removeControllers(...e) {
    this._each("unregister", e, this.controllers);
  }
  removeElements(...e) {
    this._each("unregister", e, this.elements);
  }
  removePlugins(...e) {
    this._each("unregister", e, this.plugins);
  }
  removeScales(...e) {
    this._each("unregister", e, this.scales);
  }
  _each(e, n, r) {
    [
      ...n
    ].forEach((a) => {
      const i = r || this._getRegistryForType(a);
      r || i.isForType(a) || i === this.plugins && a.id ? this._exec(e, i, a) : he(a, (o) => {
        const s = r || this._getRegistryForType(o);
        this._exec(e, s, o);
      });
    });
  }
  _exec(e, n, r) {
    const a = Jl(e);
    ge(r["before" + a], [], r), n[e](r), ge(r["after" + a], [], r);
  }
  _getRegistryForType(e) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const r = this._typedRegistries[n];
      if (r.isForType(e))
        return r;
    }
    return this.plugins;
  }
  _get(e, n, r) {
    const a = n.get(e);
    if (a === void 0)
      throw new Error('"' + e + '" is not a registered ' + r + ".");
    return a;
  }
}
var gt = /* @__PURE__ */ new wM();
class kM {
  constructor() {
    this._init = [];
  }
  notify(e, n, r, a) {
    n === "beforeInit" && (this._init = this._createDescriptors(e, !0), this._notify(this._init, e, "install"));
    const i = a ? this._descriptors(e).filter(a) : this._descriptors(e), o = this._notify(i, e, n, r);
    return n === "afterDestroy" && (this._notify(i, e, "stop"), this._notify(this._init, e, "uninstall")), o;
  }
  _notify(e, n, r, a) {
    a = a || {};
    for (const i of e) {
      const o = i.plugin, s = o[r], l = [
        n,
        a,
        i.options
      ];
      if (ge(s, l, o) === !1 && a.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    se(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(e) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(e);
    return this._notifyStateChanges(e), n;
  }
  _createDescriptors(e, n) {
    const r = e && e.config, a = ee(r.options && r.options.plugins, {}), i = xM(r);
    return a === !1 && !n ? [] : PM(e, i, a, n);
  }
  _notifyStateChanges(e) {
    const n = this._oldCache || [], r = this._cache, a = (i, o) => i.filter((s) => !o.some((l) => s.plugin.id === l.plugin.id));
    this._notify(a(n, r), e, "stop"), this._notify(a(r, n), e, "start");
  }
}
function xM(t) {
  const e = {}, n = [], r = Object.keys(gt.plugins.items);
  for (let i = 0; i < r.length; i++)
    n.push(gt.getPlugin(r[i]));
  const a = t.plugins || [];
  for (let i = 0; i < a.length; i++) {
    const o = a[i];
    n.indexOf(o) === -1 && (n.push(o), e[o.id] = !0);
  }
  return {
    plugins: n,
    localIds: e
  };
}
function CM(t, e) {
  return !e && t === !1 ? null : t === !0 ? {} : t;
}
function PM(t, { plugins: e, localIds: n }, r, a) {
  const i = [], o = t.getContext();
  for (const s of e) {
    const l = s.id, c = CM(r[l], a);
    c !== null && i.push({
      plugin: s,
      options: SM(t.config, {
        plugin: s,
        local: n[l]
      }, c, o)
    });
  }
  return i;
}
function SM(t, { plugin: e, local: n }, r, a) {
  const i = t.pluginScopeKeys(e), o = t.getOptionScopes(r, i);
  return n && e.defaults && o.push(e.defaults), t.createResolver(o, a, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function ml(t, e) {
  const n = Se.datasets[t] || {};
  return ((e.datasets || {})[t] || {}).indexAxis || e.indexAxis || n.indexAxis || "x";
}
function MM(t, e) {
  let n = t;
  return t === "_index_" ? n = e : t === "_value_" && (n = e === "x" ? "y" : "x"), n;
}
function OM(t, e) {
  return t === e ? "_index_" : "_value_";
}
function jd(t) {
  if (t === "x" || t === "y" || t === "r")
    return t;
}
function DM(t) {
  if (t === "top" || t === "bottom")
    return "x";
  if (t === "left" || t === "right")
    return "y";
}
function gl(t, ...e) {
  if (jd(t))
    return t;
  for (const n of e) {
    const r = n.axis || DM(n.position) || t.length > 1 && jd(t[0].toLowerCase());
    if (r)
      return r;
  }
  throw new Error(`Cannot determine type of '${t}' axis. Please provide 'axis' or 'position' option.`);
}
function Vd(t, e, n) {
  if (n[e + "AxisID"] === t)
    return {
      axis: e
    };
}
function TM(t, e) {
  if (e.data && e.data.datasets) {
    const n = e.data.datasets.filter((r) => r.xAxisID === t || r.yAxisID === t);
    if (n.length)
      return Vd(t, "x", n[0]) || Vd(t, "y", n[0]);
  }
  return {};
}
function $M(t, e) {
  const n = mn[t.type] || {
    scales: {}
  }, r = e.scales || {}, a = ml(t.type, e), i = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((o) => {
    const s = r[o];
    if (!ae(s))
      return console.error(`Invalid scale configuration for scale: ${o}`);
    if (s._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${o}`);
    const l = gl(o, s, TM(o, t), Se.scales[s.type]), c = OM(l, a), u = n.scales || {};
    i[o] = ir(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      s,
      u[l],
      u[c]
    ]);
  }), t.data.datasets.forEach((o) => {
    const s = o.type || t.type, l = o.indexAxis || ml(s, e), u = (mn[s] || {}).scales || {};
    Object.keys(u).forEach((f) => {
      const d = MM(f, l), h = o[d + "AxisID"] || d;
      i[h] = i[h] || /* @__PURE__ */ Object.create(null), ir(i[h], [
        {
          axis: d
        },
        r[h],
        u[f]
      ]);
    });
  }), Object.keys(i).forEach((o) => {
    const s = i[o];
    ir(s, [
      Se.scales[s.type],
      Se.scale
    ]);
  }), i;
}
function bp(t) {
  const e = t.options || (t.options = {});
  e.plugins = ee(e.plugins, {}), e.scales = $M(t, e);
}
function _p(t) {
  return t = t || {}, t.datasets = t.datasets || [], t.labels = t.labels || [], t;
}
function RM(t) {
  return t = t || {}, t.data = _p(t.data), bp(t), t;
}
const qd = /* @__PURE__ */ new Map(), wp = /* @__PURE__ */ new Set();
function la(t, e) {
  let n = qd.get(t);
  return n || (n = e(), qd.set(t, n), wp.add(n)), n;
}
const Kn = (t, e, n) => {
  const r = Kt(e, n);
  r !== void 0 && t.add(r);
};
class EM {
  constructor(e) {
    this._config = RM(e), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(e) {
    this._config.type = e;
  }
  get data() {
    return this._config.data;
  }
  set data(e) {
    this._config.data = _p(e);
  }
  get options() {
    return this._config.options;
  }
  set options(e) {
    this._config.options = e;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const e = this._config;
    this.clearCache(), bp(e);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(e) {
    return la(e, () => [
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(e, n) {
    return la(`${e}.transition.${n}`, () => [
      [
        `datasets.${e}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(e, n) {
    return la(`${e}-${n}`, () => [
      [
        `datasets.${e}.elements.${n}`,
        `datasets.${e}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(e) {
    const n = e.id, r = this.type;
    return la(`${r}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...e.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(e, n) {
    const r = this._scopeCache;
    let a = r.get(e);
    return (!a || n) && (a = /* @__PURE__ */ new Map(), r.set(e, a)), a;
  }
  getOptionScopes(e, n, r) {
    const { options: a, type: i } = this, o = this._cachedScopes(e, r), s = o.get(n);
    if (s)
      return s;
    const l = /* @__PURE__ */ new Set();
    n.forEach((u) => {
      e && (l.add(e), u.forEach((f) => Kn(l, e, f))), u.forEach((f) => Kn(l, a, f)), u.forEach((f) => Kn(l, mn[i] || {}, f)), u.forEach((f) => Kn(l, Se, f)), u.forEach((f) => Kn(l, fl, f));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), wp.has(n) && o.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: e, type: n } = this;
    return [
      e,
      mn[n] || {},
      Se.datasets[n] || {},
      {
        type: n
      },
      Se,
      fl
    ];
  }
  resolveNamedOptions(e, n, r, a = [
    ""
  ]) {
    const i = {
      $shared: !0
    }, { resolver: o, subPrefixes: s } = Ud(this._resolverCache, e, a);
    let l = o;
    if (LM(o, n)) {
      i.$shared = !1, r = Qt(r) ? r() : r;
      const c = this.createResolver(e, r, s);
      l = An(o, r, c);
    }
    for (const c of n)
      i[c] = l[c];
    return i;
  }
  createResolver(e, n, r = [
    ""
  ], a) {
    const { resolver: i } = Ud(this._resolverCache, e, r);
    return ae(n) ? An(i, n, void 0, a) : i;
  }
}
function Ud(t, e, n) {
  let r = t.get(e);
  r || (r = /* @__PURE__ */ new Map(), t.set(e, r));
  const a = n.join();
  let i = r.get(a);
  return i || (i = {
    resolver: ic(e, n),
    subPrefixes: n.filter((s) => !s.toLowerCase().includes("hover"))
  }, r.set(a, i)), i;
}
const AM = (t) => ae(t) && Object.getOwnPropertyNames(t).reduce((e, n) => e || Qt(t[n]), !1);
function LM(t, e) {
  const { isScriptable: n, isIndexable: r } = Jh(t);
  for (const a of e) {
    const i = n(a), o = r(a), s = (o || i) && t[a];
    if (i && (Qt(s) || AM(s)) || o && ye(s))
      return !0;
  }
  return !1;
}
var IM = "4.4.0";
const NM = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function Yd(t, e) {
  return t === "top" || t === "bottom" || NM.indexOf(t) === -1 && e === "x";
}
function Xd(t, e) {
  return function(n, r) {
    return n[t] === r[t] ? n[e] - r[e] : n[t] - r[t];
  };
}
function Kd(t) {
  const e = t.chart, n = e.options.animation;
  e.notifyPlugins("afterRender"), ge(n && n.onComplete, [
    t
  ], e);
}
function WM(t) {
  const e = t.chart, n = e.options.animation;
  ge(n && n.onProgress, [
    t
  ], e);
}
function kp(t) {
  return ip() && typeof t == "string" ? t = document.getElementById(t) : t && t.length && (t = t[0]), t && t.canvas && (t = t.canvas), t;
}
const ci = {}, Qd = (t) => {
  const e = kp(t);
  return Object.values(ci).filter((n) => n.canvas === e).pop();
};
function zM(t, e, n) {
  const r = Object.keys(t);
  for (const a of r) {
    const i = +a;
    if (i >= e) {
      const o = t[a];
      delete t[a], (n > 0 || i > e) && (t[i + n] = o);
    }
  }
}
function BM(t, e, n, r) {
  return !n || t.type === "mouseout" ? null : r ? e : t;
}
function ca(t, e, n) {
  return t.options.clip ? t[n] : e[n];
}
function FM(t, e) {
  const { xScale: n, yScale: r } = t;
  return n && r ? {
    left: ca(n, e, "left"),
    right: ca(n, e, "right"),
    top: ca(r, e, "top"),
    bottom: ca(r, e, "bottom")
  } : e;
}
class Ot {
  static register(...e) {
    gt.add(...e), Gd();
  }
  static unregister(...e) {
    gt.remove(...e), Gd();
  }
  constructor(e, n) {
    const r = this.config = new EM(n), a = kp(e), i = Qd(a);
    if (i)
      throw new Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
    const o = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || aM(a))(), this.platform.updateConfig(r);
    const s = this.platform.acquireContext(a, o.aspectRatio), l = s && s.canvas, c = l && l.height, u = l && l.width;
    if (this.id = j6(), this.ctx = s, this.canvas = l, this.width = u, this.height = c, this._options = o, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new kM(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = iP((f) => this.update(f), o.resizeDelay || 0), this._dataChanges = [], ci[this.id] = this, !s || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    Pt.listen(this, "complete", Kd), Pt.listen(this, "progress", WM), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: e, maintainAspectRatio: n }, width: r, height: a, _aspectRatio: i } = this;
    return se(e) ? n && i ? i : a ? r / a : null : e;
  }
  get data() {
    return this.config.data;
  }
  set data(e) {
    this.config.data = e;
  }
  get options() {
    return this._options;
  }
  set options(e) {
    this.config.options = e;
  }
  get registry() {
    return gt;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : yd(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return md(this.canvas, this.ctx), this;
  }
  stop() {
    return Pt.stop(this), this;
  }
  resize(e, n) {
    Pt.running(this) ? this._resizeBeforeDraw = {
      width: e,
      height: n
    } : this._resize(e, n);
  }
  _resize(e, n) {
    const r = this.options, a = this.canvas, i = r.maintainAspectRatio && this.aspectRatio, o = this.platform.getMaximumSize(a, e, n, i), s = r.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = o.width, this.height = o.height, this._aspectRatio = this.aspectRatio, yd(this, s, !0) && (this.notifyPlugins("resize", {
      size: o
    }), ge(r.onResize, [
      this,
      o
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    he(n, (r, a) => {
      r.id = a;
    });
  }
  buildOrUpdateScales() {
    const e = this.options, n = e.scales, r = this.scales, a = Object.keys(r).reduce((o, s) => (o[s] = !1, o), {});
    let i = [];
    n && (i = i.concat(Object.keys(n).map((o) => {
      const s = n[o], l = gl(o, s), c = l === "r", u = l === "x";
      return {
        options: s,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), he(i, (o) => {
      const s = o.options, l = s.id, c = gl(l, s), u = ee(s.type, o.dtype);
      (s.position === void 0 || Yd(s.position, c) !== Yd(o.dposition)) && (s.position = o.dposition), a[l] = !0;
      let f = null;
      if (l in r && r[l].type === u)
        f = r[l];
      else {
        const d = gt.getScale(u);
        f = new d({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), r[f.id] = f;
      }
      f.init(s, e);
    }), he(a, (o, s) => {
      o || delete r[s];
    }), he(r, (o) => {
      Be.configure(this, o, o.options), Be.addBox(this, o);
    });
  }
  _updateMetasets() {
    const e = this._metasets, n = this.data.datasets.length, r = e.length;
    if (e.sort((a, i) => a.index - i.index), r > n) {
      for (let a = n; a < r; ++a)
        this._destroyDatasetMeta(a);
      e.splice(n, r - n);
    }
    this._sortedMetasets = e.slice(0).sort(Xd("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: e, data: { datasets: n } } = this;
    e.length > n.length && delete this._stacks, e.forEach((r, a) => {
      n.filter((i) => i === r._dataset).length === 0 && this._destroyDatasetMeta(a);
    });
  }
  buildOrUpdateControllers() {
    const e = [], n = this.data.datasets;
    let r, a;
    for (this._removeUnreferencedMetasets(), r = 0, a = n.length; r < a; r++) {
      const i = n[r];
      let o = this.getDatasetMeta(r);
      const s = i.type || this.config.type;
      if (o.type && o.type !== s && (this._destroyDatasetMeta(r), o = this.getDatasetMeta(r)), o.type = s, o.indexAxis = i.indexAxis || ml(s, this.options), o.order = i.order || 0, o.index = r, o.label = "" + i.label, o.visible = this.isDatasetVisible(r), o.controller)
        o.controller.updateIndex(r), o.controller.linkScales();
      else {
        const l = gt.getController(s), { datasetElementType: c, dataElementType: u } = Se.datasets[s];
        Object.assign(l, {
          dataElementType: gt.getElement(u),
          datasetElementType: c && gt.getElement(c)
        }), o.controller = new l(this, r), e.push(o.controller);
      }
    }
    return this._updateMetasets(), e;
  }
  _resetElements() {
    he(this.data.datasets, (e, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(e) {
    const n = this.config;
    n.update();
    const r = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), a = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: e,
      cancelable: !0
    }) === !1)
      return;
    const i = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let o = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: f } = this.getDatasetMeta(c), d = !a && i.indexOf(f) === -1;
      f.buildOrUpdateElements(d), o = Math.max(+f.getMaxOverflow(), o);
    }
    o = this._minPadding = r.layout.autoPadding ? o : 0, this._updateLayout(o), a || he(i, (c) => {
      c.reset();
    }), this._updateDatasets(e), this.notifyPlugins("afterUpdate", {
      mode: e
    }), this._layers.sort(Xd("z", "_idx"));
    const { _active: s, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : s.length && this._updateHoverStyles(s, s, !0), this.render();
  }
  _updateScales() {
    he(this.scales, (e) => {
      Be.removeBox(this, e);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const e = this.options, n = new Set(Object.keys(this._listeners)), r = new Set(e.events);
    (!od(n, r) || !!this._responsiveListeners !== e.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: e } = this, n = this._getUniformDataChanges() || [];
    for (const { method: r, start: a, count: i } of n) {
      const o = r === "_removeElements" ? -i : i;
      zM(e, a, o);
    }
  }
  _getUniformDataChanges() {
    const e = this._dataChanges;
    if (!e || !e.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, r = (i) => new Set(e.filter((o) => o[0] === i).map((o, s) => s + "," + o.splice(1).join(","))), a = r(0);
    for (let i = 1; i < n; i++)
      if (!od(a, r(i)))
        return;
    return Array.from(a).map((i) => i.split(",")).map((i) => ({
      method: i[1],
      start: +i[2],
      count: +i[3]
    }));
  }
  _updateLayout(e) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Be.update(this, this.width, this.height, e);
    const n = this.chartArea, r = n.width <= 0 || n.height <= 0;
    this._layers = [], he(this.boxes, (a) => {
      r && a.position === "chartArea" || (a.configure && a.configure(), this._layers.push(...a._layers()));
    }, this), this._layers.forEach((a, i) => {
      a._idx = i;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(e) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: e,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this._updateDataset(n, Qt(e) ? e({
          datasetIndex: n
        }) : e);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: e
      });
    }
  }
  _updateDataset(e, n) {
    const r = this.getDatasetMeta(e), a = {
      meta: r,
      index: e,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", a) !== !1 && (r.controller._update(n), a.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", a));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (Pt.has(this) ? this.attached && !Pt.running(this) && Pt.start(this) : (this.draw(), Kd({
      chart: this
    })));
  }
  draw() {
    let e;
    if (this._resizeBeforeDraw) {
      const { width: r, height: a } = this._resizeBeforeDraw;
      this._resize(r, a), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (e = 0; e < n.length && n[e].z <= 0; ++e)
      n[e].draw(this.chartArea);
    for (this._drawDatasets(); e < n.length; ++e)
      n[e].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(e) {
    const n = this._sortedMetasets, r = [];
    let a, i;
    for (a = 0, i = n.length; a < i; ++a) {
      const o = n[a];
      (!e || o.visible) && r.push(o);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this.getSortedVisibleDatasetMetas();
    for (let n = e.length - 1; n >= 0; --n)
      this._drawDataset(e[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(e) {
    const n = this.ctx, r = e._clip, a = !r.disabled, i = FM(e, this.chartArea), o = {
      meta: e,
      index: e.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", o) !== !1 && (a && wo(n, {
      left: r.left === !1 ? 0 : i.left - r.left,
      right: r.right === !1 ? this.width : i.right + r.right,
      top: r.top === !1 ? 0 : i.top - r.top,
      bottom: r.bottom === !1 ? this.height : i.bottom + r.bottom
    }), e.controller.draw(), a && ko(n), o.cancelable = !1, this.notifyPlugins("afterDatasetDraw", o));
  }
  isPointInArea(e) {
    return Rt(e, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, n, r, a) {
    const i = NS.modes[n];
    return typeof i == "function" ? i(this, e, r, a) : [];
  }
  getDatasetMeta(e) {
    const n = this.data.datasets[e], r = this._metasets;
    let a = r.filter((i) => i && i._dataset === n).pop();
    return a || (a = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: e,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, r.push(a)), a;
  }
  getContext() {
    return this.$context || (this.$context = Zt(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(e) {
    const n = this.data.datasets[e];
    if (!n)
      return !1;
    const r = this.getDatasetMeta(e);
    return typeof r.hidden == "boolean" ? !r.hidden : !n.hidden;
  }
  setDatasetVisibility(e, n) {
    const r = this.getDatasetMeta(e);
    r.hidden = !n;
  }
  toggleDataVisibility(e) {
    this._hiddenIndices[e] = !this._hiddenIndices[e];
  }
  getDataVisibility(e) {
    return !this._hiddenIndices[e];
  }
  _updateVisibility(e, n, r) {
    const a = r ? "show" : "hide", i = this.getDatasetMeta(e), o = i.controller._resolveAnimations(void 0, a);
    br(n) ? (i.data[n].hidden = !r, this.update()) : (this.setDatasetVisibility(e, r), o.update(i, {
      visible: r
    }), this.update((s) => s.datasetIndex === e ? a : void 0));
  }
  hide(e, n) {
    this._updateVisibility(e, n, !1);
  }
  show(e, n) {
    this._updateVisibility(e, n, !0);
  }
  _destroyDatasetMeta(e) {
    const n = this._metasets[e];
    n && n.controller && n.controller._destroy(), delete this._metasets[e];
  }
  _stop() {
    let e, n;
    for (this.stop(), Pt.remove(this), e = 0, n = this.data.datasets.length; e < n; ++e)
      this._destroyDatasetMeta(e);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: e, ctx: n } = this;
    this._stop(), this.config.clearCache(), e && (this.unbindEvents(), md(e, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete ci[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...e) {
    return this.canvas.toDataURL(...e);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const e = this._listeners, n = this.platform, r = (i, o) => {
      n.addEventListener(this, i, o), e[i] = o;
    }, a = (i, o, s) => {
      i.offsetX = o, i.offsetY = s, this._eventHandler(i);
    };
    he(this.options.events, (i) => r(i, a));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const e = this._responsiveListeners, n = this.platform, r = (l, c) => {
      n.addEventListener(this, l, c), e[l] = c;
    }, a = (l, c) => {
      e[l] && (n.removeEventListener(this, l, c), delete e[l]);
    }, i = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let o;
    const s = () => {
      a("attach", s), this.attached = !0, this.resize(), r("resize", i), r("detach", o);
    };
    o = () => {
      this.attached = !1, a("resize", i), this._stop(), this._resize(0, 0), r("attach", s);
    }, n.isAttached(this.canvas) ? s() : o();
  }
  unbindEvents() {
    he(this._listeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._listeners = {}, he(this._responsiveListeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(e, n, r) {
    const a = r ? "set" : "remove";
    let i, o, s, l;
    for (n === "dataset" && (i = this.getDatasetMeta(e[0].datasetIndex), i.controller["_" + a + "DatasetHoverStyle"]()), s = 0, l = e.length; s < l; ++s) {
      o = e[s];
      const c = o && this.getDatasetMeta(o.datasetIndex).controller;
      c && c[a + "HoverStyle"](o.element, o.datasetIndex, o.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e) {
    const n = this._active || [], r = e.map(({ datasetIndex: i, index: o }) => {
      const s = this.getDatasetMeta(i);
      if (!s)
        throw new Error("No dataset found at index " + i);
      return {
        datasetIndex: i,
        element: s.data[o],
        index: o
      };
    });
    !Gi(r, n) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, n));
  }
  notifyPlugins(e, n, r) {
    return this._plugins.notify(this, e, n, r);
  }
  isPluginEnabled(e) {
    return this._plugins._cache.filter((n) => n.plugin.id === e).length === 1;
  }
  _updateHoverStyles(e, n, r) {
    const a = this.options.hover, i = (l, c) => l.filter((u) => !c.some((f) => u.datasetIndex === f.datasetIndex && u.index === f.index)), o = i(n, e), s = r ? e : i(e, n);
    o.length && this.updateHoverStyle(o, a.mode, !1), s.length && a.mode && this.updateHoverStyle(s, a.mode, !0);
  }
  _eventHandler(e, n) {
    const r = {
      event: e,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(e)
    }, a = (o) => (o.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", r, a) === !1)
      return;
    const i = this._handleEvent(e, n, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, a), (i || r.changed) && this.render(), this;
  }
  _handleEvent(e, n, r) {
    const { _active: a = [], options: i } = this, o = n, s = this._getActiveElements(e, a, r, o), l = K6(e), c = BM(e, this._lastEvent, r, l);
    r && (this._lastEvent = null, ge(i.onHover, [
      e,
      s,
      this
    ], this), l && ge(i.onClick, [
      e,
      s,
      this
    ], this));
    const u = !Gi(s, a);
    return (u || n) && (this._active = s, this._updateHoverStyles(s, a, n)), this._lastEvent = c, u;
  }
  _getActiveElements(e, n, r, a) {
    if (e.type === "mouseout")
      return [];
    if (!r)
      return n;
    const i = this.options.hover;
    return this.getElementsAtEventForMode(e, i.mode, i, a);
  }
}
A(Ot, "defaults", Se), A(Ot, "instances", ci), A(Ot, "overrides", mn), A(Ot, "registry", gt), A(Ot, "version", IM), A(Ot, "getChart", Qd);
function Gd() {
  return he(Ot.instances, (t) => t._plugins.invalidate());
}
function HM(t, e, n) {
  const { startAngle: r, pixelMargin: a, x: i, y: o, outerRadius: s, innerRadius: l } = e;
  let c = a / s;
  t.beginPath(), t.arc(i, o, s, r - c, n + c), l > a ? (c = a / l, t.arc(i, o, l, n + c, r - c, !0)) : t.arc(i, o, a, n + Te, r - Te), t.closePath(), t.clip();
}
function jM(t) {
  return ac(t, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function VM(t, e, n, r) {
  const a = jM(t.options.borderRadius), i = (n - e) / 2, o = Math.min(i, r * e / 2), s = (l) => {
    const c = (n - Math.min(i, l)) * r / 2;
    return Ae(l, 0, Math.min(i, c));
  };
  return {
    outerStart: s(a.outerStart),
    outerEnd: s(a.outerEnd),
    innerStart: Ae(a.innerStart, 0, o),
    innerEnd: Ae(a.innerEnd, 0, o)
  };
}
function xn(t, e, n, r) {
  return {
    x: n + t * Math.cos(e),
    y: r + t * Math.sin(e)
  };
}
function ro(t, e, n, r, a, i) {
  const { x: o, y: s, startAngle: l, pixelMargin: c, innerRadius: u } = e, f = Math.max(e.outerRadius + r + n - c, 0), d = u > 0 ? u + r + n + c : 0;
  let h = 0;
  const m = a - l;
  if (r) {
    const Y = u > 0 ? u - r : 0, Q = f > 0 ? f - r : 0, te = (Y + Q) / 2, Re = te !== 0 ? m * te / (te + r) : m;
    h = (m - Re) / 2;
  }
  const p = Math.max(1e-3, m * f - n / ke) / f, g = (m - p) / 2, v = l + g + h, w = a - g - h, { outerStart: C, outerEnd: x, innerStart: y, innerEnd: _ } = VM(e, d, f, w - v), k = f - C, P = f - x, $ = v + C / k, O = w - x / P, D = d + y, N = d + _, q = v + y / D, le = w - _ / N;
  if (t.beginPath(), i) {
    const Y = ($ + O) / 2;
    if (t.arc(o, s, f, $, Y), t.arc(o, s, f, Y, O), x > 0) {
      const pe = xn(P, O, o, s);
      t.arc(pe.x, pe.y, x, O, w + Te);
    }
    const Q = xn(N, w, o, s);
    if (t.lineTo(Q.x, Q.y), _ > 0) {
      const pe = xn(N, le, o, s);
      t.arc(pe.x, pe.y, _, w + Te, le + Math.PI);
    }
    const te = (w - _ / d + (v + y / d)) / 2;
    if (t.arc(o, s, d, w - _ / d, te, !0), t.arc(o, s, d, te, v + y / d, !0), y > 0) {
      const pe = xn(D, q, o, s);
      t.arc(pe.x, pe.y, y, q + Math.PI, v - Te);
    }
    const Re = xn(k, v, o, s);
    if (t.lineTo(Re.x, Re.y), C > 0) {
      const pe = xn(k, $, o, s);
      t.arc(pe.x, pe.y, C, v - Te, $);
    }
  } else {
    t.moveTo(o, s);
    const Y = Math.cos($) * f + o, Q = Math.sin($) * f + s;
    t.lineTo(Y, Q);
    const te = Math.cos(O) * f + o, Re = Math.sin(O) * f + s;
    t.lineTo(te, Re);
  }
  t.closePath();
}
function qM(t, e, n, r, a) {
  const { fullCircles: i, startAngle: o, circumference: s } = e;
  let l = e.endAngle;
  if (i) {
    ro(t, e, n, r, l, a);
    for (let c = 0; c < i; ++c)
      t.fill();
    isNaN(s) || (l = o + (s % be || be));
  }
  return ro(t, e, n, r, l, a), t.fill(), l;
}
function UM(t, e, n, r, a) {
  const { fullCircles: i, startAngle: o, circumference: s, options: l } = e, { borderWidth: c, borderJoinStyle: u, borderDash: f, borderDashOffset: d } = l, h = l.borderAlign === "inner";
  if (!c)
    return;
  t.setLineDash(f || []), t.lineDashOffset = d, h ? (t.lineWidth = c * 2, t.lineJoin = u || "round") : (t.lineWidth = c, t.lineJoin = u || "bevel");
  let m = e.endAngle;
  if (i) {
    ro(t, e, n, r, m, a);
    for (let p = 0; p < i; ++p)
      t.stroke();
    isNaN(s) || (m = o + (s % be || be));
  }
  h && HM(t, e, m), i || (ro(t, e, n, r, m, a), t.stroke());
}
class Jn extends It {
  constructor(n) {
    super();
    A(this, "circumference");
    A(this, "endAngle");
    A(this, "fullCircles");
    A(this, "innerRadius");
    A(this, "outerRadius");
    A(this, "pixelMargin");
    A(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, r, a) {
    const i = this.getProps([
      "x",
      "y"
    ], a), { angle: o, distance: s } = jh(i, {
      x: n,
      y: r
    }), { startAngle: l, endAngle: c, innerRadius: u, outerRadius: f, circumference: d } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], a), h = (this.options.spacing + this.options.borderWidth) / 2, p = ee(d, c - l) >= be || _r(o, l, c), g = Tt(s, u + h, f + h);
    return p && g;
  }
  getCenterPoint(n) {
    const { x: r, y: a, startAngle: i, endAngle: o, innerRadius: s, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: c, spacing: u } = this.options, f = (i + o) / 2, d = (s + l + u + c) / 2;
    return {
      x: r + Math.cos(f) * d,
      y: a + Math.sin(f) * d
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: r, circumference: a } = this, i = (r.offset || 0) / 4, o = (r.spacing || 0) / 2, s = r.circular;
    if (this.pixelMargin = r.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = a > be ? Math.floor(a / be) : 0, a === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const l = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(l) * i, Math.sin(l) * i);
    const c = 1 - Math.sin(Math.min(ke, a || 0)), u = i * c;
    n.fillStyle = r.backgroundColor, n.strokeStyle = r.borderColor, qM(n, this, u, o, s), UM(n, this, u, o, s), n.restore();
  }
}
A(Jn, "id", "arc"), A(Jn, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), A(Jn, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), A(Jn, "descriptors", {
  _scriptable: !0,
  _indexable: (n) => n !== "borderDash"
});
function xp(t, e, n = e) {
  t.lineCap = ee(n.borderCapStyle, e.borderCapStyle), t.setLineDash(ee(n.borderDash, e.borderDash)), t.lineDashOffset = ee(n.borderDashOffset, e.borderDashOffset), t.lineJoin = ee(n.borderJoinStyle, e.borderJoinStyle), t.lineWidth = ee(n.borderWidth, e.borderWidth), t.strokeStyle = ee(n.borderColor, e.borderColor);
}
function YM(t, e, n) {
  t.lineTo(n.x, n.y);
}
function XM(t) {
  return t.stepped ? vP : t.tension || t.cubicInterpolationMode === "monotone" ? yP : YM;
}
function Cp(t, e, n = {}) {
  const r = t.length, { start: a = 0, end: i = r - 1 } = n, { start: o, end: s } = e, l = Math.max(a, o), c = Math.min(i, s), u = a < o && i < o || a > s && i > s;
  return {
    count: r,
    start: l,
    loop: e.loop,
    ilen: c < l && !u ? r + c - l : c - l
  };
}
function KM(t, e, n, r) {
  const { points: a, options: i } = e, { count: o, start: s, loop: l, ilen: c } = Cp(a, n, r), u = XM(i);
  let { move: f = !0, reverse: d } = r || {}, h, m, p;
  for (h = 0; h <= c; ++h)
    m = a[(s + (d ? c - h : h)) % o], !m.skip && (f ? (t.moveTo(m.x, m.y), f = !1) : u(t, p, m, d, i.stepped), p = m);
  return l && (m = a[(s + (d ? c : 0)) % o], u(t, p, m, d, i.stepped)), !!l;
}
function QM(t, e, n, r) {
  const a = e.points, { count: i, start: o, ilen: s } = Cp(a, n, r), { move: l = !0, reverse: c } = r || {};
  let u = 0, f = 0, d, h, m, p, g, v;
  const w = (x) => (o + (c ? s - x : x)) % i, C = () => {
    p !== g && (t.lineTo(u, g), t.lineTo(u, p), t.lineTo(u, v));
  };
  for (l && (h = a[w(0)], t.moveTo(h.x, h.y)), d = 0; d <= s; ++d) {
    if (h = a[w(d)], h.skip)
      continue;
    const x = h.x, y = h.y, _ = x | 0;
    _ === m ? (y < p ? p = y : y > g && (g = y), u = (f * u + x) / ++f) : (C(), t.lineTo(x, y), m = _, f = 0, p = g = y), v = y;
  }
  C();
}
function vl(t) {
  const e = t.options, n = e.borderDash && e.borderDash.length;
  return !t._decimated && !t._loop && !e.tension && e.cubicInterpolationMode !== "monotone" && !e.stepped && !n ? QM : KM;
}
function GM(t) {
  return t.stepped ? QP : t.tension || t.cubicInterpolationMode === "monotone" ? GP : ln;
}
function ZM(t, e, n, r) {
  let a = e._path;
  a || (a = e._path = new Path2D(), e.path(a, n, r) && a.closePath()), xp(t, e.options), t.stroke(a);
}
function JM(t, e, n, r) {
  const { segments: a, options: i } = e, o = vl(e);
  for (const s of a)
    xp(t, i, s.style), t.beginPath(), o(t, e, s, {
      start: n,
      end: n + r - 1
    }) && t.closePath(), t.stroke();
}
const e9 = typeof Path2D == "function";
function t9(t, e, n, r) {
  e9 && !e.options.segment ? ZM(t, e, n, r) : JM(t, e, n, r);
}
class jt extends It {
  constructor(e) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, e && Object.assign(this, e);
  }
  updateControlPoints(e, n) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const a = r.spanGaps ? this._loop : this._fullLoop;
      HP(this._points, r, e, a, n), this._pointsUpdated = !0;
    }
  }
  set points(e) {
    this._points = e, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = rS(this, this.options.segment));
  }
  first() {
    const e = this.segments, n = this.points;
    return e.length && n[e[0].start];
  }
  last() {
    const e = this.segments, n = this.points, r = e.length;
    return r && n[e[r - 1].end];
  }
  interpolate(e, n) {
    const r = this.options, a = e[n], i = this.points, o = up(this, {
      property: n,
      start: a,
      end: a
    });
    if (!o.length)
      return;
    const s = [], l = GM(r);
    let c, u;
    for (c = 0, u = o.length; c < u; ++c) {
      const { start: f, end: d } = o[c], h = i[f], m = i[d];
      if (h === m) {
        s.push(h);
        continue;
      }
      const p = Math.abs((a - h[n]) / (m[n] - h[n])), g = l(h, m, p, r.stepped);
      g[n] = e[n], s.push(g);
    }
    return s.length === 1 ? s[0] : s;
  }
  pathSegment(e, n, r) {
    return vl(this)(e, this, n, r);
  }
  path(e, n, r) {
    const a = this.segments, i = vl(this);
    let o = this._loop;
    n = n || 0, r = r || this.points.length - n;
    for (const s of a)
      o &= i(e, this, s, {
        start: n,
        end: n + r - 1
      });
    return !!o;
  }
  draw(e, n, r, a) {
    const i = this.options || {};
    (this.points || []).length && i.borderWidth && (e.save(), t9(e, this, r, a), e.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
A(jt, "id", "line"), A(jt, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), A(jt, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), A(jt, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash" && e !== "fill"
});
function Zd(t, e, n, r) {
  const a = t.options, { [n]: i } = t.getProps([
    n
  ], r);
  return Math.abs(e - i) < a.radius + a.hitRadius;
}
class ui extends It {
  constructor(n) {
    super();
    A(this, "parsed");
    A(this, "skip");
    A(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, r, a) {
    const i = this.options, { x: o, y: s } = this.getProps([
      "x",
      "y"
    ], a);
    return Math.pow(n - o, 2) + Math.pow(r - s, 2) < Math.pow(i.hitRadius + i.radius, 2);
  }
  inXRange(n, r) {
    return Zd(this, n, "x", r);
  }
  inYRange(n, r) {
    return Zd(this, n, "y", r);
  }
  getCenterPoint(n) {
    const { x: r, y: a } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: r,
      y: a
    };
  }
  size(n) {
    n = n || this.options || {};
    let r = n.radius || 0;
    r = Math.max(r, r && n.hoverRadius || 0);
    const a = r && n.borderWidth || 0;
    return (r + a) * 2;
  }
  draw(n, r) {
    const a = this.options;
    this.skip || a.radius < 0.1 || !Rt(this, r, this.size(a) / 2) || (n.strokeStyle = a.borderColor, n.lineWidth = a.borderWidth, n.fillStyle = a.backgroundColor, hl(n, a, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
A(ui, "id", "point"), /**
* @type {any}
*/
A(ui, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
A(ui, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function Pp(t, e) {
  const { x: n, y: r, base: a, width: i, height: o } = t.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], e);
  let s, l, c, u, f;
  return t.horizontal ? (f = o / 2, s = Math.min(n, a), l = Math.max(n, a), c = r - f, u = r + f) : (f = i / 2, s = n - f, l = n + f, c = Math.min(r, a), u = Math.max(r, a)), {
    left: s,
    top: c,
    right: l,
    bottom: u
  };
}
function Vt(t, e, n, r) {
  return t ? 0 : Ae(e, n, r);
}
function n9(t, e, n) {
  const r = t.options.borderWidth, a = t.borderSkipped, i = Zh(r);
  return {
    t: Vt(a.top, i.top, 0, n),
    r: Vt(a.right, i.right, 0, e),
    b: Vt(a.bottom, i.bottom, 0, n),
    l: Vt(a.left, i.left, 0, e)
  };
}
function r9(t, e, n) {
  const { enableBorderRadius: r } = t.getProps([
    "enableBorderRadius"
  ]), a = t.options.borderRadius, i = fn(a), o = Math.min(e, n), s = t.borderSkipped, l = r || ae(a);
  return {
    topLeft: Vt(!l || s.top || s.left, i.topLeft, 0, o),
    topRight: Vt(!l || s.top || s.right, i.topRight, 0, o),
    bottomLeft: Vt(!l || s.bottom || s.left, i.bottomLeft, 0, o),
    bottomRight: Vt(!l || s.bottom || s.right, i.bottomRight, 0, o)
  };
}
function a9(t) {
  const e = Pp(t), n = e.right - e.left, r = e.bottom - e.top, a = n9(t, n / 2, r / 2), i = r9(t, n / 2, r / 2);
  return {
    outer: {
      x: e.left,
      y: e.top,
      w: n,
      h: r,
      radius: i
    },
    inner: {
      x: e.left + a.l,
      y: e.top + a.t,
      w: n - a.l - a.r,
      h: r - a.t - a.b,
      radius: {
        topLeft: Math.max(0, i.topLeft - Math.max(a.t, a.l)),
        topRight: Math.max(0, i.topRight - Math.max(a.t, a.r)),
        bottomLeft: Math.max(0, i.bottomLeft - Math.max(a.b, a.l)),
        bottomRight: Math.max(0, i.bottomRight - Math.max(a.b, a.r))
      }
    }
  };
}
function Fo(t, e, n, r) {
  const a = e === null, i = n === null, s = t && !(a && i) && Pp(t, r);
  return s && (a || Tt(e, s.left, s.right)) && (i || Tt(n, s.top, s.bottom));
}
function i9(t) {
  return t.topLeft || t.topRight || t.bottomLeft || t.bottomRight;
}
function o9(t, e) {
  t.rect(e.x, e.y, e.w, e.h);
}
function Ho(t, e, n = {}) {
  const r = t.x !== n.x ? -e : 0, a = t.y !== n.y ? -e : 0, i = (t.x + t.w !== n.x + n.w ? e : 0) - r, o = (t.y + t.h !== n.y + n.h ? e : 0) - a;
  return {
    x: t.x + r,
    y: t.y + a,
    w: t.w + i,
    h: t.h + o,
    radius: t.radius
  };
}
class di extends It {
  constructor(e) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, e && Object.assign(this, e);
  }
  draw(e) {
    const { inflateAmount: n, options: { borderColor: r, backgroundColor: a } } = this, { inner: i, outer: o } = a9(this), s = i9(o.radius) ? wr : o9;
    e.save(), (o.w !== i.w || o.h !== i.h) && (e.beginPath(), s(e, Ho(o, n, i)), e.clip(), s(e, Ho(i, -n, o)), e.fillStyle = r, e.fill("evenodd")), e.beginPath(), s(e, Ho(i, n)), e.fillStyle = a, e.fill(), e.restore();
  }
  inRange(e, n, r) {
    return Fo(this, e, n, r);
  }
  inXRange(e, n) {
    return Fo(this, e, null, n);
  }
  inYRange(e, n) {
    return Fo(this, null, e, n);
  }
  getCenterPoint(e) {
    const { x: n, y: r, base: a, horizontal: i } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], e);
    return {
      x: i ? (n + a) / 2 : n,
      y: i ? r : (r + a) / 2
    };
  }
  getRange(e) {
    return e === "x" ? this.width / 2 : this.height / 2;
  }
}
A(di, "id", "bar"), A(di, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), A(di, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var s9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: Jn,
  BarElement: di,
  LineElement: jt,
  PointElement: ui
});
const yl = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], Jd = /* @__PURE__ */ yl.map((t) => t.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function Sp(t) {
  return yl[t % yl.length];
}
function Mp(t) {
  return Jd[t % Jd.length];
}
function l9(t, e) {
  return t.borderColor = Sp(e), t.backgroundColor = Mp(e), ++e;
}
function c9(t, e) {
  return t.backgroundColor = t.data.map(() => Sp(e++)), e;
}
function u9(t, e) {
  return t.backgroundColor = t.data.map(() => Mp(e++)), e;
}
function d9(t) {
  let e = 0;
  return (n, r) => {
    const a = t.getDatasetMeta(r).controller;
    a instanceof cn ? e = c9(n, e) : a instanceof cr ? e = u9(n, e) : a && (e = l9(n, e));
  };
}
function ef(t) {
  let e;
  for (e in t)
    if (t[e].borderColor || t[e].backgroundColor)
      return !0;
  return !1;
}
function f9(t) {
  return t && (t.borderColor || t.backgroundColor);
}
var h9 = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(t, e, n) {
    if (!n.enabled)
      return;
    const { data: { datasets: r }, options: a } = t.config, { elements: i } = a;
    if (!n.forceOverride && (ef(r) || f9(a) || i && ef(i)))
      return;
    const o = d9(t);
    r.forEach(o);
  }
};
function p9(t, e, n, r, a) {
  const i = a.samples || r;
  if (i >= n)
    return t.slice(e, e + n);
  const o = [], s = (n - 2) / (i - 2);
  let l = 0;
  const c = e + n - 1;
  let u = e, f, d, h, m, p;
  for (o[l++] = t[u], f = 0; f < i - 2; f++) {
    let g = 0, v = 0, w;
    const C = Math.floor((f + 1) * s) + 1 + e, x = Math.min(Math.floor((f + 2) * s) + 1, n) + e, y = x - C;
    for (w = C; w < x; w++)
      g += t[w].x, v += t[w].y;
    g /= y, v /= y;
    const _ = Math.floor(f * s) + 1 + e, k = Math.min(Math.floor((f + 1) * s) + 1, n) + e, { x: P, y: $ } = t[u];
    for (h = m = -1, w = _; w < k; w++)
      m = 0.5 * Math.abs((P - g) * (t[w].y - $) - (P - t[w].x) * (v - $)), m > h && (h = m, d = t[w], p = w);
    o[l++] = d, u = p;
  }
  return o[l++] = t[c], o;
}
function m9(t, e, n, r) {
  let a = 0, i = 0, o, s, l, c, u, f, d, h, m, p;
  const g = [], v = e + n - 1, w = t[e].x, x = t[v].x - w;
  for (o = e; o < e + n; ++o) {
    s = t[o], l = (s.x - w) / x * r, c = s.y;
    const y = l | 0;
    if (y === u)
      c < m ? (m = c, f = o) : c > p && (p = c, d = o), a = (i * a + s.x) / ++i;
    else {
      const _ = o - 1;
      if (!se(f) && !se(d)) {
        const k = Math.min(f, d), P = Math.max(f, d);
        k !== h && k !== _ && g.push({
          ...t[k],
          x: a
        }), P !== h && P !== _ && g.push({
          ...t[P],
          x: a
        });
      }
      o > 0 && _ !== h && g.push(t[_]), g.push(s), u = y, i = 0, m = p = c, f = d = h = o;
    }
  }
  return g;
}
function Op(t) {
  if (t._decimated) {
    const e = t._data;
    delete t._decimated, delete t._data, Object.defineProperty(t, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: e
    });
  }
}
function tf(t) {
  t.data.datasets.forEach((e) => {
    Op(e);
  });
}
function g9(t, e) {
  const n = e.length;
  let r = 0, a;
  const { iScale: i } = t, { min: o, max: s, minDefined: l, maxDefined: c } = i.getUserBounds();
  return l && (r = Ae($t(e, i.axis, o).lo, 0, n - 1)), c ? a = Ae($t(e, i.axis, s).hi + 1, r, n) - r : a = n - r, {
    start: r,
    count: a
  };
}
var v9 = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (t, e, n) => {
    if (!n.enabled) {
      tf(t);
      return;
    }
    const r = t.width;
    t.data.datasets.forEach((a, i) => {
      const { _data: o, indexAxis: s } = a, l = t.getDatasetMeta(i), c = o || a.data;
      if (Gn([
        s,
        t.options.indexAxis
      ]) === "y" || !l.controller.supportsDecimation)
        return;
      const u = t.scales[l.xAxisID];
      if (u.type !== "linear" && u.type !== "time" || t.options.parsing)
        return;
      let { start: f, count: d } = g9(l, c);
      const h = n.threshold || 4 * r;
      if (d <= h) {
        Op(a);
        return;
      }
      se(o) && (a._data = c, delete a.data, Object.defineProperty(a, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(p) {
          this._data = p;
        }
      }));
      let m;
      switch (n.algorithm) {
        case "lttb":
          m = p9(c, f, d, r, n);
          break;
        case "min-max":
          m = m9(c, f, d, r);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${n.algorithm}'`);
      }
      a._decimated = m;
    });
  },
  destroy(t) {
    tf(t);
  }
};
function y9(t, e, n) {
  const r = t.segments, a = t.points, i = e.points, o = [];
  for (const s of r) {
    let { start: l, end: c } = s;
    c = uc(l, c, a);
    const u = bl(n, a[l], a[c], s.loop);
    if (!e.segments) {
      o.push({
        source: s,
        target: u,
        start: a[l],
        end: a[c]
      });
      continue;
    }
    const f = up(e, u);
    for (const d of f) {
      const h = bl(n, i[d.start], i[d.end], d.loop), m = cp(s, a, h);
      for (const p of m)
        o.push({
          source: p,
          target: d,
          start: {
            [n]: nf(u, h, "start", Math.max)
          },
          end: {
            [n]: nf(u, h, "end", Math.min)
          }
        });
    }
  }
  return o;
}
function bl(t, e, n, r) {
  if (r)
    return;
  let a = e[t], i = n[t];
  return t === "angle" && (a = Ze(a), i = Ze(i)), {
    property: t,
    start: a,
    end: i
  };
}
function b9(t, e) {
  const { x: n = null, y: r = null } = t || {}, a = e.points, i = [];
  return e.segments.forEach(({ start: o, end: s }) => {
    s = uc(o, s, a);
    const l = a[o], c = a[s];
    r !== null ? (i.push({
      x: l.x,
      y: r
    }), i.push({
      x: c.x,
      y: r
    })) : n !== null && (i.push({
      x: n,
      y: l.y
    }), i.push({
      x: n,
      y: c.y
    }));
  }), i;
}
function uc(t, e, n) {
  for (; e > t; e--) {
    const r = n[e];
    if (!isNaN(r.x) && !isNaN(r.y))
      break;
  }
  return e;
}
function nf(t, e, n, r) {
  return t && e ? r(t[n], e[n]) : t ? t[n] : e ? e[n] : 0;
}
function Dp(t, e) {
  let n = [], r = !1;
  return ye(t) ? (r = !0, n = t) : n = b9(t, e), n.length ? new jt({
    points: n,
    options: {
      tension: 0
    },
    _loop: r,
    _fullLoop: r
  }) : null;
}
function rf(t) {
  return t && t.fill !== !1;
}
function _9(t, e, n) {
  let a = t[e].fill;
  const i = [
    e
  ];
  let o;
  if (!n)
    return a;
  for (; a !== !1 && i.indexOf(a) === -1; ) {
    if (!Pe(a))
      return a;
    if (o = t[a], !o)
      return !1;
    if (o.visible)
      return a;
    i.push(a), a = o.fill;
  }
  return !1;
}
function w9(t, e, n) {
  const r = P9(t);
  if (ae(r))
    return isNaN(r.value) ? !1 : r;
  let a = parseFloat(r);
  return Pe(a) && Math.floor(a) === a ? k9(r[0], e, a, n) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(r) >= 0 && r;
}
function k9(t, e, n, r) {
  return (t === "-" || t === "+") && (n = e + n), n === e || n < 0 || n >= r ? !1 : n;
}
function x9(t, e) {
  let n = null;
  return t === "start" ? n = e.bottom : t === "end" ? n = e.top : ae(t) ? n = e.getPixelForValue(t.value) : e.getBasePixel && (n = e.getBasePixel()), n;
}
function C9(t, e, n) {
  let r;
  return t === "start" ? r = n : t === "end" ? r = e.options.reverse ? e.min : e.max : ae(t) ? r = t.value : r = e.getBaseValue(), r;
}
function P9(t) {
  const e = t.options, n = e.fill;
  let r = ee(n && n.target, n);
  return r === void 0 && (r = !!e.backgroundColor), r === !1 || r === null ? !1 : r === !0 ? "origin" : r;
}
function S9(t) {
  const { scale: e, index: n, line: r } = t, a = [], i = r.segments, o = r.points, s = M9(e, n);
  s.push(Dp({
    x: null,
    y: e.bottom
  }, r));
  for (let l = 0; l < i.length; l++) {
    const c = i[l];
    for (let u = c.start; u <= c.end; u++)
      O9(a, o[u], s);
  }
  return new jt({
    points: a,
    options: {}
  });
}
function M9(t, e) {
  const n = [], r = t.getMatchingVisibleMetas("line");
  for (let a = 0; a < r.length; a++) {
    const i = r[a];
    if (i.index === e)
      break;
    i.hidden || n.unshift(i.dataset);
  }
  return n;
}
function O9(t, e, n) {
  const r = [];
  for (let a = 0; a < n.length; a++) {
    const i = n[a], { first: o, last: s, point: l } = D9(i, e, "x");
    if (!(!l || o && s)) {
      if (o)
        r.unshift(l);
      else if (t.push(l), !s)
        break;
    }
  }
  t.push(...r);
}
function D9(t, e, n) {
  const r = t.interpolate(e, n);
  if (!r)
    return {};
  const a = r[n], i = t.segments, o = t.points;
  let s = !1, l = !1;
  for (let c = 0; c < i.length; c++) {
    const u = i[c], f = o[u.start][n], d = o[u.end][n];
    if (Tt(a, f, d)) {
      s = a === f, l = a === d;
      break;
    }
  }
  return {
    first: s,
    last: l,
    point: r
  };
}
class Tp {
  constructor(e) {
    this.x = e.x, this.y = e.y, this.radius = e.radius;
  }
  pathSegment(e, n, r) {
    const { x: a, y: i, radius: o } = this;
    return n = n || {
      start: 0,
      end: be
    }, e.arc(a, i, o, n.end, n.start, !0), !r.bounds;
  }
  interpolate(e) {
    const { x: n, y: r, radius: a } = this, i = e.angle;
    return {
      x: n + Math.cos(i) * a,
      y: r + Math.sin(i) * a,
      angle: i
    };
  }
}
function T9(t) {
  const { chart: e, fill: n, line: r } = t;
  if (Pe(n))
    return $9(e, n);
  if (n === "stack")
    return S9(t);
  if (n === "shape")
    return !0;
  const a = R9(t);
  return a instanceof Tp ? a : Dp(a, r);
}
function $9(t, e) {
  const n = t.getDatasetMeta(e);
  return n && t.isDatasetVisible(e) ? n.dataset : null;
}
function R9(t) {
  return (t.scale || {}).getPointPositionForValue ? A9(t) : E9(t);
}
function E9(t) {
  const { scale: e = {}, fill: n } = t, r = x9(n, e);
  if (Pe(r)) {
    const a = e.isHorizontal();
    return {
      x: a ? r : null,
      y: a ? null : r
    };
  }
  return null;
}
function A9(t) {
  const { scale: e, fill: n } = t, r = e.options, a = e.getLabels().length, i = r.reverse ? e.max : e.min, o = C9(n, e, i), s = [];
  if (r.grid.circular) {
    const l = e.getPointPositionForValue(0, i);
    return new Tp({
      x: l.x,
      y: l.y,
      radius: e.getDistanceFromCenterForValue(o)
    });
  }
  for (let l = 0; l < a; ++l)
    s.push(e.getPointPositionForValue(l, o));
  return s;
}
function jo(t, e, n) {
  const r = T9(e), { line: a, scale: i, axis: o } = e, s = a.options, l = s.fill, c = s.backgroundColor, { above: u = c, below: f = c } = l || {};
  r && a.points.length && (wo(t, n), L9(t, {
    line: a,
    target: r,
    above: u,
    below: f,
    area: n,
    scale: i,
    axis: o
  }), ko(t));
}
function L9(t, e) {
  const { line: n, target: r, above: a, below: i, area: o, scale: s } = e, l = n._loop ? "angle" : e.axis;
  t.save(), l === "x" && i !== a && (af(t, r, o.top), of(t, {
    line: n,
    target: r,
    color: a,
    scale: s,
    property: l
  }), t.restore(), t.save(), af(t, r, o.bottom)), of(t, {
    line: n,
    target: r,
    color: i,
    scale: s,
    property: l
  }), t.restore();
}
function af(t, e, n) {
  const { segments: r, points: a } = e;
  let i = !0, o = !1;
  t.beginPath();
  for (const s of r) {
    const { start: l, end: c } = s, u = a[l], f = a[uc(l, c, a)];
    i ? (t.moveTo(u.x, u.y), i = !1) : (t.lineTo(u.x, n), t.lineTo(u.x, u.y)), o = !!e.pathSegment(t, s, {
      move: o
    }), o ? t.closePath() : t.lineTo(f.x, n);
  }
  t.lineTo(e.first().x, n), t.closePath(), t.clip();
}
function of(t, e) {
  const { line: n, target: r, property: a, color: i, scale: o } = e, s = y9(n, r, a);
  for (const { source: l, target: c, start: u, end: f } of s) {
    const { style: { backgroundColor: d = i } = {} } = l, h = r !== !0;
    t.save(), t.fillStyle = d, I9(t, o, h && bl(a, u, f)), t.beginPath();
    const m = !!n.pathSegment(t, l);
    let p;
    if (h) {
      m ? t.closePath() : sf(t, r, f, a);
      const g = !!r.pathSegment(t, c, {
        move: m,
        reverse: !0
      });
      p = m && g, p || sf(t, r, u, a);
    }
    t.closePath(), t.fill(p ? "evenodd" : "nonzero"), t.restore();
  }
}
function I9(t, e, n) {
  const { top: r, bottom: a } = e.chart.chartArea, { property: i, start: o, end: s } = n || {};
  i === "x" && (t.beginPath(), t.rect(o, r, s - o, a - r), t.clip());
}
function sf(t, e, n, r) {
  const a = e.interpolate(n, r);
  a && t.lineTo(a.x, a.y);
}
var N9 = {
  id: "filler",
  afterDatasetsUpdate(t, e, n) {
    const r = (t.data.datasets || []).length, a = [];
    let i, o, s, l;
    for (o = 0; o < r; ++o)
      i = t.getDatasetMeta(o), s = i.dataset, l = null, s && s.options && s instanceof jt && (l = {
        visible: t.isDatasetVisible(o),
        index: o,
        fill: w9(s, o, r),
        chart: t,
        axis: i.controller.options.indexAxis,
        scale: i.vScale,
        line: s
      }), i.$filler = l, a.push(l);
    for (o = 0; o < r; ++o)
      l = a[o], !(!l || l.fill === !1) && (l.fill = _9(a, o, n.propagate));
  },
  beforeDraw(t, e, n) {
    const r = n.drawTime === "beforeDraw", a = t.getSortedVisibleDatasetMetas(), i = t.chartArea;
    for (let o = a.length - 1; o >= 0; --o) {
      const s = a[o].$filler;
      s && (s.line.updateControlPoints(i, s.axis), r && s.fill && jo(t.ctx, s, i));
    }
  },
  beforeDatasetsDraw(t, e, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const r = t.getSortedVisibleDatasetMetas();
    for (let a = r.length - 1; a >= 0; --a) {
      const i = r[a].$filler;
      rf(i) && jo(t.ctx, i, t.chartArea);
    }
  },
  beforeDatasetDraw(t, e, n) {
    const r = e.meta.$filler;
    !rf(r) || n.drawTime !== "beforeDatasetDraw" || jo(t.ctx, r, t.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const lf = (t, e) => {
  let { boxHeight: n = e, boxWidth: r = e } = t;
  return t.usePointStyle && (n = Math.min(n, e), r = t.pointStyleWidth || Math.min(r, e)), {
    boxWidth: r,
    boxHeight: n,
    itemHeight: Math.max(e, n)
  };
}, W9 = (t, e) => t !== null && e !== null && t.datasetIndex === e.datasetIndex && t.index === e.index;
class cf extends It {
  constructor(e) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, n, r) {
    this.maxWidth = e, this.maxHeight = n, this._margins = r, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const e = this.options.labels || {};
    let n = ge(e.generateLabels, [
      this.chart
    ], this) || [];
    e.filter && (n = n.filter((r) => e.filter(r, this.chart.data))), e.sort && (n = n.sort((r, a) => e.sort(r, a, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: e, ctx: n } = this;
    if (!e.display) {
      this.width = this.height = 0;
      return;
    }
    const r = e.labels, a = $e(r.font), i = a.size, o = this._computeTitleHeight(), { boxWidth: s, itemHeight: l } = lf(r, i);
    let c, u;
    n.font = a.string, this.isHorizontal() ? (c = this.maxWidth, u = this._fitRows(o, i, s, l) + 10) : (u = this.maxHeight, c = this._fitCols(o, a, s, l) + 10), this.width = Math.min(c, e.maxWidth || this.maxWidth), this.height = Math.min(u, e.maxHeight || this.maxHeight);
  }
  _fitRows(e, n, r, a) {
    const { ctx: i, maxWidth: o, options: { labels: { padding: s } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], u = a + s;
    let f = e;
    i.textAlign = "left", i.textBaseline = "middle";
    let d = -1, h = -u;
    return this.legendItems.forEach((m, p) => {
      const g = r + n / 2 + i.measureText(m.text).width;
      (p === 0 || c[c.length - 1] + g + 2 * s > o) && (f += u, c[c.length - (p > 0 ? 0 : 1)] = 0, h += u, d++), l[p] = {
        left: 0,
        top: h,
        row: d,
        width: g,
        height: a
      }, c[c.length - 1] += g + s;
    }), f;
  }
  _fitCols(e, n, r, a) {
    const { ctx: i, maxHeight: o, options: { labels: { padding: s } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], u = o - e;
    let f = s, d = 0, h = 0, m = 0, p = 0;
    return this.legendItems.forEach((g, v) => {
      const { itemWidth: w, itemHeight: C } = z9(r, n, i, g, a);
      v > 0 && h + C + 2 * s > u && (f += d + s, c.push({
        width: d,
        height: h
      }), m += d + s, p++, d = h = 0), l[v] = {
        left: m,
        top: h,
        col: p,
        width: w,
        height: C
      }, d = Math.max(d, w), h += C + s;
    }), f += d, c.push({
      width: d,
      height: h
    }), f;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const e = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: r, labels: { padding: a }, rtl: i } } = this, o = Sn(i, this.left, this.width);
    if (this.isHorizontal()) {
      let s = 0, l = We(r, this.left + a, this.right - this.lineWidths[s]);
      for (const c of n)
        s !== c.row && (s = c.row, l = We(r, this.left + a, this.right - this.lineWidths[s])), c.top += this.top + e + a, c.left = o.leftForLtr(o.x(l), c.width), l += c.width + a;
    } else {
      let s = 0, l = We(r, this.top + e + a, this.bottom - this.columnSizes[s].height);
      for (const c of n)
        c.col !== s && (s = c.col, l = We(r, this.top + e + a, this.bottom - this.columnSizes[s].height)), c.top = l, c.left += this.left + a, c.left = o.leftForLtr(o.x(c.left), c.width), l += c.height + a;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const e = this.ctx;
      wo(e, this), this._draw(), ko(e);
    }
  }
  _draw() {
    const { options: e, columnSizes: n, lineWidths: r, ctx: a } = this, { align: i, labels: o } = e, s = Se.color, l = Sn(e.rtl, this.left, this.width), c = $e(o.font), { padding: u } = o, f = c.size, d = f / 2;
    let h;
    this.drawTitle(), a.textAlign = l.textAlign("left"), a.textBaseline = "middle", a.lineWidth = 0.5, a.font = c.string;
    const { boxWidth: m, boxHeight: p, itemHeight: g } = lf(o, f), v = function(_, k, P) {
      if (isNaN(m) || m <= 0 || isNaN(p) || p < 0)
        return;
      a.save();
      const $ = ee(P.lineWidth, 1);
      if (a.fillStyle = ee(P.fillStyle, s), a.lineCap = ee(P.lineCap, "butt"), a.lineDashOffset = ee(P.lineDashOffset, 0), a.lineJoin = ee(P.lineJoin, "miter"), a.lineWidth = $, a.strokeStyle = ee(P.strokeStyle, s), a.setLineDash(ee(P.lineDash, [])), o.usePointStyle) {
        const O = {
          radius: p * Math.SQRT2 / 2,
          pointStyle: P.pointStyle,
          rotation: P.rotation,
          borderWidth: $
        }, D = l.xPlus(_, m / 2), N = k + d;
        Gh(a, O, D, N, o.pointStyleWidth && m);
      } else {
        const O = k + Math.max((f - p) / 2, 0), D = l.leftForLtr(_, m), N = fn(P.borderRadius);
        a.beginPath(), Object.values(N).some((q) => q !== 0) ? wr(a, {
          x: D,
          y: O,
          w: m,
          h: p,
          radius: N
        }) : a.rect(D, O, m, p), a.fill(), $ !== 0 && a.stroke();
      }
      a.restore();
    }, w = function(_, k, P) {
      gn(a, P.text, _, k + g / 2, c, {
        strikethrough: P.hidden,
        textAlign: l.textAlign(P.textAlign)
      });
    }, C = this.isHorizontal(), x = this._computeTitleHeight();
    C ? h = {
      x: We(i, this.left + u, this.right - r[0]),
      y: this.top + u + x,
      line: 0
    } : h = {
      x: this.left + u,
      y: We(i, this.top + x + u, this.bottom - n[0].height),
      line: 0
    }, op(this.ctx, e.textDirection);
    const y = g + u;
    this.legendItems.forEach((_, k) => {
      a.strokeStyle = _.fontColor, a.fillStyle = _.fontColor;
      const P = a.measureText(_.text).width, $ = l.textAlign(_.textAlign || (_.textAlign = o.textAlign)), O = m + d + P;
      let D = h.x, N = h.y;
      l.setWidth(this.width), C ? k > 0 && D + O + u > this.right && (N = h.y += y, h.line++, D = h.x = We(i, this.left + u, this.right - r[h.line])) : k > 0 && N + y > this.bottom && (D = h.x = D + n[h.line].width + u, h.line++, N = h.y = We(i, this.top + x + u, this.bottom - n[h.line].height));
      const q = l.x(D);
      if (v(q, N, _), D = oP($, D + m + d, C ? D + O : this.right, e.rtl), w(l.x(D), N, _), C)
        h.x += O + u;
      else if (typeof _.text != "string") {
        const le = c.lineHeight;
        h.y += $p(_, le) + u;
      } else
        h.y += y;
    }), sp(this.ctx, e.textDirection);
  }
  drawTitle() {
    const e = this.options, n = e.title, r = $e(n.font), a = Fe(n.padding);
    if (!n.display)
      return;
    const i = Sn(e.rtl, this.left, this.width), o = this.ctx, s = n.position, l = r.size / 2, c = a.top + l;
    let u, f = this.left, d = this.width;
    if (this.isHorizontal())
      d = Math.max(...this.lineWidths), u = this.top + c, f = We(e.align, f, this.right - d);
    else {
      const m = this.columnSizes.reduce((p, g) => Math.max(p, g.height), 0);
      u = c + We(e.align, this.top, this.bottom - m - e.labels.padding - this._computeTitleHeight());
    }
    const h = We(s, f, f + d);
    o.textAlign = i.textAlign(nc(s)), o.textBaseline = "middle", o.strokeStyle = n.color, o.fillStyle = n.color, o.font = r.string, gn(o, n.text, h, u, r);
  }
  _computeTitleHeight() {
    const e = this.options.title, n = $e(e.font), r = Fe(e.padding);
    return e.display ? n.lineHeight + r.height : 0;
  }
  _getLegendItemAt(e, n) {
    let r, a, i;
    if (Tt(e, this.left, this.right) && Tt(n, this.top, this.bottom)) {
      for (i = this.legendHitBoxes, r = 0; r < i.length; ++r)
        if (a = i[r], Tt(e, a.left, a.left + a.width) && Tt(n, a.top, a.top + a.height))
          return this.legendItems[r];
    }
    return null;
  }
  handleEvent(e) {
    const n = this.options;
    if (!H9(e.type, n))
      return;
    const r = this._getLegendItemAt(e.x, e.y);
    if (e.type === "mousemove" || e.type === "mouseout") {
      const a = this._hoveredItem, i = W9(a, r);
      a && !i && ge(n.onLeave, [
        e,
        a,
        this
      ], this), this._hoveredItem = r, r && !i && ge(n.onHover, [
        e,
        r,
        this
      ], this);
    } else
      r && ge(n.onClick, [
        e,
        r,
        this
      ], this);
  }
}
function z9(t, e, n, r, a) {
  const i = B9(r, t, e, n), o = F9(a, r, e.lineHeight);
  return {
    itemWidth: i,
    itemHeight: o
  };
}
function B9(t, e, n, r) {
  let a = t.text;
  return a && typeof a != "string" && (a = a.reduce((i, o) => i.length > o.length ? i : o)), e + n.size / 2 + r.measureText(a).width;
}
function F9(t, e, n) {
  let r = t;
  return typeof e.text != "string" && (r = $p(e, n)), r;
}
function $p(t, e) {
  const n = t.text ? t.text.length : 0;
  return e * n;
}
function H9(t, e) {
  return !!((t === "mousemove" || t === "mouseout") && (e.onHover || e.onLeave) || e.onClick && (t === "click" || t === "mouseup"));
}
var j9 = {
  id: "legend",
  _element: cf,
  start(t, e, n) {
    const r = t.legend = new cf({
      ctx: t.ctx,
      options: n,
      chart: t
    });
    Be.configure(t, r, n), Be.addBox(t, r);
  },
  stop(t) {
    Be.removeBox(t, t.legend), delete t.legend;
  },
  beforeUpdate(t, e, n) {
    const r = t.legend;
    Be.configure(t, r, n), r.options = n;
  },
  afterUpdate(t) {
    const e = t.legend;
    e.buildLabels(), e.adjustHitBoxes();
  },
  afterEvent(t, e) {
    e.replay || t.legend.handleEvent(e.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(t, e, n) {
      const r = e.datasetIndex, a = n.chart;
      a.isDatasetVisible(r) ? (a.hide(r), e.hidden = !0) : (a.show(r), e.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (t) => t.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(t) {
        const e = t.data.datasets, { labels: { usePointStyle: n, pointStyle: r, textAlign: a, color: i, useBorderRadius: o, borderRadius: s } } = t.legend.options;
        return t._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(n ? 0 : void 0), u = Fe(c.borderWidth);
          return {
            text: e[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: i,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: r || c.pointStyle,
            rotation: c.rotation,
            textAlign: a || c.textAlign,
            borderRadius: o && (s || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (t) => t.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (t) => !t.startsWith("on"),
    labels: {
      _scriptable: (t) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(t)
    }
  }
};
class dc extends It {
  constructor(e) {
    super(), this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, n) {
    const r = this.options;
    if (this.left = 0, this.top = 0, !r.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = e, this.height = this.bottom = n;
    const a = ye(r.text) ? r.text.length : 1;
    this._padding = Fe(r.padding);
    const i = a * $e(r.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = i : this.width = i;
  }
  isHorizontal() {
    const e = this.options.position;
    return e === "top" || e === "bottom";
  }
  _drawArgs(e) {
    const { top: n, left: r, bottom: a, right: i, options: o } = this, s = o.align;
    let l = 0, c, u, f;
    return this.isHorizontal() ? (u = We(s, r, i), f = n + e, c = i - r) : (o.position === "left" ? (u = r + e, f = We(s, a, n), l = ke * -0.5) : (u = i - e, f = We(s, n, a), l = ke * 0.5), c = a - n), {
      titleX: u,
      titleY: f,
      maxWidth: c,
      rotation: l
    };
  }
  draw() {
    const e = this.ctx, n = this.options;
    if (!n.display)
      return;
    const r = $e(n.font), i = r.lineHeight / 2 + this._padding.top, { titleX: o, titleY: s, maxWidth: l, rotation: c } = this._drawArgs(i);
    gn(e, n.text, 0, 0, r, {
      color: n.color,
      maxWidth: l,
      rotation: c,
      textAlign: nc(n.align),
      textBaseline: "middle",
      translation: [
        o,
        s
      ]
    });
  }
}
function V9(t, e) {
  const n = new dc({
    ctx: t.ctx,
    options: e,
    chart: t
  });
  Be.configure(t, n, e), Be.addBox(t, n), t.titleBlock = n;
}
var q9 = {
  id: "title",
  _element: dc,
  start(t, e, n) {
    V9(t, n);
  },
  stop(t) {
    const e = t.titleBlock;
    Be.removeBox(t, e), delete t.titleBlock;
  },
  beforeUpdate(t, e, n) {
    const r = t.titleBlock;
    Be.configure(t, r, n), r.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const ua = /* @__PURE__ */ new WeakMap();
var U9 = {
  id: "subtitle",
  start(t, e, n) {
    const r = new dc({
      ctx: t.ctx,
      options: n,
      chart: t
    });
    Be.configure(t, r, n), Be.addBox(t, r), ua.set(t, r);
  },
  stop(t) {
    Be.removeBox(t, ua.get(t)), ua.delete(t);
  },
  beforeUpdate(t, e, n) {
    const r = ua.get(t);
    Be.configure(t, r, n), r.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const er = {
  average(t) {
    if (!t.length)
      return !1;
    let e, n, r = 0, a = 0, i = 0;
    for (e = 0, n = t.length; e < n; ++e) {
      const o = t[e].element;
      if (o && o.hasValue()) {
        const s = o.tooltipPosition();
        r += s.x, a += s.y, ++i;
      }
    }
    return {
      x: r / i,
      y: a / i
    };
  },
  nearest(t, e) {
    if (!t.length)
      return !1;
    let n = e.x, r = e.y, a = Number.POSITIVE_INFINITY, i, o, s;
    for (i = 0, o = t.length; i < o; ++i) {
      const l = t[i].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = dl(e, c);
        u < a && (a = u, s = l);
      }
    }
    if (s) {
      const l = s.tooltipPosition();
      n = l.x, r = l.y;
    }
    return {
      x: n,
      y: r
    };
  }
};
function mt(t, e) {
  return e && (ye(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t;
}
function St(t) {
  return (typeof t == "string" || t instanceof String) && t.indexOf(`
`) > -1 ? t.split(`
`) : t;
}
function Y9(t, e) {
  const { element: n, datasetIndex: r, index: a } = e, i = t.getDatasetMeta(r).controller, { label: o, value: s } = i.getLabelAndValue(a);
  return {
    chart: t,
    label: o,
    parsed: i.getParsed(a),
    raw: t.data.datasets[r].data[a],
    formattedValue: s,
    dataset: i.getDataset(),
    dataIndex: a,
    datasetIndex: r,
    element: n
  };
}
function uf(t, e) {
  const n = t.chart.ctx, { body: r, footer: a, title: i } = t, { boxWidth: o, boxHeight: s } = e, l = $e(e.bodyFont), c = $e(e.titleFont), u = $e(e.footerFont), f = i.length, d = a.length, h = r.length, m = Fe(e.padding);
  let p = m.height, g = 0, v = r.reduce((x, y) => x + y.before.length + y.lines.length + y.after.length, 0);
  if (v += t.beforeBody.length + t.afterBody.length, f && (p += f * c.lineHeight + (f - 1) * e.titleSpacing + e.titleMarginBottom), v) {
    const x = e.displayColors ? Math.max(s, l.lineHeight) : l.lineHeight;
    p += h * x + (v - h) * l.lineHeight + (v - 1) * e.bodySpacing;
  }
  d && (p += e.footerMarginTop + d * u.lineHeight + (d - 1) * e.footerSpacing);
  let w = 0;
  const C = function(x) {
    g = Math.max(g, n.measureText(x).width + w);
  };
  return n.save(), n.font = c.string, he(t.title, C), n.font = l.string, he(t.beforeBody.concat(t.afterBody), C), w = e.displayColors ? o + 2 + e.boxPadding : 0, he(r, (x) => {
    he(x.before, C), he(x.lines, C), he(x.after, C);
  }), w = 0, n.font = u.string, he(t.footer, C), n.restore(), g += m.width, {
    width: g,
    height: p
  };
}
function X9(t, e) {
  const { y: n, height: r } = e;
  return n < r / 2 ? "top" : n > t.height - r / 2 ? "bottom" : "center";
}
function K9(t, e, n, r) {
  const { x: a, width: i } = r, o = n.caretSize + n.caretPadding;
  if (t === "left" && a + i + o > e.width || t === "right" && a - i - o < 0)
    return !0;
}
function Q9(t, e, n, r) {
  const { x: a, width: i } = n, { width: o, chartArea: { left: s, right: l } } = t;
  let c = "center";
  return r === "center" ? c = a <= (s + l) / 2 ? "left" : "right" : a <= i / 2 ? c = "left" : a >= o - i / 2 && (c = "right"), K9(c, t, e, n) && (c = "center"), c;
}
function df(t, e, n) {
  const r = n.yAlign || e.yAlign || X9(t, n);
  return {
    xAlign: n.xAlign || e.xAlign || Q9(t, e, n, r),
    yAlign: r
  };
}
function G9(t, e) {
  let { x: n, width: r } = t;
  return e === "right" ? n -= r : e === "center" && (n -= r / 2), n;
}
function Z9(t, e, n) {
  let { y: r, height: a } = t;
  return e === "top" ? r += n : e === "bottom" ? r -= a + n : r -= a / 2, r;
}
function ff(t, e, n, r) {
  const { caretSize: a, caretPadding: i, cornerRadius: o } = t, { xAlign: s, yAlign: l } = n, c = a + i, { topLeft: u, topRight: f, bottomLeft: d, bottomRight: h } = fn(o);
  let m = G9(e, s);
  const p = Z9(e, l, c);
  return l === "center" ? s === "left" ? m += c : s === "right" && (m -= c) : s === "left" ? m -= Math.max(u, d) + a : s === "right" && (m += Math.max(f, h) + a), {
    x: Ae(m, 0, r.width - e.width),
    y: Ae(p, 0, r.height - e.height)
  };
}
function da(t, e, n) {
  const r = Fe(n.padding);
  return e === "center" ? t.x + t.width / 2 : e === "right" ? t.x + t.width - r.right : t.x + r.left;
}
function hf(t) {
  return mt([], St(t));
}
function J9(t, e, n) {
  return Zt(t, {
    tooltip: e,
    tooltipItems: n,
    type: "tooltip"
  });
}
function pf(t, e) {
  const n = e && e.dataset && e.dataset.tooltip && e.dataset.tooltip.callbacks;
  return n ? t.override(n) : t;
}
const Rp = {
  beforeTitle: xt,
  title(t) {
    if (t.length > 0) {
      const e = t[0], n = e.chart.data.labels, r = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return e.dataset.label || "";
      if (e.label)
        return e.label;
      if (r > 0 && e.dataIndex < r)
        return n[e.dataIndex];
    }
    return "";
  },
  afterTitle: xt,
  beforeBody: xt,
  beforeLabel: xt,
  label(t) {
    if (this && this.options && this.options.mode === "dataset")
      return t.label + ": " + t.formattedValue || t.formattedValue;
    let e = t.dataset.label || "";
    e && (e += ": ");
    const n = t.formattedValue;
    return se(n) || (e += n), e;
  },
  labelColor(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: xt,
  afterBody: xt,
  beforeFooter: xt,
  footer: xt,
  afterFooter: xt
};
function Ye(t, e, n, r) {
  const a = t[e].call(n, r);
  return typeof a > "u" ? Rp[e].call(n, r) : a;
}
class _l extends It {
  constructor(e) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = e.chart, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(e) {
    this.options = e, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const e = this._cachedAnimations;
    if (e)
      return e;
    const n = this.chart, r = this.options.setContext(this.getContext()), a = r.enabled && n.options.animation && r.animations, i = new dp(this.chart, a);
    return a._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = J9(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(e, n) {
    const { callbacks: r } = n, a = Ye(r, "beforeTitle", this, e), i = Ye(r, "title", this, e), o = Ye(r, "afterTitle", this, e);
    let s = [];
    return s = mt(s, St(a)), s = mt(s, St(i)), s = mt(s, St(o)), s;
  }
  getBeforeBody(e, n) {
    return hf(Ye(n.callbacks, "beforeBody", this, e));
  }
  getBody(e, n) {
    const { callbacks: r } = n, a = [];
    return he(e, (i) => {
      const o = {
        before: [],
        lines: [],
        after: []
      }, s = pf(r, i);
      mt(o.before, St(Ye(s, "beforeLabel", this, i))), mt(o.lines, Ye(s, "label", this, i)), mt(o.after, St(Ye(s, "afterLabel", this, i))), a.push(o);
    }), a;
  }
  getAfterBody(e, n) {
    return hf(Ye(n.callbacks, "afterBody", this, e));
  }
  getFooter(e, n) {
    const { callbacks: r } = n, a = Ye(r, "beforeFooter", this, e), i = Ye(r, "footer", this, e), o = Ye(r, "afterFooter", this, e);
    let s = [];
    return s = mt(s, St(a)), s = mt(s, St(i)), s = mt(s, St(o)), s;
  }
  _createItems(e) {
    const n = this._active, r = this.chart.data, a = [], i = [], o = [];
    let s = [], l, c;
    for (l = 0, c = n.length; l < c; ++l)
      s.push(Y9(this.chart, n[l]));
    return e.filter && (s = s.filter((u, f, d) => e.filter(u, f, d, r))), e.itemSort && (s = s.sort((u, f) => e.itemSort(u, f, r))), he(s, (u) => {
      const f = pf(e.callbacks, u);
      a.push(Ye(f, "labelColor", this, u)), i.push(Ye(f, "labelPointStyle", this, u)), o.push(Ye(f, "labelTextColor", this, u));
    }), this.labelColors = a, this.labelPointStyles = i, this.labelTextColors = o, this.dataPoints = s, s;
  }
  update(e, n) {
    const r = this.options.setContext(this.getContext()), a = this._active;
    let i, o = [];
    if (!a.length)
      this.opacity !== 0 && (i = {
        opacity: 0
      });
    else {
      const s = er[r.position].call(this, a, this._eventPosition);
      o = this._createItems(r), this.title = this.getTitle(o, r), this.beforeBody = this.getBeforeBody(o, r), this.body = this.getBody(o, r), this.afterBody = this.getAfterBody(o, r), this.footer = this.getFooter(o, r);
      const l = this._size = uf(this, r), c = Object.assign({}, s, l), u = df(this.chart, r, c), f = ff(r, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, i = {
        opacity: 1,
        x: f.x,
        y: f.y,
        width: l.width,
        height: l.height,
        caretX: s.x,
        caretY: s.y
      };
    }
    this._tooltipItems = o, this.$context = void 0, i && this._resolveAnimations().update(this, i), e && r.external && r.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(e, n, r, a) {
    const i = this.getCaretPosition(e, r, a);
    n.lineTo(i.x1, i.y1), n.lineTo(i.x2, i.y2), n.lineTo(i.x3, i.y3);
  }
  getCaretPosition(e, n, r) {
    const { xAlign: a, yAlign: i } = this, { caretSize: o, cornerRadius: s } = r, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: f } = fn(s), { x: d, y: h } = e, { width: m, height: p } = n;
    let g, v, w, C, x, y;
    return i === "center" ? (x = h + p / 2, a === "left" ? (g = d, v = g - o, C = x + o, y = x - o) : (g = d + m, v = g + o, C = x - o, y = x + o), w = g) : (a === "left" ? v = d + Math.max(l, u) + o : a === "right" ? v = d + m - Math.max(c, f) - o : v = this.caretX, i === "top" ? (C = h, x = C - o, g = v - o, w = v + o) : (C = h + p, x = C + o, g = v + o, w = v - o), y = C), {
      x1: g,
      x2: v,
      x3: w,
      y1: C,
      y2: x,
      y3: y
    };
  }
  drawTitle(e, n, r) {
    const a = this.title, i = a.length;
    let o, s, l;
    if (i) {
      const c = Sn(r.rtl, this.x, this.width);
      for (e.x = da(this, r.titleAlign, r), n.textAlign = c.textAlign(r.titleAlign), n.textBaseline = "middle", o = $e(r.titleFont), s = r.titleSpacing, n.fillStyle = r.titleColor, n.font = o.string, l = 0; l < i; ++l)
        n.fillText(a[l], c.x(e.x), e.y + o.lineHeight / 2), e.y += o.lineHeight + s, l + 1 === i && (e.y += r.titleMarginBottom - s);
    }
  }
  _drawColorBox(e, n, r, a, i) {
    const o = this.labelColors[r], s = this.labelPointStyles[r], { boxHeight: l, boxWidth: c } = i, u = $e(i.bodyFont), f = da(this, "left", i), d = a.x(f), h = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, m = n.y + h;
    if (i.usePointStyle) {
      const p = {
        radius: Math.min(c, l) / 2,
        pointStyle: s.pointStyle,
        rotation: s.rotation,
        borderWidth: 1
      }, g = a.leftForLtr(d, c) + c / 2, v = m + l / 2;
      e.strokeStyle = i.multiKeyBackground, e.fillStyle = i.multiKeyBackground, hl(e, p, g, v), e.strokeStyle = o.borderColor, e.fillStyle = o.backgroundColor, hl(e, p, g, v);
    } else {
      e.lineWidth = ae(o.borderWidth) ? Math.max(...Object.values(o.borderWidth)) : o.borderWidth || 1, e.strokeStyle = o.borderColor, e.setLineDash(o.borderDash || []), e.lineDashOffset = o.borderDashOffset || 0;
      const p = a.leftForLtr(d, c), g = a.leftForLtr(a.xPlus(d, 1), c - 2), v = fn(o.borderRadius);
      Object.values(v).some((w) => w !== 0) ? (e.beginPath(), e.fillStyle = i.multiKeyBackground, wr(e, {
        x: p,
        y: m,
        w: c,
        h: l,
        radius: v
      }), e.fill(), e.stroke(), e.fillStyle = o.backgroundColor, e.beginPath(), wr(e, {
        x: g,
        y: m + 1,
        w: c - 2,
        h: l - 2,
        radius: v
      }), e.fill()) : (e.fillStyle = i.multiKeyBackground, e.fillRect(p, m, c, l), e.strokeRect(p, m, c, l), e.fillStyle = o.backgroundColor, e.fillRect(g, m + 1, c - 2, l - 2));
    }
    e.fillStyle = this.labelTextColors[r];
  }
  drawBody(e, n, r) {
    const { body: a } = this, { bodySpacing: i, bodyAlign: o, displayColors: s, boxHeight: l, boxWidth: c, boxPadding: u } = r, f = $e(r.bodyFont);
    let d = f.lineHeight, h = 0;
    const m = Sn(r.rtl, this.x, this.width), p = function(P) {
      n.fillText(P, m.x(e.x + h), e.y + d / 2), e.y += d + i;
    }, g = m.textAlign(o);
    let v, w, C, x, y, _, k;
    for (n.textAlign = o, n.textBaseline = "middle", n.font = f.string, e.x = da(this, g, r), n.fillStyle = r.bodyColor, he(this.beforeBody, p), h = s && g !== "right" ? o === "center" ? c / 2 + u : c + 2 + u : 0, x = 0, _ = a.length; x < _; ++x) {
      for (v = a[x], w = this.labelTextColors[x], n.fillStyle = w, he(v.before, p), C = v.lines, s && C.length && (this._drawColorBox(n, e, x, m, r), d = Math.max(f.lineHeight, l)), y = 0, k = C.length; y < k; ++y)
        p(C[y]), d = f.lineHeight;
      he(v.after, p);
    }
    h = 0, d = f.lineHeight, he(this.afterBody, p), e.y -= i;
  }
  drawFooter(e, n, r) {
    const a = this.footer, i = a.length;
    let o, s;
    if (i) {
      const l = Sn(r.rtl, this.x, this.width);
      for (e.x = da(this, r.footerAlign, r), e.y += r.footerMarginTop, n.textAlign = l.textAlign(r.footerAlign), n.textBaseline = "middle", o = $e(r.footerFont), n.fillStyle = r.footerColor, n.font = o.string, s = 0; s < i; ++s)
        n.fillText(a[s], l.x(e.x), e.y + o.lineHeight / 2), e.y += o.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(e, n, r, a) {
    const { xAlign: i, yAlign: o } = this, { x: s, y: l } = e, { width: c, height: u } = r, { topLeft: f, topRight: d, bottomLeft: h, bottomRight: m } = fn(a.cornerRadius);
    n.fillStyle = a.backgroundColor, n.strokeStyle = a.borderColor, n.lineWidth = a.borderWidth, n.beginPath(), n.moveTo(s + f, l), o === "top" && this.drawCaret(e, n, r, a), n.lineTo(s + c - d, l), n.quadraticCurveTo(s + c, l, s + c, l + d), o === "center" && i === "right" && this.drawCaret(e, n, r, a), n.lineTo(s + c, l + u - m), n.quadraticCurveTo(s + c, l + u, s + c - m, l + u), o === "bottom" && this.drawCaret(e, n, r, a), n.lineTo(s + h, l + u), n.quadraticCurveTo(s, l + u, s, l + u - h), o === "center" && i === "left" && this.drawCaret(e, n, r, a), n.lineTo(s, l + f), n.quadraticCurveTo(s, l, s + f, l), n.closePath(), n.fill(), a.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(e) {
    const n = this.chart, r = this.$animations, a = r && r.x, i = r && r.y;
    if (a || i) {
      const o = er[e.position].call(this, this._active, this._eventPosition);
      if (!o)
        return;
      const s = this._size = uf(this, e), l = Object.assign({}, o, this._size), c = df(n, e, l), u = ff(e, l, c, n);
      (a._to !== u.x || i._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = s.width, this.height = s.height, this.caretX = o.x, this.caretY = o.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(e) {
    const n = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(n);
    const a = {
      width: this.width,
      height: this.height
    }, i = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const o = Fe(n.padding), s = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && s && (e.save(), e.globalAlpha = r, this.drawBackground(i, e, a, n), op(e, n.textDirection), i.y += o.top, this.drawTitle(i, e, n), this.drawBody(i, e, n), this.drawFooter(i, e, n), sp(e, n.textDirection), e.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e, n) {
    const r = this._active, a = e.map(({ datasetIndex: s, index: l }) => {
      const c = this.chart.getDatasetMeta(s);
      if (!c)
        throw new Error("Cannot find a dataset at index " + s);
      return {
        datasetIndex: s,
        element: c.data[l],
        index: l
      };
    }), i = !Gi(r, a), o = this._positionChanged(a, n);
    (i || o) && (this._active = a, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(e, n, r = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const a = this.options, i = this._active || [], o = this._getActiveElements(e, i, n, r), s = this._positionChanged(o, e), l = n || !Gi(o, i) || s;
    return l && (this._active = o, (a.enabled || a.external) && (this._eventPosition = {
      x: e.x,
      y: e.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(e, n, r, a) {
    const i = this.options;
    if (e.type === "mouseout")
      return [];
    if (!a)
      return n;
    const o = this.chart.getElementsAtEventForMode(e, i.mode, i, r);
    return i.reverse && o.reverse(), o;
  }
  _positionChanged(e, n) {
    const { caretX: r, caretY: a, options: i } = this, o = er[i.position].call(this, e, n);
    return o !== !1 && (r !== o.x || a !== o.y);
  }
}
A(_l, "positioners", er);
var eO = {
  id: "tooltip",
  _element: _l,
  positioners: er,
  afterInit(t, e, n) {
    n && (t.tooltip = new _l({
      chart: t,
      options: n
    }));
  },
  beforeUpdate(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  reset(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  afterDraw(t) {
    const e = t.tooltip;
    if (e && e._willRender()) {
      const n = {
        tooltip: e
      };
      if (t.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      e.draw(t.ctx), t.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(t, e) {
    if (t.tooltip) {
      const n = e.replay;
      t.tooltip.handleEvent(e.event, n, e.inChartArea) && (e.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (t, e) => e.bodyFont.size,
    boxWidth: (t, e) => e.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Rp
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (t) => t !== "filter" && t !== "itemSort" && t !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, tO = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: h9,
  Decimation: v9,
  Filler: N9,
  Legend: j9,
  SubTitle: U9,
  Title: q9,
  Tooltip: eO
});
const nO = (t, e, n, r) => (typeof e == "string" ? (n = t.push(e) - 1, r.unshift({
  index: n,
  label: e
})) : isNaN(e) && (n = null), n);
function rO(t, e, n, r) {
  const a = t.indexOf(e);
  if (a === -1)
    return nO(t, e, n, r);
  const i = t.lastIndexOf(e);
  return a !== i ? n : a;
}
const aO = (t, e) => t === null ? null : Ae(Math.round(t), 0, e);
function mf(t) {
  const e = this.getLabels();
  return t >= 0 && t < e.length ? e[t] : t;
}
class wl extends bn {
  constructor(e) {
    super(e), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(e) {
    const n = this._addedLabels;
    if (n.length) {
      const r = this.getLabels();
      for (const { index: a, label: i } of n)
        r[a] === i && r.splice(a, 1);
      this._addedLabels = [];
    }
    super.init(e);
  }
  parse(e, n) {
    if (se(e))
      return null;
    const r = this.getLabels();
    return n = isFinite(n) && r[n] === e ? n : rO(r, e, ee(n, e), this._addedLabels), aO(n, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let { min: r, max: a } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (e || (r = 0), n || (a = this.getLabels().length - 1)), this.min = r, this.max = a;
  }
  buildTicks() {
    const e = this.min, n = this.max, r = this.options.offset, a = [];
    let i = this.getLabels();
    i = e === 0 && n === i.length - 1 ? i : i.slice(e, n + 1), this._valueRange = Math.max(i.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let o = e; o <= n; o++)
      a.push({
        value: o
      });
    return a;
  }
  getLabelForValue(e) {
    return mf.call(this, e);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(e) {
    return typeof e != "number" && (e = this.parse(e)), e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getValueForPixel(e) {
    return Math.round(this._startValue + this.getDecimalForPixel(e) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
A(wl, "id", "category"), A(wl, "defaults", {
  ticks: {
    callback: mf
  }
});
function iO(t, e) {
  const n = [], { bounds: a, step: i, min: o, max: s, precision: l, count: c, maxTicks: u, maxDigits: f, includeBounds: d } = t, h = i || 1, m = u - 1, { min: p, max: g } = e, v = !se(o), w = !se(s), C = !se(c), x = (g - p) / (f + 1);
  let y = ld((g - p) / m / h) * h, _, k, P, $;
  if (y < 1e-14 && !v && !w)
    return [
      {
        value: p
      },
      {
        value: g
      }
    ];
  $ = Math.ceil(g / y) - Math.floor(p / y), $ > m && (y = ld($ * y / m / h) * h), se(l) || (_ = Math.pow(10, l), y = Math.ceil(y * _) / _), a === "ticks" ? (k = Math.floor(p / y) * y, P = Math.ceil(g / y) * y) : (k = p, P = g), v && w && i && J6((s - o) / i, y / 1e3) ? ($ = Math.round(Math.min((s - o) / y, u)), y = (s - o) / $, k = o, P = s) : C ? (k = v ? o : k, P = w ? s : P, $ = c - 1, y = (P - k) / $) : ($ = (P - k) / y, or($, Math.round($), y / 1e3) ? $ = Math.round($) : $ = Math.ceil($));
  const O = Math.max(cd(y), cd(k));
  _ = Math.pow(10, se(l) ? O : l), k = Math.round(k * _) / _, P = Math.round(P * _) / _;
  let D = 0;
  for (v && (d && k !== o ? (n.push({
    value: o
  }), k < o && D++, or(Math.round((k + D * y) * _) / _, o, gf(o, x, t)) && D++) : k < o && D++); D < $; ++D) {
    const N = Math.round((k + D * y) * _) / _;
    if (w && N > s)
      break;
    n.push({
      value: N
    });
  }
  return w && d && P !== s ? n.length && or(n[n.length - 1].value, s, gf(s, x, t)) ? n[n.length - 1].value = s : n.push({
    value: s
  }) : (!w || P === s) && n.push({
    value: P
  }), n;
}
function gf(t, e, { horizontal: n, minRotation: r }) {
  const a = lt(r), i = (n ? Math.sin(a) : Math.cos(a)) || 1e-3, o = 0.75 * e * ("" + t).length;
  return Math.min(e / i, o);
}
class ao extends bn {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    return se(e) || (typeof e == "number" || e instanceof Number) && !isFinite(+e) ? null : +e;
  }
  handleTickRangeOptions() {
    const { beginAtZero: e } = this.options, { minDefined: n, maxDefined: r } = this.getUserBounds();
    let { min: a, max: i } = this;
    const o = (l) => a = n ? a : l, s = (l) => i = r ? i : l;
    if (e) {
      const l = bt(a), c = bt(i);
      l < 0 && c < 0 ? s(0) : l > 0 && c > 0 && o(0);
    }
    if (a === i) {
      let l = i === 0 ? 1 : Math.abs(i * 0.05);
      s(i + l), e || o(a - l);
    }
    this.min = a, this.max = i;
  }
  getTickLimit() {
    const e = this.options.ticks;
    let { maxTicksLimit: n, stepSize: r } = e, a;
    return r ? (a = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, a > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${a} ticks. Limiting to 1000.`), a = 1e3)) : (a = this.computeTickLimit(), n = n || 11), n && (a = Math.min(n, a)), a;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const e = this.options, n = e.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const a = {
      maxTicks: r,
      bounds: e.bounds,
      min: e.min,
      max: e.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, i = this._range || this, o = iO(a, i);
    return e.bounds === "ticks" && Hh(o, this, "value"), e.reverse ? (o.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), o;
  }
  configure() {
    const e = this.ticks;
    let n = this.min, r = this.max;
    if (super.configure(), this.options.offset && e.length) {
      const a = (r - n) / Math.max(e.length - 1, 1) / 2;
      n -= a, r += a;
    }
    this._startValue = n, this._endValue = r, this._valueRange = r - n;
  }
  getLabelForValue(e) {
    return jr(e, this.chart.options.locale, this.options.ticks.format);
  }
}
class kl extends ao {
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = Pe(e) ? e : 0, this.max = Pe(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const e = this.isHorizontal(), n = e ? this.width : this.height, r = lt(this.options.ticks.minRotation), a = (e ? Math.sin(r) : Math.cos(r)) || 1e-3, i = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, i.lineHeight / a));
  }
  getPixelForValue(e) {
    return e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    return this._startValue + this.getDecimalForPixel(e) * this._valueRange;
  }
}
A(kl, "id", "linear"), A(kl, "defaults", {
  ticks: {
    callback: _o.formatters.numeric
  }
});
const xr = (t) => Math.floor(Ht(t)), an = (t, e) => Math.pow(10, xr(t) + e);
function vf(t) {
  return t / Math.pow(10, xr(t)) === 1;
}
function yf(t, e, n) {
  const r = Math.pow(10, n), a = Math.floor(t / r);
  return Math.ceil(e / r) - a;
}
function oO(t, e) {
  const n = e - t;
  let r = xr(n);
  for (; yf(t, e, r) > 10; )
    r++;
  for (; yf(t, e, r) < 10; )
    r--;
  return Math.min(r, xr(t));
}
function sO(t, { min: e, max: n }) {
  e = Ge(t.min, e);
  const r = [], a = xr(e);
  let i = oO(e, n), o = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
  const s = Math.pow(10, i), l = a > i ? Math.pow(10, a) : 0, c = Math.round((e - l) * o) / o, u = Math.floor((e - l) / s / 10) * s * 10;
  let f = Math.floor((c - u) / Math.pow(10, i)), d = Ge(t.min, Math.round((l + u + f * Math.pow(10, i)) * o) / o);
  for (; d < n; )
    r.push({
      value: d,
      major: vf(d),
      significand: f
    }), f >= 10 ? f = f < 15 ? 15 : 20 : f++, f >= 20 && (i++, f = 2, o = i >= 0 ? 1 : o), d = Math.round((l + u + f * Math.pow(10, i)) * o) / o;
  const h = Ge(t.max, d);
  return r.push({
    value: h,
    major: vf(h),
    significand: f
  }), r;
}
class xl extends bn {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    const r = ao.prototype.parse.apply(this, [
      e,
      n
    ]);
    if (r === 0) {
      this._zero = !0;
      return;
    }
    return Pe(r) && r > 0 ? r : null;
  }
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = Pe(e) ? Math.max(0, e) : null, this.max = Pe(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !Pe(this._userMin) && (this.min = e === an(this.min, 0) ? an(this.min, -1) : an(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let r = this.min, a = this.max;
    const i = (s) => r = e ? r : s, o = (s) => a = n ? a : s;
    r === a && (r <= 0 ? (i(1), o(10)) : (i(an(r, -1)), o(an(a, 1)))), r <= 0 && i(an(a, -1)), a <= 0 && o(an(r, 1)), this.min = r, this.max = a;
  }
  buildTicks() {
    const e = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, r = sO(n, this);
    return e.bounds === "ticks" && Hh(r, this, "value"), e.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  getLabelForValue(e) {
    return e === void 0 ? "0" : jr(e, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const e = this.min;
    super.configure(), this._startValue = Ht(e), this._valueRange = Ht(this.max) - Ht(e);
  }
  getPixelForValue(e) {
    return (e === void 0 || e === 0) && (e = this.min), e === null || isNaN(e) ? NaN : this.getPixelForDecimal(e === this.min ? 0 : (Ht(e) - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    const n = this.getDecimalForPixel(e);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
A(xl, "id", "logarithmic"), A(xl, "defaults", {
  ticks: {
    callback: _o.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function Cl(t) {
  const e = t.ticks;
  if (e.display && t.display) {
    const n = Fe(e.backdropPadding);
    return ee(e.font && e.font.size, Se.font.size) + n.height;
  }
  return 0;
}
function lO(t, e, n) {
  return n = ye(n) ? n : [
    n
  ], {
    w: gP(t, e.string, n),
    h: n.length * e.lineHeight
  };
}
function bf(t, e, n, r, a) {
  return t === r || t === a ? {
    start: e - n / 2,
    end: e + n / 2
  } : t < r || t > a ? {
    start: e - n,
    end: e
  } : {
    start: e,
    end: e + n
  };
}
function cO(t) {
  const e = {
    l: t.left + t._padding.left,
    r: t.right - t._padding.right,
    t: t.top + t._padding.top,
    b: t.bottom - t._padding.bottom
  }, n = Object.assign({}, e), r = [], a = [], i = t._pointLabels.length, o = t.options.pointLabels, s = o.centerPointLabels ? ke / i : 0;
  for (let l = 0; l < i; l++) {
    const c = o.setContext(t.getPointLabelContext(l));
    a[l] = c.padding;
    const u = t.getPointPosition(l, t.drawingArea + a[l], s), f = $e(c.font), d = lO(t.ctx, f, t._pointLabels[l]);
    r[l] = d;
    const h = Ze(t.getIndexAngle(l) + s), m = Math.round(ec(h)), p = bf(m, u.x, d.w, 0, 180), g = bf(m, u.y, d.h, 90, 270);
    uO(n, e, h, p, g);
  }
  t.setCenterPoint(e.l - n.l, n.r - e.r, e.t - n.t, n.b - e.b), t._pointLabelItems = hO(t, r, a);
}
function uO(t, e, n, r, a) {
  const i = Math.abs(Math.sin(n)), o = Math.abs(Math.cos(n));
  let s = 0, l = 0;
  r.start < e.l ? (s = (e.l - r.start) / i, t.l = Math.min(t.l, e.l - s)) : r.end > e.r && (s = (r.end - e.r) / i, t.r = Math.max(t.r, e.r + s)), a.start < e.t ? (l = (e.t - a.start) / o, t.t = Math.min(t.t, e.t - l)) : a.end > e.b && (l = (a.end - e.b) / o, t.b = Math.max(t.b, e.b + l));
}
function dO(t, e, n) {
  const r = t.drawingArea, { extra: a, additionalAngle: i, padding: o, size: s } = n, l = t.getPointPosition(e, r + a + o, i), c = Math.round(ec(Ze(l.angle + Te))), u = gO(l.y, s.h, c), f = pO(c), d = mO(l.x, s.w, f);
  return {
    visible: !0,
    x: l.x,
    y: u,
    textAlign: f,
    left: d,
    top: u,
    right: d + s.w,
    bottom: u + s.h
  };
}
function fO(t, e) {
  if (!e)
    return !0;
  const { left: n, top: r, right: a, bottom: i } = t;
  return !(Rt({
    x: n,
    y: r
  }, e) || Rt({
    x: n,
    y: i
  }, e) || Rt({
    x: a,
    y: r
  }, e) || Rt({
    x: a,
    y: i
  }, e));
}
function hO(t, e, n) {
  const r = [], a = t._pointLabels.length, i = t.options, { centerPointLabels: o, display: s } = i.pointLabels, l = {
    extra: Cl(i) / 2,
    additionalAngle: o ? ke / a : 0
  };
  let c;
  for (let u = 0; u < a; u++) {
    l.padding = n[u], l.size = e[u];
    const f = dO(t, u, l);
    r.push(f), s === "auto" && (f.visible = fO(f, c), f.visible && (c = f));
  }
  return r;
}
function pO(t) {
  return t === 0 || t === 180 ? "center" : t < 180 ? "left" : "right";
}
function mO(t, e, n) {
  return n === "right" ? t -= e : n === "center" && (t -= e / 2), t;
}
function gO(t, e, n) {
  return n === 90 || n === 270 ? t -= e / 2 : (n > 270 || n < 90) && (t -= e), t;
}
function vO(t, e, n) {
  const { left: r, top: a, right: i, bottom: o } = n, { backdropColor: s } = e;
  if (!se(s)) {
    const l = fn(e.borderRadius), c = Fe(e.backdropPadding);
    t.fillStyle = s;
    const u = r - c.left, f = a - c.top, d = i - r + c.width, h = o - a + c.height;
    Object.values(l).some((m) => m !== 0) ? (t.beginPath(), wr(t, {
      x: u,
      y: f,
      w: d,
      h,
      radius: l
    }), t.fill()) : t.fillRect(u, f, d, h);
  }
}
function yO(t, e) {
  const { ctx: n, options: { pointLabels: r } } = t;
  for (let a = e - 1; a >= 0; a--) {
    const i = t._pointLabelItems[a];
    if (!i.visible)
      continue;
    const o = r.setContext(t.getPointLabelContext(a));
    vO(n, o, i);
    const s = $e(o.font), { x: l, y: c, textAlign: u } = i;
    gn(n, t._pointLabels[a], l, c + s.lineHeight / 2, s, {
      color: o.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function Ep(t, e, n, r) {
  const { ctx: a } = t;
  if (n)
    a.arc(t.xCenter, t.yCenter, e, 0, be);
  else {
    let i = t.getPointPosition(0, e);
    a.moveTo(i.x, i.y);
    for (let o = 1; o < r; o++)
      i = t.getPointPosition(o, e), a.lineTo(i.x, i.y);
  }
}
function bO(t, e, n, r, a) {
  const i = t.ctx, o = e.circular, { color: s, lineWidth: l } = e;
  !o && !r || !s || !l || n < 0 || (i.save(), i.strokeStyle = s, i.lineWidth = l, i.setLineDash(a.dash), i.lineDashOffset = a.dashOffset, i.beginPath(), Ep(t, n, o, r), i.closePath(), i.stroke(), i.restore());
}
function _O(t, e, n) {
  return Zt(t, {
    label: n,
    index: e,
    type: "pointLabel"
  });
}
class tr extends ao {
  constructor(e) {
    super(e), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const e = this._padding = Fe(Cl(this.options) / 2), n = this.width = this.maxWidth - e.width, r = this.height = this.maxHeight - e.height;
    this.xCenter = Math.floor(this.left + n / 2 + e.left), this.yCenter = Math.floor(this.top + r / 2 + e.top), this.drawingArea = Math.floor(Math.min(n, r) / 2);
  }
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!1);
    this.min = Pe(e) && !isNaN(e) ? e : 0, this.max = Pe(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Cl(this.options));
  }
  generateTickLabels(e) {
    ao.prototype.generateTickLabels.call(this, e), this._pointLabels = this.getLabels().map((n, r) => {
      const a = ge(this.options.pointLabels.callback, [
        n,
        r
      ], this);
      return a || a === 0 ? a : "";
    }).filter((n, r) => this.chart.getDataVisibility(r));
  }
  fit() {
    const e = this.options;
    e.display && e.pointLabels.display ? cO(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(e, n, r, a) {
    this.xCenter += Math.floor((e - n) / 2), this.yCenter += Math.floor((r - a) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(e, n, r, a));
  }
  getIndexAngle(e) {
    const n = be / (this._pointLabels.length || 1), r = this.options.startAngle || 0;
    return Ze(e * n + lt(r));
  }
  getDistanceFromCenterForValue(e) {
    if (se(e))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - e) * n : (e - this.min) * n;
  }
  getValueForDistanceFromCenter(e) {
    if (se(e))
      return NaN;
    const n = e / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(e) {
    const n = this._pointLabels || [];
    if (e >= 0 && e < n.length) {
      const r = n[e];
      return _O(this.getContext(), e, r);
    }
  }
  getPointPosition(e, n, r = 0) {
    const a = this.getIndexAngle(e) - Te + r;
    return {
      x: Math.cos(a) * n + this.xCenter,
      y: Math.sin(a) * n + this.yCenter,
      angle: a
    };
  }
  getPointPositionForValue(e, n) {
    return this.getPointPosition(e, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(e) {
    return this.getPointPositionForValue(e || 0, this.getBaseValue());
  }
  getPointLabelPosition(e) {
    const { left: n, top: r, right: a, bottom: i } = this._pointLabelItems[e];
    return {
      left: n,
      top: r,
      right: a,
      bottom: i
    };
  }
  drawBackground() {
    const { backgroundColor: e, grid: { circular: n } } = this.options;
    if (e) {
      const r = this.ctx;
      r.save(), r.beginPath(), Ep(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), r.closePath(), r.fillStyle = e, r.fill(), r.restore();
    }
  }
  drawGrid() {
    const e = this.ctx, n = this.options, { angleLines: r, grid: a, border: i } = n, o = this._pointLabels.length;
    let s, l, c;
    if (n.pointLabels.display && yO(this, o), a.display && this.ticks.forEach((u, f) => {
      if (f !== 0) {
        l = this.getDistanceFromCenterForValue(u.value);
        const d = this.getContext(f), h = a.setContext(d), m = i.setContext(d);
        bO(this, h, l, o, m);
      }
    }), r.display) {
      for (e.save(), s = o - 1; s >= 0; s--) {
        const u = r.setContext(this.getPointLabelContext(s)), { color: f, lineWidth: d } = u;
        !d || !f || (e.lineWidth = d, e.strokeStyle = f, e.setLineDash(u.borderDash), e.lineDashOffset = u.borderDashOffset, l = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), c = this.getPointPosition(s, l), e.beginPath(), e.moveTo(this.xCenter, this.yCenter), e.lineTo(c.x, c.y), e.stroke());
      }
      e.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const e = this.ctx, n = this.options, r = n.ticks;
    if (!r.display)
      return;
    const a = this.getIndexAngle(0);
    let i, o;
    e.save(), e.translate(this.xCenter, this.yCenter), e.rotate(a), e.textAlign = "center", e.textBaseline = "middle", this.ticks.forEach((s, l) => {
      if (l === 0 && !n.reverse)
        return;
      const c = r.setContext(this.getContext(l)), u = $e(c.font);
      if (i = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        e.font = u.string, o = e.measureText(s.label).width, e.fillStyle = c.backdropColor;
        const f = Fe(c.backdropPadding);
        e.fillRect(-o / 2 - f.left, -i - u.size / 2 - f.top, o + f.width, u.size + f.height);
      }
      gn(e, s.label, 0, -i, u, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), e.restore();
  }
  drawTitle() {
  }
}
A(tr, "id", "radialLinear"), A(tr, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: _o.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(e) {
      return e;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), A(tr, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), A(tr, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const Co = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, Xe = /* @__PURE__ */ Object.keys(Co);
function _f(t, e) {
  return t - e;
}
function wf(t, e) {
  if (se(e))
    return null;
  const n = t._adapter, { parser: r, round: a, isoWeekday: i } = t._parseOpts;
  let o = e;
  return typeof r == "function" && (o = r(o)), Pe(o) || (o = typeof r == "string" ? n.parse(o, r) : n.parse(o)), o === null ? null : (a && (o = a === "week" && (En(i) || i === !0) ? n.startOf(o, "isoWeek", i) : n.startOf(o, a)), +o);
}
function kf(t, e, n, r) {
  const a = Xe.length;
  for (let i = Xe.indexOf(t); i < a - 1; ++i) {
    const o = Co[Xe[i]], s = o.steps ? o.steps : Number.MAX_SAFE_INTEGER;
    if (o.common && Math.ceil((n - e) / (s * o.size)) <= r)
      return Xe[i];
  }
  return Xe[a - 1];
}
function wO(t, e, n, r, a) {
  for (let i = Xe.length - 1; i >= Xe.indexOf(n); i--) {
    const o = Xe[i];
    if (Co[o].common && t._adapter.diff(a, r, o) >= e - 1)
      return o;
  }
  return Xe[n ? Xe.indexOf(n) : 0];
}
function kO(t) {
  for (let e = Xe.indexOf(t) + 1, n = Xe.length; e < n; ++e)
    if (Co[Xe[e]].common)
      return Xe[e];
}
function xf(t, e, n) {
  if (!n)
    t[e] = !0;
  else if (n.length) {
    const { lo: r, hi: a } = tc(n, e), i = n[r] >= e ? n[r] : n[a];
    t[i] = !0;
  }
}
function xO(t, e, n, r) {
  const a = t._adapter, i = +a.startOf(e[0].value, r), o = e[e.length - 1].value;
  let s, l;
  for (s = i; s <= o; s = +a.add(s, 1, r))
    l = n[s], l >= 0 && (e[l].major = !0);
  return e;
}
function Cf(t, e, n) {
  const r = [], a = {}, i = e.length;
  let o, s;
  for (o = 0; o < i; ++o)
    s = e[o], a[s] = o, r.push({
      value: s,
      major: !1
    });
  return i === 0 || !n ? r : xO(t, r, a, n);
}
class Cr extends bn {
  constructor(e) {
    super(e), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(e, n = {}) {
    const r = e.time || (e.time = {}), a = this._adapter = new RS._date(e.adapters.date);
    a.init(n), ir(r.displayFormats, a.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(e), this._normalized = n.normalized;
  }
  parse(e, n) {
    return e === void 0 ? null : wf(this, e);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const e = this.options, n = this._adapter, r = e.time.unit || "day";
    let { min: a, max: i, minDefined: o, maxDefined: s } = this.getUserBounds();
    function l(c) {
      !o && !isNaN(c.min) && (a = Math.min(a, c.min)), !s && !isNaN(c.max) && (i = Math.max(i, c.max));
    }
    (!o || !s) && (l(this._getLabelBounds()), (e.bounds !== "ticks" || e.ticks.source !== "labels") && l(this.getMinMax(!1))), a = Pe(a) && !isNaN(a) ? a : +n.startOf(Date.now(), r), i = Pe(i) && !isNaN(i) ? i : +n.endOf(Date.now(), r) + 1, this.min = Math.min(a, i - 1), this.max = Math.max(a + 1, i);
  }
  _getLabelBounds() {
    const e = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return e.length && (n = e[0], r = e[e.length - 1]), {
      min: n,
      max: r
    };
  }
  buildTicks() {
    const e = this.options, n = e.time, r = e.ticks, a = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    e.bounds === "ticks" && a.length && (this.min = this._userMin || a[0], this.max = this._userMax || a[a.length - 1]);
    const i = this.min, o = this.max, s = rP(a, i, o);
    return this._unit = n.unit || (r.autoSkip ? kf(n.minUnit, this.min, this.max, this._getLabelCapacity(i)) : wO(this, s.length, n.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : kO(this._unit), this.initOffsets(a), e.reverse && s.reverse(), Cf(this, s, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((e) => +e.value));
  }
  initOffsets(e = []) {
    let n = 0, r = 0, a, i;
    this.options.offset && e.length && (a = this.getDecimalForValue(e[0]), e.length === 1 ? n = 1 - a : n = (this.getDecimalForValue(e[1]) - a) / 2, i = this.getDecimalForValue(e[e.length - 1]), e.length === 1 ? r = i : r = (i - this.getDecimalForValue(e[e.length - 2])) / 2);
    const o = e.length < 3 ? 0.5 : 0.25;
    n = Ae(n, 0, o), r = Ae(r, 0, o), this._offsets = {
      start: n,
      end: r,
      factor: 1 / (n + 1 + r)
    };
  }
  _generate() {
    const e = this._adapter, n = this.min, r = this.max, a = this.options, i = a.time, o = i.unit || kf(i.minUnit, n, r, this._getLabelCapacity(n)), s = ee(a.ticks.stepSize, 1), l = o === "week" ? i.isoWeekday : !1, c = En(l) || l === !0, u = {};
    let f = n, d, h;
    if (c && (f = +e.startOf(f, "isoWeek", l)), f = +e.startOf(f, c ? "day" : o), e.diff(r, n, o) > 1e5 * s)
      throw new Error(n + " and " + r + " are too far apart with stepSize of " + s + " " + o);
    const m = a.ticks.source === "data" && this.getDataTimestamps();
    for (d = f, h = 0; d < r; d = +e.add(d, s, o), h++)
      xf(u, d, m);
    return (d === r || a.bounds === "ticks" || h === 1) && xf(u, d, m), Object.keys(u).sort(_f).map((p) => +p);
  }
  getLabelForValue(e) {
    const n = this._adapter, r = this.options.time;
    return r.tooltipFormat ? n.format(e, r.tooltipFormat) : n.format(e, r.displayFormats.datetime);
  }
  format(e, n) {
    const a = this.options.time.displayFormats, i = this._unit, o = n || a[i];
    return this._adapter.format(e, o);
  }
  _tickFormatFunction(e, n, r, a) {
    const i = this.options, o = i.ticks.callback;
    if (o)
      return ge(o, [
        e,
        n,
        r
      ], this);
    const s = i.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && s[l], f = c && s[c], d = r[n], h = c && f && d && d.major;
    return this._adapter.format(e, a || (h ? f : u));
  }
  generateTickLabels(e) {
    let n, r, a;
    for (n = 0, r = e.length; n < r; ++n)
      a = e[n], a.label = this._tickFormatFunction(a.value, n, e);
  }
  getDecimalForValue(e) {
    return e === null ? NaN : (e - this.min) / (this.max - this.min);
  }
  getPixelForValue(e) {
    const n = this._offsets, r = this.getDecimalForValue(e);
    return this.getPixelForDecimal((n.start + r) * n.factor);
  }
  getValueForPixel(e) {
    const n = this._offsets, r = this.getDecimalForPixel(e) / n.factor - n.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(e) {
    const n = this.options.ticks, r = this.ctx.measureText(e).width, a = lt(this.isHorizontal() ? n.maxRotation : n.minRotation), i = Math.cos(a), o = Math.sin(a), s = this._resolveTickFontOptions(0).size;
    return {
      w: r * i + s * o,
      h: r * o + s * i
    };
  }
  _getLabelCapacity(e) {
    const n = this.options.time, r = n.displayFormats, a = r[n.unit] || r.millisecond, i = this._tickFormatFunction(e, 0, Cf(this, [
      e
    ], this._majorUnit), a), o = this._getLabelSize(i), s = Math.floor(this.isHorizontal() ? this.width / o.w : this.height / o.h) - 1;
    return s > 0 ? s : 1;
  }
  getDataTimestamps() {
    let e = this._cache.data || [], n, r;
    if (e.length)
      return e;
    const a = this.getMatchingVisibleMetas();
    if (this._normalized && a.length)
      return this._cache.data = a[0].controller.getAllParsedValues(this);
    for (n = 0, r = a.length; n < r; ++n)
      e = e.concat(a[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(e);
  }
  getLabelTimestamps() {
    const e = this._cache.labels || [];
    let n, r;
    if (e.length)
      return e;
    const a = this.getLabels();
    for (n = 0, r = a.length; n < r; ++n)
      e.push(wf(this, a[n]));
    return this._cache.labels = this._normalized ? e : this.normalize(e);
  }
  normalize(e) {
    return qh(e.sort(_f));
  }
}
A(Cr, "id", "time"), A(Cr, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function fa(t, e, n) {
  let r = 0, a = t.length - 1, i, o, s, l;
  n ? (e >= t[r].pos && e <= t[a].pos && ({ lo: r, hi: a } = $t(t, "pos", e)), { pos: i, time: s } = t[r], { pos: o, time: l } = t[a]) : (e >= t[r].time && e <= t[a].time && ({ lo: r, hi: a } = $t(t, "time", e)), { time: i, pos: s } = t[r], { time: o, pos: l } = t[a]);
  const c = o - i;
  return c ? s + (l - s) * (e - i) / c : s;
}
class Pl extends Cr {
  constructor(e) {
    super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const e = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(e);
    this._minPos = fa(n, this.min), this._tableRange = fa(n, this.max) - this._minPos, super.initOffsets(e);
  }
  buildLookupTable(e) {
    const { min: n, max: r } = this, a = [], i = [];
    let o, s, l, c, u;
    for (o = 0, s = e.length; o < s; ++o)
      c = e[o], c >= n && c <= r && a.push(c);
    if (a.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: r,
          pos: 1
        }
      ];
    for (o = 0, s = a.length; o < s; ++o)
      u = a[o + 1], l = a[o - 1], c = a[o], Math.round((u + l) / 2) !== c && i.push({
        time: c,
        pos: o / (s - 1)
      });
    return i;
  }
  _generate() {
    const e = this.min, n = this.max;
    let r = super.getDataTimestamps();
    return (!r.includes(e) || !r.length) && r.splice(0, 0, e), (!r.includes(n) || r.length === 1) && r.push(n), r.sort((a, i) => a - i);
  }
  _getTimestampsForTable() {
    let e = this._cache.all || [];
    if (e.length)
      return e;
    const n = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return n.length && r.length ? e = this.normalize(n.concat(r)) : e = n.length ? n : r, e = this._cache.all = e, e;
  }
  getDecimalForValue(e) {
    return (fa(this._table, e) - this._minPos) / this._tableRange;
  }
  getValueForPixel(e) {
    const n = this._offsets, r = this.getDecimalForPixel(e) / n.factor - n.end;
    return fa(this._table, r * this._tableRange + this._minPos, !0);
  }
}
A(Pl, "id", "timeseries"), A(Pl, "defaults", Cr.defaults);
var CO = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: wl,
  LinearScale: kl,
  LogarithmicScale: xl,
  RadialLinearScale: tr,
  TimeScale: Cr,
  TimeSeriesScale: Pl
});
const PO = [
  $S,
  s9,
  tO,
  CO
], SO = (t, e, n, r) => {
  const a = /* @__PURE__ */ new Date();
  return t.toDateString() === (n == null ? void 0 : n.toDateString()) ? G.primary : t.toDateString() === a.toDateString() ? G.primaryInverted : e && r && !Qi(t, a) ? G.neutral : G.secondary;
}, MO = (t, e) => t === e ? G.primary : G.secondary, OO = (t, e) => {
  const n = t.createLinearGradient(0, 0, 0, 300);
  return e == null || e.forEach(function(r) {
    n.addColorStop(r.stop, r.color);
  }), n;
}, DO = (t, e) => {
  if (typeof e == "string")
    return e;
  if (typeof e == "object")
    return e == null ? void 0 : e.map((n) => typeof n == "object" ? OO(t, n) : n);
}, TO = { class: "c-bar-chart-wrapper" }, $O = ["height", "width"], RO = { class: "c-bar-chart-nav" }, EO = ["onClick"], AO = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    dataObject: null,
    datasets: { default: [{
      borderWidth: 0,
      backgroundColor: "#005DEA",
      barThickness: 30,
      borderRadius: 2
    }] },
    scales: null,
    showLeftChevron: { type: Boolean, default: !0 },
    showRightChevron: { type: Boolean, default: !0 },
    yTickLabelCallback: null,
    xTickLabelCallback: { type: Function, default: void 0 },
    tooltipTitleCallback: null,
    barChartHeight: { default: 300 },
    configPlugins: null,
    selected: null,
    hasNavigation: { type: Boolean, default: !1 },
    fadeOutFutureDate: { type: Boolean, default: !0 },
    height: null,
    width: null,
    maxTicksLimit: { default: 6 }
  },
  emits: ["on:bar-item-click", "on:chevron-click", "on:bar-item-hover", "on:tick-label-click", "on:resize"],
  setup(t, { emit: e }) {
    const n = t;
    Ot.register(...PO);
    const r = window.getComputedStyle(document.documentElement);
    let a, i;
    const o = U(), s = U(void 0), l = U({ marginLeft: 0, distanceBetweenItems: 0 }), c = I(() => {
      var O;
      return (O = n.dataObject) == null ? void 0 : O.map((D) => D.data);
    }), u = I(() => {
      var O;
      return (O = n.dataObject) == null ? void 0 : O.map((D) => D.label);
    }), f = U(void 0), d = I(() => `width:${l.value.distanceBetweenItems}px`), h = I(() => `padding-left:${l.value.marginLeft}px`), m = I(() => {
      var D, N;
      const O = (D = u.value) == null ? void 0 : D.some((q) => ze(new Date(q), /* @__PURE__ */ new Date()));
      return (N = u.value) == null ? void 0 : N.map((q) => {
        if (Hl(q)) {
          const le = new Date(q).getDate();
          return {
            displayLabel: le < 10 ? "0" + le : le + "",
            intent: SO(new Date(q), n.fadeOutFutureDate, n.selected, O),
            label: q
          };
        }
        return {
          displayLabel: q,
          intent: MO(u.value.toString(), n.selected),
          label: q
        };
      });
    }), p = I(() => {
      var O;
      return i = (O = document.getElementById("cBarChart")) == null ? void 0 : O.getContext("2d"), {
        labels: u.value,
        datasets: n.datasets.map((D) => ({
          ...D,
          data: c.value,
          backgroundColor: D.backgroundColor ? DO(i, D.backgroundColor) : "green"
        }))
      };
    }), g = I(() => {
      var O;
      return {
        x: {
          grid: {
            drawOnChartArea: !1,
            drawTicks: !1
          },
          ticks: {
            color: r.getPropertyValue("--color-neutral-5"),
            padding: 8,
            font: {
              size: 12,
              weight: 400
            },
            ...n.xTickLabelCallback && { callback: n.xTickLabelCallback }
          },
          border: {
            color: r.getPropertyValue("--color-neutral-2")
          }
        },
        y: {
          beginAtZero: !0,
          grid: {
            display: !0,
            color: r.getPropertyValue("--color-neutral-2")
          },
          border: {
            display: !1
          },
          ticks: {
            maxTicksLimit: n.maxTicksLimit,
            color: r.getPropertyValue("--color-neutral-5"),
            padding: 10,
            font: {
              size: 14,
              weight: 600
            },
            display: ((O = n == null ? void 0 : n.dataObject) == null ? void 0 : O.length) > 0,
            ...n.yTickLabelCallback && { callback: n.yTickLabelCallback }
          }
        }
      };
    }), v = I(() => ({
      responsive: !0,
      plugins: {
        legend: {
          display: !1
        },
        tooltip: {
          displayColors: !1,
          callbacks: {
            label: function(O) {
              return "";
            },
            title: n.tooltipTitleCallback
          },
          filter: function(O) {
            return O.datasetIndex === 0;
          }
        }
      },
      scales: g.value,
      onClick: (O, D) => {
        e("on:bar-item-click", O, D);
      },
      onHover: (O, D) => {
        const N = O;
        D.length === 1 ? N.native && (N.native.target.style.cursor = "pointer") : N.native && (N.native.target.style.cursor = "default"), e("on:bar-item-hover", O, D);
      }
    })), w = I(() => ({
      type: "bar",
      data: p.value,
      options: v.value
    })), C = () => {
      a && (a == null || a.destroy(), i = void 0);
    }, x = () => {
      const O = document.getElementById("cBarChart");
      C(), a = new Ot(O, w.value), i = O.getContext("2d");
    }, y = I(() => n.scales), _ = () => {
      var D;
      const O = (D = a == null ? void 0 : a.boxes) == null ? void 0 : D.find((N) => (N == null ? void 0 : N.axis) === "x");
      if (O) {
        const { left: N, width: q, ticks: le } = O, Y = q / le.length;
        l.value = {
          marginLeft: n.showLeftChevron ? N - 36 : N,
          distanceBetweenItems: Y
        };
      }
      f.value = m.value;
    }, k = () => {
      _(), e("on:resize");
    };
    Wn(() => {
      n.scales && (g.value = { ...g.value, ...y.value }), x(), _(), o.value = new ResizeObserver(k), s.value && !navigator.userAgent.includes("Mobile") && o.value.observe(s.value);
    }), jf(() => {
      var O;
      s.value && ((O = o.value) == null || O.unobserve(s.value)), C();
    }), Yt(() => n.dataObject, () => {
      x(), _();
    }), Yt(() => n.selected, () => {
      _();
    });
    const P = (O) => {
      e("on:chevron-click", O);
    }, $ = (O) => {
      e("on:tick-label-click", O);
    };
    return (O, D) => (b(), M("div", TO, [
      R("canvas", {
        id: "cBarChart",
        ref_key: "barChart",
        ref: s,
        height: t.height,
        width: t.width
      }, null, 8, $O),
      t.hasNavigation ? (b(), M("div", {
        key: 0,
        class: "c-bar-nav-wrapper",
        style: Ut(S(h))
      }, [
        t.showLeftChevron ? (b(), L(S(Xt), {
          key: 0,
          class: "c-chevron",
          "chevron-direction": "left",
          "should-toggle": !1,
          onInteracted: D[0] || (D[0] = (N) => P("left"))
        })) : E("", !0),
        R("div", RO, [
          (b(!0), M(de, null, xe(f.value, (N, q) => (b(), M("div", {
            class: "button-wrapper",
            style: Ut(S(d)),
            key: q
          }, [
            R("div", {
              class: H(["button-wrapper-div", N.intent]),
              onClick: (le) => $(N.label)
            }, [
              T(S(Ne), {
                type: "three",
                class: "c-nav-selection"
              }, {
                default: W(() => [
                  V(j(N.displayLabel), 1)
                ]),
                _: 2
              }, 1024)
            ], 10, EO)
          ], 4))), 128))
        ]),
        t.showLeftChevron ? (b(), L(S(Xt), {
          key: 1,
          class: "c-chevron c-chevron-right",
          "chevron-direction": "right",
          "should-toggle": !1,
          onInteracted: D[1] || (D[1] = (N) => P("right"))
        })) : E("", !0)
      ], 4)) : E("", !0)
    ]));
  }
});
const LO = /* @__PURE__ */ B(AO, [["__scopeId", "data-v-d636f3ba"]]), IO = { class: "c-bar-chart-with-nav" }, B$ = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    locale: { default: void 0 },
    linearGradientBackground: null,
    fadeOutGradientBackground: null,
    dateToHighlight: null,
    fadeOutFutureDate: { type: Boolean },
    dataObject: { default: void 0 },
    height: null,
    width: null,
    tooltipText: { default: "" },
    showLeftChevron: { type: Boolean, default: !1 },
    showRightChevron: { type: Boolean, default: !1 },
    yTickLabelCallback: null,
    tooltipTitleCallback: null,
    maxTicksLimit: { default: 6 },
    hoverBackgroundColor: { default: "#4c6e5d" }
  },
  emits: ["on-chevron-click", "on-resize", "on-bar-item-click", "on-tick-label-click"],
  setup(t, { emit: e }) {
    const n = t, r = U(n.dateToHighlight), { getApplicationLocale: a } = rt(), i = { it: Wr, fr: Nr, de: Er, es: Lr, en: Ar, cs: $r, da: Rr, no: zr, nl: Br, fi: Ir, sv: Fr }, o = navigator.userAgent.includes("Mobile");
    window.getComputedStyle(document.documentElement);
    const s = n.yTickLabelCallback ? n.yTickLabelCallback : function(v) {
      return v;
    }, l = function(v) {
      const w = f.value, C = new Date(this.getLabelForValue(v));
      return w[C.getDay()];
    }, c = n.tooltipTitleCallback ? n.tooltipTitleCallback : function(v) {
      return n.tooltipText + v[0].raw;
    }, u = I(() => {
      var C, x;
      const v = /* @__PURE__ */ new Date(), w = (C = n.dataObject) == null ? void 0 : C.some((y) => new Date(y.label).toDateString() === (/* @__PURE__ */ new Date()).toDateString());
      return (x = n.dataObject) == null ? void 0 : x.map((y) => w && !Qi(new Date(y.label), v) && n.fadeOutFutureDate ? n.fadeOutGradientBackground : n.linearGradientBackground);
    }), f = I(() => {
      const v = n.locale ?? a(), w = i[v];
      return [...Array(7).keys()].map((C) => {
        var x;
        return (x = w.localize) == null ? void 0 : x.day(C, { width: "short" });
      });
    }), d = I(() => [{
      borderWidth: 0,
      backgroundColor: u.value,
      maxBarThickness: 30,
      borderRadius: 2,
      label: "1",
      xAxisID: "x",
      hoverBackgroundColor: n.hoverBackgroundColor
    }]), h = (v) => {
      e("on-chevron-click", v);
    }, m = (v, w) => {
      var x, y;
      const C = (x = w[0]) == null ? void 0 : x.index;
      if (C !== void 0) {
        const _ = (y = n.dataObject[C]) == null ? void 0 : y.label;
        o || (r.value = new Date(_)), e("on-bar-item-click", _);
      }
    }, p = (v) => {
      r.value = new Date(v), e("on-tick-label-click", v);
    }, g = () => {
      e("on-resize");
    };
    return Yt(() => n.dateToHighlight, (v) => {
      r.value = v;
    }), (v, w) => (b(), M("div", IO, [
      T(S(LO), {
        "data-object": t.dataObject,
        "onOn:chevronClick": h,
        datasets: S(d),
        "y-tick-label-callback": S(s),
        "x-tick-label-callback": l,
        "tooltip-title-callback": S(c),
        "bar-chart-height": 200,
        "linear-gradient-background": t.linearGradientBackground,
        "fade-out-gradient-background": t.fadeOutGradientBackground,
        "onOn:barItemClick": m,
        "onOn:tickLabelClick": p,
        selected: r.value,
        "has-navigation": !0,
        "onOn:resize": g,
        "fade-out-future-date": t.fadeOutFutureDate,
        height: t.height,
        width: t.width,
        "show-left-chevron": t.showLeftChevron,
        "show-right-chevron": t.showRightChevron
      }, null, 8, ["data-object", "datasets", "y-tick-label-callback", "tooltip-title-callback", "linear-gradient-background", "fade-out-gradient-background", "selected", "fade-out-future-date", "height", "width", "show-left-chevron", "show-right-chevron"])
    ]));
  }
}), NO = {
  key: 0,
  class: "c-bread-crumbs-wrapper"
}, WO = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    routes: null
  },
  emits: ["on:link-click"],
  setup(t, { emit: e }) {
    const n = t, r = I(() => G.secondary), a = (o) => {
      var s;
      return o + 1 !== ((s = n.routes) == null ? void 0 : s.length);
    }, i = (o) => {
      e("on:link-click", o);
    };
    return (o, s) => {
      var l;
      return ((l = t.routes) == null ? void 0 : l.length) > 0 ? (b(), M("div", NO, [
        (b(!0), M(de, null, xe(t.routes, (c, u) => (b(), M("div", {
          key: u,
          class: "c-bread-crumbs-item"
        }, [
          T(S(Uf), {
            intent: S(r),
            label: c.routeDisplayName,
            onClick: (f) => i(c),
            class: H([c.enabled ? "enabled" : "", "c-bread-crumbs-link"])
          }, {
            default: W(() => [
              _e(o.$slots, c.iconSlotName, {}, void 0, !0)
            ]),
            _: 2
          }, 1032, ["intent", "label", "onClick", "class"]),
          a(u) ? (b(), L(S(Xt), {
            key: 0,
            "chevron-direction": "right",
            "should-toggle": !1
          })) : E("", !0)
        ]))), 128))
      ])) : E("", !0);
    };
  }
});
const F$ = /* @__PURE__ */ B(WO, [["__scopeId", "data-v-e73f17ec"]]);
const zO = {
  name: "NavItem",
  components: {
    CSubheading: Ne,
    CUi: we,
    CChevron: Xt,
    Search: eh,
    Plus: Jf,
    HelpCircle: xg,
    Calendar: uo,
    DollarSign: bg,
    Box: Gm,
    PieChart: Hg,
    Target: Qg,
    Settings: Ug,
    Key: Og,
    AppStore: ov,
    MenuIcon: Ag,
    X: Bn,
    Wallet: nv,
    Network: Bg,
    LayoutDashboard: Tg,
    NetworkReseller: lv,
    Sun: Xg,
    Moon: Wg,
    Bell: Km
  },
  props: {
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    hrefRoutePath: {
      type: String,
      required: !1,
      default: "undefined"
    },
    active: {
      type: Boolean,
      required: !1,
      default: !1
    },
    label: {
      type: String,
      required: !1,
      default: void 0
    },
    hasChevron: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isParent: {
      type: Boolean,
      required: !1,
      default: !1
    },
    indented: {
      type: Boolean,
      required: !1,
      default: !0
    },
    collapsed: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["toggle-subnav", "nav-click", "update:collapsed"],
  computed: {
    showSubnav: {
      get() {
        return !this.collapsed;
      },
      set(t) {
        this.$emit("update:collapsed", !t);
      }
    },
    navigationAccessibility() {
      const t = this.active ? { "aria-current": "page" } : {}, e = this.isParent && !this.collapsed ? { "aria-expanded": "true", "aria-selected": "true" } : {};
      return {
        "aria-label": this.label,
        ...t,
        ...e
      };
    },
    getLabel() {
      return this.isParent ? {
        component: "CSubheading",
        type: "three"
      } : {
        component: "CUi",
        type: "four"
      };
    }
  },
  methods: {
    handleNavClick(t) {
      this.$emit("nav-click", t);
    },
    handleNavLinkClick(t) {
      t.preventDefault();
    }
  }
}, BO = ["href"];
function FO(t, e, n, r, a, i) {
  const o = z("c-chevron");
  return b(), M("div", {
    class: H([{
      "c-active": n.active,
      "c-child-indent": !n.isParent && n.indented
    }, "c-main"]),
    onClick: e[2] || (e[2] = (...s) => i.handleNavClick && i.handleNavClick(...s))
  }, [
    R("a", He({ class: "c-nav-item" }, i.navigationAccessibility, {
      href: n.hrefRoutePath,
      onClick: e[0] || (e[0] = (...s) => i.handleNavLinkClick && i.handleNavLinkClick(...s))
    }), [
      n.icon ? (b(), L(_t(n.icon), {
        key: 0,
        class: H(["c-nav-icon c-icon-s", { "c-active": n.active }]),
        "aria-hidden": !!n.label
      }, null, 8, ["aria-hidden", "class"])) : E("", !0),
      n.label ? (b(), L(_t(i.getLabel.component), {
        key: 1,
        type: i.getLabel.type,
        class: H([{ "c-active": n.active }, "c-nav-label"])
      }, {
        default: W(() => [
          V(j(n.label), 1)
        ]),
        _: 1
      }, 8, ["type", "class"])) : E("", !0),
      _e(t.$slots, "badge", {}, void 0, !0)
    ], 16, BO),
    n.hasChevron ? (b(), L(o, {
      key: 0,
      activeStatus: i.showSubnav,
      "onUpdate:activeStatus": e[1] || (e[1] = (s) => i.showSubnav = s),
      "aria-expanded": i.showSubnav,
      "chevron-direction": "bottom"
    }, null, 8, ["activeStatus", "aria-expanded"])) : E("", !0)
  ], 2);
}
const Pr = /* @__PURE__ */ B(zO, [["render", FO], ["__scopeId", "data-v-e473d261"]]), HO = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    currentRoute: null,
    navRoutes: null,
    isClosed: { type: Boolean, default: !0 }
  },
  emits: ["navigate-to", "update:activeStatus"],
  setup(t, { emit: e }) {
    const n = t, r = U(), a = I(() => n.navRoutes), i = I(() => {
      let d = {};
      for (const h in n.navRoutes)
        typeof n.navRoutes[h] == "string" && (d[h] = n.navRoutes[h]);
      return d;
    }), o = I(() => {
      var h;
      return (((h = n.navRoutes) == null ? void 0 : h.children) ?? []).map((m) => {
        var g, v;
        let p = {};
        for (const w of Object.keys(m))
          typeof m[w] == "string" && (p[w] = m[w]);
        return {
          ...m,
          attributes: p,
          href: ((g = m.path) == null ? void 0 : g.indexOf("/")) === 0 ? m.path : ((v = n.navRoutes) == null ? void 0 : v.path) + `/${m.path}`
        };
      });
    }), s = () => typeof o.value.find((h) => {
      var m;
      return (h == null ? void 0 : h.name) === ((m = n.currentRoute) == null ? void 0 : m.name);
    }) == "object", l = I(() => o.value.length !== 0), c = I(() => {
      var h, m, p, g, v;
      const d = s();
      return !r.value && l.value && d ? !1 : !!(((h = a.value) == null ? void 0 : h.name) === ((m = n.currentRoute) == null ? void 0 : m.name) || r.value && d || (v = (p = a.value) == null ? void 0 : p.hiddenRoutes) != null && v.includes((g = n.currentRoute) == null ? void 0 : g.name));
    });
    Yt(r, (d) => {
      e("update:activeStatus", d);
    }), Yt(
      () => n.isClosed,
      (d) => {
        r.value !== d && (r.value = d);
      },
      { immediate: !0 }
    );
    const u = (d) => {
      var h;
      if (!r.value && ((h = o.value) == null ? void 0 : h.length) !== 0) {
        r.value = !0;
        return;
      }
      e("navigate-to", d), r.value = !1;
    }, f = (d) => e("navigate-to", d);
    return (d, h) => {
      var m;
      return b(), M("div", null, [
        T(S(Pr), He({
          collapsed: r.value,
          "onUpdate:collapsed": h[0] || (h[0] = (p) => r.value = p),
          "is-parent": !0,
          "has-chevron": S(l),
          active: S(c),
          label: S(a).label,
          "href-route-path": S(a).path,
          icon: S(a).icon,
          class: "c-nav-items-parent"
        }, S(i), {
          onNavClick: h[1] || (h[1] = (p) => u(S(a)))
        }), hi({ _: 2 }, [
          (m = S(a).meta) != null && m.badge ? {
            name: "badge",
            fn: W(() => [
              T(ur, {
                value: S(a).meta.badge.value,
                intent: S(a).meta.badge.intent
              }, null, 8, ["value", "intent"])
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["collapsed", "has-chevron", "active", "label", "href-route-path", "icon"]),
        S(l) ? (b(), L(S(co), {
          key: 0,
          status: !r.value,
          "aria-expanded": !r.value
        }, {
          default: W(() => [
            (b(!0), M(de, null, xe(S(o), (p) => {
              var g, v;
              return b(), L(S(Pr), He({
                key: p.label,
                "href-route-path": p.href,
                label: p.label,
                active: ((g = t.currentRoute) == null ? void 0 : g.name) === p.name,
                icon: p.icon,
                class: "c-nav-items-space"
              }, p.attributes, {
                onNavClick: (w) => f(p)
              }), hi({ _: 2 }, [
                (v = p.meta) != null && v.badge ? {
                  name: "badge",
                  fn: W(() => [
                    T(ur, {
                      value: p.meta.badge.value,
                      intent: p.meta.badge.intent
                    }, null, 8, ["value", "intent"])
                  ]),
                  key: "0"
                } : void 0
              ]), 1040, ["href-route-path", "label", "active", "icon", "onNavClick"]);
            }), 128)),
            T(S(lo), { class: "c-next-block-margin" })
          ]),
          _: 1
        }, 8, ["status", "aria-expanded"])) : E("", !0)
      ]);
    };
  }
});
const H$ = /* @__PURE__ */ B(HO, [["__scopeId", "data-v-a38ad984"]]);
const jO = {
  name: "NavShortcuts",
  components: {
    CSubheading: Ne,
    CRunning: zn,
    BkLogo: Xf,
    BkReachLogo: Mm,
    BkAppMarketPlace: Rm,
    CArrowLeftRightIcon: N1
  },
  props: {
    shortcuts: {
      type: Array,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    layout: {
      type: Object,
      required: !1,
      validator(t) {
        return Object.values(t).forEach((e) => {
          if (typeof e != "boolean")
            throw new Error("Could not set the layout value. Wrong prop passed.");
        }), !0;
      }
    }
  },
  emits: ["navigate-to"],
  methods: {
    handleLinkClick(t) {
      t.preventDefault();
    }
  }
}, VO = { class: "c-layer-suppressed c-shortcuts-container" }, qO = ["onClick"], UO = ["href"];
function YO(t, e, n, r, a, i) {
  const o = z("c-running"), s = z("c-subheading");
  return b(), M("div", VO, [
    T(o, {
      type: "three",
      class: "c-shortcuts-heading"
    }, {
      default: W(() => [
        V(j(n.label), 1)
      ]),
      _: 1
    }),
    (b(!0), M(de, null, xe(n.shortcuts, (l, c) => (b(), M("div", {
      key: c,
      class: H(["c-shortcuts-link", { "align-center": n.layout && n.layout.alignCenter }]),
      onClick: (u) => t.$emit("navigate-to", l.href)
    }, [
      R("a", {
        class: "c-shortcuts-link-item",
        href: l.path,
        onClick: e[0] || (e[0] = (...u) => i.handleLinkClick && i.handleLinkClick(...u))
      }, [
        l.icon ? (b(), L(_t(l.icon), {
          key: 0,
          class: "c-shortcut-icon"
        })) : E("", !0),
        T(s, { type: "three" }, {
          default: W(() => [
            V(j(l.label), 1)
          ]),
          _: 2
        }, 1024)
      ], 8, UO)
    ], 10, qO))), 128))
  ]);
}
const XO = /* @__PURE__ */ B(jO, [["render", YO]]);
const Cn = {
  Moon: "Moon",
  Sun: "Sun"
}, KO = {
  name: "NavShortcutsTriggers",
  components: {
    CCopyToClipboard: d1,
    NavItem: Pr
  },
  data() {
    return {
      modeIcon: Cn.Moon
    };
  },
  emits: ["toggle-search", "update:addActiveStatus", "update:helpActiveStatus", "toggle:darkMode", "copy-failed", "copy-success"],
  props: {
    searchActive: {
      type: Boolean,
      required: !1,
      default: !1
    },
    addActiveStatus: {
      type: Boolean,
      required: !1,
      default: !1
    },
    helpActiveStatus: {
      type: Boolean,
      required: !1,
      default: !1
    },
    darkModeActiveStatus: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hasDarkMode: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hasCopyIcon: {
      type: Boolean,
      required: !1,
      default: !1
    },
    textToCopy: {
      type: String,
      required: !1,
      default: ""
    }
  },
  mounted() {
    this.darkModeActiveStatus ? this.modeIcon = Cn.Sun : this.modeIcon = Cn.Moon;
  },
  methods: {
    handleSearchShortcut() {
      this.$emit("toggle-search", this.searchActive);
    },
    handleAddShortcut() {
      this.$emit("update:addActiveStatus", !this.addActiveStatus);
    },
    handleHelpShortcut() {
      this.$emit("update:helpActiveStatus", !this.helpActiveStatus);
    },
    handleDarkShortcut() {
      this.modeIcon === Cn.Moon ? this.modeIcon = Cn.Sun : this.modeIcon = Cn.Moon, this.$emit("toggle:darkMode", !this.darkModeActiveStatus);
    },
    copyFailed() {
      this.$emit("copy-failed");
    },
    copySuccess() {
      this.$emit("copy-success");
    }
  }
}, QO = { class: "c-shortcuts-wrapper" };
function GO(t, e, n, r, a, i) {
  const o = z("nav-item"), s = z("c-copy-to-clipboard");
  return b(), M("div", QO, [
    T(o, {
      icon: "search",
      "is-parent": !0,
      active: n.searchActive,
      onNavClick: i.handleSearchShortcut
    }, null, 8, ["active", "onNavClick"]),
    T(o, {
      icon: "plus",
      "is-parent": !0,
      active: n.addActiveStatus,
      onNavClick: i.handleAddShortcut
    }, null, 8, ["active", "onNavClick"]),
    T(o, {
      icon: "HelpCircle",
      "is-parent": !0,
      active: n.helpActiveStatus,
      onNavClick: i.handleHelpShortcut
    }, null, 8, ["active", "onNavClick"]),
    n.hasDarkMode ? (b(), L(o, {
      key: 0,
      icon: a.modeIcon,
      "is-parent": !0,
      onNavClick: i.handleDarkShortcut
    }, null, 8, ["icon", "onNavClick"])) : E("", !0),
    n.hasCopyIcon ? (b(), L(s, {
      key: 1,
      "text-to-copy": n.textToCopy,
      class: "c-nav-copy",
      onCopyFailed: i.copyFailed,
      onCopySuccess: i.copySuccess
    }, null, 8, ["text-to-copy", "onCopyFailed", "onCopySuccess"])) : E("", !0)
  ]);
}
const j$ = /* @__PURE__ */ B(KO, [["render", GO], ["__scopeId", "data-v-b9a5d903"]]);
const ZO = /* @__PURE__ */ ne({
  name: "NavAccountHead.vue",
  components: {
    CAvatar: Kf,
    CSubheading: Ne,
    CUi: we,
    CChevron: Xt
  },
  data() {
    return {
      showSubmenu: !1
    };
  },
  props: {
    fullName: {
      required: !0,
      type: String
    },
    companyName: {
      required: !0,
      type: String
    },
    url: {
      required: !1,
      type: String,
      default: void 0
    }
  },
  emits: ["toggle-submenu"],
  methods: {
    toggleSubmenu(t) {
      this.$emit("toggle-submenu", t);
    },
    handleNavHeadClick() {
      this.showSubmenu = !this.showSubmenu, this.toggleSubmenu(this.showSubmenu);
    }
  }
}), JO = { class: "c-account-info-container" };
function eD(t, e, n, r, a, i) {
  const o = z("c-avatar"), s = z("c-subheading"), l = z("c-ui"), c = z("c-chevron");
  return b(), M("div", {
    class: "c-account-info-outer",
    onClick: e[1] || (e[1] = (...u) => t.handleNavHeadClick && t.handleNavHeadClick(...u))
  }, [
    (b(), L(o, {
      key: t.companyName,
      name: t.companyName,
      url: t.url
    }, null, 8, ["name", "url"])),
    R("div", JO, [
      T(s, {
        type: "three",
        class: "c-name-field"
      }, {
        default: W(() => [
          V(j(t.fullName), 1)
        ]),
        _: 1
      }),
      T(l, {
        type: "five",
        class: "c-company-field"
      }, {
        default: W(() => [
          V(j(t.companyName), 1)
        ]),
        _: 1
      })
    ]),
    T(c, {
      class: "c-chevron-spacing",
      activeStatus: t.showSubmenu,
      "onUpdate:activeStatus": [
        e[0] || (e[0] = (u) => t.showSubmenu = u),
        t.toggleSubmenu
      ]
    }, null, 8, ["activeStatus", "onUpdate:activeStatus"])
  ]);
}
const tD = /* @__PURE__ */ B(ZO, [["render", eD], ["__scopeId", "data-v-f0c01ff2"]]);
const nD = {
  name: "NavAccountSwitcher.vue",
  emits: ["switch-account"],
  components: {
    CChevron: Xt,
    CUi: we
  },
  props: {
    companyName: {
      required: !0,
      type: String
    },
    accountNumber: {
      required: !1,
      type: String,
      default: void 0
    }
  }
}, rD = (t) => (In("data-v-da40159c"), t = t(), Nn(), t), aD = { class: "c-account-switcher-wrapper" }, iD = /* @__PURE__ */ rD(() => /* @__PURE__ */ R("span", null, " - ", -1));
function oD(t, e, n, r, a, i) {
  const o = z("c-ui"), s = z("c-chevron");
  return b(), M("div", {
    class: "c-account-switcher",
    onClick: e[1] || (e[1] = (l) => t.$emit("switch-account"))
  }, [
    R("div", aD, [
      T(o, {
        type: "four",
        class: "c-company-label"
      }, {
        default: W(() => [
          V(j(n.companyName), 1)
        ]),
        _: 1
      }),
      n.accountNumber ? (b(), L(o, {
        key: 0,
        type: "four",
        class: "c-account-number"
      }, {
        default: W(() => [
          iD,
          V(" " + j(n.accountNumber), 1)
        ]),
        _: 1
      })) : E("", !0),
      T(o, {
        type: "five",
        class: "c-switch-helper"
      }, {
        default: W(() => [
          V(" Switch vendor ")
        ]),
        _: 1
      })
    ]),
    T(s, {
      "chevron-direction": "right",
      "should-toggle": !1,
      onInteracted: e[0] || (e[0] = (l) => t.$emit("switch-account"))
    })
  ]);
}
const sD = /* @__PURE__ */ B(nD, [["render", oD], ["__scopeId", "data-v-da40159c"]]);
const lD = /* @__PURE__ */ ne({
  name: "NavAccount.vue",
  components: {
    NavAccountHead: tD,
    NavItem: Pr,
    NavAccountSwitcher: sD,
    CSeparator: lo,
    CAccordion: co,
    CBadge: ur
  },
  props: {
    fullName: {
      required: !0,
      type: String
    },
    companyName: {
      required: !0,
      type: String
    },
    accountNumber: {
      required: !1,
      type: String,
      default: void 0
    },
    avatarUrl: {
      required: !1,
      type: String,
      default: void 0
    },
    showAccountSwitcher: {
      required: !1,
      type: Boolean,
      default: !0
    },
    parentBaseHref: {
      required: !1,
      type: String,
      default: "account"
    },
    versionNumber: {
      required: !1,
      type: String,
      default: ""
    },
    showVersionNumber: {
      required: !1,
      type: Boolean,
      default: !1
    },
    routes: {
      type: Array,
      default: () => []
    }
  },
  emits: ["navigate-to", "switch-account"],
  data() {
    return {
      open: !1
    };
  },
  computed: {
    logoutRoute() {
      return this.routes.find((t) => {
        var e;
        return (e = t == null ? void 0 : t.meta) == null ? void 0 : e.logout;
      });
    },
    accountRoutes() {
      return this.routes.filter((t) => !t.logout);
    }
  },
  methods: {
    toggleSubmenu(t) {
      this.open = t !== !1;
    }
  }
}), cD = { class: "c-layer-elevated c-account-wrapper" }, uD = { class: "c-account-routes" };
function dD(t, e, n, r, a, i) {
  const o = z("nav-account-head"), s = z("c-separator"), l = z("nav-account-switcher"), c = z("c-badge"), u = z("nav-item"), f = z("c-accordion");
  return b(), M("div", cD, [
    T(o, {
      "company-name": t.companyName,
      "full-name": t.fullName,
      url: t.avatarUrl,
      onToggleSubmenu: t.toggleSubmenu
    }, null, 8, ["company-name", "full-name", "url", "onToggleSubmenu"]),
    T(f, { status: t.open }, {
      default: W(() => [
        R("div", null, [
          t.showAccountSwitcher ? (b(), L(s, {
            key: 0,
            class: "c-spacing"
          })) : E("", !0),
          t.showAccountSwitcher ? (b(), L(l, {
            key: 1,
            "company-name": t.companyName,
            "account-number": t.accountNumber,
            onSwitchAccount: e[0] || (e[0] = (d) => t.$emit("switch-account"))
          }, null, 8, ["company-name", "account-number"])) : E("", !0),
          T(s, { class: "c-spacing" }),
          R("div", uD, [
            (b(!0), M(de, null, xe(t.accountRoutes, (d, h) => (b(), M(de, {
              key: d.path
            }, [
              h + 1 === t.accountRoutes.length ? (b(), L(s, {
                key: 0,
                class: "c-spacing"
              })) : E("", !0),
              T(u, {
                indented: !1,
                label: d.label,
                "href-route-path": "/" + t.parentBaseHref + "/" + d.path,
                onNavClick: (m) => t.$emit("navigate-to", d)
              }, hi({ _: 2 }, [
                h + 1 === t.accountRoutes.length && t.versionNumber && t.showVersionNumber ? {
                  name: "badge",
                  fn: W(() => [
                    T(c, {
                      intent: "neutral",
                      value: t.versionNumber
                    }, null, 8, ["value"])
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["label", "href-route-path", "onNavClick"])
            ], 64))), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["status"])
  ]);
}
const V$ = /* @__PURE__ */ B(lD, [["render", dD], ["__scopeId", "data-v-e0c45110"]]);
const fD = {
  name: "NavBottom",
  components: {
    NavItem: Pr,
    NavShortcuts: XO,
    CAccordion: co
  },
  props: {
    sideMenuStatus: {
      required: !0,
      type: Boolean
    },
    searchStatus: {
      required: !0,
      type: Boolean
    },
    quickActionsStatus: {
      required: !1,
      default: !1,
      type: Boolean
    },
    quickActionShortCuts: {
      required: !0,
      type: Array
    },
    routes: {
      required: !0,
      type: Array,
      deep: !0,
      validator(t) {
        if (!t.filter((e) => e.icon && e.href).length)
          throw console.error("Routes passed are not valid. They must be objects"), new Error("Routes passed to NavBottom, are not valid. They must be objects");
        return !0;
      }
    }
  },
  emits: [
    "update:sideMenuStatus",
    "update:searchStatus",
    "update:quickActionsStatus",
    "navigate-to",
    "on-search",
    "navigate-quickShortcuts-to"
  ],
  data() {
    return {
      drawerStatus: !1
    };
  },
  computed: {
    quickActionsMessage() {
      const { CTranslate: t } = rt();
      return t("navBottom.quickActions");
    }
  },
  watch: {
    quickActionsStatus(t) {
      this.drawerStatus = t;
    }
  },
  methods: {
    closeMenu() {
      this.$emit("update:sideMenuStatus", !1);
    },
    openMenu() {
      this.$emit("update:sideMenuStatus", !0);
    },
    toggleQuickActions() {
      const t = !this.drawerStatus;
      this.drawerStatus = t, this.$emit("update:quickActionsStatus", t);
    },
    handleQuickActionNavigation(t) {
      this.$emit("navigate-quickShortcuts-to", t);
    }
  }
}, hD = { class: "c-bottom-navigation" }, pD = { class: "c-bottom-navigation-head" };
function mD(t, e, n, r, a, i) {
  const o = z("nav-shortcuts"), s = z("c-accordion"), l = z("nav-item");
  return b(), M("div", hD, [
    T(s, { status: a.drawerStatus }, {
      default: W(() => [
        T(o, {
          class: "c-bottom-drawer",
          layout: { alignCenter: !0 },
          label: i.quickActionsMessage,
          shortcuts: n.quickActionShortCuts,
          onNavigateTo: i.handleQuickActionNavigation
        }, null, 8, ["label", "shortcuts", "onNavigateTo"])
      ]),
      _: 1
    }, 8, ["status"]),
    R("div", pD, [
      n.sideMenuStatus ? E("", !0) : (b(), L(l, {
        key: 0,
        class: "c-mobile-nav",
        icon: "MenuIcon",
        indented: !1,
        onNavClick: i.openMenu
      }, null, 8, ["onNavClick"])),
      n.sideMenuStatus ? (b(), L(l, {
        key: 1,
        class: "c-mobile-nav",
        icon: "X",
        indented: !1,
        active: !0,
        onNavClick: i.closeMenu
      }, null, 8, ["onNavClick"])) : E("", !0),
      T(l, {
        class: "c-mobile-nav",
        icon: "search",
        active: n.searchStatus,
        indented: !1,
        onNavClick: e[0] || (e[0] = (c) => t.$emit("on-search", n.searchStatus))
      }, null, 8, ["active"]),
      T(l, {
        class: "c-mobile-nav",
        icon: "Plus",
        indented: !1,
        active: a.drawerStatus,
        onNavClick: e[1] || (e[1] = (c) => i.toggleQuickActions())
      }, null, 8, ["active"]),
      (b(!0), M(de, null, xe(n.routes, (c) => (b(), L(l, {
        key: c.href,
        class: "c-mobile-nav",
        icon: c.icon,
        indented: !1,
        onNavClick: (u) => t.$emit("navigate-to", c.href)
      }, null, 8, ["icon", "onNavClick"]))), 128))
    ])
  ]);
}
const q$ = /* @__PURE__ */ B(fD, [["render", mD], ["__scopeId", "data-v-2eeed764"]]);
const gD = {
  name: "NavTop",
  emits: ["nav-top-click"],
  components: {
    BkLogo: Xf
  },
  methods: {
    handleLogoClick(t) {
      this.$emit("nav-top-click", t);
    }
  }
};
function vD(t, e, n, r, a, i) {
  const o = z("bk-logo");
  return b(), M("div", null, [
    T(o, {
      complete: !0,
      onClick: i.handleLogoClick
    }, null, 8, ["onClick"])
  ]);
}
const U$ = /* @__PURE__ */ B(gD, [["render", vD], ["__scopeId", "data-v-63c682f7"]]);
const yD = {
  name: "TabNavItem",
  components: {
    CUi: we,
    CBadge: ur
  },
  props: {
    label: {
      type: String,
      required: !0
    },
    badgeCount: {
      type: String,
      required: !1,
      default: void 0
    },
    isActive: {
      type: Boolean,
      required: !1
    }
  },
  emits: ["update:isToggled"],
  data() {
    return {
      displayAsActive: this.isActive
    };
  },
  computed: {
    badgeType() {
      return this.displayAsActive ? G.primaryInverted : G.neutral;
    }
  },
  watch: {
    isActive(t) {
      this.displayAsActive = t;
    }
  },
  methods: {
    handleTabNavItemClick() {
      var i, o, s;
      const t = (o = (i = this.$refs.tabNavItem) == null ? void 0 : i.parentElement) == null ? void 0 : o.parentNode, e = (t == null ? void 0 : t.clientWidth) ?? 0, n = this.$refs.tabNavItem, r = (n == null ? void 0 : n.offsetWidth) ?? 0, a = ((s = n.getBoundingClientRect()) == null ? void 0 : s.left) ?? 0;
      if (t) {
        if (a + r > e) {
          const l = a + r - e;
          t.scrollLeft += l;
        } else if (a < r) {
          const l = r - a + 8;
          t.scrollLeft -= l;
        }
      }
      this.$emit("update:isToggled");
    }
  }
};
function bD(t, e, n, r, a, i) {
  const o = z("c-ui"), s = z("c-badge");
  return b(), M("div", {
    class: H(["c-tab-nav-item", { active: a.displayAsActive }]),
    onClick: e[0] || (e[0] = (...l) => i.handleTabNavItemClick && i.handleTabNavItemClick(...l)),
    ref: "tabNavItem"
  }, [
    T(o, { type: "four" }, {
      default: W(() => [
        V(j(n.label), 1)
      ]),
      _: 1
    }),
    n.badgeCount ? (b(), L(s, {
      key: 0,
      class: "c-tab-badge",
      value: n.badgeCount,
      intent: i.badgeType
    }, null, 8, ["value", "intent"])) : E("", !0)
  ], 2);
}
const _D = /* @__PURE__ */ B(yD, [["render", bD], ["__scopeId", "data-v-a3fffe98"]]);
const wD = {
  name: "TabNav",
  components: {
    CNavTabItem: _D,
    CChevron: Xt
  },
  props: {
    navItems: {
      type: Array,
      required: !0
    },
    disableConcurrentSelect: {
      type: Boolean,
      default: !0,
      required: !1
    },
    scrollOnClick: {
      type: Number,
      default: 100,
      required: !1
    }
  },
  emits: ["update:nav-items"],
  data() {
    return {
      selectedTabs: [],
      tabNavContainerWidth: 0,
      tabbedNavWidth: 0,
      isScrollableLeft: !1,
      isScrollableRight: !0
    };
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(this.onResize), this.resizeObserver.observe(this.$refs.tabbedNav), this.resizeObserver.observe(this.$refs.tabNavScrollContainer), this.onResize();
  },
  beforeUnmount() {
    this.resizeObserver.unobserve(this.$refs.tabbedNav), this.resizeObserver.unobserve(this.$refs.tabNavScrollContainer);
  },
  computed: {
    isScrollable() {
      return this.tabNavContainerWidth < this.tabbedNavWidth;
    },
    showLeftArrow() {
      return this.isScrollableLeft;
    },
    showRightArrow() {
      return this.isScrollableRight;
    }
  },
  methods: {
    onResize() {
      var t, e;
      this.tabbedNavWidth = (t = this.$refs.tabbedNav) == null ? void 0 : t.offsetWidth, this.tabNavContainerWidth = (e = this.$refs.tabNavScrollContainer) == null ? void 0 : e.clientWidth;
    },
    handleScroll() {
      const t = this.$refs.tabNavScrollContainer, e = (t == null ? void 0 : t.clientWidth) ?? 0, n = (t == null ? void 0 : t.scrollWidth) ?? 0, r = (t == null ? void 0 : t.scrollLeft) ?? 0;
      (t == null ? void 0 : t.scrollLeft) === 0 ? (this.isScrollableLeft = !1, this.isScrollableRight = !0) : e + r === n ? (this.isScrollableLeft = !0, this.isScrollableRight = !1) : (this.isScrollableLeft = !0, this.isScrollableRight = !0);
    },
    handleClickChevron(t) {
      const e = this.$refs.tabNavScrollContainer;
      t === "right" ? e.scrollLeft += this.scrollOnClick : t === "left" && (e.scrollLeft -= this.scrollOnClick);
    },
    selectNavigationTab(t) {
      const e = this.navItems.map((n) => {
        const r = this.disableConcurrentSelect ? t.label === n.label : t.label === n.label ? !t.selected : t.selected;
        return {
          ...n,
          selected: r
        };
      });
      this.$emit("update:nav-items", e);
    },
    addTabToActive(t) {
      this.disableConcurrentSelect && this.clearActiveTabs(), this.selectedTabs.push(t);
    },
    removeTabFromActive(t) {
      this.selectedTabs = [...this.selectedTabs].filter((e) => e !== t);
    },
    clearActiveTabs() {
      this.selectedTabs = [];
    }
  }
}, kD = {
  class: "c-tabbed-nav",
  ref: "tabbedNav"
};
function xD(t, e, n, r, a, i) {
  const o = z("c-chevron"), s = z("c-nav-tab-item");
  return b(), M(de, null, [
    i.showLeftArrow ? (b(), L(o, {
      key: 0,
      class: "c-chevron c-chevron-left",
      "chevron-direction": "left",
      "should-toggle": !1,
      onInteracted: e[0] || (e[0] = (l) => i.handleClickChevron("left"))
    })) : E("", !0),
    i.showRightArrow && i.isScrollable ? (b(), L(o, {
      key: 1,
      class: "c-chevron c-chevron-right",
      "chevron-direction": "right",
      "should-toggle": !1,
      onInteracted: e[1] || (e[1] = (l) => i.handleClickChevron("right"))
    })) : E("", !0),
    R("nav", He({ class: "c-tab-nav-container" }, t.$attrs), [
      R("div", {
        class: "c-tab-nav-container-scroll",
        ref: "tabNavScrollContainer",
        onScroll: e[2] || (e[2] = (...l) => i.handleScroll && i.handleScroll(...l))
      }, [
        R("div", kD, [
          (b(!0), M(de, null, xe(n.navItems, (l) => (b(), L(s, {
            key: l.label,
            label: l.label,
            "badge-count": l.badgeCount,
            "is-active": l.selected,
            class: "c-tab-nav-item",
            "onUpdate:isToggled": (c) => i.selectNavigationTab(l)
          }, null, 8, ["label", "badge-count", "is-active", "onUpdate:isToggled"]))), 128))
        ], 512)
      ], 544)
    ], 16)
  ], 64);
}
const Y$ = /* @__PURE__ */ B(wD, [["render", xD], ["__scopeId", "data-v-1e4ce2aa"]]);
const CD = {
  name: "CTextInput",
  components: {
    CUi: we
  },
  mixins: [Xl],
  data() {
    return {
      untouched: this.value.length < 1,
      focus: !1
    };
  },
  props: {
    value: {
      type: String,
      default: "",
      required: !1
    },
    label: {
      type: String,
      default: "",
      required: !1
    },
    errorMessage: {
      type: String,
      default: "",
      required: !1
    },
    disabled: {
      type: Boolean,
      default: !1,
      required: !1
    },
    criticalState: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  setup(t, { emit: e }) {
    const { validate: n, handleFocus: r } = Tr({ props: t, valueToValidate: t.value }, { emit: e });
    return { validate: n, handleFocus: r };
  },
  emits: ["update:value", Rn],
  mounted() {
    this.validate(this.value);
  },
  computed: {
    hasErrorMessage() {
      return this.errorMessage && this.errorMessage.length;
    },
    hasLabel() {
      return this.label && this.label.length;
    },
    hasPreIcon() {
      return this == null ? void 0 : this.$slots["pre-input"];
    },
    hasPostIcon() {
      return this == null ? void 0 : this.$slots["post-input"];
    },
    hasValidation() {
      return !0;
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(t) {
        const { hasValidation: e } = this;
        this.untouched = !1, e && this.validate(t), this.$emit("update:value", t);
      }
    }
  }
}, PD = { class: "c-input-wrap" }, SD = ["disabled"], MD = { class: "c-slot-icon-pre" }, OD = { class: "c-slot-icon-post" };
function DD(t, e, n, r, a, i) {
  const o = z("c-ui");
  return b(), M(de, null, [
    R("label", null, [
      i.hasLabel ? (b(), L(o, {
        key: 0,
        class: H(["c-input-label", {
          critical: n.criticalState
        }]),
        type: "four"
      }, {
        default: W(() => [
          V(j(n.label), 1)
        ]),
        _: 1
      }, 8, ["class"])) : E("", !0),
      R("span", PD, [
        Ve(R("input", He({
          "onUpdate:modelValue": e[0] || (e[0] = (s) => i.inputValue = s),
          ref: "textInput",
          onFocusin: e[1] || (e[1] = (...s) => r.handleFocus && r.handleFocus(...s)),
          onFocusout: e[2] || (e[2] = (...s) => r.handleFocus && r.handleFocus(...s)),
          type: "text"
        }, t.$attrs, {
          disabled: n.disabled,
          class: ["c-text-input-el", {
            critical: n.criticalState,
            "leading-trailing": i.hasPreIcon && i.hasPostIcon,
            leading: i.hasPreIcon && !i.hasPostIcon,
            trailing: i.hasPostIcon && !i.hasPreIcon
          }]
        }), null, 16, SD), [
          [Mr, i.inputValue]
        ]),
        R("span", MD, [
          _e(t.$slots, "pre-input", {}, void 0, !0)
        ]),
        R("span", OD, [
          _e(t.$slots, "post-input", {}, void 0, !0)
        ])
      ])
    ]),
    i.hasErrorMessage ? (b(), L(o, {
      key: 0,
      type: "five",
      class: "c-error-message"
    }, {
      default: W(() => [
        V(j(n.errorMessage), 1)
      ]),
      _: 1
    })) : E("", !0)
  ], 64);
}
const TD = /* @__PURE__ */ B(CD, [["render", DD], ["__scopeId", "data-v-bb49615a"]]);
const Pf = "search", $D = "modify", RD = "clear", ED = {
  name: "SearchInput",
  components: { CTextInput: TD, Search: eh, Delete: vg },
  emits: ["update:value"],
  props: {
    value: {
      type: String,
      required: !1,
      default: ""
    },
    delayOnTypeSearch: {
      type: Number,
      default: 300,
      required: !1
    },
    minLengthToTriggerSearch: {
      type: Number,
      default: 3,
      required: !1
    },
    enablePasteEvent: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  data() {
    return {
      searchTriggerTimeout: !1
    };
  },
  mounted() {
    this.enablePasteEvent && this.$el.addEventListener("paste", this.onPasteEvent, !1);
  },
  unmounted() {
    this.enablePasteEvent && this.$el.removeEventListener("paste", this.onPasteEvent, !1);
  },
  computed: {
    reactiveValue: {
      get() {
        return this.value;
      },
      set(t) {
        this.$emit("update:value", t);
      }
    }
  },
  watch: {
    value(t, e) {
      this.$emit($D, this.value), t && t !== e && (this.minLengthToTriggerSearch > t.length || (this.searchTriggerTimeout && clearTimeout(this.searchTriggerTimeout), this.searchTriggerTimeout = setTimeout(this.triggerSearch, this.delayOnTypeSearch)));
    }
  },
  methods: {
    triggerSearch() {
      this.$emit(Pf, this.value);
    },
    clearInput() {
      this.$emit(RD, this.value), this.reactiveValue = "";
    },
    onPasteEvent() {
      this.$emit(Pf, this.value);
    }
  }
};
function AD(t, e, n, r, a, i) {
  const o = z("search"), s = z("delete"), l = z("c-text-input");
  return b(), L(l, {
    value: i.reactiveValue,
    "onUpdate:value": e[1] || (e[1] = (c) => i.reactiveValue = c),
    ref: "searchInput",
    onKeyup: st(ve(i.triggerSearch, ["stop"]), ["enter"])
  }, {
    "pre-input": W(() => [
      T(o, { class: "c-icon-m" })
    ]),
    "post-input": W(() => [
      T(s, {
        class: "c-icon-m c-interactive",
        onClick: e[0] || (e[0] = (c) => i.clearInput())
      })
    ]),
    _: 1
  }, 8, ["value", "onKeyup"]);
}
const X$ = /* @__PURE__ */ B(ED, [["render", AD], ["__scopeId", "data-v-d46ebebe"]]);
class Ap {
  constructor(e, n = "dd/mm/yyyyy") {
    this.separator = e, this.separatorLength = e.length, this.positionsList = [], this.format = n, this.initialise(), this.maxLength = 8 + e.length * 2;
  }
  initialise() {
    let e = 1, n;
    const r = this.format.split("");
    this.positionsList = r.reduce((a, i) => {
      const o = i !== n;
      if (e = o ? 1 : e + 1, o && (n = i), ["d", "m", "y"].includes(i))
        a.push(`${i}-${e}`);
      else
        for (let s = 0; s < this.separatorLength; s++)
          a.push(!1);
      return a;
    }, []);
  }
  getEmptyConstructionDateObject() {
    return {
      "d-1": "",
      "d-2": "",
      "m-1": "",
      "m-2": "",
      "y-1": "",
      "y-2": "",
      "y-3": "",
      "y-4": ""
    };
  }
  getAsDate(e) {
    const n = ["d-1", "d-2", "m-1", "m-2", "y-1", "y-2", "y-3", "y-4"];
    for (let o of n)
      if (!e[o])
        return !1;
    const r = `${e["y-1"]}${e["y-2"]}${e["y-3"]}${e["y-4"]}`, a = `${e["m-1"]}${e["m-2"]}`, i = `${e["d-1"]}${e["d-2"]}`;
    return /* @__PURE__ */ new Date(`${r}/${a}/${i}`);
  }
  fromDateObject(e) {
    const n = Et(e, "dd"), r = Et(e, "MM"), a = Et(e, "yyyy");
    return {
      "d-1": n[0],
      "d-2": n[1],
      "m-1": r[0],
      "m-2": r[1],
      "y-1": a[0],
      "y-2": a[1],
      "y-3": a[2],
      "y-4": a[3]
    };
  }
  getFormattedDateObject(e) {
    const n = this.format.split("");
    let r = 1, a, i = !1;
    return n.reduce((o, s) => {
      const l = s !== a;
      if (r = l ? 1 : r + 1, l && (a = s), ["d", "m", "y"].includes(s)) {
        const c = `${s}-${r}`;
        if (!e[c])
          return i = !0, o[c] = "", o;
        if (i)
          return o[c] = "", o;
        o[c] = e[c];
      }
      return o;
    }, {});
  }
  getFormattedString(e) {
    const n = this.format.split("");
    let r = 1, a, i = !1;
    return n.reduce((o, s) => {
      const l = s !== a;
      if (r = l ? 1 : r + 1, l && (a = s), ["d", "m", "y"].includes(s)) {
        const c = `${s}-${r}`;
        if (e[c] || (i = !0), i)
          return o;
        o.push(e[c]);
      } else {
        if (i)
          return o;
        o.push(this.separator);
      }
      return o;
    }, []).join("");
  }
  getPositionList() {
    return this.positionsList;
  }
  doesPositionHaveSeparator(e) {
    return !this.positionsList[e];
  }
  findDayAtPosition(e) {
    if (this.positionsList[e])
      return this.positionsList[e];
    let n = e;
    for (; !this.positionsList[n] && n > -1; )
      n -= 1;
    return this.positionsList[n];
  }
  findPreviousWriteblePosition(e) {
    return e < 1 ? 0 : this.doesPositionHaveSeparator(e - 1) ? this.findPreviousWriteblePosition(e - 1) : e - 1;
  }
  findNextsWriteblePosition(e) {
    return e >= this.maxLength ? this.maxLength : this.doesPositionHaveSeparator(e + 1) ? this.findNextsWriteblePosition(e + 1) : e + 1;
  }
  getBeginOfCurrentBlock(e) {
    if (e < 1)
      return e;
    let n = e;
    if (this.doesPositionHaveSeparator(e))
      return this.getBeginOfCurrentBlock(e - 1);
    for (; n > -1 && !this.doesPositionHaveSeparator(n); )
      n -= 1;
    return n + 1;
  }
  getBeginOfNextBlock(e) {
    return this.doesPositionHaveSeparator(e) ? e < this.maxLength && !this.doesPositionHaveSeparator(e) ? this.getBeginOfNextBlock(e + 1) : e + this.separatorLength : this.getBeginOfNextBlock(e + 1);
  }
  getFirstPositionBeforeSeparatorOnTheLeft(e) {
    if (e === 0)
      return e;
    if (!this.doesPositionHaveSeparator(e))
      return this.getFirstPositionBeforeSeparatorOnTheLeft(e - 1);
    let n = e;
    for (; n > -1 && this.doesPositionHaveSeparator(n); )
      n -= 1;
    return this.getBeginOfCurrentBlock(n);
  }
  autocomplete(e, n, r, a) {
    const i = this.findDayAtPosition(
      e - 1
    );
    let o = !1;
    const s = { ...r };
    switch (i) {
      case "d-1":
        n > 3 && (s["d-1"] = "0", s["d-2"] = n, o = !0);
        break;
      case "d-2":
        a && (s["d-2"] = s["d-1"], s["d-1"] = "0", o = !0);
        break;
      case "m-1":
        n > 1 && (s["m-1"] = "0", s["m-2"] = n, o = !0);
        break;
      case "m-2":
        a && (s["m-2"] = s["m-1"], s["m-1"] = "0", o = !0);
        break;
    }
    return [s, o];
  }
}
const Sf = "update:value", LD = {
  insertText: "insertText",
  deleteContentBackward: "deleteContentBackward",
  deleteContentForward: "deleteContentForward",
  ArrowRight: "ArrowRight",
  ArrowLeft: "ArrowLeft",
  Shift: "Shift",
  Meta: "Meta",
  Delete: "Delete",
  mouse: "mouse"
}, { insertText: ID, deleteContentForward: ND, mouse: WD, deleteContentBackward: ha, ArrowRight: Mf, ArrowLeft: Of, Shift: zD, Meta: BD, Delete: FD } = LD, fc = {
  name: "CDateField",
  mixins: [Xl],
  props: {
    label: {
      required: !1,
      type: String,
      default: ""
    },
    compactMode: {
      required: !1,
      type: Boolean,
      default: !1
    },
    backgroundColor: {
      required: !1,
      type: String,
      default: "transparent"
    },
    value: {
      required: !1,
      type: Date || !1,
      default: !1
    },
    error: {
      required: !1,
      type: String,
      default: null
    },
    showErrorMessage: {
      required: !1,
      type: Boolean,
      default: !0
    },
    format: {
      required: !1,
      type: String,
      default: go.european
    },
    separator: {
      type: String,
      required: !1,
      default: " / "
    },
    placeholder: {
      required: !1,
      type: String,
      default: ""
    },
    disabled: {
      require: !1,
      type: Boolean,
      default: !1
    }
  },
  setup(t, { emit: e }) {
    const { validate: n, handleFocus: r } = Tr({ props: t }, { emit: e });
    return { validate: n, handleFocus: r };
  },
  data() {
    return {
      stringedDate: "",
      buildingDate: {
        "d-1": "",
        "d-2": "",
        "m-1": "",
        "m-2": "",
        "y-1": "",
        "y-2": "",
        "y-3": "",
        "y-4": ""
      },
      DatePositionHelper: new Ap(this.separator, this.format)
    };
  },
  components: {
    Calendar: uo,
    X: Bn,
    CRunning: zn
  },
  emits: [Sf, Rn],
  watch: {
    stringedDate(t) {
      const e = t.replaceAll(this.separator, "/");
      this.validate(e);
    },
    value(t) {
      try {
        this.buildingDate = this.DatePositionHelper.fromDateObject(t);
      } catch {
      }
      this.stringedDate = this.DatePositionHelper.getFormattedString(this.buildingDate);
    }
  },
  mounted() {
    if (this.value) {
      try {
        this.buildingDate = this.DatePositionHelper.fromDateObject(this.value);
      } catch {
      }
      this.stringedDate = this.DatePositionHelper.getFormattedString(this.buildingDate);
    }
  },
  computed: {
    inputClasses() {
      return {
        "c-input": !0,
        "c-input-compact": this.compactMode
      };
    },
    placeholderComputed() {
      return this.placeholder && this.placeholder.length ? this.placeholder : this.format.replaceAll("/", this.separator);
    }
  },
  methods: {
    handleInputChange(t) {
      const e = [
        ND,
        ha
      ], n = ["/", "\\", ".", "-", ";"], { inputType: r, data: a } = t, i = r === ha ? this.$refs.dateInput.selectionStart + 1 : this.$refs.dateInput.selectionStart, o = i === this.stringedDate.length + 1, s = n.includes(a);
      if (!e.includes(r) && isNaN(parseInt(a)) && !s) {
        this.$forceUpdate();
        return;
      }
      const l = this.DatePositionHelper.findDayAtPosition(i - 1);
      if (!l && !s) {
        this.$forceUpdate();
        return;
      }
      const [c, u] = this.DatePositionHelper.autocomplete(i, a, this.buildingDate, s);
      !u && !s ? this.buildingDate[l] = a ?? "" : this.buildingDate = c, this.buildingDate = this.DatePositionHelper.getFormattedDateObject(this.buildingDate), this.stringedDate = this.DatePositionHelper.getFormattedString(this.buildingDate), this.$forceUpdate(), this.stringedDate.replaceAll(this.separator, "/"), this.$emit(Sf, this.DatePositionHelper.getAsDate(this.buildingDate)), (!o || r === ha) && this.handlePositioning(r, u);
    },
    handleKeyboardCaretMovement(t) {
      const e = [
        Mf,
        Of,
        zD,
        BD
      ];
      if (t.key === FD) {
        this.clearInput(), this.$forceUpdate(), this.handlePositioning("mouse");
        return;
      }
      e.includes(t.key) && (t.preventDefault(), this.handlePositioning(t.key));
    },
    handleMouseCaretMovement() {
      this.handlePositioning("mouse");
    },
    handlePositioning(t, e) {
      const { DatePositionHelper: n } = this;
      let r = e ? this.$refs.dateInput.selectionStart + 1 : this.$refs.dateInput.selectionStart;
      switch (t) {
        case ID:
          r = n.findNextsWriteblePosition(
            r - 1
          );
          break;
        case ha:
          r = n.findPreviousWriteblePosition(
            r + 1
          );
          break;
        case WD:
          r = n.getBeginOfCurrentBlock(
            r
          );
          break;
        case Of:
          r = n.getBeginOfCurrentBlock(
            r - 1
          );
          break;
        case Mf:
          r = n.getBeginOfNextBlock(
            r
          );
          break;
      }
      this.$nextTick(() => {
        this.$refs.dateInput.selectionStart = r, this.$refs.dateInput.selectionEnd = r;
      });
    },
    clearInput() {
      this.stringedDate = "", this.buildingDate = this.DatePositionHelper.getEmptyConstructionDateObject();
    }
  }
}, Df = () => {
  so((t) => ({
    "57b4ae85": t.backgroundColor
  }));
}, Tf = fc.setup;
fc.setup = Tf ? (t, e) => (Df(), Tf(t, e)) : Df;
const HD = fc, jD = { class: "c-input-container" }, VD = ["value", "placeholder", "disabled"], qD = {
  key: 0,
  class: "c-field-error-message"
};
function UD(t, e, n, r, a, i) {
  const o = z("c-running"), s = z("calendar"), l = z("X");
  return b(), M("div", {
    class: H(["c-field-container", { "c-field-error": n.error, "c-field-disabled": n.disabled }])
  }, [
    T(o, { type: "two" }, {
      default: W(() => [
        V(j(n.label), 1)
      ]),
      _: 1
    }),
    R("div", jD, [
      n.compactMode ? E("", !0) : (b(), L(s, {
        key: 0,
        class: "c-icon-m c-input-icon"
      })),
      R("input", He({
        type: "text",
        class: i.inputClasses,
        inputmode: "numeric",
        value: a.stringedDate
      }, t.$attrs, {
        ref: "dateInput",
        placeholder: i.placeholderComputed,
        disabled: n.disabled,
        onInput: e[0] || (e[0] = (...c) => i.handleInputChange && i.handleInputChange(...c)),
        onKeyup: e[1] || (e[1] = (...c) => i.handleKeyboardCaretMovement && i.handleKeyboardCaretMovement(...c)),
        onClick: e[2] || (e[2] = (...c) => i.handleMouseCaretMovement && i.handleMouseCaretMovement(...c)),
        onFocusin: e[3] || (e[3] = (...c) => r.handleFocus && r.handleFocus(...c)),
        onFocusout: e[4] || (e[4] = (...c) => r.handleFocus && r.handleFocus(...c))
      }), null, 16, VD),
      a.stringedDate.length > 0 && !n.compactMode ? (b(), M("button", {
        key: 1,
        onClick: e[5] || (e[5] = (...c) => i.clearInput && i.clearInput(...c)),
        class: "c-input-btn"
      }, [
        T(l, { class: "c-icon-m" })
      ])) : E("", !0)
    ]),
    n.error && n.showErrorMessage ? (b(), M("span", qD, j(n.error), 1)) : E("", !0)
  ], 2);
}
const Sl = /* @__PURE__ */ B(HD, [["render", UD], ["__scopeId", "data-v-10c71998"]]), At = (t) => {
  if (!t || typeof t != "object")
    return !1;
  const { starts: e, ends: n, place: r } = t;
  return !e || !n || !e instanceof Date || isNaN(e) || !n instanceof Date || isNaN(n) || pr(e, n) ? !1 : r === void 0 || r in ot;
}, $f = "click", Rf = "update:valueUpdated", YD = ne({
  name: "CDateRangeField",
  components: {
    Calendar: uo,
    X: Bn,
    CRunning: zn
  },
  mixins: [Xl],
  emits: [$f, Rf],
  props: {
    label: {
      required: !1,
      type: String,
      default: ""
    },
    compactMode: {
      required: !1,
      type: Boolean,
      default: !1
    },
    dateRange: {
      required: !1,
      type: Object,
      validator(t) {
        return At(t);
      },
      default: () => ({ starts: null, ends: null })
    },
    format: {
      required: !1,
      type: String,
      default: go.european
    },
    separator: {
      type: String,
      required: !1,
      default: " / "
    },
    datesSeparator: {
      type: String,
      required: !1,
      default: " - "
    },
    placeholder: {
      required: !1,
      type: String,
      default: ""
    }
  },
  setup(t, { emit: e }) {
    const { validate: n, handleFocus: r } = Tr({ props: t }, { emit: e });
    return {
      validate: n,
      handleFocus: r
    };
  },
  watch: {
    dateRange(t) {
      At(t) && (this.stringifiedDateRange = this.buildStringifiedDateRange(t));
    }
  },
  mounted() {
    At(this.dateRange) && (this.stringifiedDateRange = this.buildStringifiedDateRange(this.dateRange));
  },
  data() {
    return {
      stringifiedDateRange: "",
      DatePositionHelper: new Ap(this.separator, this.format)
    };
  },
  computed: {
    inputClasses() {
      return {
        "c-input": !0,
        "c-input-compact": this.compactMode
      };
    },
    placeholderComputed() {
      let t = this.format.replaceAll("/", this.separator);
      return this.placeholder && this.placeholder.length && (t = this.placeholder), `${t}${this.datesSeparator}${t}`;
    }
  },
  methods: {
    handleClick() {
      this.$emit($f);
    },
    clearInput() {
      this.stringifiedDateRange = "", this.$emit(Rf, null);
    },
    buildStringifiedDateRange(t) {
      const e = this.formatDate(t.starts), n = this.formatDate(t.ends);
      return !e || !n ? "" : `${e}${this.datesSeparator}${n}`;
    },
    formatDate(t) {
      return t ? this.DatePositionHelper.getFormattedString(this.DatePositionHelper.fromDateObject(t)) : "";
    }
  }
});
const XD = { class: "c-field-container" }, KD = { class: "c-input-container" }, QD = ["placeholder"];
function GD(t, e, n, r, a, i) {
  const o = z("c-running"), s = z("calendar"), l = z("X");
  return b(), M("div", XD, [
    T(o, { type: "two" }, {
      default: W(() => [
        V(j(t.label), 1)
      ]),
      _: 1
    }),
    R("div", KD, [
      t.compactMode ? E("", !0) : (b(), L(s, {
        key: 0,
        class: "c-icon-m c-input-icon",
        onClick: t.handleClick
      }, null, 8, ["onClick"])),
      Ve(R("input", {
        type: "text",
        class: H(t.inputClasses),
        inputmode: "numeric",
        "onUpdate:modelValue": e[0] || (e[0] = (c) => t.stringifiedDateRange = c),
        ref: "dateRangeInput",
        placeholder: t.placeholderComputed,
        onClick: e[1] || (e[1] = (...c) => t.handleClick && t.handleClick(...c)),
        readonly: "readonly"
      }, null, 10, QD), [
        [Mr, t.stringifiedDateRange]
      ]),
      t.stringifiedDateRange.length > 0 && !t.compactMode ? (b(), M("button", {
        key: 1,
        onClick: e[2] || (e[2] = (...c) => t.clearInput && t.clearInput(...c)),
        class: "c-input-btn"
      }, [
        T(l, { class: "c-icon-m" })
      ])) : E("", !0)
    ])
  ]);
}
const ZD = /* @__PURE__ */ B(YD, [["render", GD], ["__scopeId", "data-v-7784d7ee"]]);
const JD = {
  name: "CRadio",
  components: {
    CUi: we
  },
  props: {
    label: {
      type: String,
      required: !1,
      default: ""
    },
    hasError: {
      type: Boolean,
      required: !1,
      default: !1
    },
    activeValue: {
      type: [String, Boolean, Number],
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1,
      required: !1
    },
    value: {
      type: [String, Boolean, Number],
      required: !0
    }
  },
  emits: ["update:activeValue"],
  computed: {
    checkedState: {
      get() {
        return this.activeValue;
      },
      set(t) {
        this.$emit("update:activeValue", t);
      }
    }
  }
}, eT = ["value", "disabled"];
function tT(t, e, n, r, a, i) {
  const o = z("c-ui");
  return b(), M("label", {
    class: H(["c-radio-label", { errored: n.hasError }])
  }, [
    Ve(R("input", He({
      type: "radio",
      class: "c-radio-input",
      "onUpdate:modelValue": e[0] || (e[0] = (s) => i.checkedState = s),
      value: n.value,
      disabled: n.disabled
    }, t.$attrs), null, 16, eT), [
      [qp, i.checkedState]
    ]),
    n.label ? (b(), L(o, {
      key: 0,
      type: "four",
      class: H([{ active: i.checkedState === n.value, disabled: n.disabled }, "c-radio-label-text"])
    }, {
      default: W(() => [
        V(j(n.label), 1)
      ]),
      _: 1
    }, 8, ["class"])) : E("", !0)
  ], 2);
}
const K$ = /* @__PURE__ */ B(JD, [["render", tT], ["__scopeId", "data-v-38e2fa2a"]]);
const nT = {
  name: "CRadio",
  components: {
    CUi: we
  },
  props: {
    label: {
      type: String,
      required: !1,
      default: ""
    },
    hasError: {
      type: Boolean,
      required: !1,
      default: !1
    },
    activeValue: {
      type: [String, Boolean, Number, Array],
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1,
      required: !1
    },
    value: {
      type: [String, Boolean, Number],
      required: !0
    },
    indeterminate: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["update:activeValue"],
  computed: {
    checkedState: {
      get() {
        return this.activeValue;
      },
      set(t) {
        this.$emit("update:activeValue", t);
      }
    }
  }
}, rT = ["value", "disabled", "indeterminate"];
function aT(t, e, n, r, a, i) {
  const o = z("c-ui");
  return b(), M("label", {
    class: H(["c-checkbox-label", { errored: n.hasError }])
  }, [
    Ve(R("input", He({
      type: "checkbox",
      class: "c-checkbox-input",
      "onUpdate:modelValue": e[0] || (e[0] = (s) => i.checkedState = s),
      value: n.value,
      disabled: n.disabled
    }, t.$attrs, {
      ref: "checkboxInputEl",
      indeterminate: n.indeterminate
    }), null, 16, rT), [
      [Vf, i.checkedState]
    ]),
    n.label ? (b(), L(o, {
      key: 0,
      type: "four",
      class: H([{ active: i.checkedState === n.value, disabled: n.disabled }, "c-checkbox-label-text"])
    }, {
      default: W(() => [
        V(j(n.label), 1)
      ]),
      _: 1
    }, 8, ["class"])) : E("", !0)
  ], 2);
}
const Lp = /* @__PURE__ */ B(nT, [["render", aT], ["__scopeId", "data-v-680b0d71"]]);
const iT = (t, e) => Ah(t) && e ? !1 : xk(t), oT = {
  name: "CDatePickerDateElement",
  components: {
    CSubheading: Ne
  },
  props: {
    dayOfTheMonth: {
      type: Date,
      required: !0
    },
    selected: {
      type: Boolean,
      required: !1,
      default: !1
    },
    strikedOut: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    inRange: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isRangeStart: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isRangeEnd: {
      type: Boolean,
      required: !1,
      default: !1
    },
    allowToday: {
      type: Boolean,
      required: !1,
      default: !0
    },
    allowPast: {
      type: Boolean,
      required: !1,
      default: !1
    },
    allowFuture: {
      type: Boolean,
      required: !1,
      default: !0
    },
    // eslint-disable-next-line vue/require-default-prop
    disableAfter: {
      type: Date,
      required: !1
    },
    // eslint-disable-next-line vue/require-default-prop
    disableBefore: {
      type: Date,
      required: !1
    },
    // eslint-disable-next-line vue/require-default-prop
    inactiveAfter: {
      type: Date,
      required: !1
    },
    // eslint-disable-next-line vue/require-default-prop
    inactiveBefore: {
      type: Date,
      required: !1
    }
  },
  emits: ["select-day"],
  computed: {
    containerClass() {
      return this.inRange ? "in-range" : this.isRangeStart && this.isRangeEnd ? "" : this.isRangeStart ? "range-start" : this.isRangeEnd ? "range-end" : "";
    },
    getElementClass() {
      let t;
      return t = this.computedParams.disabled ? "disabled " : "", t += this.computedParams.inactive && !this.computedParams.disabled ? "inactive " : "", t += this.computedParams.isCurrentDay ? "current " : "", t += this.selected && !this.computedParams.disabled ? "selected " : "", t += this.inRange ? "in-range " : "", t += this.strikedOut ? "striked-out " : "", t += this.disabled ? "un-available " : "", t;
    },
    isDisabled() {
      const { dayOfTheMonth: t, allowToday: e, allowPast: n, disableAfter: r, disableBefore: a, allowFuture: i } = this;
      return !n && iT(t, e) || !i && Zb(t) || a && mr(t, a) ? !0 : r && pr(t, r);
    },
    inactive() {
      const { dayOfTheMonth: t, inactiveBefore: e, inactiveAfter: n } = this;
      return mr(t, e) ? !0 : pr(t, n);
    },
    computedParams() {
      const { dayOfTheMonth: t, inactive: e, isDisabled: n } = this;
      return {
        day: t.getDate(),
        isCurrentDay: Ah(t),
        disabled: n,
        inactive: e,
        date: t
      };
    }
  },
  methods: {
    handleSelectDay() {
      this.isDisabled || this.$emit("select-day");
    }
  }
};
function sT(t, e, n, r, a, i) {
  const o = z("c-subheading");
  return b(), M("div", {
    class: H(["c-date-day-container", i.containerClass])
  }, [
    R("div", {
      class: H(["c-date-day-element", i.getElementClass]),
      onClick: e[0] || (e[0] = (...s) => i.handleSelectDay && i.handleSelectDay(...s))
    }, [
      T(o, { type: "three" }, {
        default: W(() => [
          V(j(i.computedParams.day), 1)
        ]),
        _: 1
      })
    ], 2)
  ], 2);
}
const lT = /* @__PURE__ */ B(oT, [["render", sT], ["__scopeId", "data-v-35f8c82d"]]);
const Ef = "update:date-selected", Af = "update:date-range", Lf = {
  it: Wr,
  fr: Nr,
  de: Er,
  es: Lr,
  en: Ar,
  cs: $r,
  da: Rr,
  no: zr,
  nl: Br,
  fi: Ir,
  sv: Fr
}, cT = {
  name: "CDatePicker",
  components: {
    CSubheading: Ne,
    CDatePickerDateElement: lT,
    CActionButton: gr,
    CUi: we,
    ChevronLeft: ho,
    ChevronRight: po
  },
  props: {
    locale: {
      required: !1,
      default: null,
      type: String
    },
    dateSelected: {
      required: !1,
      type: Date,
      default: void 0
    },
    rangeMode: {
      required: !1,
      type: Boolean,
      default: !1
    },
    dateRange: {
      required: !1,
      type: Object,
      validator(t) {
        return At(t);
      },
      default: () => ({ starts: null, ends: null, place: ot.ends })
    },
    weekStartsOnMonday: {
      type: Boolean,
      required: !1,
      default: !0
    },
    totalRows: {
      type: Number,
      required: !1,
      default: 6
    },
    allowSelectPast: {
      type: Boolean,
      required: !1,
      default: !1
    },
    allowSelectFuture: {
      type: Boolean,
      required: !1,
      default: !0
    },
    allowSelectToday: {
      type: Boolean,
      required: !1,
      default: !0
    },
    strikedOutDates: {
      type: Array,
      required: !1,
      default: () => []
    },
    disabledDates: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  emits: [Ef, Af],
  data() {
    return {
      selectedDate: this.dateSelected,
      selectedMonth: /* @__PURE__ */ new Date(),
      rangeStartsDate: this.dateRange.starts,
      rangeEndsDate: this.dateRange.ends,
      CoppiIntents: G
    };
  },
  setup() {
    const { getApplicationLocale: t } = rt();
    return { getApplicationLocale: t };
  },
  mounted() {
    if (!this.dateRange || !this.dateRange.starts && !this.dateRange.ends) {
      this.dateSelected && (this.selectedMonth = Bt(_n(this.dateSelected)));
      return;
    }
    this.selectedMonth = Bt(_n(this.dateRange.ends));
  },
  watch: {
    dateSelected(t) {
      this.selectedDate = t, this.handleClickOnDay({ date: t });
    },
    selectedDate(t) {
      Qi(t, this.selectedMonth) || (this.selectedMonth = Bt(_n(t)));
    },
    dateRange(t) {
      if (!At(t))
        return;
      let e = null;
      const n = ze(this.rangeStartsDate, t.starts), r = ze(this.rangeEndsDate, t.ends);
      n && !r ? e = t.ends : r && !n ? e = t.starts : e = t.place === ot.ends ? t.ends : t.starts, this.rangeStartsDate = t.starts, this.rangeEndsDate = null, this.handleClickOnDay({ date: t.ends }), this.setCalendarMonth(e);
    }
  },
  computed: {
    canNavigateToPreviousMonth() {
      return this.allowSelectPast ? !0 : !mr($o(this.selectedMonth, { months: 1 }), _n(/* @__PURE__ */ new Date()));
    },
    totalCells() {
      return this.totalRows * 7;
    },
    labels() {
      const t = this.locale ?? this.getApplicationLocale(), e = Lf[t], n = [...Array(7).keys()].map((r) => e.localize.day(r, { width: "short" }));
      if (this.weekStartsOnMonday) {
        const r = n.shift();
        return [...n, r];
      }
      return n;
    },
    firstDayOfSelectedMonth() {
      return _n(this.selectedMonth);
    },
    lastDayOfSelectedMonth() {
      return Q1(Mh(this.selectedMonth));
    },
    monthFirstDayPositionInWeek() {
      const { firstDayOfSelectedMonth: t, weekStartsOnMonday: e } = this, n = Gb(t);
      return e ? n === 0 ? 6 : n - 1 : n;
    },
    monthHumanName() {
      const t = this.locale ?? this.getApplicationLocale();
      return Et(this.selectedMonth, "MMMM y", { locale: Lf[t] });
    },
    calendarDays() {
      return this.getCalendarDays.map((t) => {
        if (!this.rangeMode)
          return {
            date: t,
            selected: ze(this.selectedDate, t),
            strikeOut: !!this.strikedOutDates.find((o) => ze(o, t)),
            disabled: !!this.disabledDates.find((o) => ze(o, t))
          };
        const e = this.rangeStartsDate && this.rangeEndsDate, n = ze(this.rangeStartsDate, t), r = ze(this.rangeEndsDate, t), a = n || r;
        let i = !1;
        try {
          i = !a && this.rangeStartsDate && this.rangeEndsDate && Pk(t, {
            start: this.rangeStartsDate,
            end: this.rangeEndsDate
          });
        } catch {
        }
        return {
          date: t,
          selected: a,
          inRange: i,
          isRangeStart: e && n,
          isRangeEnd: e && r,
          strikeOut: !!this.strikedOutDates.find((o) => ze(o, t)),
          disabled: !!this.disabledDates.find((o) => ze(o, t))
        };
      });
    },
    getCalendarDays() {
      const { firstDayOfSelectedMonth: t, totalCells: e, monthFirstDayPositionInWeek: n } = this;
      return Array.from(Array(e).keys()).map((r, a) => {
        if (a < n)
          return $o(
            t,
            {
              days: n - a
            }
          );
        if (a === n)
          return t;
        if (a > n)
          return mi(t, {
            days: a - n
          });
      });
    }
  },
  methods: {
    previousMonth() {
      this.selectedMonth = $o(this.selectedMonth, { months: 1 });
    },
    nextMonth() {
      this.selectedMonth = mi(this.selectedMonth, { months: 1 });
    },
    setCalendarMonth(t) {
      Qi(t, this.selectedMonth) || (this.selectedMonth = Bt(_n(t)));
    },
    handleClickOnDay(t) {
      if (!t.disabled) {
        if (!this.rangeMode) {
          this.$emit(Ef, t.date), this.selectedDate = t.date;
          return;
        }
        if (this.rangeEndsDate) {
          this.rangeStartsDate = t.date, this.rangeEndsDate = null;
          return;
        }
        if (this.rangeStartsDate) {
          mr(this.rangeStartsDate, t.date) ? this.rangeEndsDate = t.date : (this.rangeEndsDate = this.rangeStartsDate, this.rangeStartsDate = t.date), this.$emit(Af, { starts: this.rangeStartsDate, ends: this.rangeEndsDate });
          return;
        }
        if (!this.rangeStartsDate) {
          this.rangeStartsDate = t.date;
          return;
        }
      }
    }
  }
}, uT = { class: "c-date-picker-container" }, dT = { class: "c-date-picker-header" }, fT = { class: "c-days-grid" };
function hT(t, e, n, r, a, i) {
  const o = z("chevron-left"), s = z("c-action-button"), l = z("c-subheading"), c = z("chevron-right"), u = z("c-ui"), f = z("c-date-picker-date-element");
  return b(), M("div", uT, [
    R("div", dT, [
      T(s, {
        size: "small",
        disabled: !i.canNavigateToPreviousMonth,
        intent: a.CoppiIntents.secondary,
        onClick: i.previousMonth
      }, {
        default: W(() => [
          T(o)
        ]),
        _: 1
      }, 8, ["disabled", "intent", "onClick"]),
      T(l, {
        type: "two",
        class: "c-calendar-month"
      }, {
        default: W(() => [
          V(j(i.monthHumanName), 1)
        ]),
        _: 1
      }),
      T(s, {
        size: "small",
        intent: a.CoppiIntents.secondary,
        onClick: i.nextMonth
      }, {
        default: W(() => [
          T(c)
        ]),
        _: 1
      }, 8, ["intent", "onClick"])
    ]),
    R("div", fT, [
      (b(!0), M(de, null, xe(i.labels, (d) => (b(), M("div", {
        class: "c-week-day-cell",
        key: d
      }, [
        T(u, { type: "four" }, {
          default: W(() => [
            V(j(d), 1)
          ]),
          _: 2
        }, 1024)
      ]))), 128)),
      (b(!0), M(de, null, xe(i.calendarDays, (d) => (b(), L(f, {
        "day-of-the-month": d.date,
        "allow-past": n.allowSelectPast,
        "allow-future": n.allowSelectFuture,
        "allow-today": n.allowSelectToday,
        selected: d.selected,
        "striked-out": d.strikeOut,
        disabled: d.disabled,
        "in-range": d.inRange,
        "is-range-start": d.isRangeStart,
        "is-range-end": d.isRangeEnd,
        key: d.toString(),
        "inactive-after": i.lastDayOfSelectedMonth,
        "inactive-before": i.firstDayOfSelectedMonth,
        onSelectDay: () => i.handleClickOnDay(d)
      }, null, 8, ["day-of-the-month", "allow-past", "allow-future", "allow-today", "selected", "striked-out", "disabled", "in-range", "is-range-start", "is-range-end", "inactive-after", "inactive-before", "onSelectDay"]))), 128))
    ])
  ]);
}
const Ip = /* @__PURE__ */ B(cT, [["render", hT], ["__scopeId", "data-v-44d9cecf"]]), pT = { class: "c-date-range-picker-container c-layer-elevated" }, mT = { class: "c-input-wrapper" }, gT = { class: "c-input" }, vT = { class: "c-date-picker-wrapper" }, yT = { class: "c-date-range-picker-actions" }, bT = { class: "c-action-container" }, _T = { class: "c-action-container" }, wT = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    labels: {
      type: Object,
      default: () => ({
        confirm: "Confirm",
        cancel: "Cancel"
      }),
      required: !1
    },
    locale: {
      required: !1,
      default: null,
      type: String
    },
    dateRange: {
      required: !1,
      type: Object,
      validator(t) {
        return At(t);
      },
      default: () => ({ starts: null, ends: null })
    },
    allowSelectPast: {
      type: Boolean,
      required: !1,
      default: !0
    },
    allowSelectFuture: {
      type: Boolean,
      required: !1,
      default: !0
    },
    allowSelectToday: {
      type: Boolean,
      required: !1,
      default: !0
    },
    format: {
      type: String,
      required: !1,
      default: go.european
    },
    separator: {
      type: String,
      required: !1,
      default: " / "
    },
    weekStartsOnMonday: {
      type: Boolean,
      required: !1,
      default: !0
    },
    dateRangeInputWidth: {
      type: String,
      required: !1,
      default: "calc(8em + var(--s2))"
    }
  },
  emits: ["update:dateRangeSelected", "cancel"],
  setup(t, { emit: e }) {
    var x, y;
    const n = t;
    let r = U(((x = n.dateRange) == null ? void 0 : x.starts) ?? /* @__PURE__ */ new Date()), a = r, i = U(""), o = U(((y = n.dateRange) == null ? void 0 : y.ends) ?? /* @__PURE__ */ new Date()), s = o, l = U(""), c = U({
      starts: r.value,
      ends: o.value
    }), u = U();
    rt(n.locale);
    const f = `width: ${n.dateRangeInputWidth}`, d = I({
      get: () => r.value,
      set: (_) => v(ot.starts, _)
    }), h = I({
      get: () => o.value,
      set: (_) => v(ot.ends, _)
    }), m = I({
      get: () => c.value,
      set: (_) => {
        At(_) && (r.value = _.starts, a.value = _.starts, o.value = _.ends, s.value = _.ends);
      }
    }), p = () => {
      c.value = {
        starts: r.value,
        ends: o.value
      }, e("update:dateRangeSelected", c.value);
    }, g = () => {
      e("cancel");
    }, v = (_, k) => {
      if (w(k, _)) {
        if (_ === ot.starts ? a.value = k : _ === ot.ends && (s.value = k), !a.value || !s.value) {
          u.value = k;
          return;
        }
        if (pr(a.value, s.value)) {
          C("Start date must be before end date", ot.starts), C("End date must be after start date", ot.ends);
          return;
        }
        i.value = "", l.value = "", c.value = {
          starts: a.value,
          ends: s.value,
          place: _
        };
      }
    }, w = (_, k) => {
      if (_ === !1 || !(_ instanceof Date) || isNaN(_))
        return C("Wrong date", k), !1;
      const P = /* @__PURE__ */ new Date();
      return !n.allowSelectPast && mr(_, P) && !ze(_, P) ? (C("Cannot select past date", k), !1) : !n.allowSelectFuture && pr(_, P) ? (C("Cannot select future date", k), !1) : !n.allowSelectToday && ze(_, P) ? (C("Cannot select today", k), !1) : !0;
    }, C = (_, k) => {
      switch (k) {
        case ot.starts:
          i.value = _;
          break;
        case ot.ends:
          l.value = _;
          break;
      }
    };
    return (_, k) => (b(), M("div", pT, [
      R("div", mT, [
        R("div", gT, [
          T(Sl, {
            "background-color": "var(--color-neutral-1)",
            "compact-mode": !0,
            value: S(d),
            "onUpdate:value": k[0] || (k[0] = (P) => je(d) ? d.value = P : null),
            error: S(i),
            "show-error-message": !1,
            format: t.format,
            separator: t.separator,
            style: f
          }, null, 8, ["background-color", "value", "error", "format", "separator"]),
          T(zn, { type: "two" }, {
            default: W(() => [
              V(" — ")
            ]),
            _: 1
          }),
          T(Sl, {
            "background-color": "var(--color-neutral-1)",
            "compact-mode": !0,
            value: S(h),
            "onUpdate:value": k[1] || (k[1] = (P) => je(h) ? h.value = P : null),
            error: S(l),
            "show-error-message": !1,
            format: t.format,
            separator: t.separator,
            style: f
          }, null, 8, ["background-color", "value", "error", "format", "separator"])
        ])
      ]),
      R("div", vT, [
        T(Ip, {
          "total-rows": 6,
          locale: t.locale,
          "week-starts-on-monday": t.weekStartsOnMonday,
          "allow-select-today": t.allowSelectToday,
          "allow-select-future": t.allowSelectFuture,
          "allow-select-past": t.allowSelectPast,
          "range-mode": !0,
          "date-range": S(m),
          "onUpdate:dateRange": k[2] || (k[2] = (P) => je(m) ? m.value = P : null),
          "date-selected": S(u)
        }, null, 8, ["locale", "week-starts-on-monday", "allow-select-today", "allow-select-future", "allow-select-past", "date-range", "date-selected"])
      ]),
      R("div", yT, [
        R("div", bT, [
          T(dr, {
            size: "small",
            "full-width": !0,
            label: t.labels.cancel,
            onClick: g,
            intent: S(G).secondary,
            "is-loading": !1
          }, null, 8, ["label", "intent"])
        ]),
        R("div", _T, [
          T(dr, {
            size: "small",
            "full-width": !0,
            disabled: !S(c),
            label: t.labels.confirm,
            onClick: p,
            "is-loading": !1
          }, null, 8, ["disabled", "label"])
        ])
      ])
    ]));
  }
});
const kT = /* @__PURE__ */ B(wT, [["__scopeId", "data-v-84105f66"]]), xT = (t) => (In("data-v-e309d5af"), t = t(), Nn(), t), CT = ["value", "disabled"], PT = /* @__PURE__ */ xT(() => /* @__PURE__ */ R("span", { class: "c-toggle-slider round" }, null, -1)), ST = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    hasError: { type: Boolean, default: !1 },
    activeValue: { type: Boolean },
    disabled: { type: Boolean, default: !1 },
    value: { type: Boolean, default: !1 }
  },
  emits: ["update:activeValue"],
  setup(t, { emit: e }) {
    const n = t, r = I({
      get() {
        return n.activeValue;
      },
      set(a) {
        e("update:activeValue", a);
      }
    });
    return (a, i) => (b(), M("label", {
      class: H(["c-toggle-container", { errored: t.hasError }])
    }, [
      R("label", {
        class: H(["c-toggle-label", { errored: t.hasError }])
      }, [
        Ve(R("input", He({
          type: "checkbox",
          class: "c-toggle-input",
          "onUpdate:modelValue": i[0] || (i[0] = (o) => je(r) ? r.value = o : null),
          value: t.value,
          disabled: t.disabled
        }, a.$attrs), null, 16, CT), [
          [Vf, S(r)]
        ]),
        PT
      ], 2),
      R("span", {
        class: H([{ active: S(r) === t.value, disabled: t.disabled }, "c-toggle-label-text"])
      }, [
        _e(a.$slots, "default", {}, void 0, !0)
      ], 2)
    ], 2));
  }
});
const Q$ = /* @__PURE__ */ B(ST, [["__scopeId", "data-v-e309d5af"]]);
const MT = {
  name: "CTableColumnCell",
  components: {
    CUi: we
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    label: {
      required: !1,
      type: String
    },
    contentPosition: {
      type: String,
      required: !1,
      default: Pn.leading
    }
  },
  computed: {
    alignentClass() {
      switch (this.contentPosition) {
        case Pn.middle:
          return "c-cell-center";
        case Pn.trailing:
          return "c-cell-right";
        default:
          return "c-cell-left";
      }
    }
  }
};
function OT(t, e, n, r, a, i) {
  const o = z("c-ui");
  return b(), M("td", {
    class: H(["c-table-cell-container", i.alignentClass])
  }, [
    n.label ? (b(), L(o, {
      key: 0,
      type: "four",
      class: "c-table-label-no-slot"
    }, {
      default: W(() => [
        V(j(n.label), 1)
      ]),
      _: 1
    })) : E("", !0),
    _e(t.$slots, "default", {}, void 0, !0)
  ], 2);
}
const DT = /* @__PURE__ */ B(MT, [["render", OT], ["__scopeId", "data-v-dfc58899"]]);
const TT = {
  name: "CTableColumnHeader",
  components: {
    CSubheading: Ne
  },
  props: {
    label: {
      type: String,
      required: !0
    },
    contentPosition: {
      type: String,
      required: !1,
      default: Pn.leading
    }
  },
  computed: {
    alignentClass() {
      switch (this.contentPosition) {
        case Pn.middle:
          return "c-cell-center";
        case Pn.trailing:
          return "c-cell-right";
        default:
          return "c-cell-left";
      }
    }
  }
};
function $T(t, e, n, r, a, i) {
  const o = z("c-subheading");
  return b(), M("th", {
    class: H(["c-table-header", i.alignentClass])
  }, [
    T(o, { type: "four" }, {
      default: W(() => [
        V(j(n.label), 1)
      ]),
      _: 1
    })
  ], 2);
}
const Np = /* @__PURE__ */ B(TT, [["render", $T], ["__scopeId", "data-v-2a3dceed"]]);
const RT = "update:isActive", ET = {
  name: "CTableRowVerticalAccordionToggler",
  props: {
    locale: {
      required: !1,
      default: null,
      type: String
    },
    isActive: {
      required: !0,
      type: Boolean
    }
  },
  components: {
    CSubheading: Ne,
    ChevronDown: fo,
    ChevronUp: mo
  },
  setup(t, { emit: e }) {
    const { CTranslate: n } = rt(t.locale), r = I(
      () => t.isActive ? "ChevronUp" : "ChevronDown"
    ), a = I(() => t.isActive ? n("CTable.showLess") : n("CTable.showMore"));
    return { toggleStatus: () => {
      e(RT, !t.isActive);
    }, message: a, chevronComponent: r };
  }
};
function AT(t, e, n, r, a, i) {
  const o = z("c-subheading");
  return b(), M("button", {
    class: "c-table-row-accordion-toggle",
    onClick: e[0] || (e[0] = (...s) => r.toggleStatus && r.toggleStatus(...s))
  }, [
    T(o, { type: "four" }, {
      default: W(() => [
        V(j(r.message), 1)
      ]),
      _: 1
    }),
    (b(), L(_t(r.chevronComponent), { class: "c-icon-s c-table-row-accordion-toggle-chevron" }))
  ]);
}
const LT = /* @__PURE__ */ B(ET, [["render", AT], ["__scopeId", "data-v-a953bdd9"]]), IT = 320, NT = 360, WT = 640, zT = 1024, BT = 1280, FT = 1690, Dt = {
  breakpointXs: {
    label: "breakpointXs",
    maxWidth: IT
  },
  breakpointSm: {
    label: "breakpointSm",
    maxWidth: NT
  },
  breakpointMd: {
    label: "breakpointMd",
    maxWidth: WT
  },
  breakpointLg: {
    label: "breakpointLg",
    maxWidth: zT
  },
  breakpointXl: {
    label: "breakpointXl",
    maxWidth: BT
  },
  breakpointXxl: {
    label: "breakpointXxl",
    maxWidth: FT
  }
};
let nr = [];
const HT = [
  Dt.breakpointXxl,
  Dt.breakpointXl,
  Dt.breakpointLg,
  Dt.breakpointMd,
  Dt.breakpointSm
], Sr = U(!1), Wp = U(Dt.breakpointXs.label);
let Vo = 0;
const jT = (t) => {
  var e;
  if (typeof t != "number")
    throw new Error(`The width provided was not a number instead it was a ${typeof t}`);
  return ((e = HT.find((n) => t >= n.maxWidth)) == null ? void 0 : e.label) ?? Dt.breakpointXs.label;
}, Ml = () => {
  const t = window == null ? void 0 : window.innerWidth;
  !t || typeof t != "number" || (Wp.value = jT(t));
}, VT = () => {
  Sr.value || (window.addEventListener("resize", Ml), Ml(), Sr.value = !0);
}, qT = () => {
  Sr.value && (window.removeEventListener("resize", Ml), Sr.value = !1);
}, UT = (t) => {
  nr.includes(t) && (nr = nr.filter((e) => e !== t), nr.length || qT());
}, YT = () => {
  VT(), nr.push(Vo);
  const t = () => UT(Vo.toString());
  return Vo += 1, {
    isListening: Sr,
    currentBreakpoint: Wp,
    unmount: t
  };
};
const XT = ne({
  components: {
    CSubheading: Ne,
    CTableColumnCell: DT,
    CTableColumnHeader: Np,
    CUi: we,
    CAccordion: co,
    CTableRowVerticalAccordionToggler: LT
  },
  props: {
    columns: {
      type: Array,
      required: !0
    },
    collapsableColumns: {
      type: Array,
      default: () => [],
      required: !1
    },
    truncateCellOverflow: {
      type: Boolean,
      default: !1,
      required: !1
    },
    isSkeletonLoading: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  setup() {
    const { currentBreakpoint: t, unmount: e } = YT();
    return Hf(e), {
      currentBreakpoint: t
    };
  },
  data() {
    return {
      isShowingHideableMobileColumns: !1
    };
  },
  computed: {
    isFullWidthView() {
      return ![
        Dt.breakpointXs.label,
        Dt.breakpointSm.label
      ].includes(this.currentBreakpoint);
    },
    mainColumns() {
      return this.isFullWidthView ? this.columns : this.columns.filter((t) => !this.collapsableColumns.includes(t.name));
    },
    accordionColumns() {
      return this.isFullWidthView ? [] : this.columns.filter((t) => this.collapsableColumns.includes(t.name));
    }
  }
}), KT = { class: "c-table-cell-wrapper" }, QT = { class: "c-table-cell-wrapper" };
function GT(t, e, n, r, a, i) {
  const o = z("c-subheading"), s = z("c-ui"), l = z("c-table-column-cell"), c = z("c-table-column-header"), u = z("c-accordion"), f = z("c-table-row-vertical-accordion-toggler");
  return b(), M("tr", {
    class: H(["c-table-row", t.isSkeletonLoading ? "c-skeleton-row" : "c-data-row"])
  }, [
    (b(!0), M(de, null, xe(t.mainColumns, (d) => (b(), L(l, {
      key: d.name,
      class: H(t.isFullWidthView ? "column-cell" : "column-cell-vertical"),
      "content-position": d.contentPosition
    }, {
      default: W(() => [
        t.isFullWidthView ? E("", !0) : (b(), L(o, {
          key: 0,
          type: "four",
          class: "c-table-mobile-header"
        }, {
          default: W(() => [
            V(j(d.name), 1)
          ]),
          _: 2
        }, 1024)),
        R("span", KT, [
          t.isSkeletonLoading ? (b(), L(s, He({
            key: 0,
            type: "four",
            class: "c-skeleton-table"
          }, d), null, 16)) : _e(t.$slots, d.slotName, qo(He({ key: 1 }, d)), () => [
            d.value ? (b(), L(s, {
              key: 0,
              type: "four",
              class: H([{ "c-cell-truncate": t.truncateCellOverflow }, "c-table-label-no-slot-column"])
            }, {
              default: W(() => [
                V(j(d.value), 1)
              ]),
              _: 2
            }, 1032, ["class"])) : E("", !0)
          ], !0)
        ])
      ]),
      _: 2
    }, 1032, ["class", "content-position"]))), 128)),
    t.isFullWidthView ? E("", !0) : (b(), L(u, {
      key: 0,
      status: t.isShowingHideableMobileColumns,
      class: "c-vertical-container"
    }, {
      default: W(() => [
        (b(!0), M(de, null, xe(t.accordionColumns, (d) => (b(), L(l, {
          key: d.name,
          class: "column-cell-vertical",
          "content-position": d.contentPosition
        }, {
          default: W(() => [
            T(c, {
              class: "c-table-mobile-header",
              label: d.name
            }, null, 8, ["label"]),
            R("span", QT, [
              t.isSkeletonLoading ? (b(), L(s, He({
                key: 0,
                type: "four",
                class: "c-skeleton-table"
              }, d), null, 16)) : _e(t.$slots, d.slotName, qo(He({ key: 1 }, d)), () => [
                d.value ? (b(), L(s, {
                  key: 0,
                  type: "four",
                  class: H([{ "c-cell-truncate": t.truncateCellOverflow }, "c-table-label-no-slot-column"])
                }, {
                  default: W(() => [
                    V(j(d.value), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])) : E("", !0)
              ], !0)
            ])
          ]),
          _: 2
        }, 1032, ["content-position"]))), 128))
      ]),
      _: 3
    }, 8, ["status"])),
    t.accordionColumns.length ? (b(), L(f, {
      key: 1,
      class: "c-vertical-container",
      "is-active": t.isShowingHideableMobileColumns,
      "onUpdate:isActive": e[0] || (e[0] = (d) => t.isShowingHideableMobileColumns = d)
    }, null, 8, ["is-active"])) : E("", !0)
  ], 2);
}
const ZT = /* @__PURE__ */ B(XT, [["render", GT], ["__scopeId", "data-v-5002b5aa"]]);
const JT = {
  name: "CTableEmptyState",
  components: {
    CUi: we,
    Inbox: Pg
  },
  computed: {
    message() {
      const { CTranslate: t } = rt();
      return t("CTable.noRecords");
    }
  }
}, e$ = { class: "c-table-empty-state-wrapper" };
function t$(t, e, n, r, a, i) {
  const o = z("Inbox"), s = z("c-ui");
  return b(), M("div", e$, [
    T(o, { class: "c-icon-s c-inbox" }),
    T(s, {
      type: "four",
      class: "c-table-empty-state-wrapper"
    }, {
      default: W(() => [
        V(j(i.message), 1)
      ]),
      _: 1
    })
  ]);
}
const n$ = /* @__PURE__ */ B(JT, [["render", t$], ["__scopeId", "data-v-fe7667a1"]]);
const r$ = {
  name: "CTable",
  components: {
    InlineLoader: vo,
    CTableEmptyState: n$,
    CTableRow: ZT,
    CTableColumnHeader: Np
  },
  props: {
    displayHeaders: {
      type: Boolean,
      required: !1,
      default: !0
    },
    tableData: {
      type: Array,
      required: !0
    },
    collapsableColumns: {
      type: Array,
      default: () => [],
      required: !1
    },
    truncateCellOverflow: {
      type: Boolean,
      default: !1,
      required: !1
    },
    isLoading: {
      required: !1,
      default: !1,
      type: Boolean
    },
    isSkeletonLoading: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  computed: {
    distinctHeaders() {
      return this.tableData.reduce((t, e) => (e.forEach((n) => {
        t.find((r) => r.name === n.name) || t.push(n);
      }), t), []);
    },
    headers() {
      return [...this.distinctHeaders].sort((t, e) => {
        const n = t.sortOrder ?? 0, r = e.sortOrder ?? 0;
        return n - r;
      });
    },
    rows() {
      return this.tableData.map((t) => [...t].map((e) => ({
        ...e,
        slotName: e.slotName || e.name.replace(/ /g, "").toLowerCase()
      })).sort((e, n) => this.headers.indexOf(e.name) - this.headers.indexOf(n.name)));
    }
  },
  methods: {}
}, a$ = {
  ref: "cTableMain",
  class: "c-table"
}, i$ = {
  key: 2,
  class: "c-table-head"
};
function o$(t, e, n, r, a, i) {
  var u, f;
  const o = z("inline-loader"), s = z("c-table-empty-state"), l = z("c-table-column-header"), c = z("c-table-row");
  return b(), M("table", a$, [
    n.isLoading ? (b(), L(o, {
      key: 0,
      size: "m",
      class: "c-table-inline-loader"
    })) : ((u = i.rows) == null ? void 0 : u.length) === 0 ? (b(), L(s, { key: 1 })) : E("", !0),
    n.displayHeaders && ((f = i.rows) == null ? void 0 : f.length) > 0 ? (b(), M("thead", i$, [
      (b(!0), M(de, null, xe(i.headers, (d) => (b(), L(l, {
        key: d.name,
        label: d.name,
        "content-position": d.contentPosition
      }, null, 8, ["label", "content-position"]))), 128))
    ])) : E("", !0),
    R("tbody", null, [
      (b(!0), M(de, null, xe(i.rows, (d) => (b(), L(c, {
        key: d.name,
        columns: d,
        "collapsable-columns": n.collapsableColumns,
        "truncate-cell-overflow": n.truncateCellOverflow,
        "is-skeleton-loading": n.isSkeletonLoading
      }, hi({ _: 2 }, [
        xe(d, (h) => ({
          name: h.slotName,
          fn: W(() => [
            _e(t.$slots, h.slotName, qo(Up(h)), void 0, !0)
          ])
        }))
      ]), 1032, ["columns", "collapsable-columns", "truncate-cell-overflow", "is-skeleton-loading"]))), 128))
    ])
  ], 512);
}
const G$ = /* @__PURE__ */ B(r$, [["render", o$], ["__scopeId", "data-v-462fcfbb"]]);
const s$ = /* @__PURE__ */ ne({
  name: "SkeletonLoader",
  props: {
    size: {
      type: Number,
      required: !1,
      default: 36,
      validate: (t) => [12, 14, 16, 18, 20, 36].includes(t)
    }
  },
  data() {
    return {
      lastTimestamp: null,
      currentPosition: null,
      animationDuration: 10,
      reverse: !1
    };
  },
  computed: {
    sizeClass() {
      return `c-size-${String(this.size)}`;
    },
    gradient() {
      return `top:0;transform:translateX(${this.currentPosition * 10}%);`;
    }
  },
  mounted() {
    window.requestAnimationFrame(this.animateOneDirection);
  },
  methods: {
    animate(t) {
      this.lastTimestamp || (this.lastTimestamp = t);
      const e = t - this.lastTimestamp;
      let n = this.reverse ? Math.floor(100 - e / this.animationDuration % 100) : Math.floor(e / this.animationDuration % 100);
      this.reverse && n > this.currentPosition && (n = 0), !this.reverse && n < this.currentPosition && (n = 100), this.reverse = e / this.animationDuration % 200 < 100, this.currentPosition = Math.floor(n), window.requestAnimationFrame(this.animate);
    },
    animateOneDirection(t) {
      this.lastTimestamp || (this.lastTimestamp = t);
      const e = t - this.lastTimestamp, n = this.reverse ? Math.floor(100 - e / this.animationDuration % 100) : Math.floor(e / this.animationDuration % 250);
      this.currentPosition = Math.floor(n), window.requestAnimationFrame(this.animateOneDirection);
    }
  }
});
function l$(t, e, n, r, a, i) {
  return b(), M("div", {
    class: H(["c-skeleton-loader-outer", t.sizeClass])
  }, [
    R("div", {
      class: H(["c-skeleton-loader", t.sizeClass]),
      style: Ut(t.gradient)
    }, null, 6)
  ], 2);
}
const Z$ = /* @__PURE__ */ B(s$, [["render", l$], ["__scopeId", "data-v-a20a97e4"]]);
const c$ = {
  name: "CDatePickerShortcuts",
  components: {
    CSubheading: Ne
  },
  props: {
    active: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    }
  }
};
function u$(t, e, n, r, a, i) {
  const o = z("c-subheading");
  return b(), M("button", {
    class: H([{ active: n.active }, "c-date-picker-shortcut-btn"])
  }, [
    T(o, { type: "four" }, {
      default: W(() => [
        _e(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    })
  ], 2);
}
const d$ = /* @__PURE__ */ B(c$, [["render", u$], ["__scopeId", "data-v-f8e4a72b"]]);
const If = "update:dateSelected", Nf = "cancel", f$ = {
  name: "CDatePickerWithShortcuts",
  components: {
    CDatePicker: Ip,
    CDatePickerShortcut: d$,
    CButton: dr
  },
  props: {
    labels: {
      type: Object,
      default: () => ({
        confirm: "Confirm",
        cancel: "Cancel"
      }),
      required: !1
    },
    locale: {
      required: !1,
      default: null,
      type: String
    },
    dateSelected: {
      required: !1,
      type: Date,
      default: null
    },
    allowSelectPast: {
      type: Boolean,
      required: !1,
      default: !1
    },
    allowSelectFuture: {
      type: Boolean,
      required: !1,
      default: !0
    },
    allowSelectToday: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  emits: [If, Nf],
  data() {
    return {
      currentSelectedDay: this.dateSelected,
      CoppiIntents: G
    };
  },
  setup(t) {
    const { CTranslate: e } = rt(t.locale);
    return { CTranslate: e };
  },
  computed: {
    selectedIsTomorrow() {
      return this.currentSelectedDay ? Ck(this.currentSelectedDay) : !1;
    },
    selectedIsNextWeek() {
      return this.currentSelectedDay ? ze(this.currentSelectedDay, this.getNextWeek()) : !1;
    },
    selectedIsNextMonth() {
      return this.currentSelectedDay ? ze(this.currentSelectedDay, this.getNextMonth()) : !1;
    }
  },
  methods: {
    getNextMonth() {
      return Bt(
        mi(
          Mh(
            /* @__PURE__ */ new Date()
          ),
          { days: 1 }
        )
      );
    },
    getNextWeek() {
      return Bt(
        mi(
          G1(
            /* @__PURE__ */ new Date()
          ),
          { days: 2 }
        )
      );
    },
    handleConfirmClick() {
      this.$emit(If, this.currentSelectedDay);
    },
    selectNextMonth() {
      this.currentSelectedDay = this.getNextMonth();
    },
    selectTomorrow() {
      this.currentSelectedDay = jk();
    },
    selectNextWeek() {
      this.currentSelectedDay = this.getNextWeek();
    },
    handleCancelClick() {
      this.$emit(Nf);
    }
  }
}, h$ = { class: "c-date-picker-shortcuts-container c-layer-elevated" }, p$ = { class: "c-shortcuts" }, m$ = { class: "c-date-picker-shortcuts-actions" }, g$ = { class: "c-shortcut-action-container" }, v$ = { class: "c-shortcut-action-container" };
function y$(t, e, n, r, a, i) {
  const o = z("c-date-picker-shortcut"), s = z("c-date-picker"), l = z("c-button");
  return b(), M("div", h$, [
    R("div", p$, [
      T(o, {
        active: i.selectedIsTomorrow,
        onClick: i.selectTomorrow
      }, {
        default: W(() => [
          V(j(r.CTranslate("CDatePicker.tomorrow")), 1)
        ]),
        _: 1
      }, 8, ["active", "onClick"]),
      T(o, {
        active: i.selectedIsNextWeek,
        onClick: i.selectNextWeek
      }, {
        default: W(() => [
          V(j(r.CTranslate("CDatePicker.nextWeek")), 1)
        ]),
        _: 1
      }, 8, ["active", "onClick"]),
      T(o, {
        active: i.selectedIsNextMonth,
        onClick: i.selectNextMonth
      }, {
        default: W(() => [
          V(j(r.CTranslate("CDatePicker.nextMonth")), 1)
        ]),
        _: 1
      }, 8, ["active", "onClick"])
    ]),
    T(s, {
      "total-rows": 6,
      locale: n.locale,
      "week-starts-on-monday": !0,
      "date-selected": a.currentSelectedDay,
      "onUpdate:dateSelected": e[0] || (e[0] = (c) => a.currentSelectedDay = c),
      "allow-select-today": n.allowSelectToday,
      "allow-select-future": n.allowSelectFuture,
      "allow-select-past": n.allowSelectPast
    }, null, 8, ["locale", "date-selected", "allow-select-today", "allow-select-future", "allow-select-past"]),
    R("div", m$, [
      R("div", g$, [
        T(l, {
          size: "small",
          "full-width": !0,
          label: n.labels.cancel,
          onClick: i.handleCancelClick,
          intent: a.CoppiIntents.secondary
        }, null, 8, ["label", "onClick", "intent"])
      ]),
      R("div", v$, [
        T(l, {
          size: "small",
          "full-width": !0,
          disabled: !a.currentSelectedDay,
          label: n.labels.confirm,
          onClick: i.handleConfirmClick
        }, null, 8, ["disabled", "label", "onClick"])
      ])
    ])
  ]);
}
const b$ = /* @__PURE__ */ B(f$, [["render", y$], ["__scopeId", "data-v-e24f4988"]]), io = (t, e) => {
  if (t === null)
    return document.body;
  let n = getComputedStyle(t);
  const r = n.position === "absolute", a = e ? /(auto|scroll|hidden)/ : /(auto|scroll)/;
  if (n.position === "fixed")
    return document.body;
  for (let i = t; i = i.parentElement; )
    if (n = getComputedStyle(i), !(r && n.position === "static") && a.test(n.overflow + n.overflowY + n.overflowX))
      return i;
  return document.body;
}, Wf = "update:date-changed", _$ = {
  name: "CDatePickerModal",
  components: {
    CDateField: Sl,
    CDatePickerWithShortcuts: b$
  },
  directives: {
    ClickOutside: vn
  },
  props: {
    allowSelectToday: {
      type: Boolean,
      required: !1,
      default: !0
    },
    marginToKeep: {
      type: Number,
      required: !1,
      default: 8
    },
    locale: {
      required: !1,
      default: null,
      type: String
    },
    labels: {
      type: Object,
      default: () => ({
        confirm: "Confirm",
        cancel: "Cancel"
      }),
      required: !1
    },
    // default prop not required here. If empty, use method
    // eslint-disable-next-line vue/require-default-prop
    scrollingContainer: {
      type: String,
      required: !1
    },
    startingDate: {
      type: String,
      required: !1,
      default: ""
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [Wf, Rn],
  data() {
    return {
      selectedDateString: "",
      showDatePicker: !1,
      scrollPositionY: 0,
      scrollingElement: window,
      selectedDateObject: null
    };
  },
  watch: {
    selectedDateObject(t) {
      this.selectedDateString = Et(t, "d/M/y"), this.hideDatePicker(), this.$emit(Wf, t);
    }
  },
  mounted() {
    if (this.startingDate) {
      const t = Mk(this.startingDate);
      this.selectedDateObject = t, this.selectedDateString = Et(t, "d/M/y");
    }
    this.scrollingElement = this.getScrollingElement(), this.scrollingElement.addEventListener("scroll", this.handleScroll, !0);
  },
  beforeUnmount() {
    this.scrollingElement.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    datePickerModalHeight() {
      var t, e, n;
      return ((n = (e = (t = this.$refs) == null ? void 0 : t.datePickerModal) == null ? void 0 : e.$el) == null ? void 0 : n.offsetHeight) || 462;
    },
    computeDatePickerStyle() {
      const { $refs: t, scrollPositionY: e, datePickerModalHeight: n, marginToKeep: r } = this, { dateFieldInput: a } = t, { top: i } = a.$el.getBoundingClientRect(), o = a.$el.clientHeight;
      let s = "position:fixed;z-index:4000;";
      if (i - n - r > 0) {
        const u = i - r - n;
        return s += `top:${u}px;`, s;
      }
      const l = n + r + 24;
      if (window.innerHeight - i >= l) {
        const u = i + o + r;
        return s += `top:${u}px;`, s;
      }
      return s += "bottom:10px;", s;
    }
  },
  methods: {
    getScrollingElement() {
      const { scrollingContainer: t } = this;
      if (!t || typeof t != "string")
        return io(this.$el);
      if (t !== "window") {
        const e = document.querySelector(t);
        return e || (console.warn("Scrolling element couldn't be found"), io(this.$el));
      }
      return window;
    },
    handleScroll() {
      window.requestAnimationFrame(this.setScrollPosition);
    },
    setScrollPosition() {
      this.scrollPositionY = this.scrollingElement.scrollY;
    },
    hideDatePicker() {
      this.showDatePicker = !1;
    },
    activateDatePicker() {
      this.showDatePicker = !0, this.$nextTick(() => {
        this.$refs.datePickerModal.$el.focus();
      });
    }
  }
};
function w$(t, e, n, r, a, i) {
  const o = z("c-date-picker-with-shortcuts"), s = z("c-date-field"), l = Yp("click-outside");
  return b(), M("div", null, [
    a.showDatePicker ? Ve((b(), L(o, {
      key: 0,
      onCancel: i.hideDatePicker,
      style: Ut(i.computeDatePickerStyle),
      ref: "datePickerModal",
      tabindex: "0",
      labels: n.labels,
      locale: n.locale,
      "allow-select-today": n.allowSelectToday,
      dateSelected: a.selectedDateObject,
      "onUpdate:dateSelected": e[0] || (e[0] = (c) => a.selectedDateObject = c),
      disabled: n.disabled
    }, null, 8, ["onCancel", "style", "labels", "locale", "allow-select-today", "dateSelected", "disabled"])), [
      [l, i.hideDatePicker]
    ]) : E("", !0),
    T(s, {
      value: a.selectedDateObject,
      "onUpdate:value": e[1] || (e[1] = (c) => a.selectedDateObject = c),
      disabled: n.disabled,
      ref: "dateFieldInput",
      onFocus: i.activateDatePicker
    }, null, 8, ["value", "disabled", "onFocus"])
  ]);
}
const J$ = /* @__PURE__ */ B(_$, [["render", w$]]), k$ = /* @__PURE__ */ ne({
  __name: "index",
  props: {
    marginToKeep: {
      type: Number,
      required: !1,
      default: 8
    },
    locale: {
      required: !1,
      default: null,
      type: String
    },
    labels: {
      type: Object,
      default: () => ({
        confirm: "Confirm",
        cancel: "Cancel"
      }),
      required: !1
    },
    // default prop not required here. If empty, use method
    // eslint-disable-next-line vue/require-default-prop
    scrollingContainer: {
      type: String,
      required: !1
    },
    allowSelectPast: {
      type: Boolean,
      required: !1,
      default: !0
    },
    allowSelectFuture: {
      type: Boolean,
      required: !1,
      default: !0
    },
    allowSelectToday: {
      type: Boolean,
      required: !1,
      default: !0
    },
    format: {
      type: String,
      required: !1,
      default: go.european
    },
    separator: {
      type: String,
      required: !1,
      default: " / "
    },
    datesSeparator: {
      type: String,
      required: !1,
      default: " - "
    },
    weekStartsOnMonday: {
      type: Boolean,
      required: !1,
      default: !0
    },
    dateRange: {
      required: !1,
      type: Object,
      validator(t) {
        return At(t);
      },
      default: () => ({ starts: null, ends: null })
    }
  },
  emits: ["update:dateRangeSelected", "cancel"],
  setup(t, { emit: e }) {
    const n = t, r = vn;
    let a = U(!1), i = U(0), o = U(window), s = U(n.dateRange), l = U(null);
    const c = U(null), u = U(null);
    Yt(n.dateRange, (v) => {
      At(v) && (s.value = v);
    }), Wn(() => {
      var v;
      o.value = f(), (v = o.value) == null || v.addEventListener("scroll", m, !0);
    }), jf(() => {
      var v;
      (v = o.value) == null || v.removeEventListener("scroll", m);
    });
    const f = () => {
      if (n.scrollingContainer) {
        if (n.scrollingContainer !== "window") {
          const v = document.querySelector(n.scrollingContainer);
          return v || (console.warn("Scrolling element couldn't be found"), io(l.value));
        }
        return window;
      } else
        return io(l.value);
    }, d = () => {
      a.value = !a.value;
    }, h = () => {
      a.value = !1, e("cancel");
    }, m = () => {
      window.requestAnimationFrame(p);
    }, p = () => {
      var v, w;
      if (o.value instanceof Window) {
        i.value = (v = o.value) == null ? void 0 : v.scrollY;
        return;
      }
      i.value = (w = o.value) == null ? void 0 : w.scrollTop;
    }, g = (v) => {
      s.value = v, a.value = !1, e("update:dateRangeSelected", v);
    };
    return (v, w) => (b(), M("div", null, [
      T(ZD, {
        "date-range": S(s),
        format: t.format,
        separator: t.separator,
        "dates-separator": t.datesSeparator,
        ref_key: "dateRangeFieldInput",
        ref: u,
        onClick: d
      }, null, 8, ["date-range", "format", "separator", "dates-separator"]),
      S(a) ? Ve((b(), L(kT, {
        key: 0,
        ref_key: "dateRangePickerModal",
        ref: c,
        tabindex: "0",
        class: "c-date-range-picker-instance c-layer-overlay",
        labels: t.labels,
        locale: t.locale,
        "allow-select-past": t.allowSelectPast,
        "allow-select-future": t.allowSelectFuture,
        "allow-select-today": t.allowSelectToday,
        "week-starts-on-monday": t.weekStartsOnMonday,
        format: t.format,
        separator: t.separator,
        "date-range": S(s),
        "onUpdate:dateRange": w[0] || (w[0] = (C) => je(s) ? s.value = C : s = C),
        "onUpdate:dateRangeSelected": g,
        onCancel: h
      }, null, 8, ["labels", "locale", "allow-select-past", "allow-select-future", "allow-select-today", "week-starts-on-monday", "format", "separator", "date-range"])), [
        [S(r), h]
      ]) : E("", !0)
    ]));
  }
});
const eR = /* @__PURE__ */ B(k$, [["__scopeId", "data-v-00f63a30"]]), zp = "coppi-tooltip-id";
let oo, Ol = !1, fi, pa = 0;
const Dl = {}, zf = (t) => {
  var i;
  if (Ol)
    return;
  Ol = !0, fi = document.createElement("div");
  const e = (i = t.target) == null ? void 0 : i.getAttribute(zp), { defaultPointerDirection: n, tooltipContent: r, maxWidth: a } = Dl[e];
  oo = Xp(
    Jy,
    { content: r, defaultPointerDirection: n, target: t.target, maxWidth: a }
  ), oo.mount(fi), t.target.appendChild(fi);
}, Bf = (t) => {
  oo.unmount && oo.unmount(), t.target.removeChild(fi), Ol = !1;
}, tR = {
  mounted(t, e) {
    pa += 1;
    const n = typeof e.value == "string" ? e.value : e.value.content ?? "";
    t.setAttribute(zp, pa.toString()), Dl[pa] = {
      defaultPointerDirection: e.arg,
      tooltipContent: n,
      maxWidth: null
    }, typeof e.value == "object" && e.value.maxWidth && (Dl[pa].maxWidth = e.value.maxWidth), t.addEventListener("mouseenter", zf), t.addEventListener("mouseleave", Bf);
  },
  beforeUnmount(t) {
    t.removeEventListener("mouseenter", zf), t.removeEventListener("mouseleave", Bf);
  }
}, nR = {
  install: (t, e) => {
    t.config.globalProperties.$setCoppiLocale = (n) => {
      o1(n);
    }, t.config.globalProperties.$getCoppiLocale = () => dh(), s1(e);
  }
}, rR = {
  install: (t, e) => {
    t.config.globalProperties.$logError = e.logException;
  }
};
export {
  Rm as BkAppMarketPlace,
  Xf as BkLogo,
  Mm as BkReachLogo,
  co as CAccordion,
  gr as CActionButton,
  $$ as CAlert,
  N1 as CArrowLeftRightIcon,
  W$ as CAvailabilityInput,
  Kf as CAvatar,
  ur as CBadge,
  LO as CBarChart,
  B$ as CBarChartWithNavigation,
  F$ as CBreadCrumbs,
  dr as CButton,
  T$ as CCallout,
  rm as CCaption,
  S$ as CCard,
  Lp as CCheckbox,
  Xt as CChevron,
  d1 as CCopyToClipboard,
  Sl as CDateField,
  Ip as CDatePicker,
  J$ as CDatePickerModal,
  ZD as CDateRangeField,
  kT as CDateRangePicker,
  eR as CDateRangePickerModal,
  L$ as CDayNavigation,
  R$ as CDropdown,
  qf as CHeading,
  th as CIdentifier,
  Uf as CLink,
  I$ as CMonthYearPicker,
  N$ as CMultipleSearchSelection,
  _D as CNavTabItem,
  v6 as CNumberInput,
  K$ as CRadio,
  zn as CRunning,
  lo as CSeparator,
  Ne as CSubheading,
  Y$ as CTabNav,
  G$ as CTable,
  TD as CTextInput,
  A$ as CTimePicker,
  M$ as CToast,
  Q$ as CToggle,
  Jy as CTooltip,
  tR as CTooltipDirective,
  we as CUi,
  O$ as ContentPosition,
  Pn as CoppiContentPositions,
  go as CoppiDateFormats,
  rR as CoppiErrorReportingPlugin,
  G as CoppiIntents,
  dm as CoppiIntentsConstants,
  F as CoppiLocales,
  nR as CoppiLocalisationPlugin,
  ot as DateRangePickerOptionsEnum,
  vo as InlineLoader,
  V$ as NavAccount,
  H$ as NavBlock,
  q$ as NavBottom,
  Pr as NavItem,
  XO as NavShortcuts,
  j$ as NavShortcutsTriggers,
  U$ as NavTop,
  X$ as SearchInput,
  E$ as SearchResultItem,
  Z$ as SkeletonLoader,
  D$ as SupplierListItem,
  P$ as baseIntents
};
